//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import AxiosClient from './axiosClient';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ChatClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getOrCreatePatientConversationId(patientId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/agent/chat/patients/{patientId}/conversations";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrCreatePatientConversationId(_response));
        });
    }

    protected processGetOrCreatePatientConversationId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all unresolved conversations for the current agent.
     * @return List of unresolved conversations with patient information and unread counts.
     */
    getUnresolvedConversations( cancelToken?: CancelToken): Promise<PatientConversationSummaryModel[]> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/unresolved";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnresolvedConversations(_response));
        });
    }

    protected processGetUnresolvedConversations(response: AxiosResponse): Promise<PatientConversationSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientConversationSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientConversationSummaryModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientConversationSummaryModel[]>(null as any);
    }

    /**
     * Gets the complete chat history for a conversation.
    Automatically marks the conversation as read by the current agent.
     * @param patientConversationId The conversation ID to retrieve history for.
     * @return Chat history with messages and cursor information.
     */
    getChatHistory(patientConversationId: string, cancelToken?: CancelToken): Promise<ChatHistoryModel> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/{patientConversationId}/history";
        if (patientConversationId === undefined || patientConversationId === null)
            throw new Error("The parameter 'patientConversationId' must be defined.");
        url_ = url_.replace("{patientConversationId}", encodeURIComponent("" + patientConversationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChatHistory(_response));
        });
    }

    protected processGetChatHistory(response: AxiosResponse): Promise<ChatHistoryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChatHistoryModel.fromJS(resultData200);
            return Promise.resolve<ChatHistoryModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChatHistoryModel>(null as any);
    }

    /**
     * Marks a conversation as resolved.
     * @param patientConversationId The conversation ID to mark as resolved.
     * @param lastMessageId (optional) The last message id used to verify the latest state when resolving.
     * @return The updated conversation.
     */
    markConversationResolved(patientConversationId: string, lastMessageId: string | null | undefined, cancelToken?: CancelToken): Promise<PatientConversationModel> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/{patientConversationId}/resolve?";
        if (patientConversationId === undefined || patientConversationId === null)
            throw new Error("The parameter 'patientConversationId' must be defined.");
        url_ = url_.replace("{patientConversationId}", encodeURIComponent("" + patientConversationId));
        if (lastMessageId !== undefined && lastMessageId !== null)
            url_ += "lastMessageId=" + encodeURIComponent("" + lastMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkConversationResolved(_response));
        });
    }

    protected processMarkConversationResolved(response: AxiosResponse): Promise<PatientConversationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientConversationModel.fromJS(resultData200);
            return Promise.resolve<PatientConversationModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientConversationModel>(null as any);
    }

    /**
     * Marks a conversation as unresolved.
     * @param patientConversationId The conversation ID to mark as unresolved.
     * @return The updated conversation.
     */
    markConversationUnresolved(patientConversationId: string, cancelToken?: CancelToken): Promise<PatientConversationModel> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/{patientConversationId}/unresolve";
        if (patientConversationId === undefined || patientConversationId === null)
            throw new Error("The parameter 'patientConversationId' must be defined.");
        url_ = url_.replace("{patientConversationId}", encodeURIComponent("" + patientConversationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkConversationUnresolved(_response));
        });
    }

    protected processMarkConversationUnresolved(response: AxiosResponse): Promise<PatientConversationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientConversationModel.fromJS(resultData200);
            return Promise.resolve<PatientConversationModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientConversationModel>(null as any);
    }

    /**
     * Deletes a message sent by an agent.
    Patient messages cannot be deleted.
     * @param patientChatMessageId The message ID to delete.
     * @return Success status.
     */
    deleteMessage(patientChatMessageId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/agent/chat/messages/{patientChatMessageId}";
        if (patientChatMessageId === undefined || patientChatMessageId === null)
            throw new Error("The parameter 'patientChatMessageId' must be defined.");
        url_ = url_.replace("{patientChatMessageId}", encodeURIComponent("" + patientChatMessageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteMessage(_response));
        });
    }

    protected processDeleteMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Marks a conversation as read.
     * @param patientConversationId The conversation ID to mark as read.
     * @return The conversation read record.
     */
    markConversationRead(patientConversationId: string, cancelToken?: CancelToken): Promise<ConversationReadModel> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/{patientConversationId}/mark-read";
        if (patientConversationId === undefined || patientConversationId === null)
            throw new Error("The parameter 'patientConversationId' must be defined.");
        url_ = url_.replace("{patientConversationId}", encodeURIComponent("" + patientConversationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMarkConversationRead(_response));
        });
    }

    protected processMarkConversationRead(response: AxiosResponse): Promise<ConversationReadModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversationReadModel.fromJS(resultData200);
            return Promise.resolve<ConversationReadModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationReadModel>(null as any);
    }

    /**
     * Sends a chat message as an agent in a conversation.
     * @param patientConversationId The conversation ID to send the message in.
     * @param request The message content.
     * @return The sent message.
     */
    sendMessage(patientConversationId: string, request: SendMessageRequest, cancelToken?: CancelToken): Promise<PatientChatMessageModel> {
        let url_ = this.baseUrl + "/api/agent/chat/conversations/{patientConversationId}/messages";
        if (patientConversationId === undefined || patientConversationId === null)
            throw new Error("The parameter 'patientConversationId' must be defined.");
        url_ = url_.replace("{patientConversationId}", encodeURIComponent("" + patientConversationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<PatientChatMessageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientChatMessageModel.fromJS(resultData200);
            return Promise.resolve<PatientChatMessageModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientChatMessageModel>(null as any);
    }
}

export class ProgramClosureClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createProgramClosure(model: CreateProgramClosureModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/program/closures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateProgramClosure(_response));
        });
    }

    protected processCreateProgramClosure(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getProgramClosures( cancelToken?: CancelToken): Promise<ProgramClosuresResult[]> {
        let url_ = this.baseUrl + "/api/v1/program/closures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProgramClosures(_response));
        });
    }

    protected processGetProgramClosures(response: AxiosResponse): Promise<ProgramClosuresResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramClosuresResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgramClosuresResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramClosuresResult[]>(null as any);
    }

    updateProgramClosure(model: ProgramClosuresResult, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/program/closures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProgramClosure(_response));
        });
    }

    protected processUpdateProgramClosure(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    archiveProgramClosure(programClosureId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/program/closures/archive?";
        if (programClosureId === null)
            throw new Error("The parameter 'programClosureId' cannot be null.");
        else if (programClosureId !== undefined)
            url_ += "programClosureId=" + encodeURIComponent("" + programClosureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveProgramClosure(_response));
        });
    }

    protected processArchiveProgramClosure(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProgramAvailabilityClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    checkProgramAvailability(program: string | null | undefined, cancelToken?: CancelToken): Promise<ProgramAvailabilityResult> {
        let url_ = this.baseUrl + "/api/v1/program-availability?";
        if (program !== undefined && program !== null)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckProgramAvailability(_response));
        });
    }

    protected processCheckProgramAvailability(response: AxiosResponse): Promise<ProgramAvailabilityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgramAvailabilityResult.fromJS(resultData200);
            return Promise.resolve<ProgramAvailabilityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramAvailabilityResult>(null as any);
    }

    getProgramHours(numberOfDays: number | undefined, cancelToken?: CancelToken): Promise<ProgramHoursResponse> {
        let url_ = this.baseUrl + "/api/v1/program-availability/program-hours?";
        if (numberOfDays === null)
            throw new Error("The parameter 'numberOfDays' cannot be null.");
        else if (numberOfDays !== undefined)
            url_ += "numberOfDays=" + encodeURIComponent("" + numberOfDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProgramHours(_response));
        });
    }

    protected processGetProgramHours(response: AxiosResponse): Promise<ProgramHoursResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgramHoursResponse.fromJS(resultData200);
            return Promise.resolve<ProgramHoursResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramHoursResponse>(null as any);
    }
}

export class IvrAudioFilesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getIvrAudioFiles(studyId: string | null | undefined, includeDeleted: boolean | undefined, cancelToken?: CancelToken): Promise<IvrAudioFilesViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/ivraudiofiles?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetIvrAudioFiles(_response));
        });
    }

    protected processGetIvrAudioFiles(response: AxiosResponse): Promise<IvrAudioFilesViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IvrAudioFilesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IvrAudioFilesViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IvrAudioFilesViewModel[]>(null as any);
    }
}

export class BusinessHoursClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createBusinessHours(businessHours: CreateProgramBusinessHour[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/business-hours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessHours);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateBusinessHours(_response));
        });
    }

    protected processCreateBusinessHours(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAllBusinessHours( cancelToken?: CancelToken): Promise<ProgramBusinessHoursResult[]> {
        let url_ = this.baseUrl + "/api/v1/business-hours";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllBusinessHours(_response));
        });
    }

    protected processGetAllBusinessHours(response: AxiosResponse): Promise<ProgramBusinessHoursResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramBusinessHoursResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgramBusinessHoursResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramBusinessHoursResult[]>(null as any);
    }

    getProgramBusinessHours(studyId: string | null | undefined, cancelToken?: CancelToken): Promise<ProgramBusinessHoursResult[]> {
        let url_ = this.baseUrl + "/api/v1/business-hours/studyId?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProgramBusinessHours(_response));
        });
    }

    protected processGetProgramBusinessHours(response: AxiosResponse): Promise<ProgramBusinessHoursResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgramBusinessHoursResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgramBusinessHoursResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramBusinessHoursResult[]>(null as any);
    }

    updateProgramBusinessHours(businessHours: EditProgramBusinessHour[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/business-hours/update-hours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessHours);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProgramBusinessHours(_response));
        });
    }

    protected processUpdateProgramBusinessHours(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AccountClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isLoggedIn( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/is-logged-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsLoggedIn(_response));
        });
    }

    protected processIsLoggedIn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getClientsAndStudiesForLoggedInUser( cancelToken?: CancelToken): Promise<ClientSummary[]> {
        let url_ = this.baseUrl + "/api/account/clients-studies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientsAndStudiesForLoggedInUser(_response));
        });
    }

    protected processGetClientsAndStudiesForLoggedInUser(response: AxiosResponse): Promise<ClientSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientSummary[]>(null as any);
    }

    /**
     * Retrieve the clients which the logged in user can access based on their client associations in AccountAccess table
     */
    getClientsForLoggedInUser( cancelToken?: CancelToken): Promise<ClientSummary[]> {
        let url_ = this.baseUrl + "/api/account/available-clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientsForLoggedInUser(_response));
        });
    }

    protected processGetClientsForLoggedInUser(response: AxiosResponse): Promise<ClientSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientSummary[]>(null as any);
    }

    /**
     * Retrieve the studies which the logged in user can access based on their associations in AccountAccess table
     */
    getStudiesForLoggedInUser( cancelToken?: CancelToken): Promise<StudySummary[]> {
        let url_ = this.baseUrl + "/api/account/available-studies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudiesForLoggedInUser(_response));
        });
    }

    protected processGetStudiesForLoggedInUser(response: AxiosResponse): Promise<StudySummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudySummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudySummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudySummary[]>(null as any);
    }

    /**
     * Set the current client for the logged in user.  This will re-issue a new cookie with the selected client embedded as a claim.
     */
    setCurrentClientForLoggedInUser(request: SetCurrentClientRequest, cancelToken?: CancelToken): Promise<ClientSummary> {
        let url_ = this.baseUrl + "/api/account/set-current-client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCurrentClientForLoggedInUser(_response));
        });
    }

    protected processSetCurrentClientForLoggedInUser(response: AxiosResponse): Promise<ClientSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientSummary.fromJS(resultData200);
            return Promise.resolve<ClientSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientSummary>(null as any);
    }

    /**
     * Get the currently selected client for the logged in user
     */
    getCurrentClientForLoggedInUser( cancelToken?: CancelToken): Promise<ClientSummary> {
        let url_ = this.baseUrl + "/api/account/get-current-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentClientForLoggedInUser(_response));
        });
    }

    protected processGetCurrentClientForLoggedInUser(response: AxiosResponse): Promise<ClientSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientSummary.fromJS(resultData200);
            return Promise.resolve<ClientSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientSummary>(null as any);
    }

    /**
     * Get the currently selected study for the logged in user.
    The current study should be set for pages which require a study 'context'.
     */
    getCurrentStudyForLoggedInUser(studyId: string, cancelToken?: CancelToken): Promise<StudySummary> {
        let url_ = this.baseUrl + "/api/account/studies/{studyId}/get-current-study";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentStudyForLoggedInUser(_response));
        });
    }

    protected processGetCurrentStudyForLoggedInUser(response: AxiosResponse): Promise<StudySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudySummary.fromJS(resultData200);
            return Promise.resolve<StudySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudySummary>(null as any);
    }

    /**
     * Get the currently selected study for the logged in user.
    The current study should be set for pages which require a study 'context'.
     */
    getCurrentStudyForLoggedInUser2( cancelToken?: CancelToken): Promise<StudySummary> {
        let url_ = this.baseUrl + "/api/account/get-current-study";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentStudyForLoggedInUser2(_response));
        });
    }

    protected processGetCurrentStudyForLoggedInUser2(response: AxiosResponse): Promise<StudySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudySummary.fromJS(resultData200);
            return Promise.resolve<StudySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudySummary>(null as any);
    }

    /**
     * Set the current study for the logged in user.  This will re-issue a new cookie with the selected client + selected study embedded
    as separate claims.
     */
    setCurrentStudyForLoggedInUser(request: SetCurrentStudyRequest, cancelToken?: CancelToken): Promise<StudySummary> {
        let url_ = this.baseUrl + "/api/account/set-current-study";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCurrentStudyForLoggedInUser(_response));
        });
    }

    protected processSetCurrentStudyForLoggedInUser(response: AxiosResponse): Promise<StudySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudySummary.fromJS(resultData200);
            return Promise.resolve<StudySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudySummary>(null as any);
    }

    setCurrentClientAndStudyForLoggedInUser(request: SetCurrentClientStudyRequest, cancelToken?: CancelToken): Promise<ClientStudySummary> {
        let url_ = this.baseUrl + "/api/account/set-current-client-study";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCurrentClientAndStudyForLoggedInUser(_response));
        });
    }

    protected processSetCurrentClientAndStudyForLoggedInUser(response: AxiosResponse): Promise<ClientStudySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientStudySummary.fromJS(resultData200);
            return Promise.resolve<ClientStudySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientStudySummary>(null as any);
    }

    /**
     * Change the password for the logged in user
     */
    changePassword(model: ChangePasswordBindingModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reset the password of the account specified in the model.  Account is the token/email.
     */
    resetPassword(model: ResetPasswordViewModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Trigger Forgot Password process
     */
    forgotPassword(model: ForgotPasswordBindingModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Register a new account
     */
    register(model: RegisterAccountBindingModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the currently logged in account's basic information (firstname, lastname, email)
     */
    postUpdate(model: AccountModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/account/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostUpdate(_response));
        });
    }

    protected processPostUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the permissions on the specified account
     */
    updatePermissions(accountID: string, model: AccountPermissionsModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/account/update-permissions/{accountID}";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined.");
        url_ = url_.replace("{accountID}", encodeURIComponent("" + accountID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePermissions(_response));
        });
    }

    protected processUpdatePermissions(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    pulse( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/account/Pulse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPulse(_response));
        });
    }

    protected processPulse(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    validateEmail(model: ValidateEmailBindingModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/account/ValidateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateEmail(_response));
        });
    }

    protected processValidateEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Resend the hub invitation email for a hub account
     */
    sendVerificationEmail(accountID: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/resend-verification/{accountID}";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined.");
        url_ = url_.replace("{accountID}", encodeURIComponent("" + accountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendVerificationEmail(_response));
        });
    }

    protected processSendVerificationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * List accounts which have access to the selected client and which the current account has
    permission to administer
     */
    getAccounts( cancelToken?: CancelToken): Promise<AccountModel[]> {
        let url_ = this.baseUrl + "/api/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccounts(_response));
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountModel[]>(null as any);
    }

    getAvailableAccounts( cancelToken?: CancelToken): Promise<AccountModel[]> {
        let url_ = this.baseUrl + "/api/account/schedule-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableAccounts(_response));
        });
    }

    protected processGetAvailableAccounts(response: AxiosResponse): Promise<AccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountModel[]>(null as any);
    }

    /**
     * Get the current account's details (i.e. the details of the logged in user)
     */
    getCurrent( cancelToken?: CancelToken): Promise<AccountModel> {
        let url_ = this.baseUrl + "/api/account/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrent(_response));
        });
    }

    protected processGetCurrent(response: AxiosResponse): Promise<AccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountModel.fromJS(resultData200);
            return Promise.resolve<AccountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountModel>(null as any);
    }

    /**
     * Retrieve the specified account
     */
    getAccount(accountID: string, cancelToken?: CancelToken): Promise<AccountModel> {
        let url_ = this.baseUrl + "/api/account/details/{accountID}";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined.");
        url_ = url_.replace("{accountID}", encodeURIComponent("" + accountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccount(_response));
        });
    }

    protected processGetAccount(response: AxiosResponse): Promise<AccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountModel.fromJS(resultData200);
            return Promise.resolve<AccountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountModel>(null as any);
    }
}

export class AliveClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCurrentSessionInfo( cancelToken?: CancelToken): Promise<CurrentSessionInfo> {
        let url_ = this.baseUrl + "/api/Alive/session_info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentSessionInfo(_response));
        });
    }

    protected processGetCurrentSessionInfo(response: AxiosResponse): Promise<CurrentSessionInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentSessionInfo.fromJS(resultData200);
            return Promise.resolve<CurrentSessionInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentSessionInfo>(null as any);
    }

    alive( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Alive/alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAlive(_response));
        });
    }

    protected processAlive(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSessionJs( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Alive/session_dot_js";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSessionJs(_response));
        });
    }

    protected processGetSessionJs(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AttachmentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all attachments for the given patient
     * @param patientId Patient id under who the attachment was uploaded
     */
    getAllForPatient(studyId: string, patientId: string, cancelToken?: CancelToken): Promise<AttachmentsSummary> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/attachment/{patientId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllForPatient(_response));
        });
    }

    protected processGetAllForPatient(response: AxiosResponse): Promise<AttachmentsSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentsSummary.fromJS(resultData200);
            return Promise.resolve<AttachmentsSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentsSummary>(null as any);
    }

    /**
     * Download the specified attachment for the given patient
     * @param patientId Patient id under who the attachment was uploaded
     * @param id File attachment
     */
    getDownload(studyId: string, patientId: string, id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/attachment/{patientId}/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownload(_response));
        });
    }

    protected processGetDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Update the specified attachment for the given patient, with the provided tags
     * @param tags string array containing all tags for the attachment
     * @param attachmentId (optional) File attachment
     * @param patientId (optional) Patient id under who the attachment was uploaded
     */
    updateTags(studyId: string, tags: string[], attachmentId: string | undefined, patientId: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/attachment?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tags);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTags(_response));
        });
    }

    protected processUpdateTags(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Delete the specified attachment for the given patient
     * @param patientId Patient id under who the attachment was uploaded
     * @param attachmentId Attachment id
     */
    deleteAttachment(studyId: string, patientId: string, attachmentId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/attachment/{patientId}/{attachmentId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAttachment(_response));
        });
    }

    protected processDeleteAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AvatarClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvatar(path: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Avatar?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvatar(_response));
        });
    }

    protected processGetAvatar(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CategoryClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all categories for the selected client which the logged in user has access to
     */
    getCategories( cancelToken?: CancelToken): Promise<CategoryModel[]> {
        let url_ = this.baseUrl + "/api/Category";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCategories(_response));
        });
    }

    protected processGetCategories(response: AxiosResponse): Promise<CategoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryModel[]>(null as any);
    }

    /**
     * Create a new site
     */
    postCategory(category: CategoryModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostCategory(_response));
        });
    }

    protected processPostCategory(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get Category by id
     * @param id Category id
     */
    getCategory(id: string, cancelToken?: CancelToken): Promise<CategoryModel[]> {
        let url_ = this.baseUrl + "/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCategory(_response));
        });
    }

    protected processGetCategory(response: AxiosResponse): Promise<CategoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryModel[]>(null as any);
    }

    /**
     * Update an interaction
     */
    putCategory(id: string, category: CategoryModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutCategory(_response));
        });
    }

    protected processPutCategory(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ConfigurationClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Produce Javascript for a page.
     * @param isPublic (optional) 
     */
    index(isPublic: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/js/configuration?";
        if (isPublic === null)
            throw new Error("The parameter 'isPublic' cannot be null.");
        else if (isPublic !== undefined)
            url_ += "isPublic=" + encodeURIComponent("" + isPublic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIndex(_response));
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Generates a cacheable JavaScript file that defines the application's regional settings.
     * @return A JavaScript file containing a global `regionalSettings` object.
     */
    regionalSettingsScript( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/js/configuration/regional.js";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegionalSettingsScript(_response));
        });
    }

    protected processRegionalSettingsScript(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all documents for the selected client
     */
    getDocuments(studyId: string, cancelToken?: CancelToken): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocuments(_response));
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel[]>(null as any);
    }

    /**
     * Create a new document (will belong to the selected client)
     * @param studyId Study in context
     * @param file (optional) File to upload
     */
    postDocument(studyId: string, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<DocumentModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostDocument(_response));
        });
    }

    protected processPostDocument(response: AxiosResponse): Promise<DocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentModel.fromJS(resultData200);
            return Promise.resolve<DocumentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel>(null as any);
    }

    /**
     * Retrieve details about the specified document (must belong to the selected client)
     * @param studyId Study in context
     */
    getDocument(studyId: string, id: number, cancelToken?: CancelToken): Promise<DocumentModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocument(_response));
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<DocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentModel.fromJS(resultData200);
            return Promise.resolve<DocumentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel>(null as any);
    }

    /**
     * Update the specified document (must belong to the selected client)
     * @param studyId Study in context
     */
    putDocument(studyId: string, id: number, model: DocumentModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutDocument(_response));
        });
    }

    protected processPutDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified document (must belong to the selected client)
     * @param studyId Study in context
     */
    deleteDocument(studyId: string, id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDocument(_response));
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download the specified document (must belong to the selected client)
     * @param studyId Study in context
     */
    getDownload(studyId: string, id: number, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/download/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownload(_response));
        });
    }

    protected processGetDownload(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    getDocumentTags(studyId: string, documentId: number, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/tags/{documentId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocumentTags(_response));
        });
    }

    protected processGetDocumentTags(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    setDocumentTags(studyId: string, documentId: number, newTags: string[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/tags/{documentId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTags);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetDocumentTags(_response));
        });
    }

    protected processSetDocumentTags(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocumentInteractions(interactionIdQuery: number | undefined, studyId: string, interactionIdPath: number, cancelToken?: CancelToken): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/document_interactions/{interactionId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (interactionIdPath === undefined || interactionIdPath === null)
            throw new Error("The parameter 'interactionIdPath' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionIdPath));
        if (interactionIdQuery === null)
            throw new Error("The parameter 'interactionIdQuery' cannot be null.");
        else if (interactionIdQuery !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocumentInteractions(_response));
        });
    }

    protected processGetDocumentInteractions(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(null as any);
    }

    saveDocumentInteractions(interactionIdQuery: number | undefined, documentIds: number[], studyId: string, interactionIdPath: number, cancelToken?: CancelToken): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/document/document_interactions/{interactionId}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (interactionIdPath === undefined || interactionIdPath === null)
            throw new Error("The parameter 'interactionIdPath' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionIdPath));
        if (interactionIdQuery === null)
            throw new Error("The parameter 'interactionIdQuery' cannot be null.");
        else if (interactionIdQuery !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionIdQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveDocumentInteractions(_response));
        });
    }

    protected processSaveDocumentInteractions(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }
}

export class ExportClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateExportV2(format: GenerateExportV2Format | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/export/exportV2?";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGenerateExportV2(_response));
        });
    }

    protected processGenerateExportV2(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Submit an export request for an interaction within the current study
     * @param id Interaction ID
     * @param model Export parameters
     */
    getInteraction(id: number, model: ExportInteractionInputModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/export/interaction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Submit an export request for data for the current study
     * @param model Export parameters
     */
    getGlobal(model: ExportGlobalInputModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/export/global";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGlobal(_response));
        });
    }

    protected processGetGlobal(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Retrieve all non-expired exports submitted by the current user within the current study
     */
    getExports( cancelToken?: CancelToken): Promise<ExportModel[]> {
        let url_ = this.baseUrl + "/api/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetExports(_response));
        });
    }

    protected processGetExports(response: AxiosResponse): Promise<ExportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportModel[]>(null as any);
    }

    /**
     * Get details on a single export request
     * @param id Export UId
     */
    getExport(id: string, cancelToken?: CancelToken): Promise<ExportModel> {
        let url_ = this.baseUrl + "/api/export/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetExport(_response));
        });
    }

    protected processGetExport(response: AxiosResponse): Promise<ExportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportModel.fromJS(resultData200);
            return Promise.resolve<ExportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportModel>(null as any);
    }

    getDownload(id: string, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/export/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownload(_response));
        });
    }

    protected processGetDownload(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }
}

export class FileNoteClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFileNotes(patientID: string, cancelToken?: CancelToken): Promise<FileNoteModel[]> {
        let url_ = this.baseUrl + "/api/filenote/list/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFileNotes(_response));
        });
    }

    protected processGetFileNotes(response: AxiosResponse): Promise<FileNoteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileNoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileNoteModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileNoteModel[]>(null as any);
    }

    getFileNote(id: string, cancelToken?: CancelToken): Promise<FileNoteModel> {
        let url_ = this.baseUrl + "/api/filenote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFileNote(_response));
        });
    }

    protected processGetFileNote(response: AxiosResponse): Promise<FileNoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileNoteModel.fromJS(resultData200);
            return Promise.resolve<FileNoteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileNoteModel>(null as any);
    }

    /**
     * Create a new fileNote
     */
    postFileNote(model: NewFileNoteModel, patientID: string, cancelToken?: CancelToken): Promise<FileNoteModel> {
        let url_ = this.baseUrl + "/api/filenote/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostFileNote(_response));
        });
    }

    protected processPostFileNote(response: AxiosResponse): Promise<FileNoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileNoteModel.fromJS(resultData200);
            return Promise.resolve<FileNoteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileNoteModel>(null as any);
    }
}

export class GraphClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    dashboardGraph(studyId: string, graphType: DashboardGraphType, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/graph/studies/{studyId}/dashboard/{graphType}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (graphType === undefined || graphType === null)
            throw new Error("The parameter 'graphType' must be defined.");
        url_ = url_.replace("{graphType}", encodeURIComponent("" + graphType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDashboardGraph(_response));
        });
    }

    protected processDashboardGraph(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * List all documents for the selected client
     */
    patientGraph(graphID: number, patientID: string, studyId: string, cancelToken?: CancelToken): Promise<PatientGraphModel[]> {
        let url_ = this.baseUrl + "/api/graph/studies/{studyId}/participant/{patientID}/{graphID}";
        if (graphID === undefined || graphID === null)
            throw new Error("The parameter 'graphID' must be defined.");
        url_ = url_.replace("{graphID}", encodeURIComponent("" + graphID));
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPatientGraph(_response));
        });
    }

    protected processPatientGraph(response: AxiosResponse): Promise<PatientGraphModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientGraphModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientGraphModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientGraphModel[]>(null as any);
    }
}

export class HubAccountPatientClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieve a hub account for the specified HubAccountPatientID (must belong to the selected client)
     */
    getHubAccount(id: string, patientID: string, cancelToken?: CancelToken): Promise<HubResourceModel> {
        let url_ = this.baseUrl + "/api/HubAccountPatient/{patientID}/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHubAccount(_response));
        });
    }

    protected processGetHubAccount(response: AxiosResponse): Promise<HubResourceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HubResourceModel.fromJS(resultData200);
            return Promise.resolve<HubResourceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubResourceModel>(null as any);
    }

    /**
     * Update the specified hub account for a participant (must belong to the selected client)
     */
    putHubAccount(id: string, model: HubAccountPatientModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubAccountPatient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutHubAccount(_response));
        });
    }

    protected processPutHubAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a hub account for a participant (must belong to the selected client)
     */
    postHubAccount(model: HubAccountPatientModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubAccountPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostHubAccount(_response));
        });
    }

    protected processPostHubAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resend the hub invitation email for a hub account
     */
    resendInvitation(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubAccountPatient/resend-invitation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResendInvitation(_response));
        });
    }

    protected processResendInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HubConsentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get the consent form for this study
     */
    getForm( cancelToken?: CancelToken): Promise<HubConsentFormModel[]> {
        let url_ = this.baseUrl + "/api/HubConsent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetForm(_response));
        });
    }

    protected processGetForm(response: AxiosResponse): Promise<HubConsentFormModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubConsentFormModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubConsentFormModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubConsentFormModel[]>(null as any);
    }

    /**
     * Create a new page (will belong to the selected client)
     */
    postConsent(model: HubConsentFormModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostConsent(_response));
        });
    }

    protected processPostConsent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the specified page (must belong to the selected client)
     */
    putConsent(id: string, model: HubConsentFormModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubConsent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutConsent(_response));
        });
    }

    protected processPutConsent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a HubPatientConsent form
     */
    getConsentForPatient(patientID: string, consentID: string, cancelToken?: CancelToken): Promise<HubPatientConsentModel[]> {
        let url_ = this.baseUrl + "/api/HubConsent/{patientID}/{consentId}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (consentID === undefined || consentID === null)
            throw new Error("The parameter 'consentID' must be defined.");
        url_ = url_.replace("{consentID}", encodeURIComponent("" + consentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetConsentForPatient(_response));
        });
    }

    protected processGetConsentForPatient(response: AxiosResponse): Promise<HubPatientConsentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubPatientConsentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubPatientConsentModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubPatientConsentModel[]>(null as any);
    }

    signConsent(patientID: string, consentID: string, model: ConsentSignature, task: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubConsent/{patientID}/{consentId}?";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (consentID === undefined || consentID === null)
            throw new Error("The parameter 'consentID' must be defined.");
        url_ = url_.replace("{consentID}", encodeURIComponent("" + consentID));
        if (task !== undefined && task !== null)
            url_ += "task=" + encodeURIComponent("" + task) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignConsent(_response));
        });
    }

    protected processSignConsent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HubEventClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all hub events for the selected study
     */
    getEvents( cancelToken?: CancelToken): Promise<HubEventModel[]> {
        let url_ = this.baseUrl + "/api/HubEvent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEvents(_response));
        });
    }

    protected processGetEvents(response: AxiosResponse): Promise<HubEventModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubEventModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubEventModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubEventModel[]>(null as any);
    }

    /**
     * Create a new event (will belong to the selected client)
     */
    postEvent(model: HubEventModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostEvent(_response));
        });
    }

    protected processPostEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve details about the specified event (must belong to the selected client)
     */
    getEvent(id: string, cancelToken?: CancelToken): Promise<HubEventModel> {
        let url_ = this.baseUrl + "/api/HubEvent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEvent(_response));
        });
    }

    protected processGetEvent(response: AxiosResponse): Promise<HubEventModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HubEventModel.fromJS(resultData200);
            return Promise.resolve<HubEventModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubEventModel>(null as any);
    }

    /**
     * Update the specified event (must belong to the selected client)
     */
    putEvent(id: string, model: HubEventModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubEvent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutEvent(_response));
        });
    }

    protected processPutEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified dpage (must belong to the selected client)
     */
    deleteEvent(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubEvent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteEvent(_response));
        });
    }

    protected processDeleteEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HubPageClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all hub pages for the selected study
     */
    getCurrentPagesCount( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/HubPage/current-pages-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentPagesCount(_response));
        });
    }

    protected processGetCurrentPagesCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * List all hub pages for the selected study
     */
    getPages( cancelToken?: CancelToken): Promise<HubPageModel[]> {
        let url_ = this.baseUrl + "/api/HubPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPages(_response));
        });
    }

    protected processGetPages(response: AxiosResponse): Promise<HubPageModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubPageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubPageModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubPageModel[]>(null as any);
    }

    /**
     * Create a new page (will belong to the selected client)
     */
    postPage(model: HubPageModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostPage(_response));
        });
    }

    protected processPostPage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * List all hub pages for the selected study
     */
    getPages2(status: PageStatus, cancelToken?: CancelToken): Promise<HubPageModel[]> {
        let url_ = this.baseUrl + "/api/HubPage/status/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPages2(_response));
        });
    }

    protected processGetPages2(response: AxiosResponse): Promise<HubPageModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubPageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubPageModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubPageModel[]>(null as any);
    }

    /**
     * Retrieve details about the specified page (must belong to the selected client)
     */
    getPage(id: string, cancelToken?: CancelToken): Promise<HubPageModel> {
        let url_ = this.baseUrl + "/api/HubPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPage(_response));
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<HubPageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HubPageModel.fromJS(resultData200);
            return Promise.resolve<HubPageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubPageModel>(null as any);
    }

    /**
     * Update the specified page (must belong to the selected client)
     */
    putPage(id: string, model: HubPageModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutPage(_response));
        });
    }

    protected processPutPage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified dpage (must belong to the selected client)
     */
    deletePage(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeletePage(_response));
        });
    }

    protected processDeletePage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getImage(path: string | null | undefined, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/HubPage/image?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }
}

export class HubResourceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all hub resources for the selected client
     */
    getResources( cancelToken?: CancelToken): Promise<HubResourceModel[]> {
        let url_ = this.baseUrl + "/api/HubResource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResources(_response));
        });
    }

    protected processGetResources(response: AxiosResponse): Promise<HubResourceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HubResourceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HubResourceModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubResourceModel[]>(null as any);
    }

    /**
     * Create a new resource (will belong to the selected client)
     */
    postResource(model: HubResourceModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostResource(_response));
        });
    }

    protected processPostResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve details about the specified resource (must belong to the selected client)
     */
    getResource(id: string, cancelToken?: CancelToken): Promise<HubResourceModel> {
        let url_ = this.baseUrl + "/api/HubResource/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResource(_response));
        });
    }

    protected processGetResource(response: AxiosResponse): Promise<HubResourceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HubResourceModel.fromJS(resultData200);
            return Promise.resolve<HubResourceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubResourceModel>(null as any);
    }

    /**
     * Update the specified document (must belong to the selected client)
     */
    putResource(id: string, model: HubResourceModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubResource/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutResource(_response));
        });
    }

    protected processPutResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified document (must belong to the selected client)
     */
    deleteResource(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HubResource/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteResource(_response));
        });
    }

    protected processDeleteResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download the specified resource (must belong to the selected client)
     */
    getDownload(id: string, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/HubResource/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownload(_response));
        });
    }

    protected processGetDownload(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    /**
     * Upload a PDF resource
     * @param file (optional) 
     */
    upload(file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<HubResourceModel> {
        let url_ = this.baseUrl + "/api/HubResource/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpload(_response));
        });
    }

    protected processUpload(response: AxiosResponse): Promise<HubResourceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HubResourceModel.fromJS(resultData200);
            return Promise.resolve<HubResourceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubResourceModel>(null as any);
    }
}

export class InteractionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all interactions for the selected client ( not filtered to the current client/study )
     */
    getClientInteractions( cancelToken?: CancelToken): Promise<InteractionModel[]> {
        let url_ = this.baseUrl + "/api/interactions/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientInteractions(_response));
        });
    }

    protected processGetClientInteractions(response: AxiosResponse): Promise<InteractionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InteractionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InteractionModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionModel[]>(null as any);
    }

    /**
     * Get all interactions for the selected client and study
     */
    getInteractions( cancelToken?: CancelToken): Promise<InteractionSummaryModel[]> {
        let url_ = this.baseUrl + "/api/interactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteractions(_response));
        });
    }

    protected processGetInteractions(response: AxiosResponse): Promise<InteractionSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InteractionSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InteractionSummaryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionSummaryModel[]>(null as any);
    }

    /**
     * Create a new interaction
     */
    postInteraction(interaction: InteractionModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interaction);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInteraction(_response));
        });
    }

    protected processPostInteraction(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get all interactions and details for the selected client
     */
    getInteractionsAndQuestions( cancelToken?: CancelToken): Promise<InteractionExportModel[]> {
        let url_ = this.baseUrl + "/api/interactions/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteractionsAndQuestions(_response));
        });
    }

    protected processGetInteractionsAndQuestions(response: AxiosResponse): Promise<InteractionExportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InteractionExportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InteractionExportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionExportModel[]>(null as any);
    }

    /**
     * Get a specific interaction
     */
    getInteraction(id: number, cancelToken?: CancelToken): Promise<InteractionModel> {
        let url_ = this.baseUrl + "/api/interactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<InteractionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionModel.fromJS(resultData200);
            return Promise.resolve<InteractionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionModel>(null as any);
    }

    /**
     * Update an interaction
     */
    putInteraction(id: number, interaction: InteractionModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interaction);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutInteraction(_response));
        });
    }

    protected processPutInteraction(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Delete the specified interaction
     */
    deleteInteraction(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/interactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInteraction(_response));
        });
    }

    protected processDeleteInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyInteraction(id: number, toSite: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions/import/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSite);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCopyInteraction(_response));
        });
    }

    protected processCopyInteraction(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    rescoreInteraction(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/interactions/Rescore/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRescoreInteraction(_response));
        });
    }

    protected processRescoreInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve the available interactions that can be used with a trigger.
     */
    getAvailableTriggerInteractions( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/interactions/ForTrigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableTriggerInteractions(_response));
        });
    }

    protected processGetAvailableTriggerInteractions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Retrieve the id of the prescription interaction
     */
    getPrescriptionInteractionId( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions/PrescriptionInteractionId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPrescriptionInteractionId(_response));
        });
    }

    protected processGetPrescriptionInteractionId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Retrieves the ID of the LabWork interaction.
     */
    getLabWorkInteractionId( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions/LabWorkInteractionId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLabWorkInteractionId(_response));
        });
    }

    protected processGetLabWorkInteractionId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Retrieves the ID of the Medications interaction.
     */
    getMedicationsInteractionId( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/interactions/MedicationsInteractionId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMedicationsInteractionId(_response));
        });
    }

    protected processGetMedicationsInteractionId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Retrieves the patient chart interaction IDs.
     */
    getPatientChartInteractionIds( cancelToken?: CancelToken): Promise<LumediMWMInteractionIds> {
        let url_ = this.baseUrl + "/api/interactions/interactionIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientChartInteractionIds(_response));
        });
    }

    protected processGetPatientChartInteractionIds(response: AxiosResponse): Promise<LumediMWMInteractionIds> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LumediMWMInteractionIds.fromJS(resultData200);
            return Promise.resolve<LumediMWMInteractionIds>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Sets the default interaction ID for an interaction type.
     * @param settingName (optional) 
     * @param interactionId (optional) 
     */
    setDefaultInteractionId(settingName: string | null | undefined, interactionId: number | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/interactions/interactionId?";
        if (settingName !== undefined && settingName !== null)
            url_ += "settingName=" + encodeURIComponent("" + settingName) + "&";
        if (interactionId !== undefined && interactionId !== null)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetDefaultInteractionId(_response));
        });
    }

    protected processSetDefaultInteractionId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Export a json definition of an interaction.
     */
    getJsonExport(interactionId: number, cancelToken?: CancelToken): Promise<InteractionJsonExportModel> {
        let url_ = this.baseUrl + "/api/interactions/export-json/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJsonExport(_response));
        });
    }

    protected processGetJsonExport(response: AxiosResponse): Promise<InteractionJsonExportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionJsonExportModel.fromJS(resultData200);
            return Promise.resolve<InteractionJsonExportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionJsonExportModel>(null as any);
    }

    /**
     * Import an interaction from its json definition.
     */
    importJson(model: InteractionJsonImportModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/interactions/import-json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportJson(_response));
        });
    }

    protected processImportJson(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Preview an interaction update from its json definition.
     */
    previewUpdateJson(model: InteractionJsonImportModel, cancelToken?: CancelToken): Promise<InteractionUpdatePreview> {
        let url_ = this.baseUrl + "/api/interactions/preview-update-json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPreviewUpdateJson(_response));
        });
    }

    protected processPreviewUpdateJson(response: AxiosResponse): Promise<InteractionUpdatePreview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionUpdatePreview.fromJS(resultData200);
            return Promise.resolve<InteractionUpdatePreview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionUpdatePreview>(null as any);
    }

    /**
     * Update an existing interaction from its json definition.
     */
    updateJson(model: InteractionJsonImportModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/interactions/update-json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateJson(_response));
        });
    }

    protected processUpdateJson(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class InvestigationClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInvestigations(status: InvestigationStatus | undefined, patientID: string | null | undefined, cancelToken?: CancelToken): Promise<InvestigationModel[]> {
        let url_ = this.baseUrl + "/api/investigation?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (patientID !== undefined && patientID !== null)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvestigations(_response));
        });
    }

    protected processGetInvestigations(response: AxiosResponse): Promise<InvestigationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestigationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvestigationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvestigationModel[]>(null as any);
    }

    /**
     * Create a new investigation
     */
    postInvestigation(model: NewInvestigationModel, cancelToken?: CancelToken): Promise<InvestigationModel> {
        let url_ = this.baseUrl + "/api/investigation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInvestigation(_response));
        });
    }

    protected processPostInvestigation(response: AxiosResponse): Promise<InvestigationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvestigationModel.fromJS(resultData200);
            return Promise.resolve<InvestigationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvestigationModel>(null as any);
    }

    getInvestigation(id: string, cancelToken?: CancelToken): Promise<InvestigationModel> {
        let url_ = this.baseUrl + "/api/investigation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvestigation(_response));
        });
    }

    protected processGetInvestigation(response: AxiosResponse): Promise<InvestigationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvestigationModel.fromJS(resultData200);
            return Promise.resolve<InvestigationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvestigationModel>(null as any);
    }
}

export class LabWorkClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the lab work list for a patient's chart.
     * @param patientId (optional) The patient identifier.
     */
    getLabWorkList(patientId: string | undefined, cancelToken?: CancelToken): Promise<LabWorkSummaryModel[]> {
        let url_ = this.baseUrl + "/api/LabWork/labWorkList?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLabWorkList(_response));
        });
    }

    protected processGetLabWorkList(response: AxiosResponse): Promise<LabWorkSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabWorkSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LabWorkSummaryModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class MedicationsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the medications list for a patient's chart.
     * @param patientId (optional) The patient identifier.
     */
    getMedicationList(patientId: string | undefined, cancelToken?: CancelToken): Promise<MedicationListModel> {
        let url_ = this.baseUrl + "/api/Medications/medicationList?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMedicationList(_response));
        });
    }

    protected processGetMedicationList(response: AxiosResponse): Promise<MedicationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MedicationListModel.fromJS(resultData200);
            return Promise.resolve<MedicationListModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class MenuClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Produce top-level menus for the selected client
     * @param isStudy (optional) 
     */
    getMenu(isStudy: boolean | undefined, cancelToken?: CancelToken): Promise<MenuInfo> {
        let url_ = this.baseUrl + "/api/menu?";
        if (isStudy === null)
            throw new Error("The parameter 'isStudy' cannot be null.");
        else if (isStudy !== undefined)
            url_ += "isStudy=" + encodeURIComponent("" + isStudy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMenu(_response));
        });
    }

    protected processGetMenu(response: AxiosResponse): Promise<MenuInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MenuInfo.fromJS(resultData200);
            return Promise.resolve<MenuInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuInfo>(null as any);
    }
}

export class OfflineInteractionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get the specified offline interaction
     */
    getOfflineInteraction(id: string, cancelToken?: CancelToken): Promise<OfflineInteractionModel> {
        let url_ = this.baseUrl + "/api/offlineinteraction/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOfflineInteraction(_response));
        });
    }

    protected processGetOfflineInteraction(response: AxiosResponse): Promise<OfflineInteractionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfflineInteractionModel.fromJS(resultData200);
            return Promise.resolve<OfflineInteractionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfflineInteractionModel>(null as any);
    }

    /**
     * Create an offline interaction
     */
    postOfflineInteraction(model: NewOfflineInteractionModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/offlineinteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostOfflineInteraction(_response));
        });
    }

    protected processPostOfflineInteraction(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Set the offline interaction as used
     */
    putOfflineInteraction(model: CompleteOfflineInteractionModel, id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/offlineinteraction/completed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutOfflineInteraction(_response));
        });
    }

    protected processPutOfflineInteraction(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Log in to the application.  Currently cookies are issued for protecting the API.
     */
    getOfflineUser(id: string, cancelToken?: CancelToken): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/offlineinteraction/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOfflineUser(_response));
        });
    }

    protected processGetOfflineUser(response: AxiosResponse): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenResponse.fromJS(resultData200);
            return Promise.resolve<TokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenResponse>(null as any);
    }
}

export class PatientInteractionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get patient interactions for the specified patient
     * @param patientID (optional) 
     */
    getPatientInteractions(studyId: string, patientID: string | undefined, cancelToken?: CancelToken): Promise<PatientInteraction[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientID === null)
            throw new Error("The parameter 'patientID' cannot be null.");
        else if (patientID !== undefined)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientInteractions(_response));
        });
    }

    protected processGetPatientInteractions(response: AxiosResponse): Promise<PatientInteraction[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientInteraction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientInteraction[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientInteraction[]>(null as any);
    }

    /**
     * Create a new patient interaction
     */
    postInteraction(studyId: string, patientInteraction: PatientInteraction, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientInteraction);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInteraction(_response));
        });
    }

    protected processPostInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the specified patient interaction
     */
    getPatientInteraction(studyId: string, id: number, cancelToken?: CancelToken): Promise<PatientInteraction> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientInteraction(_response));
        });
    }

    protected processGetPatientInteraction(response: AxiosResponse): Promise<PatientInteraction> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientInteraction.fromJS(resultData200);
            return Promise.resolve<PatientInteraction>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientInteraction>(null as any);
    }

    /**
     * Update the specified patient interaction
     */
    putInteraction(studyId: string, id: number, patientInteraction: PatientInteraction, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientInteraction);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutInteraction(_response));
        });
    }

    protected processPutInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified patient interaction
     */
    deletePatientInteraction(studyId: string, id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeletePatientInteraction(_response));
        });
    }

    protected processDeletePatientInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Flag the specified patient interaction
     */
    flagInteraction(studyId: string, id: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions/flag/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFlagInteraction(_response));
        });
    }

    protected processFlagInteraction(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the specified patient interaction's Verified status (for monitoring purposes)
     */
    verifyInteraction(studyId: string, id: number, model: PatientInteractionVerify, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patientinteractions/verify/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processVerifyInteraction(_response));
        });
    }

    protected processVerifyInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doCreateEmptyPatientAndRedirectToInteraction(languageCode: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patient/doCreateEmptyPatientAndRedirectToInteraction?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCreateEmptyPatientAndRedirectToInteraction(_response));
        });
    }

    protected processDoCreateEmptyPatientAndRedirectToInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 302) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve a list of patients for the selected client
     * @param uniqueId (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param status (optional) 
     * @param siteId (optional) 
     * @param phone (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param neverScheduled (optional) 
     */
    getPatients(studyId: string, uniqueId: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, status: string | null | undefined, siteId: string | null | undefined, phone: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, neverScheduled: boolean | null | undefined, cancelToken?: CancelToken): Promise<PatientModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (uniqueId !== undefined && uniqueId !== null)
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (neverScheduled !== undefined && neverScheduled !== null)
            url_ += "neverScheduled=" + encodeURIComponent("" + neverScheduled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatients(_response));
        });
    }

    protected processGetPatients(response: AxiosResponse): Promise<PatientModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientModel[]>(null as any);
    }

    /**
     * Retrieve a specific patient for the selected client
     * @param includeExtendedInformation (optional) 
     */
    getPatient(studyId: string, id: string, includeExtendedInformation: boolean | undefined, cancelToken?: CancelToken): Promise<PatientModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{id}?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeExtendedInformation === null)
            throw new Error("The parameter 'includeExtendedInformation' cannot be null.");
        else if (includeExtendedInformation !== undefined)
            url_ += "includeExtendedInformation=" + encodeURIComponent("" + includeExtendedInformation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatient(_response));
        });
    }

    protected processGetPatient(response: AxiosResponse): Promise<PatientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientModel.fromJS(resultData200);
            return Promise.resolve<PatientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientModel>(null as any);
    }

    /**
     * Retrieve a report for the specified patient/report and selected client
     * @param patientID (optional) 
     * @param reportID (optional) 
     * @param conversion (optional) 
     */
    getReport(studyId: string, patientID: string | undefined, reportID: string | undefined, conversion: string | null | undefined, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientID === null)
            throw new Error("The parameter 'patientID' cannot be null.");
        else if (patientID !== undefined)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        if (reportID === null)
            throw new Error("The parameter 'reportID' cannot be null.");
        else if (reportID !== undefined)
            url_ += "reportID=" + encodeURIComponent("" + reportID) + "&";
        if (conversion !== undefined && conversion !== null)
            url_ += "conversion=" + encodeURIComponent("" + conversion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    /**
     * Post a view event for the selected client
     */
    postView(studyId: string, model: PatientViewModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/view";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostView(_response));
        });
    }

    protected processPostView(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    validateEmaCode(appCode: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patients/validateCode?";
        if (appCode !== undefined && appCode !== null)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processValidateEmaCode(_response));
        });
    }

    protected processValidateEmaCode(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getActiveOfflineInteractions( cancelToken?: CancelToken): Promise<AutomatedOfflineInteractionModel[]> {
        let url_ = this.baseUrl + "/api/patients/isCodeActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveOfflineInteractions(_response));
        });
    }

    protected processGetActiveOfflineInteractions(response: AxiosResponse): Promise<AutomatedOfflineInteractionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutomatedOfflineInteractionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AutomatedOfflineInteractionModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutomatedOfflineInteractionModel[]>(null as any);
    }

    postPatientStub(studyId: string, patientStubModel: PatientStubModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/patients/stub";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientStubModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostPatientStub(_response));
        });
    }

    protected processPostPatientStub(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Retrieve obesity counters for a patient
     */
    getPatientObesityCounters(studyId: string, patientId: string, cancelToken?: CancelToken): Promise<PatientObesityModuleSummary> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{patientId}/obesityCounters";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientObesityCounters(_response));
        });
    }

    protected processGetPatientObesityCounters(response: AxiosResponse): Promise<PatientObesityModuleSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientObesityModuleSummary.fromJS(resultData200);
            return Promise.resolve<PatientObesityModuleSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientObesityModuleSummary>(null as any);
    }

    /**
     * Retrieve obesity counters for a patient
     * @param status (optional) 
     */
    getPatientVisitSummaryForStatus(studyId: string, patientId: string, status: PatientStatus | null | undefined, cancelToken?: CancelToken): Promise<PatientVisitSummary> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{patientId}/visitSummary?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientVisitSummaryForStatus(_response));
        });
    }

    protected processGetPatientVisitSummaryForStatus(response: AxiosResponse): Promise<PatientVisitSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientVisitSummary.fromJS(resultData200);
            return Promise.resolve<PatientVisitSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientVisitSummary>(null as any);
    }

    /**
     * Gets appointments for a patient
     */
    getPatientAppointments(patientId: string, studyId: string, cancelToken?: CancelToken): Promise<PublicPatientAppointmentModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{patientId}/appointments";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAppointments(_response));
        });
    }

    protected processGetPatientAppointments(response: AxiosResponse): Promise<PublicPatientAppointmentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientAppointmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicPatientAppointmentModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientAppointmentModel[]>(null as any);
    }

    /**
     * Retrieve face sheet stats for a patient.
     */
    getFaceSheetStats(studyId: string, patientId: string, cancelToken?: CancelToken): Promise<GetPatientFaceSheetStatsResponse> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{patientId}/faceSheet";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFaceSheetStats(_response));
        });
    }

    protected processGetFaceSheetStats(response: AxiosResponse): Promise<GetPatientFaceSheetStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientFaceSheetStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientFaceSheetStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientFaceSheetStatsResponse>(null as any);
    }

    /**
     * Retrieve a specific patient for the selected client
     */
    getPatientProfile(studyId: string, patientId: string, cancelToken?: CancelToken): Promise<GetPatientProfileResponse> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/{patientId}/profile";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientProfile(_response));
        });
    }

    protected processGetPatientProfile(response: AxiosResponse): Promise<GetPatientProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientProfileResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientProfileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientProfileResponse>(null as any);
    }

    getPendingAdminOverviewCalls(studyId: string, cancelToken?: CancelToken): Promise<GetPendingAdminOverviewCallResponse[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/pendingAdminOverviewCall";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPendingAdminOverviewCalls(_response));
        });
    }

    protected processGetPendingAdminOverviewCalls(response: AxiosResponse): Promise<GetPendingAdminOverviewCallResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPendingAdminOverviewCallResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetPendingAdminOverviewCallResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPendingAdminOverviewCallResponse[]>(null as any);
    }

    getNotPerformantPayments(studyId: string, cancelToken?: CancelToken): Promise<GetNonPerformantPaymentResponse[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/notPerformantPayment";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNotPerformantPayments(_response));
        });
    }

    protected processGetNotPerformantPayments(response: AxiosResponse): Promise<GetNonPerformantPaymentResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetNonPerformantPaymentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetNonPerformantPaymentResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNonPerformantPaymentResponse[]>(null as any);
    }

    getMissedAppointments(studyId: string, cancelToken?: CancelToken): Promise<GetMissedAppointmentsResponse[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/participants/missedAppointments";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMissedAppointments(_response));
        });
    }

    protected processGetMissedAppointments(response: AxiosResponse): Promise<GetMissedAppointmentsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetMissedAppointmentsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetMissedAppointmentsResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissedAppointmentsResponse[]>(null as any);
    }

    get(studyId: string | undefined, uniqueId: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, status: string | null | undefined, siteId: string | null | undefined, cancelToken?: CancelToken): Promise<SearchedPatient[]> {
        let url_ = this.baseUrl + "/api/v1/patients?";
        if (studyId === null)
            throw new Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (uniqueId !== undefined && uniqueId !== null)
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<SearchedPatient[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchedPatient.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchedPatient[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchedPatient[]>(null as any);
    }
}

export class ReportClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a new report for the selected client
     * @param file (optional) 
     */
    postReport(studyId: string, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<ReportModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostReport(_response));
        });
    }

    protected processPostReport(response: AxiosResponse): Promise<ReportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportModel.fromJS(resultData200);
            return Promise.resolve<ReportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportModel>(null as any);
    }

    /**
     * List reports for the selected client
     * @param reportType (optional) 
     */
    getReports(studyId: string, reportType: ReportType | undefined, cancelToken?: CancelToken): Promise<ReportModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/reports?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReports(_response));
        });
    }

    protected processGetReports(response: AxiosResponse): Promise<ReportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportModel[]>(null as any);
    }

    /**
     * Retrieve a report for the selected client
     */
    getReport(id: string, studyId: string, cancelToken?: CancelToken): Promise<ReportModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<ReportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportModel.fromJS(resultData200);
            return Promise.resolve<ReportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportModel>(null as any);
    }

    /**
     * Update the specified report for the selected client
     */
    putReport(studyId: string, id: string, model: ReportModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutReport(_response));
        });
    }

    protected processPutReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified report for the selected client
     */
    deleteReport(id: string, studyId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteReport(_response));
        });
    }

    protected processDeleteReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download a report template for the selected client
     */
    getDownload(studyId: string, id: string, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/report/download/{id}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDownload(_response));
        });
    }

    protected processGetDownload(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    /**
     * Get the interaction stuffy stuff - TODO needs to factor in client/site restrictions to patient data
     * @param id Interaction id
     * @param identifying (optional) 
     * @param latest (optional) 
     * @param blankReplacement (optional) 
     * @param enrolled (optional) 
     * @param format (optional) 
     * @deprecated
     */
    getInteraction(id: number, identifying: boolean | undefined, latest: boolean | undefined, blankReplacement: string | null | undefined, enrolled: boolean | undefined, format: string | null | undefined, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/interaction/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (identifying === null)
            throw new Error("The parameter 'identifying' cannot be null.");
        else if (identifying !== undefined)
            url_ += "identifying=" + encodeURIComponent("" + identifying) + "&";
        if (latest === null)
            throw new Error("The parameter 'latest' cannot be null.");
        else if (latest !== undefined)
            url_ += "latest=" + encodeURIComponent("" + latest) + "&";
        if (blankReplacement !== undefined && blankReplacement !== null)
            url_ += "blankReplacement=" + encodeURIComponent("" + blankReplacement) + "&";
        if (enrolled === null)
            throw new Error("The parameter 'enrolled' cannot be null.");
        else if (enrolled !== undefined)
            url_ += "enrolled=" + encodeURIComponent("" + enrolled) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    /**
     * Export global stuffy stuff TODO - needs to factor in client/site restrictions to patients
     * @param blankReplacement (optional) 
     * @param format (optional) 
     * @param timepoint (optional) 
     * @param patientID (optional) 
     * @deprecated
     */
    getGlobal(questionIDs: number[], blankReplacement: string | null | undefined, format: string | null | undefined, timepoint: string | null | undefined, patientID: string | null | undefined, cancelToken?: CancelToken): Promise<Stream> {
        let url_ = this.baseUrl + "/api/global?";
        if (blankReplacement !== undefined && blankReplacement !== null)
            url_ += "blankReplacement=" + encodeURIComponent("" + blankReplacement) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (timepoint !== undefined && timepoint !== null)
            url_ += "timepoint=" + encodeURIComponent("" + timepoint) + "&";
        if (patientID !== undefined && patientID !== null)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionIDs);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGlobal(_response));
        });
    }

    protected processGetGlobal(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }
}

export class PatientWeightClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the weight history for a patient.
     * @param patientId The patient identifier.
     */
    get(patientId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientWeight/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class PaymentsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doRedirectToSendPaymentLinkInteraction(patientId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Payments/interactionRedirect?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoRedirectToSendPaymentLinkInteraction(_response));
        });
    }

    protected processDoRedirectToSendPaymentLinkInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    doRedirectToSendOnGoingPaymentLinkInteraction(patientId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Payments/interactionRedirectOnGoingSupportPayment?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoRedirectToSendOnGoingPaymentLinkInteraction(_response));
        });
    }

    protected processDoRedirectToSendOnGoingPaymentLinkInteraction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    generatePrivateSitePaymentLink(patientId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Payments/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeneratePrivateSitePaymentLink(_response));
        });
    }

    protected processGeneratePrivateSitePaymentLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    mercadoPagoWebhookCall(request: MercadoPagoWebhookEvent, xSignature: string | null | undefined, requestId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Payments/mpago-webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "x-signature": xSignature !== undefined && xSignature !== null ? "" + xSignature : "",
                "x-request-id": requestId !== undefined && requestId !== null ? "" + requestId : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMercadoPagoWebhookCall(_response));
        });
    }

    protected processMercadoPagoWebhookCall(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    webhookCall( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Payments/call";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWebhookCall(_response));
        });
    }

    protected processWebhookCall(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PhysicianClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get physicians for the study in context.
     * @param studyId The studyId associated with physician.
     * @param country (optional) The country to filter physicians by. If provided, must be an exact match.
     * @param province (optional) The province to filter physicians by. If provided, must be an exact match.
     * @param city (optional) The city to filter physicians by. Is a partial match.
     * @param firstName (optional) Physician first name
     * @param lastName (optional) Physician last name
     * @param showUnvalidated (optional) Whether to show or hide unvalidated
     */
    getPhysiciansForStudy(studyId: string, country: string | null | undefined, province: string | null | undefined, city: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, showUnvalidated: boolean | null | undefined, cancelToken?: CancelToken): Promise<PhysicianModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (province !== undefined && province !== null)
            url_ += "province=" + encodeURIComponent("" + province) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (showUnvalidated !== undefined && showUnvalidated !== null)
            url_ += "showUnvalidated=" + encodeURIComponent("" + showUnvalidated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysiciansForStudy(_response));
        });
    }

    protected processGetPhysiciansForStudy(response: AxiosResponse): Promise<PhysicianModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhysicianModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PhysicianModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhysicianModel[]>(null as any);
    }

    /**
     * Create a new physician entity for the study in context.
     * @param studyId The studyId associated with physician.
     * @param model The model containing the physician information.
     */
    createPhysician(studyId: string, model: CreatePhysicianModel, cancelToken?: CancelToken): Promise<PhysicianModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreatePhysician(_response));
        });
    }

    protected processCreatePhysician(response: AxiosResponse): Promise<PhysicianModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PhysicianModel.fromJS(resultData200);
            return Promise.resolve<PhysicianModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhysicianModel>(null as any);
    }

    /**
     * Get a physician by their id for the study in context.
     * @param physicianID The id of the physician to retrieve.
     */
    getPhysician(studyId: string, physicianID: string, cancelToken?: CancelToken): Promise<PhysicianModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians/{physicianID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (physicianID === undefined || physicianID === null)
            throw new Error("The parameter 'physicianID' must be defined.");
        url_ = url_.replace("{physicianID}", encodeURIComponent("" + physicianID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysician(_response));
        });
    }

    protected processGetPhysician(response: AxiosResponse): Promise<PhysicianModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PhysicianModel.fromJS(resultData200);
            return Promise.resolve<PhysicianModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhysicianModel>(null as any);
    }

    /**
     * Update the details of a physician entity.
     * @param studyId The studyId associated with physician.
     * @param physicianID The id of the physician being updated.
     * @param model The model containing the new physician information.
     */
    updatePhysician(studyId: string, physicianID: string, model: CreatePhysicianModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians/{physicianID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (physicianID === undefined || physicianID === null)
            throw new Error("The parameter 'physicianID' must be defined.");
        url_ = url_.replace("{physicianID}", encodeURIComponent("" + physicianID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePhysician(_response));
        });
    }

    protected processUpdatePhysician(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Delete a physician entity.
     * @param studyId The studyId associated with physician.
     * @param physicianID The id of the physician to delete.
     */
    deletePhysician(studyId: string, physicianID: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians/{physicianID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (physicianID === undefined || physicianID === null)
            throw new Error("The parameter 'physicianID' must be defined.");
        url_ = url_.replace("{physicianID}", encodeURIComponent("" + physicianID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeletePhysician(_response));
        });
    }

    protected processDeletePhysician(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Import physicians into the study in context.
     * @param studyId The studyId associated with physician.
     * @param file (optional) The CSV file to import.
     */
    importPhysicians(studyId: string, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/physicians/import";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImportPhysicians(_response));
        });
    }

    protected processImportPhysicians(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Download a CSV template containing the header information for a physician import.
     * @return .CSV file download containing the header row for the import.
     */
    downloadTemplate( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/physicians/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadTemplate(_response));
        });
    }

    protected processDownloadTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProductsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    productsGet(request: ParameterlessPaginatedRequest, cancelToken?: CancelToken): Promise<PaginatedResponseOfProductDto> {
        let url_ = this.baseUrl + "/api/Products/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProductsGet(_response));
        });
    }

    protected processProductsGet(response: AxiosResponse): Promise<PaginatedResponseOfProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfProductDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfProductDto>(null as any);
    }

    productsGetSingleFull(productId: string, cancelToken?: CancelToken): Promise<ProductDto> {
        let url_ = this.baseUrl + "/api/Products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProductsGetSingleFull(_response));
        });
    }

    protected processProductsGetSingleFull(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return Promise.resolve<ProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(null as any);
    }

    productsUpsert(product: ProductDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProductsUpsert(_response));
        });
    }

    protected processProductsUpsert(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProvinceStateClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all provinces or states for the selected country
     * @param countryCode (optional) 
     */
    getProvinceStates(countryCode: string | null | undefined, cancelToken?: CancelToken): Promise<ProvinceStateModel[]> {
        let url_ = this.baseUrl + "/api/ProvinceState?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProvinceStates(_response));
        });
    }

    protected processGetProvinceStates(response: AxiosResponse): Promise<ProvinceStateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceStateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProvinceStateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProvinceStateModel[]>(null as any);
    }
}

export class QuestionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get questions for the specified interaction
     * @param interactionID (optional) 
     */
    getQuestions(interactionID: number | undefined, cancelToken?: CancelToken): Promise<Question[]> {
        let url_ = this.baseUrl + "/api/questions?";
        if (interactionID === null)
            throw new Error("The parameter 'interactionID' cannot be null.");
        else if (interactionID !== undefined)
            url_ += "interactionID=" + encodeURIComponent("" + interactionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestions(_response));
        });
    }

    protected processGetQuestions(response: AxiosResponse): Promise<Question[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Question.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Question[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Question[]>(null as any);
    }

    /**
     * Create a new question
     */
    postQuestion(question: Question, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(question);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostQuestion(_response));
        });
    }

    protected processPostQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the specified question
     */
    getQuestion(id: number, cancelToken?: CancelToken): Promise<Question> {
        let url_ = this.baseUrl + "/api/questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestion(_response));
        });
    }

    protected processGetQuestion(response: AxiosResponse): Promise<Question> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Question.fromJS(resultData200);
            return Promise.resolve<Question>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Question>(null as any);
    }

    /**
     * Update the specified question
     */
    putQuestion(id: number, question: Question, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(question);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutQuestion(_response));
        });
    }

    protected processPutQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark a question as inactive (i.e. soft delete)
     */
    deleteQuestion(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteQuestion(_response));
        });
    }

    protected processDeleteQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a blank question
     */
    getBlankQuestion(questionType: QuestionType, cancelToken?: CancelToken): Promise<Question> {
        let url_ = this.baseUrl + "/api/questions/blank/{questionType}";
        if (questionType === undefined || questionType === null)
            throw new Error("The parameter 'questionType' must be defined.");
        url_ = url_.replace("{questionType}", encodeURIComponent("" + questionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBlankQuestion(_response));
        });
    }

    protected processGetBlankQuestion(response: AxiosResponse): Promise<Question> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Question.fromJS(resultData200);
            return Promise.resolve<Question>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Question>(null as any);
    }
}

export class SitesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all sites for the selected client which the logged in user has access to
     * @param isFromAdminSection (optional) If this is being called from an admin page section where
                we want to restrict to only sites which the user has Administrator access to.
     */
    getSites(isFromAdminSection: boolean | undefined, cancelToken?: CancelToken): Promise<SiteModel[]> {
        let url_ = this.baseUrl + "/api/sites?";
        if (isFromAdminSection === null)
            throw new Error("The parameter 'isFromAdminSection' cannot be null.");
        else if (isFromAdminSection !== undefined)
            url_ += "isFromAdminSection=" + encodeURIComponent("" + isFromAdminSection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSites(_response));
        });
    }

    protected processGetSites(response: AxiosResponse): Promise<SiteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SiteModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteModel[]>(null as any);
    }

    /**
     * Create a new site
     */
    postSite(site: SiteModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(site);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostSite(_response));
        });
    }

    protected processPostSite(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get Site by id
     * @param id Site id
     */
    getSite(id: string, cancelToken?: CancelToken): Promise<SiteModel[]> {
        let url_ = this.baseUrl + "/api/sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSite(_response));
        });
    }

    protected processGetSite(response: AxiosResponse): Promise<SiteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SiteModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteModel[]>(null as any);
    }

    /**
     * Update an interaction
     */
    putSite(id: string, site: SiteModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(site);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutSite(_response));
        });
    }

    protected processPutSite(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StudyClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all studies which the logged in user has access to for the selected client
     * @param isFromAdminSection (optional) If the API endpoint is being called from the admin section
                then we will only include studies (and associated sites) for which the user has Administrator
                access.
     */
    getStudies(isFromAdminSection: boolean | undefined, cancelToken?: CancelToken): Promise<StudyModel[]> {
        let url_ = this.baseUrl + "/api/study?";
        if (isFromAdminSection === null)
            throw new Error("The parameter 'isFromAdminSection' cannot be null.");
        else if (isFromAdminSection !== undefined)
            url_ += "isFromAdminSection=" + encodeURIComponent("" + isFromAdminSection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudies(_response));
        });
    }

    protected processGetStudies(response: AxiosResponse): Promise<StudyModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyModel[]>(null as any);
    }

    /**
     * Create a new study associated to the selected client
     */
    createStudy(model: StudyModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateStudy(_response));
        });
    }

    protected processCreateStudy(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Get the specific study
     * @param isFromAdminSection (optional) If the API endpoint is being called from the admin section
                then we will only include sites associated with the study for which the user has Administrator
                access.
     */
    getStudy(id: string, isFromAdminSection: boolean | undefined, cancelToken?: CancelToken): Promise<StudyModel> {
        let url_ = this.baseUrl + "/api/study/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isFromAdminSection === null)
            throw new Error("The parameter 'isFromAdminSection' cannot be null.");
        else if (isFromAdminSection !== undefined)
            url_ += "isFromAdminSection=" + encodeURIComponent("" + isFromAdminSection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudy(_response));
        });
    }

    protected processGetStudy(response: AxiosResponse): Promise<StudyModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyModel.fromJS(resultData200);
            return Promise.resolve<StudyModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyModel>(null as any);
    }

    /**
     * Update an existing study associated with the selected client
     */
    updateStudy(id: string, model: StudyModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudy(_response));
        });
    }

    protected processUpdateStudy(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateStudyPublicSettings(id: string, model: StudySummary, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/PublicSiteSettings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyPublicSettings(_response));
        });
    }

    protected processUpdateStudyPublicSettings(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateStudySettings(id: string, model: StudySummary, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/settings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudySettings(_response));
        });
    }

    protected processUpdateStudySettings(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Get the Dashboard information for the current logged in user's selected study
     */
    getCurrentStudyDashboard(studyId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/{studyId}/dashboard";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentStudyDashboard(_response));
        });
    }

    protected processGetCurrentStudyDashboard(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the Welcome page information for the logged in user's selected study.
    Will create the default system interactions for the study if the study's setup is not complete.
     */
    getCurrentStudyWelcome( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/Welcome";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentStudyWelcome(_response));
        });
    }

    protected processGetCurrentStudyWelcome(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Creates selected optional system/default interactions for a study.
     */
    addDefaultInteraction(systemInteraction: WelcomeStudyInteractionModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/AddInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemInteraction);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddDefaultInteraction(_response));
        });
    }

    protected processAddDefaultInteraction(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Send the Feedback email
     * @param studyId Study in context
     */
    sendFeedback(studyId: string, feedback: FeedbackModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/study/{studyId}/feedback";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendFeedback(_response));
        });
    }

    protected processSendFeedback(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TaskClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List tasks
     * @param start (optional) 
     * @param end (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param patientID (optional) 
     */
    getTasks(start: Date | null | undefined, end: Date | null | undefined, status: TaskStatus | undefined, type: TaskType | undefined, patientID: string | null | undefined, cancelToken?: CancelToken): Promise<TaskModel[]> {
        let url_ = this.baseUrl + "/api/task?";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (patientID !== undefined && patientID !== null)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: AxiosResponse): Promise<TaskModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel[]>(null as any);
    }

    /**
     * Create a new task
     */
    postTask(model: TaskModel, cancelToken?: CancelToken): Promise<TaskModel> {
        let url_ = this.baseUrl + "/api/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostTask(_response));
        });
    }

    protected processPostTask(response: AxiosResponse): Promise<TaskModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskModel.fromJS(resultData200);
            return Promise.resolve<TaskModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel>(null as any);
    }

    /**
     * List tasks
     * @param start (optional) 
     * @param end (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param patientID (optional) 
     */
    getCalendarEvents(start: Date | null | undefined, end: Date | null | undefined, status: TaskStatus | undefined, type: TaskType | undefined, patientID: string | null | undefined, cancelToken?: CancelToken): Promise<CalendarEventFeedModel[]> {
        let url_ = this.baseUrl + "/api/task/calendar?";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (patientID !== undefined && patientID !== null)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCalendarEvents(_response));
        });
    }

    protected processGetCalendarEvents(response: AxiosResponse): Promise<CalendarEventFeedModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarEventFeedModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalendarEventFeedModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarEventFeedModel[]>(null as any);
    }

    hasConflict(scheduledOnDate: string | null | undefined, scheduledOnTime: string | null | undefined, durationInMinutes: number | null | undefined, taskId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/task/conflict?";
        if (scheduledOnDate !== undefined && scheduledOnDate !== null)
            url_ += "scheduledOnDate=" + encodeURIComponent("" + scheduledOnDate) + "&";
        if (scheduledOnTime !== undefined && scheduledOnTime !== null)
            url_ += "scheduledOnTime=" + encodeURIComponent("" + scheduledOnTime) + "&";
        if (durationInMinutes !== undefined && durationInMinutes !== null)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHasConflict(_response));
        });
    }

    protected processHasConflict(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Get list of scheduled questionnaire packages
     * @param timepoint (optional) 
     * @param status (optional) 
     */
    getPackages(timepoint: number | undefined, status: TaskStatus | undefined, cancelToken?: CancelToken): Promise<TaskModel[]> {
        let url_ = this.baseUrl + "/api/task/Packages?";
        if (timepoint === null)
            throw new Error("The parameter 'timepoint' cannot be null.");
        else if (timepoint !== undefined)
            url_ += "timepoint=" + encodeURIComponent("" + timepoint) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPackages(_response));
        });
    }

    protected processGetPackages(response: AxiosResponse): Promise<TaskModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel[]>(null as any);
    }

    completePackage(model: CompletePackageModel, cancelToken?: CancelToken): Promise<TaskModel> {
        let url_ = this.baseUrl + "/api/task/CompletePackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompletePackage(_response));
        });
    }

    protected processCompletePackage(response: AxiosResponse): Promise<TaskModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskModel.fromJS(resultData200);
            return Promise.resolve<TaskModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel>(null as any);
    }

    emailInteraction(model: EmailInteractionModel, cancelToken?: CancelToken): Promise<TaskModel> {
        let url_ = this.baseUrl + "/api/task/EmailInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEmailInteraction(_response));
        });
    }

    protected processEmailInteraction(response: AxiosResponse): Promise<TaskModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskModel.fromJS(resultData200);
            return Promise.resolve<TaskModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel>(null as any);
    }

    /**
     * Get the specified task
     */
    getTask(id: string, cancelToken?: CancelToken): Promise<TaskModel> {
        let url_ = this.baseUrl + "/api/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTask(_response));
        });
    }

    protected processGetTask(response: AxiosResponse): Promise<TaskModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskModel.fromJS(resultData200);
            return Promise.resolve<TaskModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskModel>(null as any);
    }

    /**
     * Update the specified task
     */
    putTask(id: string, model: TaskModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTask(_response));
        });
    }

    protected processPutTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the specified task
     */
    deleteTask(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/task/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTask(_response));
        });
    }

    protected processDeleteTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TimepointsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * List all timepoints belonging to the study for the selected client
     */
    getTimepoints( cancelToken?: CancelToken): Promise<Timepoint[]> {
        let url_ = this.baseUrl + "/api/timepoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimepoints(_response));
        });
    }

    protected processGetTimepoints(response: AxiosResponse): Promise<Timepoint[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Timepoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Timepoint[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Timepoint[]>(null as any);
    }

    saveTimepoints(timepoints: Timepoint[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/timepoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timepoints);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTimepoints(_response));
        });
    }

    protected processSaveTimepoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TokenClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Log in to the application.  Currently cookies are issued for protecting the API.
     * @param grant_Type (optional) OAuth2 grant type
     * @param username (optional) Username  (i.e. email address)
     * @param password (optional) Password
     * @param url (optional) correct URL
     */
    issueToken(grant_Type: string | null | undefined, username: string | null | undefined, password: string | null | undefined, url: string | null | undefined, cancelToken?: CancelToken): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (grant_Type !== null && grant_Type !== undefined)
            content_.append("Grant_Type", grant_Type.toString());
        if (username !== null && username !== undefined)
            content_.append("Username", username.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIssueToken(_response));
        });
    }

    protected processIssueToken(response: AxiosResponse): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenResponse.fromJS(resultData200);
            return Promise.resolve<TokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    /**
     * Log in application to fitbit page.  Currently cookies are issued for protecting the API.
     * @param grant_Type (optional) OAuth2 grant type
     * @param username (optional) Username  (i.e. email address)
     * @param password (optional) Password
     * @param url (optional) correct URL
     */
    issueFitbitToken(grant_Type: string | null | undefined, username: string | null | undefined, password: string | null | undefined, url: string | null | undefined, cancelToken?: CancelToken): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/token/fitbit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (grant_Type !== null && grant_Type !== undefined)
            content_.append("Grant_Type", grant_Type.toString());
        if (username !== null && username !== undefined)
            content_.append("Username", username.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIssueFitbitToken(_response));
        });
    }

    protected processIssueFitbitToken(response: AxiosResponse): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenResponse.fromJS(resultData200);
            return Promise.resolve<TokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenResponse>(null as any);
    }
}

export class TriggersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Delete an existing Trigger from an Interaction.
     * @param id TriggerId of the Trigger to delete.
     */
    delete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Triggers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Update an existing Trigger.
     * @param id The TriggerId of the Trigger to update.
     * @param model The model containing all of the new Trigger data.
     */
    put(id: number, model: UpdateTriggerModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Triggers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPut(_response));
        });
    }

    protected processPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * Create a new Trigger and add it to an existing Interaction.
     * @param model The model containing all of the required Trigger data.
     * @return The TriggerId of the newly created Trigger
     */
    post(model: CreateTriggerModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Triggers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPost(_response));
        });
    }

    protected processPost(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return Promise.resolve<string>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);

        }
    }
}

export class VersionClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get the informational version from the current assembly
    to represent the application version.
     */
    getVersion( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVersion(_response));
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Get information about the current request
     */
    getHeaders( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/version/headers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHeaders(_response));
        });
    }

    protected processGetHeaders(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StudySettingsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get the branding of a study.
     */
    getStudyBranding(studyId: string, cancelToken?: CancelToken): Promise<StudyBrandingModel> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/settings/branding";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyBranding(_response));
        });
    }

    protected processGetStudyBranding(response: AxiosResponse): Promise<StudyBrandingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyBrandingModel.fromJS(resultData200);
            return Promise.resolve<StudyBrandingModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyBrandingModel>(null as any);
    }

    /**
     * Updates the branding of a study.
     */
    updateStudyPrimaryColor(studyId: string, model: UpdateStudyBrandingModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/settings/branding";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyPrimaryColor(_response));
        });
    }

    protected processUpdateStudyPrimaryColor(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StudyLanguagesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all languages for a study.
     */
    getLanguageSettings( cancelToken?: CancelToken): Promise<StudyLanguageResult[]> {
        let url_ = this.baseUrl + "/api/v1/study/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetLanguageSettings(_response));
        });
    }

    protected processGetLanguageSettings(response: AxiosResponse): Promise<StudyLanguageResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyLanguageResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyLanguageResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyLanguageResult[]>(null as any);
    }

    /**
     * Update the list of supported languages for the study in context.
     */
    updateLanguages(model: StudyLanguageApiModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/study/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateLanguages(_response));
        });
    }

    protected processUpdateLanguages(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Enables a language for the study in context.
     */
    enableLanguage(languageCode: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/study/languages/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnableLanguage(_response));
        });
    }

    protected processEnableLanguage(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Disables a language for the study in context.
     */
    disableLanguage(languageCode: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/study/languages/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisableLanguage(_response));
        });
    }

    protected processDisableLanguage(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class FaxNumbersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all defined fax numbers.
     */
    get(studyId: string, cancelToken?: CancelToken): Promise<StudyFaxNumberInfo[]> {
        let url_ = this.baseUrl + "/api/v1/study/fax-numbers/get/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<StudyFaxNumberInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFaxNumberInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyFaxNumberInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFaxNumberInfo[]>(null as any);
    }

    delete(faxNumberId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/study/fax-numbers/delete/{faxNumberId}";
        if (faxNumberId === undefined || faxNumberId === null)
            throw new Error("The parameter 'faxNumberId' must be defined.");
        url_ = url_.replace("{faxNumberId}", encodeURIComponent("" + faxNumberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    create(model: UpdateFaxModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/study/fax-numbers/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    update(id: string, model: UpdateFaxModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/study/fax-numbers/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class QuestionnaireSectionClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setQuestionnaireSection(interactionId: number | undefined, section: InteractionHeading | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/SetQuestionnaireSection?";
        if (interactionId === null)
            throw new Error("The parameter 'interactionId' cannot be null.");
        else if (interactionId !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        if (section === null)
            throw new Error("The parameter 'section' cannot be null.");
        else if (section !== undefined)
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetQuestionnaireSection(_response));
        });
    }

    protected processSetQuestionnaireSection(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getQuestionnaires(interactionId: number | null | undefined, cancelToken?: CancelToken): Promise<GetInteractionHeadingsResponse[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/GetQuestionnaires?";
        if (interactionId !== undefined && interactionId !== null)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestionnaires(_response));
        });
    }

    protected processGetQuestionnaires(response: AxiosResponse): Promise<GetInteractionHeadingsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInteractionHeadingsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInteractionHeadingsResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInteractionHeadingsResponse[]>(null as any);
    }
}

export class QuestionnaireBehaviourClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doSetBehaviourForQuestionnaire(interactionId: number | undefined, interactionBehaviourFullClassName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionnaireBehaviour/DoSetBehaviourForQuestionnaire?";
        if (interactionId === null)
            throw new Error("The parameter 'interactionId' cannot be null.");
        else if (interactionId !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        if (interactionBehaviourFullClassName !== undefined && interactionBehaviourFullClassName !== null)
            url_ += "interactionBehaviourFullClassName=" + encodeURIComponent("" + interactionBehaviourFullClassName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSetBehaviourForQuestionnaire(_response));
        });
    }

    protected processDoSetBehaviourForQuestionnaire(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getQuestionnaires(interactionId: number | null | undefined, cancelToken?: CancelToken): Promise<GetInteractionsResponse[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireBehaviour/GetQuestionnaires?";
        if (interactionId !== undefined && interactionId !== null)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestionnaires(_response));
        });
    }

    protected processGetQuestionnaires(response: AxiosResponse): Promise<GetInteractionsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInteractionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInteractionsResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInteractionsResponse[]>(null as any);
    }

    getAvailableBehaviours( cancelToken?: CancelToken): Promise<GetAvailableBehavioursResponse[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireBehaviour/GetAvailableBehaviours";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableBehaviours(_response));
        });
    }

    protected processGetAvailableBehaviours(response: AxiosResponse): Promise<GetAvailableBehavioursResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAvailableBehavioursResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAvailableBehavioursResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAvailableBehavioursResponse[]>(null as any);
    }
}

export class QuestionnairePatientStatusVisibilityClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setQuestionnairePatientStatusVisibility(interactionId: number | undefined, status: PatientStatus | undefined, visible: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionnairePatientStatusVisibility/SetQuestionnaireVisibilty?";
        if (interactionId === null)
            throw new Error("The parameter 'interactionId' cannot be null.");
        else if (interactionId !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (visible === null)
            throw new Error("The parameter 'visible' cannot be null.");
        else if (visible !== undefined)
            url_ += "visible=" + encodeURIComponent("" + visible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetQuestionnairePatientStatusVisibility(_response));
        });
    }

    protected processSetQuestionnairePatientStatusVisibility(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getQuestionnaires(interactionId: number | null | undefined, cancelToken?: CancelToken): Promise<GetInteractionPatientStatusVisibilityResponse[]> {
        let url_ = this.baseUrl + "/api/QuestionnairePatientStatusVisibility/GetQuestionnaires?";
        if (interactionId !== undefined && interactionId !== null)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestionnaires(_response));
        });
    }

    protected processGetQuestionnaires(response: AxiosResponse): Promise<GetInteractionPatientStatusVisibilityResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInteractionPatientStatusVisibilityResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInteractionPatientStatusVisibilityResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInteractionPatientStatusVisibilityResponse[]>(null as any);
    }
}

export class PharmacyClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get pharmacies for the study in context.
     * @param studyId The studyId associated with pharmacy.
     * @param name (optional) The name to filter pharmacies by. If provided, is a partial match.
     * @param province (optional) The province to filter pharmacies by. If provided, must be an exact match.
     * @param city (optional) The city to filter pharmacies by. If provided, is a partial match.
     * @param showUnvalidated (optional) Whether to show or hide unvalidated
     */
    getPharmaciesForStudy(studyId: string, name: string | null | undefined, province: string | null | undefined, city: string | null | undefined, showUnvalidated: boolean | null | undefined, cancelToken?: CancelToken): Promise<PharmacyModel[]> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/pharmacies?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (province !== undefined && province !== null)
            url_ += "province=" + encodeURIComponent("" + province) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (showUnvalidated !== undefined && showUnvalidated !== null)
            url_ += "showUnvalidated=" + encodeURIComponent("" + showUnvalidated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPharmaciesForStudy(_response));
        });
    }

    protected processGetPharmaciesForStudy(response: AxiosResponse): Promise<PharmacyModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PharmacyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PharmacyModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyModel[]>(null as any);
    }

    /**
     * Create a new pharmacy entity for the study in context.
     * @param studyId The studyId associated with pharmacy.
     * @param model The model containing the pharmacy information.
     */
    createPharmacy(studyId: string, model: CreatePharmacyModel, cancelToken?: CancelToken): Promise<PharmacyModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/pharmacies";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreatePharmacy(_response));
        });
    }

    protected processCreatePharmacy(response: AxiosResponse): Promise<PharmacyModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PharmacyModel.fromJS(resultData200);
            return Promise.resolve<PharmacyModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyModel>(null as any);
    }

    /**
     * Get a pharmacy by their id for the study in context.
     * @param studyId The studyId associated with pharmacy.
     * @param pharmacyID The id of the pharmacy to retrieve.
     */
    getPharmacy(studyId: string, pharmacyID: string, cancelToken?: CancelToken): Promise<PharmacyModel> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/pharmacies/{pharmacyID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pharmacyID === undefined || pharmacyID === null)
            throw new Error("The parameter 'pharmacyID' must be defined.");
        url_ = url_.replace("{pharmacyID}", encodeURIComponent("" + pharmacyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPharmacy(_response));
        });
    }

    protected processGetPharmacy(response: AxiosResponse): Promise<PharmacyModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PharmacyModel.fromJS(resultData200);
            return Promise.resolve<PharmacyModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyModel>(null as any);
    }

    /**
     * Update the details of a pharmacy entity.
     * @param studyId The studyId associated with pharmacy.
     * @param pharmacyID The id of the pharmacy being updated.
     * @param model The model containing the new pharmacy information.
     */
    updatePharmacy(studyId: string, pharmacyID: string, model: CreatePharmacyModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/pharmacies/{pharmacyID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pharmacyID === undefined || pharmacyID === null)
            throw new Error("The parameter 'pharmacyID' must be defined.");
        url_ = url_.replace("{pharmacyID}", encodeURIComponent("" + pharmacyID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdatePharmacy(_response));
        });
    }

    protected processUpdatePharmacy(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Delete a pharmacy entity.
     * @param studyId The studyId associated with pharmacy.
     * @param pharmacyID The id of the pharmacy to delete.
     */
    deletePharmacy(studyId: string, pharmacyID: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/studies/{studyId}/pharmacies/{pharmacyID}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pharmacyID === undefined || pharmacyID === null)
            throw new Error("The parameter 'pharmacyID' must be defined.");
        url_ = url_.replace("{pharmacyID}", encodeURIComponent("" + pharmacyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeletePharmacy(_response));
        });
    }

    protected processDeletePharmacy(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PaymentTransactionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTransactionHistory(request: PaginatedRequestOfGuid, cancelToken?: CancelToken): Promise<PaginatedResponseOfPatientPaymentTransactionHistory> {
        let url_ = this.baseUrl + "/api/PaymentTransactions/transactionHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransactionHistory(_response));
        });
    }

    protected processGetTransactionHistory(response: AxiosResponse): Promise<PaginatedResponseOfPatientPaymentTransactionHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfPatientPaymentTransactionHistory.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfPatientPaymentTransactionHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfPatientPaymentTransactionHistory>(null as any);
    }

    getTransactionLinkHistory(request: PaginatedRequestOfGuid, cancelToken?: CancelToken): Promise<PaginatedResponseOfPatientPaymentTransactionLinkHistory> {
        let url_ = this.baseUrl + "/api/PaymentTransactions/transactionLinkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransactionLinkHistory(_response));
        });
    }

    protected processGetTransactionLinkHistory(response: AxiosResponse): Promise<PaginatedResponseOfPatientPaymentTransactionLinkHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfPatientPaymentTransactionLinkHistory.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfPatientPaymentTransactionLinkHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfPatientPaymentTransactionLinkHistory>(null as any);
    }

    getSubscriptionStatus(patientId: string | undefined, cancelToken?: CancelToken): Promise<PatientSubscriptionStatusDto[]> {
        let url_ = this.baseUrl + "/api/PaymentTransactions/subscriptionStatus?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSubscriptionStatus(_response));
        });
    }

    protected processGetSubscriptionStatus(response: AxiosResponse): Promise<PatientSubscriptionStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSubscriptionStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSubscriptionStatusDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSubscriptionStatusDto[]>(null as any);
    }
}

export class OhipReportsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    downloadOhipAppointmentReport(start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ohip-reports/ohip-appointments-report?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadOhipAppointmentReport(_response));
        });
    }

    protected processDownloadOhipAppointmentReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class InteractionDesignerClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a new interaction for a study.
     */
    createInteraction(model: CreateInteractionRequestModel, cancelToken?: CancelToken): Promise<CreateInteractionResponseModel> {
        let url_ = this.baseUrl + "/api/interaction-designer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateInteraction(_response));
        });
    }

    protected processCreateInteraction(response: AxiosResponse): Promise<CreateInteractionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateInteractionResponseModel.fromJS(resultData200);
            return Promise.resolve<CreateInteractionResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateInteractionResponseModel>(null as any);
    }

    updateInteraction(model: UpdateInteractionRequestModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/interaction-designer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateInteraction(_response));
        });
    }

    protected processUpdateInteraction(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getInteraction(interactionId: number, cancelToken?: CancelToken): Promise<InteractionEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<InteractionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionEditModel.fromJS(resultData200);
            return Promise.resolve<InteractionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionEditModel>(null as any);
    }

    getQuestion(questionId: number, cancelToken?: CancelToken): Promise<QuestionEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/questions/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQuestion(_response));
        });
    }

    protected processGetQuestion(response: AxiosResponse): Promise<QuestionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionEditModel.fromJS(resultData200);
            return Promise.resolve<QuestionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionEditModel>(null as any);
    }

    deleteQuestion(questionId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/interaction-designer/questions/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteQuestion(_response));
        });
    }

    protected processDeleteQuestion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveQuestion(model: SaveQuestionRequestModel, cancelToken?: CancelToken): Promise<QuestionEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveQuestion(_response));
        });
    }

    protected processSaveQuestion(response: AxiosResponse): Promise<QuestionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionEditModel.fromJS(resultData200);
            return Promise.resolve<QuestionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionEditModel>(null as any);
    }

    /**
     * Create a new question in an interaction.
     */
    createQuestion(model: CreateQuestionRequestModel, cancelToken?: CancelToken): Promise<QuestionEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateQuestion(_response));
        });
    }

    protected processCreateQuestion(response: AxiosResponse): Promise<QuestionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionEditModel.fromJS(resultData200);
            return Promise.resolve<QuestionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionEditModel>(null as any);
    }

    moveQuestionToPosition(model: MoveQuestionToPositionRequestModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/interaction-designer/questions/position";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMoveQuestionToPosition(_response));
        });
    }

    protected processMoveQuestionToPosition(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateTrigger(model: UpdateTriggerRequestModel, cancelToken?: CancelToken): Promise<TriggerEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/triggers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTrigger(_response));
        });
    }

    protected processUpdateTrigger(response: AxiosResponse): Promise<TriggerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TriggerEditModel.fromJS(resultData200);
            return Promise.resolve<TriggerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TriggerEditModel>(null as any);
    }

    addTrigger(model: AddTriggerRequestModel, cancelToken?: CancelToken): Promise<TriggerEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/triggers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddTrigger(_response));
        });
    }

    protected processAddTrigger(response: AxiosResponse): Promise<TriggerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TriggerEditModel.fromJS(resultData200);
            return Promise.resolve<TriggerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TriggerEditModel>(null as any);
    }

    getTrigger(triggerId: number, cancelToken?: CancelToken): Promise<TriggerEditModel> {
        let url_ = this.baseUrl + "/api/interaction-designer/triggers/{triggerId}";
        if (triggerId === undefined || triggerId === null)
            throw new Error("The parameter 'triggerId' must be defined.");
        url_ = url_.replace("{triggerId}", encodeURIComponent("" + triggerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTrigger(_response));
        });
    }

    protected processGetTrigger(response: AxiosResponse): Promise<TriggerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TriggerEditModel.fromJS(resultData200);
            return Promise.resolve<TriggerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TriggerEditModel>(null as any);
    }

    getReports(interactionId: number, cancelToken?: CancelToken): Promise<ReportModel2[]> {
        let url_ = this.baseUrl + "/api/interaction-designer/{interactionId}/reports";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReports(_response));
        });
    }

    protected processGetReports(response: AxiosResponse): Promise<ReportModel2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportModel2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReportModel2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportModel2[]>(null as any);
    }

    getEmailTemplates(interactionId: number, cancelToken?: CancelToken): Promise<EmailTemplateModel2[]> {
        let url_ = this.baseUrl + "/api/interaction-designer/{interactionId}/email-templates";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailTemplates(_response));
        });
    }

    protected processGetEmailTemplates(response: AxiosResponse): Promise<EmailTemplateModel2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateModel2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailTemplateModel2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateModel2[]>(null as any);
    }
}

export class EmaReminderIntervalsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createReminderInterval(studyId: string, model: UpdateReminderIntervalsModel, cancelToken?: CancelToken): Promise<ReminderIntervalResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/{studyId}/reminder-intervals";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateReminderInterval(_response));
        });
    }

    protected processCreateReminderInterval(response: AxiosResponse): Promise<ReminderIntervalResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReminderIntervalResult.fromJS(resultData200);
            return Promise.resolve<ReminderIntervalResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderIntervalResult>(null as any);
    }

    updateReminderInterval(reminderIntervalId: string, model: UpdateReminderIntervalsModel, cancelToken?: CancelToken): Promise<ReminderIntervalResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/reminder-intervals/{reminderIntervalId}";
        if (reminderIntervalId === undefined || reminderIntervalId === null)
            throw new Error("The parameter 'reminderIntervalId' must be defined.");
        url_ = url_.replace("{reminderIntervalId}", encodeURIComponent("" + reminderIntervalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateReminderInterval(_response));
        });
    }

    protected processUpdateReminderInterval(response: AxiosResponse): Promise<ReminderIntervalResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReminderIntervalResult.fromJS(resultData200);
            return Promise.resolve<ReminderIntervalResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderIntervalResult>(null as any);
    }

    deleteReminderInterval(reminderIntervalId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/reminder-intervals/{reminderIntervalId}";
        if (reminderIntervalId === undefined || reminderIntervalId === null)
            throw new Error("The parameter 'reminderIntervalId' must be defined.");
        url_ = url_.replace("{reminderIntervalId}", encodeURIComponent("" + reminderIntervalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteReminderInterval(_response));
        });
    }

    protected processDeleteReminderInterval(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmaStudyClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInteractions( cancelToken?: CancelToken): Promise<InteractionResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/interactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteractions(_response));
        });
    }

    protected processGetInteractions(response: AxiosResponse): Promise<InteractionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InteractionResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InteractionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionResult[]>(null as any);
    }

    updateInteraction(model: UpdateStudyInteractionModel, cancelToken?: CancelToken): Promise<EmaStudyResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/interactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateInteraction(_response));
        });
    }

    protected processUpdateInteraction(response: AxiosResponse): Promise<EmaStudyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmaStudyResult.fromJS(resultData200);
            return Promise.resolve<EmaStudyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaStudyResult>(null as any);
    }

    updateEma(model: UpdateEmaStudyModel, cancelToken?: CancelToken): Promise<EmaStudyResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEma(_response));
        });
    }

    protected processUpdateEma(response: AxiosResponse): Promise<EmaStudyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmaStudyResult.fromJS(resultData200);
            return Promise.resolve<EmaStudyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaStudyResult>(null as any);
    }

    getEmaStudy( cancelToken?: CancelToken): Promise<EmaStudyResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmaStudy(_response));
        });
    }

    protected processGetEmaStudy(response: AxiosResponse): Promise<EmaStudyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmaStudyResult.fromJS(resultData200);
            return Promise.resolve<EmaStudyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaStudyResult>(null as any);
    }

    enableEma( cancelToken?: CancelToken): Promise<EmaStudyResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnableEma(_response));
        });
    }

    protected processEnableEma(response: AxiosResponse): Promise<EmaStudyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmaStudyResult.fromJS(resultData200);
            return Promise.resolve<EmaStudyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaStudyResult>(null as any);
    }

    disableEma( cancelToken?: CancelToken): Promise<EmaStudyResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisableEma(_response));
        });
    }

    protected processDisableEma(response: AxiosResponse): Promise<EmaStudyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmaStudyResult.fromJS(resultData200);
            return Promise.resolve<EmaStudyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmaStudyResult>(null as any);
    }
}

export class EmaTimeWindowsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createTimeWindow(studyId: string, model: UpdateTimeWindowModel, cancelToken?: CancelToken): Promise<TimeWindowResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/{studyId}/time-windows";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTimeWindow(_response));
        });
    }

    protected processCreateTimeWindow(response: AxiosResponse): Promise<TimeWindowResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeWindowResult.fromJS(resultData200);
            return Promise.resolve<TimeWindowResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeWindowResult>(null as any);
    }

    updateTimeWindow(timeWindowId: string, model: UpdateTimeWindowModel, cancelToken?: CancelToken): Promise<TimeWindowResult> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/time-windows/{timeWindowId}";
        if (timeWindowId === undefined || timeWindowId === null)
            throw new Error("The parameter 'timeWindowId' must be defined.");
        url_ = url_.replace("{timeWindowId}", encodeURIComponent("" + timeWindowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTimeWindow(_response));
        });
    }

    protected processUpdateTimeWindow(response: AxiosResponse): Promise<TimeWindowResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeWindowResult.fromJS(resultData200);
            return Promise.resolve<TimeWindowResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeWindowResult>(null as any);
    }

    deleteTimeWindow(timeWindowId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/ema/time-windows/{timeWindowId}";
        if (timeWindowId === undefined || timeWindowId === null)
            throw new Error("The parameter 'timeWindowId' must be defined.");
        url_ = url_.replace("{timeWindowId}", encodeURIComponent("" + timeWindowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTimeWindow(_response));
        });
    }

    protected processDeleteTimeWindow(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmailTemplateClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Delete the specified template (must belong to the selected client)
     */
    deleteTemplate(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTemplate(_response));
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve details about the specified email template (must belong to the selected client)
     */
    getTemplate(id: number, cancelToken?: CancelToken): Promise<EmailTemplateModel> {
        let url_ = this.baseUrl + "/api/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplate(_response));
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<EmailTemplateModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateModel.fromJS(resultData200);
            return Promise.resolve<EmailTemplateModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateModel>(null as any);
    }

    /**
     * Update the specified EmailTemplate (must belong to the selected client)
     * @param id EmailTemplateID
     * @param model EmailTemplateModel
     */
    putTemplate(id: number, model: UpdateEmailTemplateModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutTemplate(_response));
        });
    }

    protected processPutTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * List all email templates for the selected study
     * @param name (optional) 
     * @param templateType (optional) 
     */
    getTemplates(name: string | null | undefined, templateType: EmailTemplateType | null | undefined, cancelToken?: CancelToken): Promise<EmailTemplateModel[]> {
        let url_ = this.baseUrl + "/api/EmailTemplate?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (templateType !== undefined && templateType !== null)
            url_ += "templateType=" + encodeURIComponent("" + templateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplates(_response));
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<EmailTemplateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailTemplateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateModel[]>(null as any);
    }

    /**
     * Create a new EmailTemplate record (will belong to the selected client)
     * @param model EmailTemplateModel
     */
    postTemplate(model: CreateEmailTemplateModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostTemplate(_response));
        });
    }

    protected processPostTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AsteriskManagementClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the status of the asterisk connection.
     */
    getStatus( cancelToken?: CancelToken): Promise<AsteriskStatusModel> {
        let url_ = this.baseUrl + "/api/v1/asterisk/management/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatus(_response));
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AsteriskStatusModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AsteriskStatusModel.fromJS(resultData200);
            return Promise.resolve<AsteriskStatusModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskStatusModel>(null as any);
    }

    /**
     * Starts the asterisk manager connection.
     * @param forceRestart (optional) If the asterisk connection is currently connected, stops, and then starts the connection again.
     */
    start(forceRestart: boolean | undefined, cancelToken?: CancelToken): Promise<AsteriskStartResponse> {
        let url_ = this.baseUrl + "/api/v1/asterisk/management/start?";
        if (forceRestart === null)
            throw new Error("The parameter 'forceRestart' cannot be null.");
        else if (forceRestart !== undefined)
            url_ += "forceRestart=" + encodeURIComponent("" + forceRestart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStart(_response));
        });
    }

    protected processStart(response: AxiosResponse): Promise<AsteriskStartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AsteriskStartResponse.fromJS(resultData200);
            return Promise.resolve<AsteriskStartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskStartResponse>(null as any);
    }
}

export class PatientSiteClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getByUserName(username: string | null | undefined, cancelToken?: CancelToken): Promise<PatientLoginDto> {
        let url_ = this.baseUrl + "/api/patientSite/GetByUserName?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByUserName(_response));
        });
    }

    protected processGetByUserName(response: AxiosResponse): Promise<PatientLoginDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientLoginDto.fromJS(resultData200);
            return Promise.resolve<PatientLoginDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientLoginDto>(null as any);
    }

    getPasswordHash(email: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/patientSite/PasswordHash?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPasswordHash(_response));
        });
    }

    protected processGetPasswordHash(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setPasswordHash(email: string | null | undefined, pass: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patientSite/PasswordHash?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (pass !== undefined && pass !== null)
            url_ += "pass=" + encodeURIComponent("" + pass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetPasswordHash(_response));
        });
    }

    protected processSetPasswordHash(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doActivateAccount(token: string | null | undefined, hashedPassword: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/patientSite/activateAccount?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (hashedPassword !== undefined && hashedPassword !== null)
            url_ += "hashedPassword=" + encodeURIComponent("" + hashedPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoActivateAccount(_response));
        });
    }

    protected processDoActivateAccount(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    doSendForgetPasswordEmail(email: string | null | undefined, token: string | null | undefined, cancelToken?: CancelToken): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/patientSite/sendForgetPasswordEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSendForgetPasswordEmail(_response));
        });
    }

    protected processDoSendForgetPasswordEmail(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }

    getPatientPublicInteractionRequests(patientLoginId: string | undefined, cancelToken?: CancelToken): Promise<GetPublicInteractionRequestsInPendingStatusItem[]> {
        let url_ = this.baseUrl + "/api/patientSite/patientPublicInteractionRequests?";
        if (patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' cannot be null.");
        else if (patientLoginId !== undefined)
            url_ += "patientLoginId=" + encodeURIComponent("" + patientLoginId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientPublicInteractionRequests(_response));
        });
    }

    protected processGetPatientPublicInteractionRequests(response: AxiosResponse): Promise<GetPublicInteractionRequestsInPendingStatusItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPublicInteractionRequestsInPendingStatusItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem[]>(null as any);
    }

    getPatientResources(patientId: string, cancelToken?: CancelToken): Promise<GetPatientResourcesResponse[]> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientResources(_response));
        });
    }

    protected processGetPatientResources(response: AxiosResponse): Promise<GetPatientResourcesResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPatientResourcesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetPatientResourcesResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientResourcesResponse[]>(null as any);
    }

    getVideoResourceSASUrl(patientLoginId: string, documentId: number, cancelToken?: CancelToken): Promise<GetVideoResourceSasUrlResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientLoginId}/patientResources/{documentId}/sas";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideoResourceSASUrl(_response));
        });
    }

    protected processGetVideoResourceSASUrl(response: AxiosResponse): Promise<GetVideoResourceSasUrlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVideoResourceSasUrlResponse.fromJS(resultData200);
            return Promise.resolve<GetVideoResourceSasUrlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVideoResourceSasUrlResponse>(null as any);
    }

    getPatientResourceDetails(patientId: string, documentId: number, cancelToken?: CancelToken): Promise<GetPatientResourceDetailsResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources/{documentId}/details";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientResourceDetails(_response));
        });
    }

    protected processGetPatientResourceDetails(response: AxiosResponse): Promise<GetPatientResourceDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientResourceDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientResourceDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientResourceDetailsResponse>(null as any);
    }

    getProgramDetails(patientLoginId: string, cancelToken?: CancelToken): Promise<ProgramDetailsResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientLoginId}/programDetails";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProgramDetails(_response));
        });
    }

    protected processGetProgramDetails(response: AxiosResponse): Promise<ProgramDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgramDetailsResponse.fromJS(resultData200);
            return Promise.resolve<ProgramDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramDetailsResponse>(null as any);
    }

    downloadPatientResource(patientId: string, documentId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources/{documentId}/download";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadPatientResource(_response));
        });
    }

    protected processDownloadPatientResource(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReportsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientsWithoutFaxedAe(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events/fax-pending";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithoutFaxedAe(_response));
        });
    }

    protected processGetPatientsWithoutFaxedAe(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getPatientsWithAe(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithAe(_response));
        });
    }

    protected processGetPatientsWithAe(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getPatientsWithAeContainingCcglow(studyId: string, containsCcglow: boolean | undefined, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events/cc-glow?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (containsCcglow === null)
            throw new Error("The parameter 'containsCcglow' cannot be null.");
        else if (containsCcglow !== undefined)
            url_ += "containsCcglow=" + encodeURIComponent("" + containsCcglow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithAeContainingCcglow(_response));
        });
    }

    protected processGetPatientsWithAeContainingCcglow(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getCcglowSummary(studyId: string, cancelToken?: CancelToken): Promise<AeCcglowSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/adverse-events/study/ccglow";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCcglowSummary(_response));
        });
    }

    protected processGetCcglowSummary(response: AxiosResponse): Promise<AeCcglowSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AeCcglowSummary.fromJS(resultData200);
            return Promise.resolve<AeCcglowSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AeCcglowSummary>(null as any);
    }

    getAeSummary(studyId: string, cancelToken?: CancelToken): Promise<AeSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/adverse-events/study";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAeSummary(_response));
        });
    }

    protected processGetAeSummary(response: AxiosResponse): Promise<AeSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AeSummary.fromJS(resultData200);
            return Promise.resolve<AeSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AeSummary>(null as any);
    }

    getMonthlyReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/monthly?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMonthlyReport(_response));
        });
    }

    protected processGetMonthlyReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPhysicianReport(studyId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/physicians";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysicianReport(_response));
        });
    }

    protected processGetPhysicianReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSourceDataValidationReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/source-data-validation?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSourceDataValidationReport(_response));
        });
    }

    protected processGetSourceDataValidationReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getReconciliationReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/reconciliation?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReconciliationReport(_response));
        });
    }

    protected processGetReconciliationReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getStoppedTakingSummary(studyId: string, cancelToken?: CancelToken): Promise<StoppedTakingSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/stopped-taking";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStoppedTakingSummary(_response));
        });
    }

    protected processGetStoppedTakingSummary(response: AxiosResponse): Promise<StoppedTakingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StoppedTakingSummary.fromJS(resultData200);
            return Promise.resolve<StoppedTakingSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoppedTakingSummary>(null as any);
    }

    getStoppedTakingPatients(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/stopped-taking/patients";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStoppedTakingPatients(_response));
        });
    }

    protected processGetStoppedTakingPatients(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }
}

export class PatientAppointmentsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientAppointments(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicPatientAppointmentModel[]> {
        let url_ = this.baseUrl + "/api/patientSite/appointments/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAppointments(_response));
        });
    }

    protected processGetPatientAppointments(response: AxiosResponse): Promise<PublicPatientAppointmentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientAppointmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicPatientAppointmentModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientAppointmentModel[]>(null as any);
    }

    createEssentialsAppointmentAndPaymentLink(patientLoginId: string, cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse> {
        let url_ = this.baseUrl + "/api/patientAppointments/createEssentialsAppointmentAndPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientLoginId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEssentialsAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateEssentialsAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(null as any);
    }

    createAppointmentAndPaymentLink(request: AppointmentAndPaymentLinkRequest, cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse> {
        let url_ = this.baseUrl + "/api/patientAppointments/createAppointmentAndPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(null as any);
    }

    appointmentPurchased(request: AppointmentPurchasedConfirmRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patientAppointments/appointmentPurchased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAppointmentPurchased(_response));
        });
    }

    protected processAppointmentPurchased(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientDeviceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    registerDevice(patientLoginId: string, req: RegisterDeviceRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/devices/{patientLoginId}/register";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterDevice(_response));
        });
    }

    protected processRegisterDevice(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    unregisterDevice(patientId: string, req: RegisterDeviceRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/devices/{patientId}/unregister";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnregisterDevice(_response));
        });
    }

    protected processUnregisterDevice(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PatientProductsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientAvailableProductsForPurchase(patientLoginId: string, productKind: ProductKind, cancelToken?: CancelToken): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto> {
        let url_ = this.baseUrl + "/api/patientSite/products/getPatientAvailableProductsForPurchase/{patientLoginId}/{productKind}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (productKind === undefined || productKind === null)
            throw new Error("The parameter 'productKind' must be defined.");
        url_ = url_.replace("{productKind}", encodeURIComponent("" + productKind));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAvailableProductsForPurchase(_response));
        });
    }

    protected processGetPatientAvailableProductsForPurchase(response: AxiosResponse): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto>(null as any);
    }
}

export class PatientReceiptsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientReceipts(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicPatientReceiptModel[]> {
        let url_ = this.baseUrl + "/api/patientSite/receipts/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientReceipts(_response));
        });
    }

    protected processGetPatientReceipts(response: AxiosResponse): Promise<PublicPatientReceiptModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientReceiptModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicPatientReceiptModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientReceiptModel[]>(null as any);
    }

    downloadReceipt(patientLoginId: string, patientInteractionId: number, model: DownloadReceiptRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/receipts/{patientLoginId}/{patientInteractionId}/download";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (patientInteractionId === undefined || patientInteractionId === null)
            throw new Error("The parameter 'patientInteractionId' must be defined.");
        url_ = url_.replace("{patientInteractionId}", encodeURIComponent("" + patientInteractionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadReceipt(_response));
        });
    }

    protected processDownloadReceipt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PatientSiteChatClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getChat(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicSitePatientConversationModel> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChat(_response));
        });
    }

    protected processGetChat(response: AxiosResponse): Promise<PublicSitePatientConversationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientConversationModel.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientConversationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientConversationModel>(null as any);
    }

    sendMessage(patientLoginId: string, model: SendChatMessageRequest, cancelToken?: CancelToken): Promise<PublicSitePatientMessageModel> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<PublicSitePatientMessageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientMessageModel.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientMessageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientMessageModel>(null as any);
    }

    getUnreadMessagesCount(patientLoginId: string, cancelToken?: CancelToken): Promise<UnreadMessagesResponse> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}/unread";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnreadMessagesCount(_response));
        });
    }

    protected processGetUnreadMessagesCount(response: AxiosResponse): Promise<UnreadMessagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnreadMessagesResponse.fromJS(resultData200);
            return Promise.resolve<UnreadMessagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnreadMessagesResponse>(null as any);
    }
}

export class PatientSiteNymbleClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    enrollWithNymble(patientLoginId: string, nymbleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/enroll";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nymbleId);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnrollWithNymble(_response));
        });
    }

    protected processEnrollWithNymble(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    unenrollWithNymble(patientLoginId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/unenroll";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnenrollWithNymble(_response));
        });
    }

    protected processUnenrollWithNymble(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getNymbleId(patientLoginId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/nymbleId";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNymbleId(_response));
        });
    }

    protected processGetNymbleId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getNymbleEnrollData(patientLoginId: string, cancelToken?: CancelToken): Promise<GetNymbleEnrollData> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/nymble-enroll-data";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNymbleEnrollData(_response));
        });
    }

    protected processGetNymbleEnrollData(response: AxiosResponse): Promise<GetNymbleEnrollData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNymbleEnrollData.fromJS(resultData200);
            return Promise.resolve<GetNymbleEnrollData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNymbleEnrollData>(null as any);
    }

    sendNymbleMessageNotification(nymbleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{nymbleId}/nymble-send-notification";
        if (nymbleId === undefined || nymbleId === null)
            throw new Error("The parameter 'nymbleId' must be defined.");
        url_ = url_.replace("{nymbleId}", encodeURIComponent("" + nymbleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendNymbleMessageNotification(_response));
        });
    }

    protected processSendNymbleMessageNotification(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StudyParticipantsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStudyPspSystemPatient(studyId: string, cancelToken?: CancelToken): Promise<GetSystemPatientModel> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/system-patient";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyPspSystemPatient(_response));
        });
    }

    protected processGetStudyPspSystemPatient(response: AxiosResponse): Promise<GetSystemPatientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSystemPatientModel.fromJS(resultData200);
            return Promise.resolve<GetSystemPatientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSystemPatientModel>(null as any);
    }

    updateStudyPspSystemPatient(studyId: string, model: UpdateStudyPspSystemPatientModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/system-patient";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyPspSystemPatient(_response));
        });
    }

    protected processUpdateStudyPspSystemPatient(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getParticipants(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParticipants(_response));
        });
    }

    protected processGetParticipants(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getSummary(studyId: string, cancelToken?: CancelToken): Promise<ParticipantsSummaryResult> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/statuses/summary";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSummary(_response));
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<ParticipantsSummaryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ParticipantsSummaryResult.fromJS(resultData200);
            return Promise.resolve<ParticipantsSummaryResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParticipantsSummaryResult>(null as any);
    }

    getParticipantsForStatus(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryStatusResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/statuses";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParticipantsForStatus(_response));
        });
    }

    protected processGetParticipantsForStatus(response: AxiosResponse): Promise<PatientSummaryStatusResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryStatusResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientSummaryStatusResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryStatusResult[]>(null as any);
    }

    getEnrollmentCount(studyId: string, start: Date | null | undefined, end: Date | null | undefined, cancelToken?: CancelToken): Promise<EnrollmentCountModel> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/count?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentCount(_response));
        });
    }

    protected processGetEnrollmentCount(response: AxiosResponse): Promise<EnrollmentCountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrollmentCountModel.fromJS(resultData200);
            return Promise.resolve<EnrollmentCountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentCountModel>(null as any);
    }
}

export class MetricsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQueueMetrics( cancelToken?: CancelToken): Promise<QueueMetricsModel> {
        let url_ = this.baseUrl + "/api/metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueueMetrics(_response));
        });
    }

    protected processGetQueueMetrics(response: AxiosResponse): Promise<QueueMetricsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueMetricsModel.fromJS(resultData200);
            return Promise.resolve<QueueMetricsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueMetricsModel>(null as any);
    }

    getQueueMetrics2( cancelToken?: CancelToken): Promise<QueueMetricsModel2> {
        let url_ = this.baseUrl + "/api/v1/metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueueMetrics2(_response));
        });
    }

    protected processGetQueueMetrics2(response: AxiosResponse): Promise<QueueMetricsModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueMetricsModel2.fromJS(resultData200);
            return Promise.resolve<QueueMetricsModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueMetricsModel2>(null as any);
    }

    getInboundCallMetrics( cancelToken?: CancelToken): Promise<CallMetricsModel> {
        let url_ = this.baseUrl + "/api/v1/metrics/calls";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInboundCallMetrics(_response));
        });
    }

    protected processGetInboundCallMetrics(response: AxiosResponse): Promise<CallMetricsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallMetricsModel.fromJS(resultData200);
            return Promise.resolve<CallMetricsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallMetricsModel>(null as any);
    }
}

export class InteractionAuditsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuditableUsers(studyId: string, cancelToken?: CancelToken): Promise<AccountSummaryResult[]> {
        let url_ = this.baseUrl + "/api/interaction-audits/studies/{studyId}/accounts";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAuditableUsers(_response));
        });
    }

    protected processGetAuditableUsers(response: AxiosResponse): Promise<AccountSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountSummaryResult[]>(null as any);
    }

    getAccountInteractions(studyId: string, accountId: string | null | undefined, cancelToken?: CancelToken): Promise<PatientInteractionSummaryResult[]> {
        let url_ = this.baseUrl + "/api/interaction-audits/studies/{studyId}/interactions?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccountInteractions(_response));
        });
    }

    protected processGetAccountInteractions(response: AxiosResponse): Promise<PatientInteractionSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientInteractionSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PatientInteractionSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientInteractionSummaryResult[]>(null as any);
    }
}

export class AsteriskClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSummary(studyId: string, cancelToken?: CancelToken): Promise<AsteriskSummaryModel> {
        let url_ = this.baseUrl + "/api/asterisk/studies/{studyId}/summary";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSummary(_response));
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<AsteriskSummaryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AsteriskSummaryModel.fromJS(resultData200);
            return Promise.resolve<AsteriskSummaryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskSummaryModel>(null as any);
    }

    getSnapshot( cancelToken?: CancelToken): Promise<ChannelsStateSnapshot> {
        let url_ = this.baseUrl + "/api/v1/asterisk/snapshot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSnapshot(_response));
        });
    }

    protected processGetSnapshot(response: AxiosResponse): Promise<ChannelsStateSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelsStateSnapshot.fromJS(resultData200);
            return Promise.resolve<ChannelsStateSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelsStateSnapshot>(null as any);
    }

    getQueuesSnapshot( cancelToken?: CancelToken): Promise<QueueSummariesSnapshot> {
        let url_ = this.baseUrl + "/api/v1/asterisk/queues/snapshot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueuesSnapshot(_response));
        });
    }

    protected processGetQueuesSnapshot(response: AxiosResponse): Promise<QueueSummariesSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueSummariesSnapshot.fromJS(resultData200);
            return Promise.resolve<QueueSummariesSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueSummariesSnapshot>(null as any);
    }

    getQueues( cancelToken?: CancelToken): Promise<AsteriskQueueResult[]> {
        let url_ = this.baseUrl + "/api/v1/asterisk/queues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueues(_response));
        });
    }

    protected processGetQueues(response: AxiosResponse): Promise<AsteriskQueueResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AsteriskQueueResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AsteriskQueueResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskQueueResult[]>(null as any);
    }
}

export class QuestionnaireEngineClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProvinceState(countryCode: string | null | undefined, cancelToken?: CancelToken): Promise<ProvinceState[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/ProvinceState?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProvinceState(_response));
        });
    }

    protected processGetProvinceState(response: AxiosResponse): Promise<ProvinceState[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceState.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProvinceState[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProvinceState[]>(null as any);
    }

    getPharmacies(request: GetPharmaciesRequest, cancelToken?: CancelToken): Promise<PharmacyModel[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/Pharmacies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPharmacies(_response));
        });
    }

    protected processGetPharmacies(response: AxiosResponse): Promise<PharmacyModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PharmacyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PharmacyModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyModel[]>(null as any);
    }

    getPhysician(request: GetPhysicianRequest, cancelToken?: CancelToken): Promise<PhysicianModel[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/Physician";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysician(_response));
        });
    }

    protected processGetPhysician(response: AxiosResponse): Promise<PhysicianModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhysicianModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PhysicianModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhysicianModel[]>(null as any);
    }

    getEnrollmentInteractionPublic(languageCode: string | null | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/enrollmentInteractionPublic?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentInteractionPublic(_response));
        });
    }

    protected processGetEnrollmentInteractionPublic(response: AxiosResponse): Promise<InteractionRenderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel>(null as any);
    }

    postEnrollmentInteractionPublic(request: PostEnrollmentInteractionRequest, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/enrollmentInteractionPublic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostEnrollmentInteractionPublic(_response));
        });
    }

    protected processPostEnrollmentInteractionPublic(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse>(null as any);
    }

    getGenericInteractionPublic(requestKey: string | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/PublicGenericInteraction?";
        if (requestKey === null)
            throw new Error("The parameter 'requestKey' cannot be null.");
        else if (requestKey !== undefined)
            url_ += "requestKey=" + encodeURIComponent("" + requestKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGenericInteractionPublic(_response));
        });
    }

    protected processGetGenericInteractionPublic(response: AxiosResponse): Promise<InteractionRenderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel>(null as any);
    }

    postGenericInteractionPublic(request: PostGenericInteractionPublicRequest, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/PublicGenericInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostGenericInteractionPublic(_response));
        });
    }

    protected processPostGenericInteractionPublic(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse>(null as any);
    }

    getInteraction(interactionId: number | undefined, languageCode: string | null | undefined, patientId: string | undefined, editingInteractionId: number | null | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel> {
        let url_ = this.baseUrl + "/api/questionnaireEngine?";
        if (interactionId === null)
            throw new Error("The parameter 'interactionId' cannot be null.");
        else if (interactionId !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (editingInteractionId !== undefined && editingInteractionId !== null)
            url_ += "editingInteractionId=" + encodeURIComponent("" + editingInteractionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<InteractionRenderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel>(null as any);
    }

    postInteraction(response: InteractionResponseModel, cancelToken?: CancelToken): Promise<InteractionModel2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/interaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInteraction(_response));
        });
    }

    protected processPostInteraction(response: AxiosResponse): Promise<InteractionModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionModel2.fromJS(resultData200);
            return Promise.resolve<InteractionModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionModel2>(null as any);
    }
}

export class MWMAccountClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doAccountDeactivate(accountId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/accountDeactivate?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoAccountDeactivate(_response));
        });
    }

    protected processDoAccountDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doResendVerificationEmail(accountId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/resendVerificationEmail/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoResendVerificationEmail(_response));
        });
    }

    protected processDoResendVerificationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAccounts( cancelToken?: CancelToken): Promise<AccountDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccounts(_response));
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto[]>(null as any);
    }

    getCultures( cancelToken?: CancelToken): Promise<AccountCultureResponseDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/cultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCultures(_response));
        });
    }

    protected processGetCultures(response: AxiosResponse): Promise<AccountCultureResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountCultureResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountCultureResponseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCultureResponseDto[]>(null as any);
    }

    doSetCulture(request: AccountCultureSetRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/cultures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSetCulture(_response));
        });
    }

    protected processDoSetCulture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doCreateAccount(adminRegisterRequestModel: AdminRegisterRequestModel, cancelToken?: CancelToken): Promise<AdminRegisterResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(adminRegisterRequestModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCreateAccount(_response));
        });
    }

    protected processDoCreateAccount(response: AxiosResponse): Promise<AdminRegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminRegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<AdminRegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminRegisterResponseModel>(null as any);
    }

    getCurrentUserRole( cancelToken?: CancelToken): Promise<CurrentUserRole> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/currentRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentUserRole(_response));
        });
    }

    protected processGetCurrentUserRole(response: AxiosResponse): Promise<CurrentUserRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUserRole.fromJS(resultData200);
            return Promise.resolve<CurrentUserRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserRole>(null as any);
    }
}

export class MWMAgentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCurrentAgent( cancelToken?: CancelToken): Promise<SimpleAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentAgent(_response));
        });
    }

    protected processGetCurrentAgent(response: AxiosResponse): Promise<SimpleAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleAgentDto.fromJS(resultData200);
            return Promise.resolve<SimpleAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleAgentDto>(null as any);
    }

    saveCurrentAgent(simpleAgentDto: SimpleAgentDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simpleAgentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCurrentAgent(_response));
        });
    }

    protected processSaveCurrentAgent(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    getCurrentAgentAgentRole( cancelToken?: CancelToken): Promise<AgentRole> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgentRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentAgentAgentRole(_response));
        });
    }

    protected processGetCurrentAgentAgentRole(response: AxiosResponse): Promise<AgentRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<AgentRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRole>(null as any);
    }

    getProfilePicture( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/profilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProfilePicture(_response));
        });
    }

    protected processGetProfilePicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDownloadFile(key: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/file/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDownloadFile(_response));
        });
    }

    protected processDoDownloadFile(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doUploadFile(formFile: FileParameter | undefined, fileType: AgentFileType | undefined, agentId: string | undefined, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (agentId === null || agentId === undefined)
            throw new Error("The parameter 'agentId' cannot be null.");
        else
            content_.append("AgentId", agentId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoUploadFile(_response));
        });
    }

    protected processDoUploadFile(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    getSingle(agentId: string, cancelToken?: CancelToken): Promise<FullAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/get/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingle(_response));
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<FullAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FullAgentDto.fromJS(resultData200);
            return Promise.resolve<FullAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FullAgentDto>(null as any);
    }

    getAgentSearch(filters_agentRoles: AgentRole[] | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfSummaryAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/search?";
        if (filters_agentRoles !== undefined && filters_agentRoles !== null)
            filters_agentRoles && filters_agentRoles.forEach(item => { url_ += "Filters.agentRoles=" + encodeURIComponent("" + item) + "&"; });
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentSearch(_response));
        });
    }

    protected processGetAgentSearch(response: AxiosResponse): Promise<PaginatedResponseOfSummaryAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfSummaryAgentDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfSummaryAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfSummaryAgentDto>(null as any);
    }

    getList(filters: GetListRequest | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfFullAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/list?";
        if (filters !== undefined && filters !== null)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PaginatedResponseOfFullAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfFullAgentDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfFullAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfFullAgentDto>(null as any);
    }

    save(agentSaveRequestServiceModel: FullAgentDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentSaveRequestServiceModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    saveAgentNotes(agentNoteDto: AgentNoteDto, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentNoteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveAgentNotes(_response));
        });
    }

    protected processSaveAgentNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    getAgentNotes(agentId: string | null | undefined, reviewed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentNotes?";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (reviewed !== undefined && reviewed !== null)
            url_ += "Reviewed=" + encodeURIComponent("" + reviewed) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentNotes(_response));
        });
    }

    protected processGetAgentNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    saveAgentAdminNotes(agentAdminNoteDto: AgentAdminNoteDto, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentAdminNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentAdminNoteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveAgentAdminNotes(_response));
        });
    }

    protected processSaveAgentAdminNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    getAgentAdminNotes(agentId: string | null | undefined, reviewed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentAdminNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentAdminNotes?";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (reviewed !== undefined && reviewed !== null)
            url_ += "Reviewed=" + encodeURIComponent("" + reviewed) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentAdminNotes(_response));
        });
    }

    protected processGetAgentAdminNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentAdminNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentAdminNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentAdminNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentAdminNoteDto>(null as any);
    }

    doReviewAgentAdminNote(doReviewAgentAdminNote: DoReviewAgentAdminNoteModelRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/reviewNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doReviewAgentAdminNote);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoReviewAgentAdminNote(_response));
        });
    }

    protected processDoReviewAgentAdminNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doSetActiveDevice(activeDevice: DoSetActiveDeviceRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/activeDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activeDevice);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSetActiveDevice(_response));
        });
    }

    protected processDoSetActiveDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPendingDevices(agentId: string | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfDeviceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/pendingDevices?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPendingDevices(_response));
        });
    }

    protected processGetPendingDevices(response: AxiosResponse): Promise<PaginatedResponseOfDeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfDeviceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfDeviceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfDeviceDto>(null as any);
    }

    doDetachDevice(agentId: string | undefined, deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/detachDevice?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDetachDevice(_response));
        });
    }

    protected processDoDetachDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveChecks(agentDeviceCheckDto: AgentDeviceCheckDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/checks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentDeviceCheckDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveChecks(_response));
        });
    }

    protected processSaveChecks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getChecks(agentId: string | undefined, cancelToken?: CancelToken): Promise<AgentDeviceCheckDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/checks?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChecks(_response));
        });
    }

    protected processGetChecks(response: AxiosResponse): Promise<AgentDeviceCheckDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentDeviceCheckDto.fromJS(resultData200);
            return Promise.resolve<AgentDeviceCheckDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDeviceCheckDto>(null as any);
    }

    doCreateAccount(agentRegisterRequestModel: AgentRegisterRequestModel, cancelToken?: CancelToken): Promise<AgentRegisterResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/createAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentRegisterRequestModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCreateAccount(_response));
        });
    }

    protected processDoCreateAccount(response: AxiosResponse): Promise<AgentRegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentRegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentRegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegisterResponseModel>(null as any);
    }

    getAgentReport(agentId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/report?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentReport(_response));
        });
    }

    protected processGetAgentReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMDashboardClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAdminDashboardCounts( cancelToken?: CancelToken): Promise<DashboardResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMDashboard/adminCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAdminDashboardCounts(_response));
        });
    }

    protected processGetAdminDashboardCounts(response: AxiosResponse): Promise<DashboardResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardResponseModel.fromJS(resultData200);
            return Promise.resolve<DashboardResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardResponseModel>(null as any);
    }
}

export class MWMDeviceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDevicesReport(agentId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/report?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDevicesReport(_response));
        });
    }

    protected processGetDevicesReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSingle(deviceId: string, cancelToken?: CancelToken): Promise<DeviceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/get/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingle(_response));
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<DeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceDto.fromJS(resultData200);
            return Promise.resolve<DeviceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto>(null as any);
    }

    getList( cancelToken?: CancelToken): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto[]>(null as any);
    }

    getListPending( cancelToken?: CancelToken): Promise<DeviceAgentDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/listPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListPending(_response));
        });
    }

    protected processGetListPending(response: AxiosResponse): Promise<DeviceAgentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceAgentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeviceAgentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceAgentDto[]>(null as any);
    }

    save(device: DeviceDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    doReactivateDevice(deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/reactivateDevice?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoReactivateDevice(_response));
        });
    }

    protected processDoReactivateDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDeleteDevice(deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/deleteDevice?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDeleteDevice(_response));
        });
    }

    protected processDoDeleteDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMInvoiceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInvoicePdf(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/invoicePdf/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoicePdf(_response));
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/delete/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInvoice(_response));
        });
    }

    protected processDeleteInvoice(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getInvoicingStatus(filters_FromDateInclusive: Date | null | undefined, filters_ToDateInclusive: Date | null | undefined, filters_AgentId: string | null | undefined, filters_AgentRoles: AgentRole[] | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfInvoicingStatusDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/invoicesStatus?";
        if (filters_FromDateInclusive !== undefined && filters_FromDateInclusive !== null)
            url_ += "Filters.FromDateInclusive=" + encodeURIComponent(filters_FromDateInclusive ? "" + filters_FromDateInclusive.toISOString() : "") + "&";
        if (filters_ToDateInclusive !== undefined && filters_ToDateInclusive !== null)
            url_ += "Filters.ToDateInclusive=" + encodeURIComponent(filters_ToDateInclusive ? "" + filters_ToDateInclusive.toISOString() : "") + "&";
        if (filters_AgentId !== undefined && filters_AgentId !== null)
            url_ += "Filters.AgentId=" + encodeURIComponent("" + filters_AgentId) + "&";
        if (filters_AgentRoles !== undefined && filters_AgentRoles !== null)
            filters_AgentRoles && filters_AgentRoles.forEach(item => { url_ += "Filters.AgentRoles=" + encodeURIComponent("" + item) + "&"; });
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoicingStatus(_response));
        });
    }

    protected processGetInvoicingStatus(response: AxiosResponse): Promise<PaginatedResponseOfInvoicingStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfInvoicingStatusDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfInvoicingStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfInvoicingStatusDto>(null as any);
    }

    getInvoices(filters_InvoiceFlow: InvoiceFlow | undefined, filters_Year: number | null | undefined, filters_InvoiceStatus: InvoiceStatus | null | undefined, filters_ServicePeriod: Date | null | undefined, filters_AgentId: string | null | undefined, filters_InvoiceNumber: number | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/all?";
        if (filters_InvoiceFlow === null)
            throw new Error("The parameter 'filters_InvoiceFlow' cannot be null.");
        else if (filters_InvoiceFlow !== undefined)
            url_ += "Filters.InvoiceFlow=" + encodeURIComponent("" + filters_InvoiceFlow) + "&";
        if (filters_Year !== undefined && filters_Year !== null)
            url_ += "Filters.Year=" + encodeURIComponent("" + filters_Year) + "&";
        if (filters_InvoiceStatus !== undefined && filters_InvoiceStatus !== null)
            url_ += "Filters.InvoiceStatus=" + encodeURIComponent("" + filters_InvoiceStatus) + "&";
        if (filters_ServicePeriod !== undefined && filters_ServicePeriod !== null)
            url_ += "Filters.ServicePeriod=" + encodeURIComponent(filters_ServicePeriod ? "" + filters_ServicePeriod.toISOString() : "") + "&";
        if (filters_AgentId !== undefined && filters_AgentId !== null)
            url_ += "Filters.AgentId=" + encodeURIComponent("" + filters_AgentId) + "&";
        if (filters_InvoiceNumber !== undefined && filters_InvoiceNumber !== null)
            url_ += "Filters.InvoiceNumber=" + encodeURIComponent("" + filters_InvoiceNumber) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoices(_response));
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<PaginatedResponseOfInvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfInvoiceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfInvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfInvoiceDto>(null as any);
    }

    getInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoice(_response));
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDto.fromJS(resultData200);
            return Promise.resolve<InvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    disputeInvoice(doDisputeRequest: DoDisputeRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/dispute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doDisputeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisputeInvoice(_response));
        });
    }

    protected processDisputeInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    submitInvoiceForApproval(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/submitForApproval/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubmitInvoiceForApproval(_response));
        });
    }

    protected processSubmitInvoiceForApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    adminApprove(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/adminApprove/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAdminApprove(_response));
        });
    }

    protected processAdminApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    agentApprove(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/agentApprove/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAgentApprove(_response));
        });
    }

    protected processAgentApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    completeInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/complete/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteInvoice(_response));
        });
    }

    protected processCompleteInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveInvoice(createInvoiceRequest: CreateInvoiceRequest, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInvoiceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveInvoice(_response));
        });
    }

    protected processSaveInvoice(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    updateInvoice(updateInvoiceRequest: UpdateInvoiceRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInvoiceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateInvoice(_response));
        });
    }

    protected processUpdateInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMLoginClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    ping( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPing(_response));
        });
    }

    protected processPing(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doVerifyAccount(accountVerifyRequest: AccountVerifyRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/verifyAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountVerifyRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoVerifyAccount(_response));
        });
    }

    protected processDoVerifyAccount(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doForgotPasswordStart(forgotPasswordStartModel: DoForgotPasswordStartModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/forgotPasswordStart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordStartModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoForgotPasswordStart(_response));
        });
    }

    protected processDoForgotPasswordStart(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doForgotPasswordComplete(doCompleteForgotPasswordRequest: DoCompleteForgotPasswordRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/forgotPasswordComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doCompleteForgotPasswordRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoForgotPasswordComplete(_response));
        });
    }

    protected processDoForgotPasswordComplete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doAuthenticate(accountAuthenticateModel: AccountAuthenticateModel, cancelToken?: CancelToken): Promise<AccountAuthenticateModelResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountAuthenticateModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoAuthenticate(_response));
        });
    }

    protected processDoAuthenticate(response: AxiosResponse): Promise<AccountAuthenticateModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountAuthenticateModelResponse.fromJS(resultData200);
            return Promise.resolve<AccountAuthenticateModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountAuthenticateModelResponse>(null as any);
    }
}

export class MWMSettingsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllSettings( cancelToken?: CancelToken): Promise<MWMSettings> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllSettings(_response));
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<MWMSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MWMSettings.fromJS(resultData200);
            return Promise.resolve<MWMSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MWMSettings>(null as any);
    }

    setAllSettings(newSettings: MWMSettings, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetAllSettings(_response));
        });
    }

    protected processSetAllSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPublicSettings( cancelToken?: CancelToken): Promise<MWMPublicSettings> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPublicSettings(_response));
        });
    }

    protected processGetPublicSettings(response: AxiosResponse): Promise<MWMPublicSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MWMPublicSettings.fromJS(resultData200);
            return Promise.resolve<MWMPublicSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MWMPublicSettings>(null as any);
    }
}

export class MWMTrainingClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveResource(resourceId: string | null | undefined, externalLink: string | null | undefined, blobId: string | null | undefined, formFile: FileParameter | null | undefined, resourceType: ResourceType2 | undefined, name: string | undefined, description: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (resourceId !== null && resourceId !== undefined)
            content_.append("ResourceId", resourceId.toString());
        if (externalLink !== null && externalLink !== undefined)
            content_.append("ExternalLink", externalLink.toString());
        if (blobId !== null && blobId !== undefined)
            content_.append("BlobId", blobId.toString());
        if (formFile !== null && formFile !== undefined)
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (resourceType === null || resourceType === undefined)
            throw new Error("The parameter 'resourceType' cannot be null.");
        else
            content_.append("ResourceType", resourceType.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveResource(_response));
        });
    }

    protected processSaveResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDownloadResourceFile(blobId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceFileDownload/{blobId}";
        if (blobId === undefined || blobId === null)
            throw new Error("The parameter 'blobId' must be defined.");
        url_ = url_.replace("{blobId}", encodeURIComponent("" + blobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDownloadResourceFile(_response));
        });
    }

    protected processDoDownloadResourceFile(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doDeleteResource(resourceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceDelete/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDeleteResource(_response));
        });
    }

    protected processDoDeleteResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doSortTasks(doSortTasksRequest: DoSortTasksRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortTasksRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortTasks(_response));
        });
    }

    protected processDoSortTasks(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doSortModules(doSortModulesRequest: DoSortModulesRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortModulesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortModules(_response));
        });
    }

    protected processDoSortModules(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doSortTopics(doSortTopicsRequest: DoSortTopicsRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/topics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortTopicsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortTopics(_response));
        });
    }

    protected processDoSortTopics(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteTopic(topicId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/topic/{topicId}";
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTopic(_response));
        });
    }

    protected processDeleteTopic(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteTask(taskId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/task/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTask(_response));
        });
    }

    protected processDeleteTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteModule(moduleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/module/{moduleId}";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteModule(_response));
        });
    }

    protected processDeleteModule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCompleteHelpRequest(helpRequestId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest/{helpRequestId}";
        if (helpRequestId === undefined || helpRequestId === null)
            throw new Error("The parameter 'helpRequestId' must be defined.");
        url_ = url_.replace("{helpRequestId}", encodeURIComponent("" + helpRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCompleteHelpRequest(_response));
        });
    }

    protected processDoCompleteHelpRequest(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveHelpRequest(helpRequestDto: HelpRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(helpRequestDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveHelpRequest(_response));
        });
    }

    protected processSaveHelpRequest(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getHelpRequest(filters_Completed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfHelpRequestSummaryDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest?";
        if (filters_Completed !== undefined && filters_Completed !== null)
            url_ += "Filters.Completed=" + encodeURIComponent("" + filters_Completed) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHelpRequest(_response));
        });
    }

    protected processGetHelpRequest(response: AxiosResponse): Promise<PaginatedResponseOfHelpRequestSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfHelpRequestSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfHelpRequestSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfHelpRequestSummaryDto>(null as any);
    }

    saveModule(moduleDto: SaveModuleRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveModule(_response));
        });
    }

    protected processSaveModule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveTopic(topicDto: SaveTopicRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/topic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTopic(_response));
        });
    }

    protected processSaveTopic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveTask(formFile: FileParameter | null | undefined, saveTaskRequest_TaskId: string | null | undefined, saveTaskRequest_Name: string | null | undefined, saveTaskRequest_Detailes: string | null | undefined, saveTaskRequest_ExternalUrl: string | null | undefined, saveTaskRequest_Content: string | null | undefined, saveTaskRequest_Description: string | null | undefined, saveTaskRequest_TopicId: string | undefined, saveTaskRequest_TaskType: TaskType2 | undefined, saveTaskRequest_BlobId: string | null | undefined, saveTaskRequest_IsEmbedded: boolean | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (saveTaskRequest_TaskId !== null && saveTaskRequest_TaskId !== undefined)
            content_.append("SaveTaskRequest.TaskId", saveTaskRequest_TaskId.toString());
        if (saveTaskRequest_Name !== null && saveTaskRequest_Name !== undefined)
            content_.append("SaveTaskRequest.Name", saveTaskRequest_Name.toString());
        if (saveTaskRequest_Detailes !== null && saveTaskRequest_Detailes !== undefined)
            content_.append("SaveTaskRequest.Detailes", saveTaskRequest_Detailes.toString());
        if (saveTaskRequest_ExternalUrl !== null && saveTaskRequest_ExternalUrl !== undefined)
            content_.append("SaveTaskRequest.ExternalUrl", saveTaskRequest_ExternalUrl.toString());
        if (saveTaskRequest_Content !== null && saveTaskRequest_Content !== undefined)
            content_.append("SaveTaskRequest.Content", saveTaskRequest_Content.toString());
        if (saveTaskRequest_Description !== null && saveTaskRequest_Description !== undefined)
            content_.append("SaveTaskRequest.Description", saveTaskRequest_Description.toString());
        if (saveTaskRequest_TopicId === null || saveTaskRequest_TopicId === undefined)
            throw new Error("The parameter 'saveTaskRequest_TopicId' cannot be null.");
        else
            content_.append("SaveTaskRequest.TopicId", saveTaskRequest_TopicId.toString());
        if (saveTaskRequest_TaskType === null || saveTaskRequest_TaskType === undefined)
            throw new Error("The parameter 'saveTaskRequest_TaskType' cannot be null.");
        else
            content_.append("SaveTaskRequest.TaskType", saveTaskRequest_TaskType.toString());
        if (saveTaskRequest_BlobId !== null && saveTaskRequest_BlobId !== undefined)
            content_.append("SaveTaskRequest.BlobId", saveTaskRequest_BlobId.toString());
        if (saveTaskRequest_IsEmbedded !== null && saveTaskRequest_IsEmbedded !== undefined)
            content_.append("SaveTaskRequest.IsEmbedded", saveTaskRequest_IsEmbedded.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTask(_response));
        });
    }

    protected processSaveTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doCompleteTask(agentCompleteTaskRequest: AgentCompleteTaskRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/taskComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentCompleteTaskRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCompleteTask(_response));
        });
    }

    protected processDoCompleteTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getResources(filters_ResourceType: ResourceType2 | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfResourceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resources?";
        if (filters_ResourceType === null)
            throw new Error("The parameter 'filters_ResourceType' cannot be null.");
        else if (filters_ResourceType !== undefined)
            url_ += "Filters.ResourceType=" + encodeURIComponent("" + filters_ResourceType) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResources(_response));
        });
    }

    protected processGetResources(response: AxiosResponse): Promise<PaginatedResponseOfResourceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfResourceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfResourceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfResourceDto>(null as any);
    }

    getHelpRequestCount( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequestCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHelpRequestCount(_response));
        });
    }

    protected processGetHelpRequestCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStatus(agentId: string | null | undefined, cancelToken?: CancelToken): Promise<AgentTaskCompletionStatusSummary> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/status?";
        if (agentId !== undefined && agentId !== null)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatus(_response));
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AgentTaskCompletionStatusSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentTaskCompletionStatusSummary.fromJS(resultData200);
            return Promise.resolve<AgentTaskCompletionStatusSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentTaskCompletionStatusSummary>(null as any);
    }

    getModules(filters_AgentRole: AgentRole | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadModuleDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/modules?";
        if (filters_AgentRole === null)
            throw new Error("The parameter 'filters_AgentRole' cannot be null.");
        else if (filters_AgentRole !== undefined)
            url_ += "Filters.AgentRole=" + encodeURIComponent("" + filters_AgentRole) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetModules(_response));
        });
    }

    protected processGetModules(response: AxiosResponse): Promise<PaginatedResponseOfReadModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadModuleDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadModuleDto>(null as any);
    }

    getTopics(filters_ModuleId: string | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadTopicDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/topics?";
        if (filters_ModuleId === null)
            throw new Error("The parameter 'filters_ModuleId' cannot be null.");
        else if (filters_ModuleId !== undefined)
            url_ += "Filters.ModuleId=" + encodeURIComponent("" + filters_ModuleId) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTopics(_response));
        });
    }

    protected processGetTopics(response: AxiosResponse): Promise<PaginatedResponseOfReadTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadTopicDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadTopicDto>(null as any);
    }

    getTasks(filters_TopicId: string | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadTaskDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/tasks?";
        if (filters_TopicId === null)
            throw new Error("The parameter 'filters_TopicId' cannot be null.");
        else if (filters_TopicId !== undefined)
            url_ += "Filters.TopicId=" + encodeURIComponent("" + filters_TopicId) + "&";
        if (returnCounters === null)
            throw new Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: AxiosResponse): Promise<PaginatedResponseOfReadTaskDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadTaskDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadTaskDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadTaskDto>(null as any);
    }

    getAgentTask(taskId: string | undefined, cancelToken?: CancelToken): Promise<AgentTaskViewCompleteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/agent/getTask?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentTask(_response));
        });
    }

    protected processGetAgentTask(response: AxiosResponse): Promise<AgentTaskViewCompleteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentTaskViewCompleteDto.fromJS(resultData200);
            return Promise.resolve<AgentTaskViewCompleteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentTaskViewCompleteDto>(null as any);
    }

    getAgentModules(agentId: string | null | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentModuleDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/agent/getModules?";
        if (agentId !== undefined && agentId !== null)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentModules(_response));
        });
    }

    protected processGetAgentModules(response: AxiosResponse): Promise<PaginatedResponseOfAgentModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentModuleDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentModuleDto>(null as any);
    }
}

export class WrapUpClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    completePhoneWrapUp(phoneCallRecordId: string, model: CompletePhoneWrapUpModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/wrap-up/{phoneCallRecordId}/complete";
        if (phoneCallRecordId === undefined || phoneCallRecordId === null)
            throw new Error("The parameter 'phoneCallRecordId' must be defined.");
        url_ = url_.replace("{phoneCallRecordId}", encodeURIComponent("" + phoneCallRecordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompletePhoneWrapUp(_response));
        });
    }

    protected processCompletePhoneWrapUp(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPendingWrapUps( cancelToken?: CancelToken): Promise<PhoneWrapUpPendingResult[]> {
        let url_ = this.baseUrl + "/api/wrap-up";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPendingWrapUps(_response));
        });
    }

    protected processGetPendingWrapUps(response: AxiosResponse): Promise<PhoneWrapUpPendingResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneWrapUpPendingResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PhoneWrapUpPendingResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhoneWrapUpPendingResult[]>(null as any);
    }
}

export class UsersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserContext( cancelToken?: CancelToken): Promise<UserContextResult> {
        let url_ = this.baseUrl + "/api/v1/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserContext(_response));
        });
    }

    protected processGetUserContext(response: AxiosResponse): Promise<UserContextResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserContextResult.fromJS(resultData200);
            return Promise.resolve<UserContextResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContextResult>(null as any);
    }

    setUserIsEnabled(userId: string, model: SetUserIsEnabledModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/enabled";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserIsEnabled(_response));
        });
    }

    protected processSetUserIsEnabled(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UserStatusesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserStatus( cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserStatus(_response));
        });
    }

    protected processGetUserStatus(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }

    setUserStatus(model: SetUserStatusModel, cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserStatus(_response));
        });
    }

    protected processSetUserStatus(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }

    extendExpiration(userStatusId: string, model: ExtendExpirationModel, cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses/{userStatusId}";
        if (userStatusId === undefined || userStatusId === null)
            throw new Error("The parameter 'userStatusId' must be defined.");
        url_ = url_.replace("{userStatusId}", encodeURIComponent("" + userStatusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExtendExpiration(_response));
        });
    }

    protected processExtendExpiration(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }
}

export class UserStatusesHistoryClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    statusHistory(userId: string, cancelToken?: CancelToken): Promise<UserStatusHistoryResult[]> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/statuses";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStatusHistory(_response));
        });
    }

    protected processStatusHistory(response: AxiosResponse): Promise<UserStatusHistoryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserStatusHistoryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserStatusHistoryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusHistoryResult[]>(null as any);
    }
}

export class UserRolesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setUserRoles(studyId: string, model: SetUserRolesModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/user/roles/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserRoles(_response));
        });
    }

    protected processSetUserRoles(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PublicTasksClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getJoin(callbackTaskId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/public-tasks/{callbackTaskId}/join";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJoin(_response));
        });
    }

    protected processGetJoin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TasksClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCallbackTasks(isActive: boolean | null | undefined, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks?";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallbackTasks(_response));
        });
    }

    protected processGetCallbackTasks(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    createTask(model: CreateCallbackTaskModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTask(_response));
        });
    }

    protected processCreateTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCallDurationOptions(studyId: string | null | undefined, callType: CallType | null | undefined, excludeSystem: boolean | undefined, cancelToken?: CancelToken): Promise<StudyCallDurationOptionResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/options?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (callType !== undefined && callType !== null)
            url_ += "callType=" + encodeURIComponent("" + callType) + "&";
        if (excludeSystem === null)
            throw new Error("The parameter 'excludeSystem' cannot be null.");
        else if (excludeSystem !== undefined)
            url_ += "excludeSystem=" + encodeURIComponent("" + excludeSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallDurationOptions(_response));
        });
    }

    protected processGetCallDurationOptions(response: AxiosResponse): Promise<StudyCallDurationOptionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyCallDurationOptionResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyCallDurationOptionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyCallDurationOptionResult[]>(null as any);
    }

    createCallAttempt(callbackTaskId: string, model: CreateCallbackAttemptModel, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/{callbackTaskId}/attempts";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallAttempt(_response));
        });
    }

    protected processCreateCallAttempt(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    requeueTask(callbackTaskId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/{callbackTaskId}/requeue";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRequeueTask(_response));
        });
    }

    protected processRequeueTask(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    getJoin(callbackTaskId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/join";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJoin(_response));
        });
    }

    protected processGetJoin(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getRedirect(callbackTaskId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/redirect";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRedirect(_response));
        });
    }

    protected processGetRedirect(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTaskStateHistory(taskItemId: string, cancelToken?: CancelToken): Promise<TaskStateResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/states";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaskStateHistory(_response));
        });
    }

    protected processGetTaskStateHistory(response: AxiosResponse): Promise<TaskStateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskStateResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskStateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskStateResult[]>(null as any);
    }

    getHasRating(callbackTaskId: string, cancelToken?: CancelToken): Promise<ValueTupleOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/hasRating";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHasRating(_response));
        });
    }

    protected processGetHasRating(response: AxiosResponse): Promise<ValueTupleOfStringAndBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueTupleOfStringAndBoolean.fromJS(resultData200);
            return Promise.resolve<ValueTupleOfStringAndBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfStringAndBoolean>(null as any);
    }

    setRating(callbackTaskId: string, model: CallRatingModel, cancelToken?: CancelToken): Promise<number | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/rating";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetRating(_response));
        });
    }

    protected processSetRating(response: AxiosResponse): Promise<number | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number | null>(null as any);
    }

    archiveTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/archive";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveTask(_response));
        });
    }

    protected processArchiveTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    wrapUpArchive(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/wrap-up/archive";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWrapUpArchive(_response));
        });
    }

    protected processWrapUpArchive(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    cancelTask(taskItemId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/cancel";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelTask(_response));
        });
    }

    protected processCancelTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    completeTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/complete";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteTask(_response));
        });
    }

    protected processCompleteTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    handleTask(taskItemId: string, model: HandleTaskModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/handle";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHandleTask(_response));
        });
    }

    protected processHandleTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    unArchiveTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/unarchive";
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnArchiveTask(_response));
        });
    }

    protected processUnArchiveTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createAgentCallbackTask(model: AgentCreateCallbackTaskModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/agents/callbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAgentCallbackTask(_response));
        });
    }

    protected processCreateAgentCallbackTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createHcpCallbackTask(model: AgentCreateHcpCallbackTaskModel, cancelToken?: CancelToken): Promise<CreateHcpCallResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/agents/callbacks/hcp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateHcpCallbackTask(_response));
        });
    }

    protected processCreateHcpCallbackTask(response: AxiosResponse): Promise<CreateHcpCallResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateHcpCallResponse.fromJS(resultData200);
            return Promise.resolve<CreateHcpCallResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateHcpCallResponse>(null as any);
    }

    getAppointmentCountForUserStudy(studyId: string, userId: string, shiftStart: Date | undefined, shiftEnd: Date | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/tasks/studies/{studyId}/users/{userId}/apppointments?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (shiftStart === null)
            throw new Error("The parameter 'shiftStart' cannot be null.");
        else if (shiftStart !== undefined)
            url_ += "shiftStart=" + encodeURIComponent(shiftStart ? "" + shiftStart.toISOString() : "") + "&";
        if (shiftEnd === null)
            throw new Error("The parameter 'shiftEnd' cannot be null.");
        else if (shiftEnd !== undefined)
            url_ += "shiftEnd=" + encodeURIComponent(shiftEnd ? "" + shiftEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppointmentCountForUserStudy(_response));
        });
    }

    protected processGetAppointmentCountForUserStudy(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCallAttemptConfiguration(studyId: string | undefined, callType: CallType | undefined, agentType: AgentType | undefined, cancelToken?: CancelToken): Promise<CallAttemptConfigurationResult> {
        let url_ = this.baseUrl + "/api/v1/tasks/call-attempt-config?";
        if (studyId === null)
            throw new Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (callType === null)
            throw new Error("The parameter 'callType' cannot be null.");
        else if (callType !== undefined)
            url_ += "callType=" + encodeURIComponent("" + callType) + "&";
        if (agentType === null)
            throw new Error("The parameter 'agentType' cannot be null.");
        else if (agentType !== undefined)
            url_ += "agentType=" + encodeURIComponent("" + agentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallAttemptConfiguration(_response));
        });
    }

    protected processGetCallAttemptConfiguration(response: AxiosResponse): Promise<CallAttemptConfigurationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallAttemptConfigurationResult.fromJS(resultData200);
            return Promise.resolve<CallAttemptConfigurationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallAttemptConfigurationResult>(null as any);
    }

    recreateVideoAppointmentLinks( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/recreateVideoAppointmentLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRecreateVideoAppointmentLinks(_response));
        });
    }

    protected processRecreateVideoAppointmentLinks(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StudiesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStudiesForUser( cancelToken?: CancelToken): Promise<StudyResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudiesForUser(_response));
        });
    }

    protected processGetStudiesForUser(response: AxiosResponse): Promise<StudyResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyResult[]>(null as any);
    }

    updateStudyUser(userId: string, model: UpdateStudyUserModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyUser(_response));
        });
    }

    protected processUpdateStudyUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getStudyEmailConfiguration(studyId: string, cancelToken?: CancelToken): Promise<StudyEmailConfigurationResult> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/emails/configuration";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyEmailConfiguration(_response));
        });
    }

    protected processGetStudyEmailConfiguration(response: AxiosResponse): Promise<StudyEmailConfigurationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyEmailConfigurationResult.fromJS(resultData200);
            return Promise.resolve<StudyEmailConfigurationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyEmailConfigurationResult>(null as any);
    }

    updateStudyEmailConfiguration(studyId: string, model: UpdateStudyEmailConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/emails/configuration";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyEmailConfiguration(_response));
        });
    }

    protected processUpdateStudyEmailConfiguration(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StatusesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRootStatuses( cancelToken?: CancelToken): Promise<RootStatusResult[]> {
        let url_ = this.baseUrl + "/api/v1/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRootStatuses(_response));
        });
    }

    protected processGetRootStatuses(response: AxiosResponse): Promise<RootStatusResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RootStatusResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RootStatusResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RootStatusResult[]>(null as any);
    }

    createSubStatus(statusId: string, model: NewStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/sub-statuses";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateSubStatus(_response));
        });
    }

    protected processCreateSubStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    updateStatus(statusId: string, model: UpdateStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStatus(_response));
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    deleteSubStatusStatus(statusId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSubStatusStatus(_response));
        });
    }

    protected processDeleteSubStatusStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateDurationStatus(statusId: string, model: UpdateDurationStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/duration/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDurationStatus(_response));
        });
    }

    protected processUpdateDurationStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    createDurationSubStatus(statusId: string, model: NewDurationStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/sub-statuses/duration";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDurationSubStatus(_response));
        });
    }

    protected processCreateDurationSubStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    updateStatusCulture(statusId: string, cultureCode: string, model: UpdateStatusCultureViewModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/cultures/{cultureCode}";
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        if (cultureCode === undefined || cultureCode === null)
            throw new Error("The parameter 'cultureCode' must be defined.");
        url_ = url_.replace("{cultureCode}", encodeURIComponent("" + cultureCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStatusCulture(_response));
        });
    }

    protected processUpdateStatusCulture(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class RolesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllRoles( cancelToken?: CancelToken): Promise<CallbackRoleResult[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRoles(_response));
        });
    }

    protected processGetAllRoles(response: AxiosResponse): Promise<CallbackRoleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackRoleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallbackRoleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult[]>(null as any);
    }

    createRole(model: CreateRoleModel, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateRole(_response));
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    getRoles(studyId: string, cancelToken?: CancelToken): Promise<CallbackRoleResult[]> {
        let url_ = this.baseUrl + "/api/v1/roles/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<CallbackRoleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackRoleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallbackRoleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult[]>(null as any);
    }

    getRoleById(roleId: string, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoleById(_response));
        });
    }

    protected processGetRoleById(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    updateRole(roleId: string, model: UpdateRoleModel, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRole(_response));
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    deleteRole(roleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteRole(_response));
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PhoneClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAsteriskUser( cancelToken?: CancelToken): Promise<GetSoftphoneUserResponse> {
        let url_ = this.baseUrl + "/api/Phone/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAsteriskUser(_response));
        });
    }

    protected processGetAsteriskUser(response: AxiosResponse): Promise<GetSoftphoneUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSoftphoneUserResponse.fromJS(resultData200);
            return Promise.resolve<GetSoftphoneUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSoftphoneUserResponse>(null as any);
    }
}

export class PermissionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPermissions( cancelToken?: CancelToken): Promise<PermissionResult[]> {
        let url_ = this.baseUrl + "/api/v1/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPermissions(_response));
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PermissionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PermissionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionResult[]>(null as any);
    }
}

export class PatientUnsubscribeClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isPatientUnsubscribed(patientId: string, cancelToken?: CancelToken): Promise<IsPatientUnsubscribedModel> {
        let url_ = this.baseUrl + "/api/unsubscribe/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsPatientUnsubscribed(_response));
        });
    }

    protected processIsPatientUnsubscribed(response: AxiosResponse): Promise<IsPatientUnsubscribedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsPatientUnsubscribedModel.fromJS(resultData200);
            return Promise.resolve<IsPatientUnsubscribedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsPatientUnsubscribedModel>(null as any);
    }

    unsubscribe(patientId: string, cancelToken?: CancelToken): Promise<IsPatientUnsubscribedModel> {
        let url_ = this.baseUrl + "/api/unsubscribe/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnsubscribe(_response));
        });
    }

    protected processUnsubscribe(response: AxiosResponse): Promise<IsPatientUnsubscribedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsPatientUnsubscribedModel.fromJS(resultData200);
            return Promise.resolve<IsPatientUnsubscribedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsPatientUnsubscribedModel>(null as any);
    }
}

export class PatientFollowUpsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isValidEmailFollowUp(model: ValidateFollowUpModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/validateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsValidEmailFollowUp(_response));
        });
    }

    protected processIsValidEmailFollowUp(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setFollowUpAnswers(followUpId: string, model: SaxendaAnswerModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{followUpId}/submitAnswers";
        if (followUpId === undefined || followUpId === null)
            throw new Error("The parameter 'followUpId' must be defined.");
        url_ = url_.replace("{followUpId}", encodeURIComponent("" + followUpId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetFollowUpAnswers(_response));
        });
    }

    protected processSetFollowUpAnswers(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PatientFollowUpsManagementClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSchedules(studyId: string | null | undefined, cancelToken?: CancelToken): Promise<StudyFollowUpScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSchedules(_response));
        });
    }

    protected processGetSchedules(response: AxiosResponse): Promise<StudyFollowUpScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpScheduleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyFollowUpScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpScheduleResult[]>(null as any);
    }

    getCallSchedules(studyId: string, cancelToken?: CancelToken): Promise<StudyFollowUpCallScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/callSchedules";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallSchedules(_response));
        });
    }

    protected processGetCallSchedules(response: AxiosResponse): Promise<StudyFollowUpCallScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpCallScheduleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyFollowUpCallScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpCallScheduleResult[]>(null as any);
    }

    createCallSchedule(studyId: string, model: CallScheduleModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/callSchedules";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallSchedule(_response));
        });
    }

    protected processCreateCallSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateCallSchedule(callScheduleId: string, model: CallScheduleModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/callSchedules/{callScheduleId}";
        if (callScheduleId === undefined || callScheduleId === null)
            throw new Error("The parameter 'callScheduleId' must be defined.");
        url_ = url_.replace("{callScheduleId}", encodeURIComponent("" + callScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCallSchedule(_response));
        });
    }

    protected processUpdateCallSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteCallSchedule(callScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/callSchedules/{callScheduleId}";
        if (callScheduleId === undefined || callScheduleId === null)
            throw new Error("The parameter 'callScheduleId' must be defined.");
        url_ = url_.replace("{callScheduleId}", encodeURIComponent("" + callScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteCallSchedule(_response));
        });
    }

    protected processDeleteCallSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEmailSchedules(studyId: string, cancelToken?: CancelToken): Promise<StudyFollowUpEmailScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/emailSchedules";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailSchedules(_response));
        });
    }

    protected processGetEmailSchedules(response: AxiosResponse): Promise<StudyFollowUpEmailScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpEmailScheduleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyFollowUpEmailScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpEmailScheduleResult[]>(null as any);
    }

    createEmailSchedule(studyId: string, model: EmailScheduleModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/emailSchedules";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEmailSchedule(_response));
        });
    }

    protected processCreateEmailSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateEmailSchedule(emailScheduleId: string, model: EmailScheduleModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/emailSchedules/{emailScheduleId}";
        if (emailScheduleId === undefined || emailScheduleId === null)
            throw new Error("The parameter 'emailScheduleId' must be defined.");
        url_ = url_.replace("{emailScheduleId}", encodeURIComponent("" + emailScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmailSchedule(_response));
        });
    }

    protected processUpdateEmailSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteEmailSchedule(emailScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/emailSchedules/{emailScheduleId}";
        if (emailScheduleId === undefined || emailScheduleId === null)
            throw new Error("The parameter 'emailScheduleId' must be defined.");
        url_ = url_.replace("{emailScheduleId}", encodeURIComponent("" + emailScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteEmailSchedule(_response));
        });
    }

    protected processDeleteEmailSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MissedAppointmentFollowupClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createEmailFollowup(model: MissedAppointmentEmailFollowupModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEmailFollowup(_response));
        });
    }

    protected processCreateEmailFollowup(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEmailFollowupSchedules(studyId: string, cancelToken?: CancelToken): Promise<MissedAppointmentEmailScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/{studyId}/emailFollowUpSchedules";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailFollowupSchedules(_response));
        });
    }

    protected processGetEmailFollowupSchedules(response: AxiosResponse): Promise<MissedAppointmentEmailScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissedAppointmentEmailScheduleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MissedAppointmentEmailScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissedAppointmentEmailScheduleResult[]>(null as any);
    }

    updateEmailFollowupSchedule(scheduleId: string, model: MissedAppointmentEmailFollowupModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/updateEmailFollowUpSchedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmailFollowupSchedule(_response));
        });
    }

    protected processUpdateEmailFollowupSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteFollowupSchedule(scheduleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/deleteEmailFollowUpSchedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteFollowupSchedule(_response));
        });
    }

    protected processDeleteFollowupSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getStudyCallAttemptConfigurations(studyId: string, cancelToken?: CancelToken): Promise<CallAttemptConfigurationResult[]> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/callbackConfigurations/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyCallAttemptConfigurations(_response));
        });
    }

    protected processGetStudyCallAttemptConfigurations(response: AxiosResponse): Promise<CallAttemptConfigurationResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallAttemptConfigurationResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallAttemptConfigurationResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallAttemptConfigurationResult[]>(null as any);
    }

    createCallConfiguration(studyId: string, model: MissedAppointmentCallConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/{studyId}/callBackConfiguration";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallConfiguration(_response));
        });
    }

    protected processCreateCallConfiguration(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateCallConfiguration(configurationId: string, model: MissedAppointmentCallConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/callbackConfiguration/{configurationId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCallConfiguration(_response));
        });
    }

    protected processUpdateCallConfiguration(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MessageThreadsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMessageThreadSummaries( cancelToken?: CancelToken): Promise<MessageThreadSummaryResult[]> {
        let url_ = this.baseUrl + "/message-threads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMessageThreadSummaries(_response));
        });
    }

    protected processGetMessageThreadSummaries(response: AxiosResponse): Promise<MessageThreadSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageThreadSummaryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MessageThreadSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadSummaryResult[]>(null as any);
    }

    createThread(model: CreateMessageThreadRequestModel, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateThread(_response));
        });
    }

    protected processCreateThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    getThread(messageThreadId: string, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetThread(_response));
        });
    }

    protected processGetThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    readThread(messageThreadId: string, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/read";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReadThread(_response));
        });
    }

    protected processReadThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    createComment(model: CreateCommentForMessageThreadRequestModel, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateComment(_response));
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    completeThread(messageThreadId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/complete";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteThread(_response));
        });
    }

    protected processCompleteThread(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    uncompleteThread(messageThreadId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/uncomplete";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUncompleteThread(_response));
        });
    }

    protected processUncompleteThread(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class InitialStateClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loadEmails( cancelToken?: CancelToken): Promise<InitialStateEmailResult> {
        let url_ = this.baseUrl + "/api/InitialState/emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadEmails(_response));
        });
    }

    protected processLoadEmails(response: AxiosResponse): Promise<InitialStateEmailResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InitialStateEmailResult.fromJS(resultData200);
            return Promise.resolve<InitialStateEmailResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InitialStateEmailResult>(null as any);
    }

    loadAdministrativeData( cancelToken?: CancelToken): Promise<AdministrativeDataResult> {
        let url_ = this.baseUrl + "/api/InitialState/administrative-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadAdministrativeData(_response));
        });
    }

    protected processLoadAdministrativeData(response: AxiosResponse): Promise<AdministrativeDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdministrativeDataResult.fromJS(resultData200);
            return Promise.resolve<AdministrativeDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdministrativeDataResult>(null as any);
    }

    loadTaskData( cancelToken?: CancelToken): Promise<TaskDataResult> {
        let url_ = this.baseUrl + "/api/InitialState/task-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadTaskData(_response));
        });
    }

    protected processLoadTaskData(response: AxiosResponse): Promise<TaskDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskDataResult.fromJS(resultData200);
            return Promise.resolve<TaskDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDataResult>(null as any);
    }
}

export class IncomingVideosClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getActiveVideos( cancelToken?: CancelToken): Promise<IncomingVideoResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveVideos(_response));
        });
    }

    protected processGetActiveVideos(response: AxiosResponse): Promise<IncomingVideoResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingVideoResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IncomingVideoResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoResult[]>(null as any);
    }

    getInProgressVideos( cancelToken?: CancelToken): Promise<InProgressVideoCallResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/in-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInProgressVideos(_response));
        });
    }

    protected processGetInProgressVideos(response: AxiosResponse): Promise<InProgressVideoCallResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InProgressVideoCallResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InProgressVideoCallResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InProgressVideoCallResult[]>(null as any);
    }

    getVideo(incomingVideoId: string, cancelToken?: CancelToken): Promise<IncomingVideoResult> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideo(_response));
        });
    }

    protected processGetVideo(response: AxiosResponse): Promise<IncomingVideoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncomingVideoResult.fromJS(resultData200);
            return Promise.resolve<IncomingVideoResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoResult>(null as any);
    }

    joinVideo(incomingVideoId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/join";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processJoinVideo(_response));
        });
    }

    protected processJoinVideo(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTaskStateHistory(incomingVideoId: string, cancelToken?: CancelToken): Promise<IncomingVideoStateResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/states";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaskStateHistory(_response));
        });
    }

    protected processGetTaskStateHistory(response: AxiosResponse): Promise<IncomingVideoStateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingVideoStateResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IncomingVideoStateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoStateResult[]>(null as any);
    }

    complete(model: CompleteIncomingVideoModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processComplete(_response));
        });
    }

    protected processComplete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    unArchiveTask(incomingVideoId: string, model: UpdateIncomingVideoStateModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/unarchive";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnArchiveTask(_response));
        });
    }

    protected processUnArchiveTask(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createIncomingVideo(language: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateIncomingVideo(_response));
        });
    }

    protected processCreateIncomingVideo(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getHasRating(incomingVideoId: string, cancelToken?: CancelToken): Promise<ValueTupleOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/hasRating";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHasRating(_response));
        });
    }

    protected processGetHasRating(response: AxiosResponse): Promise<ValueTupleOfStringAndBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueTupleOfStringAndBoolean.fromJS(resultData200);
            return Promise.resolve<ValueTupleOfStringAndBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfStringAndBoolean>(null as any);
    }

    setRating(incomingVideoId: string, model: CallRatingModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/rating";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetRating(_response));
        });
    }

    protected processSetRating(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmailTemplatesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTemplates(studyId: string | null | undefined, cancelToken?: CancelToken): Promise<EmailTemplateResult[]> {
        let url_ = this.baseUrl + "/api/email-templates?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplates(_response));
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<EmailTemplateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailTemplateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult[]>(null as any);
    }

    getTemplate(templateId: string, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplate(_response));
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    deleteTemplate(templateId: string, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTemplate(_response));
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    updateTemplate(templateId: string, model: UpdateEmailTemplateModel2, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTemplate(_response));
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    createTemplate(studyId: string, model: CreateEmailTemplateModel2, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTemplate(_response));
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    updateContent(emailContentId: string, subject: string | null | undefined, body: string | null | undefined, files: FileParameter[] | null | undefined, deleteAttachmentIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<EmailContentResult> {
        let url_ = this.baseUrl + "/api/email-templates/contents/{emailContentId}";
        if (emailContentId === undefined || emailContentId === null)
            throw new Error("The parameter 'emailContentId' must be defined.");
        url_ = url_.replace("{emailContentId}", encodeURIComponent("" + emailContentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (body !== null && body !== undefined)
            content_.append("Body", body.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (deleteAttachmentIds !== null && deleteAttachmentIds !== undefined)
            deleteAttachmentIds.forEach(item_ => content_.append("DeleteAttachmentIds", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateContent(_response));
        });
    }

    protected processUpdateContent(response: AxiosResponse): Promise<EmailContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailContentResult.fromJS(resultData200);
            return Promise.resolve<EmailContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailContentResult>(null as any);
    }

    createContent(emailTemplateId: string, model: CreateEmailContentModel, cancelToken?: CancelToken): Promise<EmailContentResult> {
        let url_ = this.baseUrl + "/api/email-templates/{emailTemplateId}/contents";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateContent(_response));
        });
    }

    protected processCreateContent(response: AxiosResponse): Promise<EmailContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailContentResult.fromJS(resultData200);
            return Promise.resolve<EmailContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailContentResult>(null as any);
    }
}

export class EmailClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInfoEmails( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/InfoEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInfoEmails(_response));
        });
    }

    protected processGetInfoEmails(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getProcessedInfoEmails( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessedInfoEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProcessedInfoEmails(_response));
        });
    }

    protected processGetProcessedInfoEmails(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getFaxReceipts( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/FaxReceipts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFaxReceipts(_response));
        });
    }

    protected processGetFaxReceipts(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getProcessedFaxReceipts( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessedFaxReceipts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProcessedFaxReceipts(_response));
        });
    }

    protected processGetProcessedFaxReceipts(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getSentFaxes( cancelToken?: CancelToken): Promise<SentEmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/SentFaxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSentFaxes(_response));
        });
    }

    protected processGetSentFaxes(response: AxiosResponse): Promise<SentEmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SentEmailResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SentEmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SentEmailResult[]>(null as any);
    }

    processEmail(model: ProcessEmailModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProcessEmail(_response));
        });
    }

    protected processProcessEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    unprocessEmail(model: ProcessEmailModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/emails/UnprocessEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnprocessEmail(_response));
        });
    }

    protected processUnprocessEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAttachment(emailAddress: string, messageID: string, fileName: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/emails/{emailAddress}/{messageID}/{fileName}";
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        if (messageID === undefined || messageID === null)
            throw new Error("The parameter 'messageID' must be defined.");
        url_ = url_.replace("{messageID}", encodeURIComponent("" + messageID));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmailSendersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEmailSenders( cancelToken?: CancelToken): Promise<EmailSenderServiceResult[]> {
        let url_ = this.baseUrl + "/api/v1/emailSenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailSenders(_response));
        });
    }

    protected processGetEmailSenders(response: AxiosResponse): Promise<EmailSenderServiceResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailSenderServiceResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailSenderServiceResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailSenderServiceResult[]>(null as any);
    }
}

export class CulturesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCultures( cancelToken?: CancelToken): Promise<CultureResult[]> {
        let url_ = this.baseUrl + "/api/cultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCultures(_response));
        });
    }

    protected processGetCultures(response: AxiosResponse): Promise<CultureResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CultureResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CultureResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CultureResult[]>(null as any);
    }
}

export class CallActionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTransferSurvey( cancelToken?: CancelToken): Promise<SurveyUIModel[]> {
        let url_ = this.baseUrl + "/api/v1/callActions/surveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransferSurvey(_response));
        });
    }

    protected processGetTransferSurvey(response: AxiosResponse): Promise<SurveyUIModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyUIModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SurveyUIModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyUIModel[]>(null as any);
    }

    doCallTransferToAgent(agentUserId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToAgent?";
        if (agentUserId === null)
            throw new Error("The parameter 'agentUserId' cannot be null.");
        else if (agentUserId !== undefined)
            url_ += "agentUserId=" + encodeURIComponent("" + agentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferToAgent(_response));
        });
    }

    protected processDoCallTransferToAgent(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallTransferSurvey(surveyId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToSurvey?";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferSurvey(_response));
        });
    }

    protected processDoCallTransferSurvey(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallTransferCustomerCare( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToCustomerCare";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferCustomerCare(_response));
        });
    }

    protected processDoCallTransferCustomerCare(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallTransferExternalNumber(destination: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToExternalNumber?";
        if (destination !== undefined && destination !== null)
            url_ += "destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferExternalNumber(_response));
        });
    }

    protected processDoCallTransferExternalNumber(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallMerge( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/merge";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallMerge(_response));
        });
    }

    protected processDoCallMerge(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doHangUp( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/hangup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoHangUp(_response));
        });
    }

    protected processDoHangUp(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallMergeAndQuit( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/mergeandquit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallMergeAndQuit(_response));
        });
    }

    protected processDoCallMergeAndQuit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    doCallAbort( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/callActions/abort";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallAbort(_response));
        });
    }

    protected processDoCallAbort(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class StudyUserScheduleClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setStudyUserScheduleIsLockedFalse(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/unlock?";
        if (studyUserScheduleId === null)
            throw new Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStudyUserScheduleIsLockedFalse(_response));
        });
    }

    protected processSetStudyUserScheduleIsLockedFalse(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setStudyUserScheduleIsLockedTrue(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/lock?";
        if (studyUserScheduleId === null)
            throw new Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStudyUserScheduleIsLockedTrue(_response));
        });
    }

    protected processSetStudyUserScheduleIsLockedTrue(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSchedules(userId: string | null | undefined, studyId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<UserScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSchedules(_response));
        });
    }

    protected processGetSchedules(response: AxiosResponse): Promise<UserScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserScheduleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserScheduleResult[]>(null as any);
    }

    createStudyUserSchedule(model: CreateStudyUserScheduleModel, cancelToken?: CancelToken): Promise<UserScheduleResult> {
        let url_ = this.baseUrl + "/api/v1/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateStudyUserSchedule(_response));
        });
    }

    protected processCreateStudyUserSchedule(response: AxiosResponse): Promise<UserScheduleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserScheduleResult.fromJS(resultData200);
            return Promise.resolve<UserScheduleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserScheduleResult>(null as any);
    }

    updateUserSchedule(model: UpdateUserScheduleRequestModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserSchedule(_response));
        });
    }

    protected processUpdateUserSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getScheduleReport(studyId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/report?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleReport(_response));
        });
    }

    protected processGetScheduleReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteStudyUserSchedule(studyUserScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyUserScheduleId}";
        if (studyUserScheduleId === undefined || studyUserScheduleId === null)
            throw new Error("The parameter 'studyUserScheduleId' must be defined.");
        url_ = url_.replace("{studyUserScheduleId}", encodeURIComponent("" + studyUserScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteStudyUserSchedule(_response));
        });
    }

    protected processDeleteStudyUserSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getScheduleOpeningsForUser(userId: string | null, studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/{userId}/openings?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningsForUser(_response));
        });
    }

    protected processGetScheduleOpeningsForUser(response: AxiosResponse): Promise<ScheduleOpeningResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScheduleOpeningResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult[]>(null as any);
    }

    getScheduleOpeningsForStudy(studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/openings?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningsForStudy(_response));
        });
    }

    protected processGetScheduleOpeningsForStudy(response: AxiosResponse): Promise<ScheduleOpeningResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScheduleOpeningResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult[]>(null as any);
    }

    getScheduleOpeningSlotsForUser(userId: string | null, studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/{userId}/openings/slots?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningSlotsForUser(_response));
        });
    }

    protected processGetScheduleOpeningSlotsForUser(response: AxiosResponse): Promise<ScheduleOpeningResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScheduleOpeningResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult[]>(null as any);
    }

    getScheduleOpeningSlotsForStudy(studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/openings/slots?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningSlotsForStudy(_response));
        });
    }

    protected processGetScheduleOpeningSlotsForStudy(response: AxiosResponse): Promise<ScheduleOpeningResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScheduleOpeningResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult[]>(null as any);
    }

    getStudyUserHours(userId: string | null | undefined, studyId: string | null | undefined, from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<StudyUserHoursResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/studies/hours?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyUserHours(_response));
        });
    }

    protected processGetStudyUserHours(response: AxiosResponse): Promise<StudyUserHoursResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyUserHoursResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StudyUserHoursResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyUserHoursResult[]>(null as any);
    }

    isUserScheduled(userId: string, studyUserScheduleId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/{userId}/scheduleValidation?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyUserScheduleId !== undefined && studyUserScheduleId !== null)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsUserScheduled(_response));
        });
    }

    protected processIsUserScheduled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    duplicateSchedule(studyId: string, model: DuplicateScheduleViewModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/duplicateSchedule";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicateSchedule(_response));
        });
    }

    protected processDuplicateSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    postSchedule(studyId: string, model: PostScheduleViewModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/schedulePostDate";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostSchedule(_response));
        });
    }

    protected processPostSchedule(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    currentSchedulePostedDate(studyId: string, cancelToken?: CancelToken): Promise<Date | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/currentSchedulePostDate";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCurrentSchedulePostedDate(_response));
        });
    }

    protected processCurrentSchedulePostedDate(response: AxiosResponse): Promise<Date | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return Promise.resolve<Date | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date | null>(null as any);
    }

    getScheduleGrid(studyId: string | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<GridScheduleViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/scheduleGrid?";
        if (studyId === null)
            throw new Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleGrid(_response));
        });
    }

    protected processGetScheduleGrid(response: AxiosResponse): Promise<GridScheduleViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridScheduleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GridScheduleViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridScheduleViewModel[]>(null as any);
    }

    userScheduleAppointmentCheck(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/userScheduleAppointmentCheck?";
        if (studyUserScheduleId === null)
            throw new Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserScheduleAppointmentCheck(_response));
        });
    }

    protected processUserScheduleAppointmentCheck(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    doesDestinationWeekHaveAppointments(start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/doesDestinationWeekHaveAppointments?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoesDestinationWeekHaveAppointments(_response));
        });
    }

    protected processDoesDestinationWeekHaveAppointments(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AvailabilityClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvailabilityForCurrentUser( cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForCurrentUser(_response));
        });
    }

    protected processGetAvailabilityForCurrentUser(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    getAvailabilityForAllUsers(start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/allUsers?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForAllUsers(_response));
        });
    }

    protected processGetAvailabilityForAllUsers(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    getAvailabilityForUser(userId: string, toDate: Date | null | undefined, fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForUser(_response));
        });
    }

    protected processGetAvailabilityForUser(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    createEntry(model: AvailabilityViewModel, cancelToken?: CancelToken): Promise<AvailabilityViewModel> {
        let url_ = this.baseUrl + "/api/v1/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEntry(_response));
        });
    }

    protected processCreateEntry(response: AxiosResponse): Promise<AvailabilityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityViewModel.fromJS(resultData200);
            return Promise.resolve<AvailabilityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityViewModel>(null as any);
    }

    updateAvailability(model: AvailabilityViewModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAvailability(_response));
        });
    }

    protected processUpdateAvailability(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteAvailability(entryId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/availability/{entryId}";
        if (entryId === undefined || entryId === null)
            throw new Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAvailability(_response));
        });
    }

    protected processDeleteAvailability(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isUserAvailable(userId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/availability/{userId}/availabilityValidation?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsUserAvailable(_response));
        });
    }

    protected processIsUserAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    duplicateAvailability(model: DuplicateAvailabilityViewModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/availability/duplicateAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicateAvailability(_response));
        });
    }

    protected processDuplicateAvailability(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CallHistoryClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCallHistory(to: Date | undefined, from: Date | undefined, cancelToken?: CancelToken): Promise<CallHistoryResult[]> {
        let url_ = this.baseUrl + "/api/call-history?";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallHistory(_response));
        });
    }

    protected processGetCallHistory(response: AxiosResponse): Promise<CallHistoryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallHistoryResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CallHistoryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallHistoryResult[]>(null as any);
    }
}

export class QueuesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQueues( cancelToken?: CancelToken): Promise<AsteriskQueueResult[]> {
        let url_ = this.baseUrl + "/api/queues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueues(_response));
        });
    }

    protected processGetQueues(response: AxiosResponse): Promise<AsteriskQueueResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AsteriskQueueResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AsteriskQueueResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskQueueResult[]>(null as any);
    }

    getQueuesAssignments( cancelToken?: CancelToken): Promise<UserQueuesResult[]> {
        let url_ = this.baseUrl + "/api/queues/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueuesAssignments(_response));
        });
    }

    protected processGetQueuesAssignments(response: AxiosResponse): Promise<UserQueuesResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserQueuesResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserQueuesResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserQueuesResult[]>(null as any);
    }

    setUserQueues(userId: string, model: SetUserQueuesModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/queues/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserQueues(_response));
        });
    }

    protected processSetUserQueues(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    joinQueue(model: JoinTempQueueModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/queues/join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processJoinQueue(_response));
        });
    }

    protected processJoinQueue(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AppointmentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAppointments(from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<AppointmentResult[]> {
        let url_ = this.baseUrl + "/api/appointments?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppointments(_response));
        });
    }

    protected processGetAppointments(response: AxiosResponse): Promise<AppointmentResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppointmentResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentResult[]>(null as any);
    }

    updateAppointment(model: UpdateAppointmentModel, cancelToken?: CancelToken): Promise<AppointmentOutcome> {
        let url_ = this.baseUrl + "/api/appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAppointment(_response));
        });
    }

    protected processUpdateAppointment(response: AxiosResponse): Promise<AppointmentOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<AppointmentOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentOutcome>(null as any);
    }

    getUserPendingAppointments( cancelToken?: CancelToken): Promise<AppointmentResult[]> {
        let url_ = this.baseUrl + "/api/appointments/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserPendingAppointments(_response));
        });
    }

    protected processGetUserPendingAppointments(response: AxiosResponse): Promise<AppointmentResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppointmentResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentResult[]>(null as any);
    }

    createPendingAppointment(model: CreatePendingAppointmentModel, cancelToken?: CancelToken): Promise<PendingAppointmentCreatedModel> {
        let url_ = this.baseUrl + "/api/appointments/pending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreatePendingAppointment(_response));
        });
    }

    protected processCreatePendingAppointment(response: AxiosResponse): Promise<PendingAppointmentCreatedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PendingAppointmentCreatedModel.fromJS(resultData200);
            return Promise.resolve<PendingAppointmentCreatedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PendingAppointmentCreatedModel>(null as any);
    }

    updateAppointmentTime(model: UpdateAppointmentTimeModel, cancelToken?: CancelToken): Promise<AppointmentOutcome> {
        let url_ = this.baseUrl + "/api/appointments/time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAppointmentTime(_response));
        });
    }

    protected processUpdateAppointmentTime(response: AxiosResponse): Promise<AppointmentOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<AppointmentOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentOutcome>(null as any);
    }

    cancelPendingAppointment(appointmentId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/appointments/pending/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelPendingAppointment(_response));
        });
    }

    protected processCancelPendingAppointment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    finalizeHcpManualBreakAppointment(model: FinalizeHcpBreakAppointmentModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/appointments/break";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFinalizeHcpManualBreakAppointment(_response));
        });
    }

    protected processFinalizeHcpManualBreakAppointment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteAppointment(appointmentId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/appointments/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAppointment(_response));
        });
    }

    protected processDeleteAppointment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AgentsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAll( cancelToken?: CancelToken): Promise<UserResult[]> {
        let url_ = this.baseUrl + "/api/v1/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult[]>(null as any);
    }

    getUser(userId: string, cancelToken?: CancelToken): Promise<UserResult> {
        let url_ = this.baseUrl + "/api/v1/agents/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResult.fromJS(resultData200);
            return Promise.resolve<UserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult>(null as any);
    }

    getAllUsersAllStudies( cancelToken?: CancelToken): Promise<UserResult[]> {
        let url_ = this.baseUrl + "/api/v1/agents/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllUsersAllStudies(_response));
        });
    }

    protected processGetAllUsersAllStudies(response: AxiosResponse): Promise<UserResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult[]>(null as any);
    }
}

export class PatientConversationSummaryModel implements IPatientConversationSummaryModel {
    patientConversationId!: string;
    patientId!: string;
    lumediStudyId!: string;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    state!: ConversationState;
    stateModifiedOn!: Date;
    lastMessageSentOn?: Date | undefined;

    constructor(data?: IPatientConversationSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientConversationId = _data["PatientConversationId"];
            this.patientId = _data["PatientId"];
            this.lumediStudyId = _data["LumediStudyId"];
            this.patientFirstName = _data["PatientFirstName"];
            this.patientLastName = _data["PatientLastName"];
            this.state = _data["State"];
            this.stateModifiedOn = _data["StateModifiedOn"] ? new Date(_data["StateModifiedOn"].toString()) : <any>undefined;
            this.lastMessageSentOn = _data["LastMessageSentOn"] ? new Date(_data["LastMessageSentOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientConversationSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConversationSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientConversationId"] = this.patientConversationId;
        data["PatientId"] = this.patientId;
        data["LumediStudyId"] = this.lumediStudyId;
        data["PatientFirstName"] = this.patientFirstName;
        data["PatientLastName"] = this.patientLastName;
        data["State"] = this.state;
        data["StateModifiedOn"] = this.stateModifiedOn ? this.stateModifiedOn.toISOString() : <any>undefined;
        data["LastMessageSentOn"] = this.lastMessageSentOn ? this.lastMessageSentOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientConversationSummaryModel {
    patientConversationId: string;
    patientId: string;
    lumediStudyId: string;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    state: ConversationState;
    stateModifiedOn: Date;
    lastMessageSentOn?: Date | undefined;
}

export enum ConversationState {
    Unknown = 0,
    Resolved = 1,
    Unresolved = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ChatHistoryModel implements IChatHistoryModel {
    conversation?: PatientConversationModel | undefined;
    messages?: PatientChatMessageModel[] | undefined;
    lastReadTimestamp?: Date | undefined;

    constructor(data?: IChatHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversation = _data["Conversation"] ? PatientConversationModel.fromJS(_data["Conversation"]) : <any>undefined;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(PatientChatMessageModel.fromJS(item));
            }
            this.lastReadTimestamp = _data["LastReadTimestamp"] ? new Date(_data["LastReadTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : <any>undefined);
        }
        data["LastReadTimestamp"] = this.lastReadTimestamp ? this.lastReadTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatHistoryModel {
    conversation?: PatientConversationModel | undefined;
    messages?: PatientChatMessageModel[] | undefined;
    lastReadTimestamp?: Date | undefined;
}

export class PatientConversationModel implements IPatientConversationModel {
    patientConversationId!: string;
    patientId!: string;
    state!: ConversationState;
    stateModifiedOn!: Date;

    constructor(data?: IPatientConversationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientConversationId = _data["PatientConversationId"];
            this.patientId = _data["PatientId"];
            this.state = _data["State"];
            this.stateModifiedOn = _data["StateModifiedOn"] ? new Date(_data["StateModifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientConversationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConversationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientConversationId"] = this.patientConversationId;
        data["PatientId"] = this.patientId;
        data["State"] = this.state;
        data["StateModifiedOn"] = this.stateModifiedOn ? this.stateModifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientConversationModel {
    patientConversationId: string;
    patientId: string;
    state: ConversationState;
    stateModifiedOn: Date;
}

export class PatientChatMessageModel implements IPatientChatMessageModel {
    patientChatMessageId!: string;
    patientConversationId!: string;
    sentOn!: Date;
    message?: string | undefined;
    senderType!: ChatSender;
    sendingAccountId?: string | undefined;
    senderName?: string | undefined;
    deletedOn?: Date | undefined;
    deletedByName?: string | undefined;

    constructor(data?: IPatientChatMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientChatMessageId = _data["PatientChatMessageId"];
            this.patientConversationId = _data["PatientConversationId"];
            this.sentOn = _data["SentOn"] ? new Date(_data["SentOn"].toString()) : <any>undefined;
            this.message = _data["Message"];
            this.senderType = _data["SenderType"];
            this.sendingAccountId = _data["SendingAccountId"];
            this.senderName = _data["SenderName"];
            this.deletedOn = _data["DeletedOn"] ? new Date(_data["DeletedOn"].toString()) : <any>undefined;
            this.deletedByName = _data["DeletedByName"];
        }
    }

    static fromJS(data: any): PatientChatMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientChatMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientChatMessageId"] = this.patientChatMessageId;
        data["PatientConversationId"] = this.patientConversationId;
        data["SentOn"] = this.sentOn ? this.sentOn.toISOString() : <any>undefined;
        data["Message"] = this.message;
        data["SenderType"] = this.senderType;
        data["SendingAccountId"] = this.sendingAccountId;
        data["SenderName"] = this.senderName;
        data["DeletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["DeletedByName"] = this.deletedByName;
        return data;
    }
}

export interface IPatientChatMessageModel {
    patientChatMessageId: string;
    patientConversationId: string;
    sentOn: Date;
    message?: string | undefined;
    senderType: ChatSender;
    sendingAccountId?: string | undefined;
    senderName?: string | undefined;
    deletedOn?: Date | undefined;
    deletedByName?: string | undefined;
}

export enum ChatSender {
    Unknown = 0,
    Patient = 1,
    Agent = 2,
    System = 3,
}

export class ConversationReadModel implements IConversationReadModel {
    conversationReadId!: string;
    patientConversationId!: string;
    viewer!: ViewerType;
    accountId?: string | undefined;
    readOn!: Date;

    constructor(data?: IConversationReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationReadId = _data["ConversationReadId"];
            this.patientConversationId = _data["PatientConversationId"];
            this.viewer = _data["Viewer"];
            this.accountId = _data["AccountId"];
            this.readOn = _data["ReadOn"] ? new Date(_data["ReadOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConversationReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConversationReadId"] = this.conversationReadId;
        data["PatientConversationId"] = this.patientConversationId;
        data["Viewer"] = this.viewer;
        data["AccountId"] = this.accountId;
        data["ReadOn"] = this.readOn ? this.readOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConversationReadModel {
    conversationReadId: string;
    patientConversationId: string;
    viewer: ViewerType;
    accountId?: string | undefined;
    readOn: Date;
}

export enum ViewerType {
    Unknown = 0,
    Patient = 1,
    Agent = 2,
}

export class SendMessageRequest implements ISendMessageRequest {
    message!: string;

    constructor(data?: ISendMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): SendMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        return data;
    }
}

export interface ISendMessageRequest {
    message: string;
}

export class CreateProgramClosureModel implements ICreateProgramClosureModel {
    name?: string | undefined;
    startOn!: Date;
    endOn!: Date;
    type!: ClosureType;
    studyIds?: string[] | undefined;
    ivrAudioFileId!: string;

    constructor(data?: ICreateProgramClosureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.type = _data["Type"];
            if (Array.isArray(_data["StudyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["StudyIds"])
                    this.studyIds!.push(item);
            }
            this.ivrAudioFileId = _data["IvrAudioFileId"];
        }
    }

    static fromJS(data: any): CreateProgramClosureModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProgramClosureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["Type"] = this.type;
        if (Array.isArray(this.studyIds)) {
            data["StudyIds"] = [];
            for (let item of this.studyIds)
                data["StudyIds"].push(item);
        }
        data["IvrAudioFileId"] = this.ivrAudioFileId;
        return data;
    }
}

export interface ICreateProgramClosureModel {
    name?: string | undefined;
    startOn: Date;
    endOn: Date;
    type: ClosureType;
    studyIds?: string[] | undefined;
    ivrAudioFileId: string;
}

export enum ClosureType {
    Holiday = 0,
    GeneralClosure = 1,
}

export class ProgramClosuresResult implements IProgramClosuresResult {
    id!: string;
    studyIds?: string[] | undefined;
    ivrAudioFileId!: string;
    name?: string | undefined;
    type!: ClosureType;
    startOn!: Date;
    endOn!: Date;

    constructor(data?: IProgramClosuresResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            if (Array.isArray(_data["StudyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["StudyIds"])
                    this.studyIds!.push(item);
            }
            this.ivrAudioFileId = _data["IvrAudioFileId"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramClosuresResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramClosuresResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        if (Array.isArray(this.studyIds)) {
            data["StudyIds"] = [];
            for (let item of this.studyIds)
                data["StudyIds"].push(item);
        }
        data["IvrAudioFileId"] = this.ivrAudioFileId;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramClosuresResult {
    id: string;
    studyIds?: string[] | undefined;
    ivrAudioFileId: string;
    name?: string | undefined;
    type: ClosureType;
    startOn: Date;
    endOn: Date;
}

export class ProgramAvailabilityResult implements IProgramAvailabilityResult {
    isOpen!: boolean;
    closedAudioPath?: string | undefined;

    constructor(data?: IProgramAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOpen = _data["IsOpen"];
            this.closedAudioPath = _data["ClosedAudioPath"];
        }
    }

    static fromJS(data: any): ProgramAvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramAvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsOpen"] = this.isOpen;
        data["ClosedAudioPath"] = this.closedAudioPath;
        return data;
    }
}

export interface IProgramAvailabilityResult {
    isOpen: boolean;
    closedAudioPath?: string | undefined;
}

export class ProgramHoursResponse implements IProgramHoursResponse {
    calculatedFor!: Date;
    /** The opening time on CalculatedFor. */
    openingTime!: Date;
    /** The closing time on CalculatedFor. */
    closedTime!: Date;
    /** Closures that are currently occuring on the date of CalculatedFor. */
    closures?: ProgramClosureConfiguration[] | undefined;
    timeSlots?: ProgramTimeSlot[] | undefined;

    constructor(data?: IProgramHoursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculatedFor = _data["CalculatedFor"] ? new Date(_data["CalculatedFor"].toString()) : <any>undefined;
            this.openingTime = _data["OpeningTime"] ? new Date(_data["OpeningTime"].toString()) : <any>undefined;
            this.closedTime = _data["ClosedTime"] ? new Date(_data["ClosedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["Closures"])) {
                this.closures = [] as any;
                for (let item of _data["Closures"])
                    this.closures!.push(ProgramClosureConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["TimeSlots"])) {
                this.timeSlots = [] as any;
                for (let item of _data["TimeSlots"])
                    this.timeSlots!.push(ProgramTimeSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramHoursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramHoursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CalculatedFor"] = this.calculatedFor ? this.calculatedFor.toISOString() : <any>undefined;
        data["OpeningTime"] = this.openingTime ? this.openingTime.toISOString() : <any>undefined;
        data["ClosedTime"] = this.closedTime ? this.closedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.closures)) {
            data["Closures"] = [];
            for (let item of this.closures)
                data["Closures"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.timeSlots)) {
            data["TimeSlots"] = [];
            for (let item of this.timeSlots)
                data["TimeSlots"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProgramHoursResponse {
    calculatedFor: Date;
    /** The opening time on CalculatedFor. */
    openingTime: Date;
    /** The closing time on CalculatedFor. */
    closedTime: Date;
    /** Closures that are currently occuring on the date of CalculatedFor. */
    closures?: ProgramClosureConfiguration[] | undefined;
    timeSlots?: ProgramTimeSlot[] | undefined;
}

export class ProgramClosureConfiguration implements IProgramClosureConfiguration {
    from!: Date;
    to!: Date;

    constructor(data?: IProgramClosureConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramClosureConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramClosureConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramClosureConfiguration {
    from: Date;
    to: Date;
}

export class ProgramTimeSlot implements IProgramTimeSlot {
    from!: Date;
    to!: Date;

    constructor(data?: IProgramTimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramTimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramTimeSlot {
    from: Date;
    to: Date;
}

export class IvrAudioFilesViewModel implements IIvrAudioFilesViewModel {
    id!: string;
    name?: string | undefined;

    constructor(data?: IIvrAudioFilesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): IvrAudioFilesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IvrAudioFilesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IIvrAudioFilesViewModel {
    id: string;
    name?: string | undefined;
}

export class CreateProgramBusinessHour implements ICreateProgramBusinessHour {
    studyId?: string | undefined;
    day!: DayOfWeek;
    openingTime?: string | undefined;
    closingTime?: string | undefined;

    constructor(data?: ICreateProgramBusinessHour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.day = _data["Day"];
            this.openingTime = _data["OpeningTime"];
            this.closingTime = _data["ClosingTime"];
        }
    }

    static fromJS(data: any): CreateProgramBusinessHour {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProgramBusinessHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["Day"] = this.day;
        data["OpeningTime"] = this.openingTime;
        data["ClosingTime"] = this.closingTime;
        return data;
    }
}

export interface ICreateProgramBusinessHour {
    studyId?: string | undefined;
    day: DayOfWeek;
    openingTime?: string | undefined;
    closingTime?: string | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class ProgramBusinessHoursResult implements IProgramBusinessHoursResult {
    id!: string;
    studyId?: string | undefined;
    dayofWeek!: DayOfWeek;
    openingTime?: string | undefined;
    openingTimeSeconds!: number;
    closingTime?: string | undefined;
    closingTimeSeconds!: number;

    constructor(data?: IProgramBusinessHoursResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.dayofWeek = _data["DayofWeek"];
            this.openingTime = _data["OpeningTime"];
            this.openingTimeSeconds = _data["OpeningTimeSeconds"];
            this.closingTime = _data["ClosingTime"];
            this.closingTimeSeconds = _data["ClosingTimeSeconds"];
        }
    }

    static fromJS(data: any): ProgramBusinessHoursResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramBusinessHoursResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["DayofWeek"] = this.dayofWeek;
        data["OpeningTime"] = this.openingTime;
        data["OpeningTimeSeconds"] = this.openingTimeSeconds;
        data["ClosingTime"] = this.closingTime;
        data["ClosingTimeSeconds"] = this.closingTimeSeconds;
        return data;
    }
}

export interface IProgramBusinessHoursResult {
    id: string;
    studyId?: string | undefined;
    dayofWeek: DayOfWeek;
    openingTime?: string | undefined;
    openingTimeSeconds: number;
    closingTime?: string | undefined;
    closingTimeSeconds: number;
}

export class EditProgramBusinessHour implements IEditProgramBusinessHour {
    id!: string;
    openingTime?: string | undefined;
    closingTime?: string | undefined;

    constructor(data?: IEditProgramBusinessHour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.openingTime = _data["OpeningTime"];
            this.closingTime = _data["ClosingTime"];
        }
    }

    static fromJS(data: any): EditProgramBusinessHour {
        data = typeof data === 'object' ? data : {};
        let result = new EditProgramBusinessHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["OpeningTime"] = this.openingTime;
        data["ClosingTime"] = this.closingTime;
        return data;
    }
}

export interface IEditProgramBusinessHour {
    id: string;
    openingTime?: string | undefined;
    closingTime?: string | undefined;
}

export class ClientSummary implements IClientSummary {
    clientID!: string;
    name?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    isSelected!: boolean;
    hasClientWideAdminAccess!: boolean;
    isAdmin!: boolean;
    isAccountAdmin!: boolean;
    canScheduleAccess!: boolean;
    studies?: StudySummary[] | undefined;

    constructor(data?: IClientSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["ClientID"];
            this.name = _data["Name"];
            this.city = _data["City"];
            this.province = _data["Province"];
            this.country = _data["Country"];
            this.isSelected = _data["IsSelected"];
            this.hasClientWideAdminAccess = _data["HasClientWideAdminAccess"];
            this.isAdmin = _data["IsAdmin"];
            this.isAccountAdmin = _data["IsAccountAdmin"];
            this.canScheduleAccess = _data["CanScheduleAccess"];
            if (Array.isArray(_data["Studies"])) {
                this.studies = [] as any;
                for (let item of _data["Studies"])
                    this.studies!.push(StudySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientID"] = this.clientID;
        data["Name"] = this.name;
        data["City"] = this.city;
        data["Province"] = this.province;
        data["Country"] = this.country;
        data["IsSelected"] = this.isSelected;
        data["HasClientWideAdminAccess"] = this.hasClientWideAdminAccess;
        data["IsAdmin"] = this.isAdmin;
        data["IsAccountAdmin"] = this.isAccountAdmin;
        data["CanScheduleAccess"] = this.canScheduleAccess;
        if (Array.isArray(this.studies)) {
            data["Studies"] = [];
            for (let item of this.studies)
                data["Studies"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IClientSummary {
    clientID: string;
    name?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    isSelected: boolean;
    hasClientWideAdminAccess: boolean;
    isAdmin: boolean;
    isAccountAdmin: boolean;
    canScheduleAccess: boolean;
    studies?: StudySummary[] | undefined;
}

export class StudySummary implements IStudySummary {
    studyID!: string;
    defaultAvatars?: string[] | undefined;
    studyName?: string | undefined;
    description?: string | undefined;
    isSchedulingAllowed!: boolean;
    isOfflineInteractionsAllowed!: boolean;
    isPersonallyIdentifiableInformationStored!: boolean;
    maintainPhysicianList!: boolean;
    isSetupComplete!: boolean;
    showAllRegistrationQuestionsByDefault!: boolean;
    sponsor?: string | undefined;
    department?: string | undefined;
    investigator?: string | undefined;
    coordinator?: string | undefined;
    hasPublicSite!: boolean;
    isEMAEnabled!: boolean;
    isCustomTriggersEnabled!: boolean;
    publicSiteName?: string | undefined;
    publicSiteRootUrl?: string | undefined;
    canEdit!: boolean;
    isAdmin!: boolean;
    isAccountAdmin!: boolean;
    canScheduleAccess!: boolean;
    isFitbitStudy!: boolean;
    isQuestionnaireDateEditingDisabled!: boolean;
    isQuestionnaireDataFlagDisabled!: boolean;
    studyType!: StudyType;
    availableSites?: SiteModel[] | undefined;
    timepoints?: Timepoint[] | undefined;
    documentCategories?: CategoryModel[] | undefined;
    emailTemplates?: EmailTemplateModel[] | undefined;
    systemInteractions?: SystemInteractionModel[] | undefined;
    defaultCountry?: string | undefined;
    hasTimepoints!: boolean;
    supportedLanguages?: LanguageModel[] | undefined;
    faxNumbers?: StudyFaxNumberInfo[] | undefined;

    constructor(data?: IStudySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyID = _data["StudyID"];
            if (Array.isArray(_data["DefaultAvatars"])) {
                this.defaultAvatars = [] as any;
                for (let item of _data["DefaultAvatars"])
                    this.defaultAvatars!.push(item);
            }
            this.studyName = _data["StudyName"];
            this.description = _data["Description"];
            this.isSchedulingAllowed = _data["IsSchedulingAllowed"];
            this.isOfflineInteractionsAllowed = _data["IsOfflineInteractionsAllowed"];
            this.isPersonallyIdentifiableInformationStored = _data["IsPersonallyIdentifiableInformationStored"];
            this.maintainPhysicianList = _data["MaintainPhysicianList"];
            this.isSetupComplete = _data["IsSetupComplete"];
            this.showAllRegistrationQuestionsByDefault = _data["ShowAllRegistrationQuestionsByDefault"];
            this.sponsor = _data["Sponsor"];
            this.department = _data["Department"];
            this.investigator = _data["Investigator"];
            this.coordinator = _data["Coordinator"];
            this.hasPublicSite = _data["HasPublicSite"];
            this.isEMAEnabled = _data["IsEMAEnabled"];
            this.isCustomTriggersEnabled = _data["IsCustomTriggersEnabled"];
            this.publicSiteName = _data["PublicSiteName"];
            this.publicSiteRootUrl = _data["PublicSiteRootUrl"];
            this.canEdit = _data["CanEdit"];
            this.isAdmin = _data["IsAdmin"];
            this.isAccountAdmin = _data["IsAccountAdmin"];
            this.canScheduleAccess = _data["CanScheduleAccess"];
            this.isFitbitStudy = _data["IsFitbitStudy"];
            this.isQuestionnaireDateEditingDisabled = _data["IsQuestionnaireDateEditingDisabled"];
            this.isQuestionnaireDataFlagDisabled = _data["IsQuestionnaireDataFlagDisabled"];
            this.studyType = _data["StudyType"];
            if (Array.isArray(_data["AvailableSites"])) {
                this.availableSites = [] as any;
                for (let item of _data["AvailableSites"])
                    this.availableSites!.push(SiteModel.fromJS(item));
            }
            if (Array.isArray(_data["Timepoints"])) {
                this.timepoints = [] as any;
                for (let item of _data["Timepoints"])
                    this.timepoints!.push(Timepoint.fromJS(item));
            }
            if (Array.isArray(_data["DocumentCategories"])) {
                this.documentCategories = [] as any;
                for (let item of _data["DocumentCategories"])
                    this.documentCategories!.push(CategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["EmailTemplates"])) {
                this.emailTemplates = [] as any;
                for (let item of _data["EmailTemplates"])
                    this.emailTemplates!.push(EmailTemplateModel.fromJS(item));
            }
            if (Array.isArray(_data["SystemInteractions"])) {
                this.systemInteractions = [] as any;
                for (let item of _data["SystemInteractions"])
                    this.systemInteractions!.push(SystemInteractionModel.fromJS(item));
            }
            this.defaultCountry = _data["DefaultCountry"];
            this.hasTimepoints = _data["HasTimepoints"];
            if (Array.isArray(_data["SupportedLanguages"])) {
                this.supportedLanguages = [] as any;
                for (let item of _data["SupportedLanguages"])
                    this.supportedLanguages!.push(LanguageModel.fromJS(item));
            }
            if (Array.isArray(_data["FaxNumbers"])) {
                this.faxNumbers = [] as any;
                for (let item of _data["FaxNumbers"])
                    this.faxNumbers!.push(StudyFaxNumberInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudySummary {
        data = typeof data === 'object' ? data : {};
        let result = new StudySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyID"] = this.studyID;
        if (Array.isArray(this.defaultAvatars)) {
            data["DefaultAvatars"] = [];
            for (let item of this.defaultAvatars)
                data["DefaultAvatars"].push(item);
        }
        data["StudyName"] = this.studyName;
        data["Description"] = this.description;
        data["IsSchedulingAllowed"] = this.isSchedulingAllowed;
        data["IsOfflineInteractionsAllowed"] = this.isOfflineInteractionsAllowed;
        data["IsPersonallyIdentifiableInformationStored"] = this.isPersonallyIdentifiableInformationStored;
        data["MaintainPhysicianList"] = this.maintainPhysicianList;
        data["IsSetupComplete"] = this.isSetupComplete;
        data["ShowAllRegistrationQuestionsByDefault"] = this.showAllRegistrationQuestionsByDefault;
        data["Sponsor"] = this.sponsor;
        data["Department"] = this.department;
        data["Investigator"] = this.investigator;
        data["Coordinator"] = this.coordinator;
        data["HasPublicSite"] = this.hasPublicSite;
        data["IsEMAEnabled"] = this.isEMAEnabled;
        data["IsCustomTriggersEnabled"] = this.isCustomTriggersEnabled;
        data["PublicSiteName"] = this.publicSiteName;
        data["PublicSiteRootUrl"] = this.publicSiteRootUrl;
        data["CanEdit"] = this.canEdit;
        data["IsAdmin"] = this.isAdmin;
        data["IsAccountAdmin"] = this.isAccountAdmin;
        data["CanScheduleAccess"] = this.canScheduleAccess;
        data["IsFitbitStudy"] = this.isFitbitStudy;
        data["IsQuestionnaireDateEditingDisabled"] = this.isQuestionnaireDateEditingDisabled;
        data["IsQuestionnaireDataFlagDisabled"] = this.isQuestionnaireDataFlagDisabled;
        data["StudyType"] = this.studyType;
        if (Array.isArray(this.availableSites)) {
            data["AvailableSites"] = [];
            for (let item of this.availableSites)
                data["AvailableSites"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.timepoints)) {
            data["Timepoints"] = [];
            for (let item of this.timepoints)
                data["Timepoints"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentCategories)) {
            data["DocumentCategories"] = [];
            for (let item of this.documentCategories)
                data["DocumentCategories"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.emailTemplates)) {
            data["EmailTemplates"] = [];
            for (let item of this.emailTemplates)
                data["EmailTemplates"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.systemInteractions)) {
            data["SystemInteractions"] = [];
            for (let item of this.systemInteractions)
                data["SystemInteractions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["DefaultCountry"] = this.defaultCountry;
        data["HasTimepoints"] = this.hasTimepoints;
        if (Array.isArray(this.supportedLanguages)) {
            data["SupportedLanguages"] = [];
            for (let item of this.supportedLanguages)
                data["SupportedLanguages"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.faxNumbers)) {
            data["FaxNumbers"] = [];
            for (let item of this.faxNumbers)
                data["FaxNumbers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IStudySummary {
    studyID: string;
    defaultAvatars?: string[] | undefined;
    studyName?: string | undefined;
    description?: string | undefined;
    isSchedulingAllowed: boolean;
    isOfflineInteractionsAllowed: boolean;
    isPersonallyIdentifiableInformationStored: boolean;
    maintainPhysicianList: boolean;
    isSetupComplete: boolean;
    showAllRegistrationQuestionsByDefault: boolean;
    sponsor?: string | undefined;
    department?: string | undefined;
    investigator?: string | undefined;
    coordinator?: string | undefined;
    hasPublicSite: boolean;
    isEMAEnabled: boolean;
    isCustomTriggersEnabled: boolean;
    publicSiteName?: string | undefined;
    publicSiteRootUrl?: string | undefined;
    canEdit: boolean;
    isAdmin: boolean;
    isAccountAdmin: boolean;
    canScheduleAccess: boolean;
    isFitbitStudy: boolean;
    isQuestionnaireDateEditingDisabled: boolean;
    isQuestionnaireDataFlagDisabled: boolean;
    studyType: StudyType;
    availableSites?: SiteModel[] | undefined;
    timepoints?: Timepoint[] | undefined;
    documentCategories?: CategoryModel[] | undefined;
    emailTemplates?: EmailTemplateModel[] | undefined;
    systemInteractions?: SystemInteractionModel[] | undefined;
    defaultCountry?: string | undefined;
    hasTimepoints: boolean;
    supportedLanguages?: LanguageModel[] | undefined;
    faxNumbers?: StudyFaxNumberInfo[] | undefined;
}

export enum StudyType {
    Cohort = 1,
    CrossSectional = 2,
    PatientSupport = 3,
    CaseControl = 4,
    PhaseI = 5,
    PhaseII = 6,
    PhaseIII = 7,
    PhaseIV = 8,
}

export class SiteModel implements ISiteModel {
    siteID!: string;
    siteName?: string | undefined;
    uniqueCode?: string | undefined;
    clientID!: string;
    studies?: StudyModel[] | undefined;

    constructor(data?: ISiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteID = _data["SiteID"];
            this.siteName = _data["SiteName"];
            this.uniqueCode = _data["UniqueCode"];
            this.clientID = _data["ClientID"];
            if (Array.isArray(_data["Studies"])) {
                this.studies = [] as any;
                for (let item of _data["Studies"])
                    this.studies!.push(StudyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SiteID"] = this.siteID;
        data["SiteName"] = this.siteName;
        data["UniqueCode"] = this.uniqueCode;
        data["ClientID"] = this.clientID;
        if (Array.isArray(this.studies)) {
            data["Studies"] = [];
            for (let item of this.studies)
                data["Studies"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISiteModel {
    siteID: string;
    siteName?: string | undefined;
    uniqueCode?: string | undefined;
    clientID: string;
    studies?: StudyModel[] | undefined;
}

export class StudyModel implements IStudyModel {
    studyID!: string;
    studyName!: string;
    studyType!: StudyType;
    description?: string | undefined;
    sponsor?: string | undefined;
    investigator?: string | undefined;
    coordinator?: string | undefined;
    department?: string | undefined;
    isSchedulingAllowed!: boolean;
    isEMAEnabled!: boolean;
    isPersonallyIdentifiableInformationStored!: boolean;
    isOfflineInteractionsAllowed!: boolean;
    showAllRegistrationQuestionsByDefault!: boolean;
    numberOfTimepoints!: number;
    hasDeviceIntegration!: boolean;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    sites?: SiteModel[] | undefined;

    constructor(data?: IStudyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyID = _data["StudyID"];
            this.studyName = _data["StudyName"];
            this.studyType = _data["StudyType"];
            this.description = _data["Description"];
            this.sponsor = _data["Sponsor"];
            this.investigator = _data["Investigator"];
            this.coordinator = _data["Coordinator"];
            this.department = _data["Department"];
            this.isSchedulingAllowed = _data["IsSchedulingAllowed"];
            this.isEMAEnabled = _data["IsEMAEnabled"];
            this.isPersonallyIdentifiableInformationStored = _data["IsPersonallyIdentifiableInformationStored"];
            this.isOfflineInteractionsAllowed = _data["IsOfflineInteractionsAllowed"];
            this.showAllRegistrationQuestionsByDefault = _data["ShowAllRegistrationQuestionsByDefault"];
            this.numberOfTimepoints = _data["NumberOfTimepoints"];
            this.hasDeviceIntegration = _data["HasDeviceIntegration"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            if (Array.isArray(_data["Sites"])) {
                this.sites = [] as any;
                for (let item of _data["Sites"])
                    this.sites!.push(SiteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyID"] = this.studyID;
        data["StudyName"] = this.studyName;
        data["StudyType"] = this.studyType;
        data["Description"] = this.description;
        data["Sponsor"] = this.sponsor;
        data["Investigator"] = this.investigator;
        data["Coordinator"] = this.coordinator;
        data["Department"] = this.department;
        data["IsSchedulingAllowed"] = this.isSchedulingAllowed;
        data["IsEMAEnabled"] = this.isEMAEnabled;
        data["IsPersonallyIdentifiableInformationStored"] = this.isPersonallyIdentifiableInformationStored;
        data["IsOfflineInteractionsAllowed"] = this.isOfflineInteractionsAllowed;
        data["ShowAllRegistrationQuestionsByDefault"] = this.showAllRegistrationQuestionsByDefault;
        data["NumberOfTimepoints"] = this.numberOfTimepoints;
        data["HasDeviceIntegration"] = this.hasDeviceIntegration;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.sites)) {
            data["Sites"] = [];
            for (let item of this.sites)
                data["Sites"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IStudyModel {
    studyID: string;
    studyName: string;
    studyType: StudyType;
    description?: string | undefined;
    sponsor?: string | undefined;
    investigator?: string | undefined;
    coordinator?: string | undefined;
    department?: string | undefined;
    isSchedulingAllowed: boolean;
    isEMAEnabled: boolean;
    isPersonallyIdentifiableInformationStored: boolean;
    isOfflineInteractionsAllowed: boolean;
    showAllRegistrationQuestionsByDefault: boolean;
    numberOfTimepoints: number;
    hasDeviceIntegration: boolean;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    sites?: SiteModel[] | undefined;
}

export class Timepoint implements ITimepoint {
    timepointID!: number;
    studyID!: string;
    position!: number;
    interval?: number | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    intervalUnit?: IntervalOptions | undefined;
    interactions?: TimepointInteractionModel[] | undefined;
    label?: string | undefined;

    constructor(data?: ITimepoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timepointID = _data["TimepointID"];
            this.studyID = _data["StudyID"];
            this.position = _data["Position"];
            this.interval = _data["Interval"];
            this.startTime = _data["StartTime"] ? new Date(_data["StartTime"].toString()) : <any>undefined;
            this.endTime = _data["EndTime"] ? new Date(_data["EndTime"].toString()) : <any>undefined;
            this.intervalUnit = _data["IntervalUnit"];
            if (Array.isArray(_data["Interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["Interactions"])
                    this.interactions!.push(TimepointInteractionModel.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): Timepoint {
        data = typeof data === 'object' ? data : {};
        let result = new Timepoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TimepointID"] = this.timepointID;
        data["StudyID"] = this.studyID;
        data["Position"] = this.position;
        data["Interval"] = this.interval;
        data["StartTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["EndTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["IntervalUnit"] = this.intervalUnit;
        if (Array.isArray(this.interactions)) {
            data["Interactions"] = [];
            for (let item of this.interactions)
                data["Interactions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Label"] = this.label;
        return data;
    }
}

export interface ITimepoint {
    timepointID: number;
    studyID: string;
    position: number;
    interval?: number | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    intervalUnit?: IntervalOptions | undefined;
    interactions?: TimepointInteractionModel[] | undefined;
    label?: string | undefined;
}

export enum IntervalOptions {
    Day = 0,
    Week = 1,
    Month = 2,
}

export class TimepointInteractionModel implements ITimepointInteractionModel {
    interactionID!: number;
    name?: string | undefined;

    constructor(data?: ITimepointInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): TimepointInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimepointInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        return data;
    }
}

export interface ITimepointInteractionModel {
    interactionID: number;
    name?: string | undefined;
}

export class CategoryModel implements ICategoryModel {
    categoryID!: string;
    studyID!: string;
    name?: string | undefined;
    isActive!: boolean;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;

    constructor(data?: ICategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryID = _data["CategoryID"];
            this.studyID = _data["StudyID"];
            this.name = _data["Name"];
            this.isActive = _data["IsActive"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
        }
    }

    static fromJS(data: any): CategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryID"] = this.categoryID;
        data["StudyID"] = this.studyID;
        data["Name"] = this.name;
        data["IsActive"] = this.isActive;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ICategoryModel {
    categoryID: string;
    studyID: string;
    name?: string | undefined;
    isActive: boolean;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
}

export class EmailTemplateModel implements IEmailTemplateModel {
    emailTemplateID!: number;
    studyID!: string;
    type!: EmailTemplateType;
    name?: string | undefined;
    subjectLine?: string | undefined;
    template?: string | undefined;
    consentRequiredInfo?: string | undefined;
    consentNotRequiredInfo?: string | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    templateTypeName?: string | undefined;

    constructor(data?: IEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplateID = _data["EmailTemplateID"];
            this.studyID = _data["StudyID"];
            this.type = _data["Type"];
            this.name = _data["Name"];
            this.subjectLine = _data["SubjectLine"];
            this.template = _data["Template"];
            this.consentRequiredInfo = _data["ConsentRequiredInfo"];
            this.consentNotRequiredInfo = _data["ConsentNotRequiredInfo"];
            this.emailRecipientType = _data["EmailRecipientType"];
            this.emailRecipientTypeName = _data["EmailRecipientTypeName"];
            this.templateTypeName = _data["TemplateTypeName"];
        }
    }

    static fromJS(data: any): EmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailTemplateID"] = this.emailTemplateID;
        data["StudyID"] = this.studyID;
        data["Type"] = this.type;
        data["Name"] = this.name;
        data["SubjectLine"] = this.subjectLine;
        data["Template"] = this.template;
        data["ConsentRequiredInfo"] = this.consentRequiredInfo;
        data["ConsentNotRequiredInfo"] = this.consentNotRequiredInfo;
        data["EmailRecipientType"] = this.emailRecipientType;
        data["EmailRecipientTypeName"] = this.emailRecipientTypeName;
        data["TemplateTypeName"] = this.templateTypeName;
        return data;
    }
}

export interface IEmailTemplateModel {
    emailTemplateID: number;
    studyID: string;
    type: EmailTemplateType;
    name?: string | undefined;
    subjectLine?: string | undefined;
    template?: string | undefined;
    consentRequiredInfo?: string | undefined;
    consentNotRequiredInfo?: string | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    templateTypeName?: string | undefined;
}

export enum EmailTemplateType {
    HubInvitation = 1,
    QuestionnairePackage = 2,
    QuestionnairePackageReminder = 3,
    TriggerTemplate = 4,
    ParticipantTemplate = 5,
    PhysicianFaxTemplate = 6,
    AdverseEventFaxTemplate = 7,
}

export enum EmailTemplateRecipientType {
    Participant = 0,
    Admin = 1,
    Both = 2,
    Specify = 3,
}

export class SystemInteractionModel implements ISystemInteractionModel {
    interactionID!: number;
    name?: string | undefined;
    systemInteractionType!: SystemInteractionType;

    constructor(data?: ISystemInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
            this.systemInteractionType = _data["SystemInteractionType"];
        }
    }

    static fromJS(data: any): SystemInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        data["SystemInteractionType"] = this.systemInteractionType;
        return data;
    }
}

export interface ISystemInteractionModel {
    interactionID: number;
    name?: string | undefined;
    systemInteractionType: SystemInteractionType;
}

export enum SystemInteractionType {
    Registration = 1,
    Discontinue = 2,
    Reactivate = 3,
    RecordEmail = 4,
    RecordMailSent = 5,
    RecordPhoneCall = 6,
    CriticalInformation = 7,
}

export class LanguageModel implements ILanguageModel {
    language?: string | undefined;
    languageCode?: string | undefined;
    isDefault!: boolean;

    constructor(data?: ILanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): LanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface ILanguageModel {
    language?: string | undefined;
    languageCode?: string | undefined;
    isDefault: boolean;
}

export class StudyFaxNumberInfo implements IStudyFaxNumberInfo {
    faxNumberId!: string;
    faxNumber?: string | undefined;
    label?: string | undefined;

    constructor(data?: IStudyFaxNumberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxNumberId = _data["FaxNumberId"];
            this.faxNumber = _data["FaxNumber"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): StudyFaxNumberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFaxNumberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FaxNumberId"] = this.faxNumberId;
        data["FaxNumber"] = this.faxNumber;
        data["Label"] = this.label;
        return data;
    }
}

export interface IStudyFaxNumberInfo {
    faxNumberId: string;
    faxNumber?: string | undefined;
    label?: string | undefined;
}

export class SetCurrentClientRequest implements ISetCurrentClientRequest {
    /** Client ID to set as the current client */
    clientID!: string;

    constructor(data?: ISetCurrentClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["ClientID"];
        }
    }

    static fromJS(data: any): SetCurrentClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetCurrentClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientID"] = this.clientID;
        return data;
    }
}

export interface ISetCurrentClientRequest {
    /** Client ID to set as the current client */
    clientID: string;
}

export class SetCurrentStudyRequest implements ISetCurrentStudyRequest {
    /** Study ID to set as the current study */
    studyID!: string;

    constructor(data?: ISetCurrentStudyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyID = _data["StudyID"];
        }
    }

    static fromJS(data: any): SetCurrentStudyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetCurrentStudyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyID"] = this.studyID;
        return data;
    }
}

export interface ISetCurrentStudyRequest {
    /** Study ID to set as the current study */
    studyID: string;
}

export class ClientStudySummary implements IClientStudySummary {
    clientID!: string;
    clientName?: string | undefined;
    studyID!: string;
    studyName?: string | undefined;

    constructor(data?: IClientStudySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["ClientID"];
            this.clientName = _data["ClientName"];
            this.studyID = _data["StudyID"];
            this.studyName = _data["StudyName"];
        }
    }

    static fromJS(data: any): ClientStudySummary {
        data = typeof data === 'object' ? data : {};
        let result = new ClientStudySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientID"] = this.clientID;
        data["ClientName"] = this.clientName;
        data["StudyID"] = this.studyID;
        data["StudyName"] = this.studyName;
        return data;
    }
}

export interface IClientStudySummary {
    clientID: string;
    clientName?: string | undefined;
    studyID: string;
    studyName?: string | undefined;
}

export class SetCurrentClientStudyRequest implements ISetCurrentClientStudyRequest {
    /** Client ID to set as the current client */
    clientID!: string;
    /** Study ID to set as the current study */
    studyID!: string;

    constructor(data?: ISetCurrentClientStudyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["ClientID"];
            this.studyID = _data["StudyID"];
        }
    }

    static fromJS(data: any): SetCurrentClientStudyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetCurrentClientStudyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ClientID"] = this.clientID;
        data["StudyID"] = this.studyID;
        return data;
    }
}

export interface ISetCurrentClientStudyRequest {
    /** Client ID to set as the current client */
    clientID: string;
    /** Study ID to set as the current study */
    studyID: string;
}

export class ChangePasswordBindingModel implements IChangePasswordBindingModel {
    oldPassword!: string;
    newPassword!: string;
    confirmPassword?: string | undefined;

    constructor(data?: IChangePasswordBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["OldPassword"];
            this.newPassword = _data["NewPassword"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OldPassword"] = this.oldPassword;
        data["NewPassword"] = this.newPassword;
        data["ConfirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangePasswordBindingModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword?: string | undefined;
}

export class ResetPasswordViewModel implements IResetPasswordViewModel {
    token!: string;
    confirmPassword!: string;
    email!: string;
    password!: string;

    constructor(data?: IResetPasswordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.confirmPassword = _data["ConfirmPassword"];
            this.email = _data["Email"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): ResetPasswordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["ConfirmPassword"] = this.confirmPassword;
        data["Email"] = this.email;
        data["Password"] = this.password;
        return data;
    }
}

export interface IResetPasswordViewModel {
    token: string;
    confirmPassword: string;
    email: string;
    password: string;
}

export class ForgotPasswordBindingModel implements IForgotPasswordBindingModel {
    email!: string;
    domain!: string;

    constructor(data?: IForgotPasswordBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.domain = _data["Domain"];
        }
    }

    static fromJS(data: any): ForgotPasswordBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Domain"] = this.domain;
        return data;
    }
}

export interface IForgotPasswordBindingModel {
    email: string;
    domain: string;
}

export class RegisterAccountBindingModel implements IRegisterAccountBindingModel {
    email!: string;
    firstName!: string;
    lastName!: string;
    domain?: string | undefined;

    constructor(data?: IRegisterAccountBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.domain = _data["Domain"];
        }
    }

    static fromJS(data: any): RegisterAccountBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAccountBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Domain"] = this.domain;
        return data;
    }
}

export interface IRegisterAccountBindingModel {
    email: string;
    firstName: string;
    lastName: string;
    domain?: string | undefined;
}

export class AccountModel implements IAccountModel {
    accountID!: string;
    status!: AccountStatus;
    statusName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    properName?: string | undefined;
    email?: string | undefined;
    isAdmin!: boolean;
    isRestricted!: boolean;
    /** List of access which the account has for the current client */
    clientAccess?: AccountAccessModel[] | undefined;
    /** List of access which the account has for specific sites under the current client */
    siteAccess?: AccountAccessModel[] | undefined;
    /** List of patient ids which the account has access for under the current client */
    patientAccess?: PatientAccessModel[] | undefined;
    domain?: string | undefined;
    roles?: Role[] | undefined;
    patients?: PatientAccountModel[] | undefined;
    canAdministerClient!: boolean;

    constructor(data?: IAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountID = _data["AccountID"];
            this.status = _data["Status"];
            this.statusName = _data["StatusName"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.fullName = _data["FullName"];
            this.properName = _data["ProperName"];
            this.email = _data["Email"];
            this.isAdmin = _data["IsAdmin"];
            this.isRestricted = _data["IsRestricted"];
            if (Array.isArray(_data["ClientAccess"])) {
                this.clientAccess = [] as any;
                for (let item of _data["ClientAccess"])
                    this.clientAccess!.push(AccountAccessModel.fromJS(item));
            }
            if (Array.isArray(_data["SiteAccess"])) {
                this.siteAccess = [] as any;
                for (let item of _data["SiteAccess"])
                    this.siteAccess!.push(AccountAccessModel.fromJS(item));
            }
            if (Array.isArray(_data["PatientAccess"])) {
                this.patientAccess = [] as any;
                for (let item of _data["PatientAccess"])
                    this.patientAccess!.push(PatientAccessModel.fromJS(item));
            }
            this.domain = _data["Domain"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            if (Array.isArray(_data["Patients"])) {
                this.patients = [] as any;
                for (let item of _data["Patients"])
                    this.patients!.push(PatientAccountModel.fromJS(item));
            }
            this.canAdministerClient = _data["CanAdministerClient"];
        }
    }

    static fromJS(data: any): AccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountID"] = this.accountID;
        data["Status"] = this.status;
        data["StatusName"] = this.statusName;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["FullName"] = this.fullName;
        data["ProperName"] = this.properName;
        data["Email"] = this.email;
        data["IsAdmin"] = this.isAdmin;
        data["IsRestricted"] = this.isRestricted;
        if (Array.isArray(this.clientAccess)) {
            data["ClientAccess"] = [];
            for (let item of this.clientAccess)
                data["ClientAccess"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.siteAccess)) {
            data["SiteAccess"] = [];
            for (let item of this.siteAccess)
                data["SiteAccess"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.patientAccess)) {
            data["PatientAccess"] = [];
            for (let item of this.patientAccess)
                data["PatientAccess"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Domain"] = this.domain;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.patients)) {
            data["Patients"] = [];
            for (let item of this.patients)
                data["Patients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CanAdministerClient"] = this.canAdministerClient;
        return data;
    }
}

export interface IAccountModel {
    accountID: string;
    status: AccountStatus;
    statusName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    properName?: string | undefined;
    email?: string | undefined;
    isAdmin: boolean;
    isRestricted: boolean;
    /** List of access which the account has for the current client */
    clientAccess?: AccountAccessModel[] | undefined;
    /** List of access which the account has for specific sites under the current client */
    siteAccess?: AccountAccessModel[] | undefined;
    /** List of patient ids which the account has access for under the current client */
    patientAccess?: PatientAccessModel[] | undefined;
    domain?: string | undefined;
    roles?: Role[] | undefined;
    patients?: PatientAccountModel[] | undefined;
    canAdministerClient: boolean;
}

export enum AccountStatus {
    Pending = 0,
    Active = 1,
    Deleted = 2,
    PendingTrial = 3,
    Verified = 4,
}

export class AccountAccessModel implements IAccountAccessModel {
    roleID!: number;
    siteID?: string | undefined;
    canExportData!: boolean;

    constructor(data?: IAccountAccessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleID = _data["RoleID"];
            this.siteID = _data["SiteID"];
            this.canExportData = _data["CanExportData"];
        }
    }

    static fromJS(data: any): AccountAccessModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAccessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleID"] = this.roleID;
        data["SiteID"] = this.siteID;
        data["CanExportData"] = this.canExportData;
        return data;
    }
}

export interface IAccountAccessModel {
    roleID: number;
    siteID?: string | undefined;
    canExportData: boolean;
}

export class PatientAccessModel implements IPatientAccessModel {
    patientID!: string;
    uniqueID?: string | undefined;
    siteID!: string;
    fullName?: string | undefined;

    constructor(data?: IPatientAccessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.uniqueID = _data["UniqueID"];
            this.siteID = _data["SiteID"];
            this.fullName = _data["FullName"];
        }
    }

    static fromJS(data: any): PatientAccessModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAccessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["UniqueID"] = this.uniqueID;
        data["SiteID"] = this.siteID;
        data["FullName"] = this.fullName;
        return data;
    }
}

export interface IPatientAccessModel {
    patientID: string;
    uniqueID?: string | undefined;
    siteID: string;
    fullName?: string | undefined;
}

export class Role implements IRole {
    roleID!: number;
    name?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleID = _data["RoleID"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleID"] = this.roleID;
        data["Name"] = this.name;
        return data;
    }
}

export interface IRole {
    roleID: number;
    name?: string | undefined;
}

export class PatientAccountModel implements IPatientAccountModel {
    patientID!: string;
    fullName?: string | undefined;
    uniqueID?: string | undefined;
    siteID!: string;
    displayName?: string | undefined;

    constructor(data?: IPatientAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.fullName = _data["FullName"];
            this.uniqueID = _data["UniqueID"];
            this.siteID = _data["SiteID"];
            this.displayName = _data["DisplayName"];
        }
    }

    static fromJS(data: any): PatientAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["FullName"] = this.fullName;
        data["UniqueID"] = this.uniqueID;
        data["SiteID"] = this.siteID;
        data["DisplayName"] = this.displayName;
        return data;
    }
}

export interface IPatientAccountModel {
    patientID: string;
    fullName?: string | undefined;
    uniqueID?: string | undefined;
    siteID: string;
    displayName?: string | undefined;
}

export class AccountPermissionsModel implements IAccountPermissionsModel {
    accountAccesses?: AccountAccessModel[] | undefined;
    patientAccesses?: PatientAccessModel[] | undefined;

    constructor(data?: IAccountPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AccountAccesses"])) {
                this.accountAccesses = [] as any;
                for (let item of _data["AccountAccesses"])
                    this.accountAccesses!.push(AccountAccessModel.fromJS(item));
            }
            if (Array.isArray(_data["PatientAccesses"])) {
                this.patientAccesses = [] as any;
                for (let item of _data["PatientAccesses"])
                    this.patientAccesses!.push(PatientAccessModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountAccesses)) {
            data["AccountAccesses"] = [];
            for (let item of this.accountAccesses)
                data["AccountAccesses"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.patientAccesses)) {
            data["PatientAccesses"] = [];
            for (let item of this.patientAccesses)
                data["PatientAccesses"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAccountPermissionsModel {
    accountAccesses?: AccountAccessModel[] | undefined;
    patientAccesses?: PatientAccessModel[] | undefined;
}

export class ValidateEmailBindingModel implements IValidateEmailBindingModel {
    email!: string;
    token!: string;
    password!: string;
    confirmPassword?: string | undefined;

    constructor(data?: IValidateEmailBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.token = _data["Token"];
            this.password = _data["Password"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ValidateEmailBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Token"] = this.token;
        data["Password"] = this.password;
        data["ConfirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IValidateEmailBindingModel {
    email: string;
    token: string;
    password: string;
    confirmPassword?: string | undefined;
}

export class CurrentSessionInfo implements ICurrentSessionInfo {
    remainingSeconds!: number;

    constructor(data?: ICurrentSessionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remainingSeconds = _data["RemainingSeconds"];
        }
    }

    static fromJS(data: any): CurrentSessionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentSessionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RemainingSeconds"] = this.remainingSeconds;
        return data;
    }
}

export interface ICurrentSessionInfo {
    remainingSeconds: number;
}

export class AttachmentsSummary implements IAttachmentsSummary {
    attachments?: AttachmentModel[] | undefined;
    canDelete!: boolean;
    canEditTags!: boolean;

    constructor(data?: IAttachmentsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(AttachmentModel.fromJS(item));
            }
            this.canDelete = _data["CanDelete"];
            this.canEditTags = _data["CanEditTags"];
        }
    }

    static fromJS(data: any): AttachmentsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CanDelete"] = this.canDelete;
        data["CanEditTags"] = this.canEditTags;
        return data;
    }
}

export interface IAttachmentsSummary {
    attachments?: AttachmentModel[] | undefined;
    canDelete: boolean;
    canEditTags: boolean;
}

export class AttachmentModel implements IAttachmentModel {
    attachmentID!: string;
    fileName?: string | undefined;
    patientID!: string;
    tags?: string[] | undefined;
    categoryName?: string | undefined;
    modifiedOn!: Date;
    name?: string | undefined;
    status?: string | undefined;

    constructor(data?: IAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentID = _data["AttachmentID"];
            this.fileName = _data["FileName"];
            this.patientID = _data["PatientID"];
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(item);
            }
            this.categoryName = _data["CategoryName"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): AttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttachmentID"] = this.attachmentID;
        data["FileName"] = this.fileName;
        data["PatientID"] = this.patientID;
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item);
        }
        data["CategoryName"] = this.categoryName;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["Status"] = this.status;
        return data;
    }
}

export interface IAttachmentModel {
    attachmentID: string;
    fileName?: string | undefined;
    patientID: string;
    tags?: string[] | undefined;
    categoryName?: string | undefined;
    modifiedOn: Date;
    name?: string | undefined;
    status?: string | undefined;
}

export class DocumentModel implements IDocumentModel {
    documentID!: number;
    name!: string;
    description!: string;
    filename!: string;
    documentType!: DocumentType;
    documentTypeName?: string | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    downloadFilename?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["DocumentID"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.filename = _data["Filename"];
            this.documentType = _data["DocumentType"];
            this.documentTypeName = _data["DocumentTypeName"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.downloadFilename = _data["DownloadFilename"];
            this.icon = _data["Icon"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentID"] = this.documentID;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Filename"] = this.filename;
        data["DocumentType"] = this.documentType;
        data["DocumentTypeName"] = this.documentTypeName;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["DownloadFilename"] = this.downloadFilename;
        data["Icon"] = this.icon;
        return data;
    }
}

export interface IDocumentModel {
    documentID: number;
    name: string;
    description: string;
    filename: string;
    documentType: DocumentType;
    documentTypeName?: string | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    downloadFilename?: string | undefined;
    icon?: string | undefined;
}

export enum DocumentType {
    Other = 0,
    Excel = 1,
    PowerPoint = 2,
    Word = 3,
    PDF = 4,
    Image = 5,
    Video = 6,
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canRead!: boolean;
    canWrite!: boolean;
    canSeek!: boolean;
    canTimeout!: boolean;
    length!: number;
    position!: number;
    readTimeout!: number;
    writeTimeout!: number;

    constructor(data?: IStream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canRead = _data["CanRead"];
            this.canWrite = _data["CanWrite"];
            this.canSeek = _data["CanSeek"];
            this.canTimeout = _data["CanTimeout"];
            this.length = _data["Length"];
            this.position = _data["Position"];
            this.readTimeout = _data["ReadTimeout"];
            this.writeTimeout = _data["WriteTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanRead"] = this.canRead;
        data["CanWrite"] = this.canWrite;
        data["CanSeek"] = this.canSeek;
        data["CanTimeout"] = this.canTimeout;
        data["Length"] = this.length;
        data["Position"] = this.position;
        data["ReadTimeout"] = this.readTimeout;
        data["WriteTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }
}

export interface IStream extends IMarshalByRefObject {
    canRead: boolean;
    canWrite: boolean;
    canSeek: boolean;
    canTimeout: boolean;
    length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;
}

export class DocumentDto implements IDocumentDto {
    documentID!: number;
    filename?: string | undefined;
    documentType!: DocumentType;
    name?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
    createdOn!: Date;
    modifiedOn!: Date;
    documentTags?: string[] | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["DocumentID"];
            this.filename = _data["Filename"];
            this.documentType = _data["DocumentType"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.contentType = _data["ContentType"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["DocumentTags"])) {
                this.documentTags = [] as any;
                for (let item of _data["DocumentTags"])
                    this.documentTags!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentID"] = this.documentID;
        data["Filename"] = this.filename;
        data["DocumentType"] = this.documentType;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ContentType"] = this.contentType;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.documentTags)) {
            data["DocumentTags"] = [];
            for (let item of this.documentTags)
                data["DocumentTags"].push(item);
        }
        return data;
    }
}

export interface IDocumentDto {
    documentID: number;
    filename?: string | undefined;
    documentType: DocumentType;
    name?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
    createdOn: Date;
    modifiedOn: Date;
    documentTags?: string[] | undefined;
}

export class ServiceOutcome implements IServiceOutcome {
    isSuccessful!: boolean;

    constructor(data?: IServiceOutcome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["IsSuccessful"];
        }
    }

    static fromJS(data: any): ServiceOutcome {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOutcome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IServiceOutcome {
    isSuccessful: boolean;
}

export enum GenerateExportV2Format {
    Csv = 0,
}

export class ExportInteractionInputModel implements IExportInteractionInputModel {
    identifying!: boolean;
    latest!: boolean;
    blankReplacement?: string | undefined;
    enrolled!: boolean;
    format?: string | undefined;

    constructor(data?: IExportInteractionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifying = _data["Identifying"];
            this.latest = _data["Latest"];
            this.blankReplacement = _data["BlankReplacement"];
            this.enrolled = _data["Enrolled"];
            this.format = _data["Format"];
        }
    }

    static fromJS(data: any): ExportInteractionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInteractionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Identifying"] = this.identifying;
        data["Latest"] = this.latest;
        data["BlankReplacement"] = this.blankReplacement;
        data["Enrolled"] = this.enrolled;
        data["Format"] = this.format;
        return data;
    }
}

export interface IExportInteractionInputModel {
    identifying: boolean;
    latest: boolean;
    blankReplacement?: string | undefined;
    enrolled: boolean;
    format?: string | undefined;
}

export class ExportGlobalInputModel implements IExportGlobalInputModel {
    blankReplacement?: string | undefined;
    timepoint?: string | undefined;
    patientID?: string | undefined;
    questions?: number[] | undefined;
    scoringSections?: number[] | undefined;
    format?: string | undefined;

    constructor(data?: IExportGlobalInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blankReplacement = _data["BlankReplacement"];
            this.timepoint = _data["Timepoint"];
            this.patientID = _data["PatientID"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(item);
            }
            if (Array.isArray(_data["ScoringSections"])) {
                this.scoringSections = [] as any;
                for (let item of _data["ScoringSections"])
                    this.scoringSections!.push(item);
            }
            this.format = _data["Format"];
        }
    }

    static fromJS(data: any): ExportGlobalInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportGlobalInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BlankReplacement"] = this.blankReplacement;
        data["Timepoint"] = this.timepoint;
        data["PatientID"] = this.patientID;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item);
        }
        if (Array.isArray(this.scoringSections)) {
            data["ScoringSections"] = [];
            for (let item of this.scoringSections)
                data["ScoringSections"].push(item);
        }
        data["Format"] = this.format;
        return data;
    }
}

export interface IExportGlobalInputModel {
    blankReplacement?: string | undefined;
    timepoint?: string | undefined;
    patientID?: string | undefined;
    questions?: number[] | undefined;
    scoringSections?: number[] | undefined;
    format?: string | undefined;
}

export class ExportModel implements IExportModel {
    exportID!: string;
    type?: string | undefined;
    outputFormatType?: string | undefined;
    status?: string | undefined;
    createdOn!: Date;
    expiresOn?: Date | undefined;
    numberOfRows?: number | undefined;
    interactionName?: string | undefined;
    patientUniqueID?: string | undefined;
    timepointLabel?: string | undefined;
    numberOfQuestions?: number | undefined;
    numberOfScoringSections?: number | undefined;

    constructor(data?: IExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportID = _data["ExportID"];
            this.type = _data["Type"];
            this.outputFormatType = _data["OutputFormatType"];
            this.status = _data["Status"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
            this.numberOfRows = _data["NumberOfRows"];
            this.interactionName = _data["InteractionName"];
            this.patientUniqueID = _data["PatientUniqueID"];
            this.timepointLabel = _data["TimepointLabel"];
            this.numberOfQuestions = _data["NumberOfQuestions"];
            this.numberOfScoringSections = _data["NumberOfScoringSections"];
        }
    }

    static fromJS(data: any): ExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExportID"] = this.exportID;
        data["Type"] = this.type;
        data["OutputFormatType"] = this.outputFormatType;
        data["Status"] = this.status;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["NumberOfRows"] = this.numberOfRows;
        data["InteractionName"] = this.interactionName;
        data["PatientUniqueID"] = this.patientUniqueID;
        data["TimepointLabel"] = this.timepointLabel;
        data["NumberOfQuestions"] = this.numberOfQuestions;
        data["NumberOfScoringSections"] = this.numberOfScoringSections;
        return data;
    }
}

export interface IExportModel {
    exportID: string;
    type?: string | undefined;
    outputFormatType?: string | undefined;
    status?: string | undefined;
    createdOn: Date;
    expiresOn?: Date | undefined;
    numberOfRows?: number | undefined;
    interactionName?: string | undefined;
    patientUniqueID?: string | undefined;
    timepointLabel?: string | undefined;
    numberOfQuestions?: number | undefined;
    numberOfScoringSections?: number | undefined;
}

export class FileNoteModel implements IFileNoteModel {
    fileNoteID!: string;
    createdOn!: Date;
    createdBy?: string | undefined;
    createdByID!: string;
    patientID!: string;
    patientName?: string | undefined;
    patientStudyID?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    formattedDescription?: string | undefined;

    constructor(data?: IFileNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileNoteID = _data["FileNoteID"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.createdByID = _data["CreatedByID"];
            this.patientID = _data["PatientID"];
            this.patientName = _data["PatientName"];
            this.patientStudyID = _data["PatientStudyID"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.formattedDescription = _data["FormattedDescription"];
        }
    }

    static fromJS(data: any): FileNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileNoteID"] = this.fileNoteID;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["CreatedByID"] = this.createdByID;
        data["PatientID"] = this.patientID;
        data["PatientName"] = this.patientName;
        data["PatientStudyID"] = this.patientStudyID;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["FormattedDescription"] = this.formattedDescription;
        return data;
    }
}

export interface IFileNoteModel {
    fileNoteID: string;
    createdOn: Date;
    createdBy?: string | undefined;
    createdByID: string;
    patientID: string;
    patientName?: string | undefined;
    patientStudyID?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    formattedDescription?: string | undefined;
}

export class NewFileNoteModel implements INewFileNoteModel {
    patientID!: string;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: INewFileNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.title = _data["Title"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): NewFileNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewFileNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["Title"] = this.title;
        data["Description"] = this.description;
        return data;
    }
}

export interface INewFileNoteModel {
    patientID: string;
    title?: string | undefined;
    description?: string | undefined;
}

export enum DashboardGraphType {
    ActiveParticipantsByTimepoint = 1,
    ParticipantsByStatus = 2,
}

export class PatientGraphModel implements IPatientGraphModel {
    graphID!: number;
    interactionID!: number;
    interactionName?: string | undefined;
    interactionVariablePrefix?: string | undefined;
    graphType!: PatientGraphType;
    patientID!: string;
    jSON?: string[] | undefined;

    constructor(data?: IPatientGraphModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graphID = _data["GraphID"];
            this.interactionID = _data["InteractionID"];
            this.interactionName = _data["InteractionName"];
            this.interactionVariablePrefix = _data["InteractionVariablePrefix"];
            this.graphType = _data["GraphType"];
            this.patientID = _data["PatientID"];
            if (Array.isArray(_data["JSON"])) {
                this.jSON = [] as any;
                for (let item of _data["JSON"])
                    this.jSON!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientGraphModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientGraphModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GraphID"] = this.graphID;
        data["InteractionID"] = this.interactionID;
        data["InteractionName"] = this.interactionName;
        data["InteractionVariablePrefix"] = this.interactionVariablePrefix;
        data["GraphType"] = this.graphType;
        data["PatientID"] = this.patientID;
        if (Array.isArray(this.jSON)) {
            data["JSON"] = [];
            for (let item of this.jSON)
                data["JSON"].push(item);
        }
        return data;
    }
}

export interface IPatientGraphModel {
    graphID: number;
    interactionID: number;
    interactionName?: string | undefined;
    interactionVariablePrefix?: string | undefined;
    graphType: PatientGraphType;
    patientID: string;
    jSON?: string[] | undefined;
}

export enum PatientGraphType {
    None = 0,
    Bar = 1,
    ScoreBar = 2,
    BarTrend = 3,
    Radar = 4,
}

export class HubResourceModel implements IHubResourceModel {
    hubResourceID!: string;
    studyID!: string;
    title!: string;
    description?: string | undefined;
    link!: string;
    resourceType!: ResourceType;
    imageSource?: string | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    resourceTypeName?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IHubResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hubResourceID = _data["HubResourceID"];
            this.studyID = _data["StudyID"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.link = _data["Link"];
            this.resourceType = _data["ResourceType"];
            this.imageSource = _data["ImageSource"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.resourceTypeName = _data["ResourceTypeName"];
            this.icon = _data["Icon"];
        }
    }

    static fromJS(data: any): HubResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HubResourceID"] = this.hubResourceID;
        data["StudyID"] = this.studyID;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["Link"] = this.link;
        data["ResourceType"] = this.resourceType;
        data["ImageSource"] = this.imageSource;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ResourceTypeName"] = this.resourceTypeName;
        data["Icon"] = this.icon;
        return data;
    }
}

export interface IHubResourceModel {
    hubResourceID: string;
    studyID: string;
    title: string;
    description?: string | undefined;
    link: string;
    resourceType: ResourceType;
    imageSource?: string | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    resourceTypeName?: string | undefined;
    icon?: string | undefined;
}

export enum ResourceType {
    Video = 1,
    ExternalLink = 2,
    PDF = 3,
}

export class HubAccountPatientModel implements IHubAccountPatientModel {
    patientID!: string;
    patientUniqueID?: string | undefined;
    patientName?: string | undefined;
    patientAge?: number | undefined;
    displayAge?: string | undefined;
    siteName?: string | undefined;
    hubAccountPatientID!: string;
    hubAccountID?: string | undefined;
    email!: string;
    emailConfirmed!: boolean;
    firstName!: string;
    lastName!: string;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    consentRequired!: boolean;
    consentRecieved?: Date | undefined;
    relationshipType!: RelationshipType;
    status!: AccountStatus;
    relationshipDescription?: string | undefined;

    constructor(data?: IHubAccountPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.patientUniqueID = _data["PatientUniqueID"];
            this.patientName = _data["PatientName"];
            this.patientAge = _data["PatientAge"];
            this.displayAge = _data["DisplayAge"];
            this.siteName = _data["SiteName"];
            this.hubAccountPatientID = _data["HubAccountPatientID"];
            this.hubAccountID = _data["HubAccountID"];
            this.email = _data["Email"];
            this.emailConfirmed = _data["EmailConfirmed"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.consentRequired = _data["ConsentRequired"];
            this.consentRecieved = _data["ConsentRecieved"] ? new Date(_data["ConsentRecieved"].toString()) : <any>undefined;
            this.relationshipType = _data["RelationshipType"];
            this.status = _data["Status"];
            this.relationshipDescription = _data["RelationshipDescription"];
        }
    }

    static fromJS(data: any): HubAccountPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubAccountPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["PatientUniqueID"] = this.patientUniqueID;
        data["PatientName"] = this.patientName;
        data["PatientAge"] = this.patientAge;
        data["DisplayAge"] = this.displayAge;
        data["SiteName"] = this.siteName;
        data["HubAccountPatientID"] = this.hubAccountPatientID;
        data["HubAccountID"] = this.hubAccountID;
        data["Email"] = this.email;
        data["EmailConfirmed"] = this.emailConfirmed;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ConsentRequired"] = this.consentRequired;
        data["ConsentRecieved"] = this.consentRecieved ? this.consentRecieved.toISOString() : <any>undefined;
        data["RelationshipType"] = this.relationshipType;
        data["Status"] = this.status;
        data["RelationshipDescription"] = this.relationshipDescription;
        return data;
    }
}

export interface IHubAccountPatientModel {
    patientID: string;
    patientUniqueID?: string | undefined;
    patientName?: string | undefined;
    patientAge?: number | undefined;
    displayAge?: string | undefined;
    siteName?: string | undefined;
    hubAccountPatientID: string;
    hubAccountID?: string | undefined;
    email: string;
    emailConfirmed: boolean;
    firstName: string;
    lastName: string;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    consentRequired: boolean;
    consentRecieved?: Date | undefined;
    relationshipType: RelationshipType;
    status: AccountStatus;
    relationshipDescription?: string | undefined;
}

export enum RelationshipType {
    Guardian = 0,
    Self = 1,
    Other = 2,
}

export class HubConsentFormModel implements IHubConsentFormModel {
    studyConsentFormID!: string;
    studyID!: string;
    siteID!: string;
    consentHtml?: string | undefined;
    version!: number;
    status!: ConsentFormStatus;
    autoEnrollPatientOnConsent!: boolean;
    autoSendEnrollmentPackageOnConsent!: boolean;
    requireInternalSignature!: boolean;
    defaultEmailTemplateID?: number | undefined;
    ccEmail?: string | undefined;
    createdOn!: Date;
    createdByAccountID!: string;
    modifiedOn!: Date;
    modifiedByAccountID!: string;
    isNew!: boolean;
    categoryID?: string | undefined;

    constructor(data?: IHubConsentFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyConsentFormID = _data["StudyConsentFormID"];
            this.studyID = _data["StudyID"];
            this.siteID = _data["SiteID"];
            this.consentHtml = _data["ConsentHtml"];
            this.version = _data["Version"];
            this.status = _data["Status"];
            this.autoEnrollPatientOnConsent = _data["AutoEnrollPatientOnConsent"];
            this.autoSendEnrollmentPackageOnConsent = _data["AutoSendEnrollmentPackageOnConsent"];
            this.requireInternalSignature = _data["RequireInternalSignature"];
            this.defaultEmailTemplateID = _data["DefaultEmailTemplateID"];
            this.ccEmail = _data["CcEmail"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdByAccountID = _data["CreatedByAccountID"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedByAccountID = _data["ModifiedByAccountID"];
            this.isNew = _data["IsNew"];
            this.categoryID = _data["CategoryID"];
        }
    }

    static fromJS(data: any): HubConsentFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubConsentFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyConsentFormID"] = this.studyConsentFormID;
        data["StudyID"] = this.studyID;
        data["SiteID"] = this.siteID;
        data["ConsentHtml"] = this.consentHtml;
        data["Version"] = this.version;
        data["Status"] = this.status;
        data["AutoEnrollPatientOnConsent"] = this.autoEnrollPatientOnConsent;
        data["AutoSendEnrollmentPackageOnConsent"] = this.autoSendEnrollmentPackageOnConsent;
        data["RequireInternalSignature"] = this.requireInternalSignature;
        data["DefaultEmailTemplateID"] = this.defaultEmailTemplateID;
        data["CcEmail"] = this.ccEmail;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedByAccountID"] = this.createdByAccountID;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedByAccountID"] = this.modifiedByAccountID;
        data["IsNew"] = this.isNew;
        data["CategoryID"] = this.categoryID;
        return data;
    }
}

export interface IHubConsentFormModel {
    studyConsentFormID: string;
    studyID: string;
    siteID: string;
    consentHtml?: string | undefined;
    version: number;
    status: ConsentFormStatus;
    autoEnrollPatientOnConsent: boolean;
    autoSendEnrollmentPackageOnConsent: boolean;
    requireInternalSignature: boolean;
    defaultEmailTemplateID?: number | undefined;
    ccEmail?: string | undefined;
    createdOn: Date;
    createdByAccountID: string;
    modifiedOn: Date;
    modifiedByAccountID: string;
    isNew: boolean;
    categoryID?: string | undefined;
}

export enum ConsentFormStatus {
    InActive = 0,
    Active = 1,
    Deleted = 2,
}

export class HubPatientConsentModel implements IHubPatientConsentModel {
    hubPatientConsentID!: string;
    studySiteConsentFormID!: string;
    consentHtml?: string | undefined;
    hubAccountName?: string | undefined;
    patientName?: string | undefined;
    uniqueID?: string | undefined;
    patientSiteName?: string | undefined;
    externalSignature?: ConsentSignature | undefined;
    internalSignature?: ConsentSignature | undefined;

    constructor(data?: IHubPatientConsentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hubPatientConsentID = _data["HubPatientConsentID"];
            this.studySiteConsentFormID = _data["StudySiteConsentFormID"];
            this.consentHtml = _data["ConsentHtml"];
            this.hubAccountName = _data["HubAccountName"];
            this.patientName = _data["PatientName"];
            this.uniqueID = _data["UniqueID"];
            this.patientSiteName = _data["PatientSiteName"];
            this.externalSignature = _data["ExternalSignature"] ? ConsentSignature.fromJS(_data["ExternalSignature"]) : <any>undefined;
            this.internalSignature = _data["InternalSignature"] ? ConsentSignature.fromJS(_data["InternalSignature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HubPatientConsentModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubPatientConsentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HubPatientConsentID"] = this.hubPatientConsentID;
        data["StudySiteConsentFormID"] = this.studySiteConsentFormID;
        data["ConsentHtml"] = this.consentHtml;
        data["HubAccountName"] = this.hubAccountName;
        data["PatientName"] = this.patientName;
        data["UniqueID"] = this.uniqueID;
        data["PatientSiteName"] = this.patientSiteName;
        data["ExternalSignature"] = this.externalSignature ? this.externalSignature.toJSON() : <any>undefined;
        data["InternalSignature"] = this.internalSignature ? this.internalSignature.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHubPatientConsentModel {
    hubPatientConsentID: string;
    studySiteConsentFormID: string;
    consentHtml?: string | undefined;
    hubAccountName?: string | undefined;
    patientName?: string | undefined;
    uniqueID?: string | undefined;
    patientSiteName?: string | undefined;
    externalSignature?: ConsentSignature | undefined;
    internalSignature?: ConsentSignature | undefined;
}

export class ConsentSignature implements IConsentSignature {
    firstName?: string | undefined;
    lastName?: string | undefined;
    signature?: string | undefined;
    signedOn!: Date;

    constructor(data?: IConsentSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.signature = _data["Signature"];
            this.signedOn = _data["SignedOn"] ? new Date(_data["SignedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsentSignature {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Signature"] = this.signature;
        data["SignedOn"] = this.signedOn ? this.signedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConsentSignature {
    firstName?: string | undefined;
    lastName?: string | undefined;
    signature?: string | undefined;
    signedOn: Date;
}

export class HubEventModel implements IHubEventModel {
    hubEventID!: string;
    studyID!: string;
    siteID?: string | undefined;
    patientID?: string | undefined;
    title?: string | undefined;
    link?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    submittedBy?: string | undefined;
    status!: EventStatus;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    eventStatusName?: string | undefined;

    constructor(data?: IHubEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hubEventID = _data["HubEventID"];
            this.studyID = _data["StudyID"];
            this.siteID = _data["SiteID"];
            this.patientID = _data["PatientID"];
            this.title = _data["Title"];
            this.link = _data["Link"];
            this.startDate = _data["StartDate"];
            this.endDate = _data["EndDate"];
            this.submittedBy = _data["SubmittedBy"];
            this.status = _data["Status"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.eventStatusName = _data["EventStatusName"];
        }
    }

    static fromJS(data: any): HubEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HubEventID"] = this.hubEventID;
        data["StudyID"] = this.studyID;
        data["SiteID"] = this.siteID;
        data["PatientID"] = this.patientID;
        data["Title"] = this.title;
        data["Link"] = this.link;
        data["StartDate"] = this.startDate;
        data["EndDate"] = this.endDate;
        data["SubmittedBy"] = this.submittedBy;
        data["Status"] = this.status;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["EventStatusName"] = this.eventStatusName;
        return data;
    }
}

export interface IHubEventModel {
    hubEventID: string;
    studyID: string;
    siteID?: string | undefined;
    patientID?: string | undefined;
    title?: string | undefined;
    link?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    submittedBy?: string | undefined;
    status: EventStatus;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    eventStatusName?: string | undefined;
}

export enum EventStatus {
    Active = 0,
    Deleted = 1,
    Submitted = 2,
}

export class HubPageModel implements IHubPageModel {
    hubPageID!: string;
    studyID!: string;
    name!: string;
    slug?: string | undefined;
    sEOTitle?: string | undefined;
    sEODescription?: string | undefined;
    design?: Element[] | undefined;
    hTML?: string | undefined;
    position!: number;
    status!: PageStatus;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    version!: number;
    includeInNav!: boolean;
    pageStatusName?: string | undefined;

    constructor(data?: IHubPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hubPageID = _data["HubPageID"];
            this.studyID = _data["StudyID"];
            this.name = _data["Name"];
            this.slug = _data["Slug"];
            this.sEOTitle = _data["SEOTitle"];
            this.sEODescription = _data["SEODescription"];
            if (Array.isArray(_data["Design"])) {
                this.design = [] as any;
                for (let item of _data["Design"])
                    this.design!.push(Element.fromJS(item));
            }
            this.hTML = _data["HTML"];
            this.position = _data["Position"];
            this.status = _data["Status"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.version = _data["Version"];
            this.includeInNav = _data["IncludeInNav"];
            this.pageStatusName = _data["PageStatusName"];
        }
    }

    static fromJS(data: any): HubPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HubPageID"] = this.hubPageID;
        data["StudyID"] = this.studyID;
        data["Name"] = this.name;
        data["Slug"] = this.slug;
        data["SEOTitle"] = this.sEOTitle;
        data["SEODescription"] = this.sEODescription;
        if (Array.isArray(this.design)) {
            data["Design"] = [];
            for (let item of this.design)
                data["Design"].push(item ? item.toJSON() : <any>undefined);
        }
        data["HTML"] = this.hTML;
        data["Position"] = this.position;
        data["Status"] = this.status;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["Version"] = this.version;
        data["IncludeInNav"] = this.includeInNav;
        data["PageStatusName"] = this.pageStatusName;
        return data;
    }
}

export interface IHubPageModel {
    hubPageID: string;
    studyID: string;
    name: string;
    slug?: string | undefined;
    sEOTitle?: string | undefined;
    sEODescription?: string | undefined;
    design?: Element[] | undefined;
    hTML?: string | undefined;
    position: number;
    status: PageStatus;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    version: number;
    includeInNav: boolean;
    pageStatusName?: string | undefined;
}

export class Element implements IElement {
    type?: string | undefined;
    content?: string | undefined;

    constructor(data?: IElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.content = _data["Content"];
        }
    }

    static fromJS(data: any): Element {
        data = typeof data === 'object' ? data : {};
        let result = new Element();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Content"] = this.content;
        return data;
    }
}

export interface IElement {
    type?: string | undefined;
    content?: string | undefined;
}

export enum PageStatus {
    Draft = 0,
    Published = 1,
    Deleted = -1,
}

export class InteractionModel implements IInteractionModel {
    interactionID!: number;
    name?: string | undefined;
    interactionType!: InteractionType;
    interactionSecurityType!: InteractionSecurityType;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    siteID!: string;
    siteName?: string | undefined;
    studyID!: string;
    studyName?: string | undefined;
    canEdit!: boolean;
    canExport!: boolean;
    description?: string | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    /** For FaxAttachment type */
    faxNumberId?: string | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    autoScheduleDescription?: string | undefined;
    autoScheduleIntervalName?: string | undefined;
    ages?: string | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    isActive!: boolean;
    questions?: Question[] | undefined;
    patientInteractions?: PatientInteraction[] | undefined;
    questionCount!: number;
    instances!: number;
    scoreType!: ScoreType;
    scoringSections?: ScoringSectionModel[] | undefined;
    graphType!: PatientGraphType;
    noteType!: InteractionNoteType;
    variablePrefix?: string | undefined;
    rescore!: boolean;
    isPriority!: boolean;
    requiresInternalSignature!: boolean;
    isSystemType!: boolean;
    categoryID?: string | undefined;
    timepoints?: NewInteractionTimepointModel[] | undefined;
    scheduledTimepoints?: number[] | undefined;
    graphs?: Graph[] | undefined;
    triggers?: TriggerModel[] | undefined;
    interactionTranslations?: InteractionTranslationModel[] | undefined;

    constructor(data?: IInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
            this.interactionType = _data["InteractionType"];
            this.interactionSecurityType = _data["InteractionSecurityType"];
            this.minAge = _data["MinAge"];
            this.maxAge = _data["MaxAge"];
            this.autoScheduleLength = _data["AutoScheduleLength"];
            this.siteID = _data["SiteID"];
            this.siteName = _data["SiteName"];
            this.studyID = _data["StudyID"];
            this.studyName = _data["StudyName"];
            this.canEdit = _data["CanEdit"];
            this.canExport = _data["CanExport"];
            this.description = _data["Description"];
            this.tabPosition = _data["TabPosition"];
            this.tabName = _data["TabName"];
            this.faxNumberId = _data["FaxNumberId"];
            this.autoScheduleInterval = _data["AutoScheduleInterval"];
            this.autoScheduleDescription = _data["AutoScheduleDescription"];
            this.autoScheduleIntervalName = _data["AutoScheduleIntervalName"];
            this.ages = _data["Ages"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.isActive = _data["IsActive"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["PatientInteractions"])) {
                this.patientInteractions = [] as any;
                for (let item of _data["PatientInteractions"])
                    this.patientInteractions!.push(PatientInteraction.fromJS(item));
            }
            this.questionCount = _data["QuestionCount"];
            this.instances = _data["Instances"];
            this.scoreType = _data["ScoreType"];
            if (Array.isArray(_data["ScoringSections"])) {
                this.scoringSections = [] as any;
                for (let item of _data["ScoringSections"])
                    this.scoringSections!.push(ScoringSectionModel.fromJS(item));
            }
            this.graphType = _data["GraphType"];
            this.noteType = _data["NoteType"];
            this.variablePrefix = _data["VariablePrefix"];
            this.rescore = _data["Rescore"];
            this.isPriority = _data["IsPriority"];
            this.requiresInternalSignature = _data["RequiresInternalSignature"];
            this.isSystemType = _data["IsSystemType"];
            this.categoryID = _data["CategoryID"];
            if (Array.isArray(_data["Timepoints"])) {
                this.timepoints = [] as any;
                for (let item of _data["Timepoints"])
                    this.timepoints!.push(NewInteractionTimepointModel.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledTimepoints"])) {
                this.scheduledTimepoints = [] as any;
                for (let item of _data["ScheduledTimepoints"])
                    this.scheduledTimepoints!.push(item);
            }
            if (Array.isArray(_data["Graphs"])) {
                this.graphs = [] as any;
                for (let item of _data["Graphs"])
                    this.graphs!.push(Graph.fromJS(item));
            }
            if (Array.isArray(_data["Triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["Triggers"])
                    this.triggers!.push(TriggerModel.fromJS(item));
            }
            if (Array.isArray(_data["InteractionTranslations"])) {
                this.interactionTranslations = [] as any;
                for (let item of _data["InteractionTranslations"])
                    this.interactionTranslations!.push(InteractionTranslationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        data["InteractionType"] = this.interactionType;
        data["InteractionSecurityType"] = this.interactionSecurityType;
        data["MinAge"] = this.minAge;
        data["MaxAge"] = this.maxAge;
        data["AutoScheduleLength"] = this.autoScheduleLength;
        data["SiteID"] = this.siteID;
        data["SiteName"] = this.siteName;
        data["StudyID"] = this.studyID;
        data["StudyName"] = this.studyName;
        data["CanEdit"] = this.canEdit;
        data["CanExport"] = this.canExport;
        data["Description"] = this.description;
        data["TabPosition"] = this.tabPosition;
        data["TabName"] = this.tabName;
        data["FaxNumberId"] = this.faxNumberId;
        data["AutoScheduleInterval"] = this.autoScheduleInterval;
        data["AutoScheduleDescription"] = this.autoScheduleDescription;
        data["AutoScheduleIntervalName"] = this.autoScheduleIntervalName;
        data["Ages"] = this.ages;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["IsActive"] = this.isActive;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.patientInteractions)) {
            data["PatientInteractions"] = [];
            for (let item of this.patientInteractions)
                data["PatientInteractions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["QuestionCount"] = this.questionCount;
        data["Instances"] = this.instances;
        data["ScoreType"] = this.scoreType;
        if (Array.isArray(this.scoringSections)) {
            data["ScoringSections"] = [];
            for (let item of this.scoringSections)
                data["ScoringSections"].push(item ? item.toJSON() : <any>undefined);
        }
        data["GraphType"] = this.graphType;
        data["NoteType"] = this.noteType;
        data["VariablePrefix"] = this.variablePrefix;
        data["Rescore"] = this.rescore;
        data["IsPriority"] = this.isPriority;
        data["RequiresInternalSignature"] = this.requiresInternalSignature;
        data["IsSystemType"] = this.isSystemType;
        data["CategoryID"] = this.categoryID;
        if (Array.isArray(this.timepoints)) {
            data["Timepoints"] = [];
            for (let item of this.timepoints)
                data["Timepoints"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.scheduledTimepoints)) {
            data["ScheduledTimepoints"] = [];
            for (let item of this.scheduledTimepoints)
                data["ScheduledTimepoints"].push(item);
        }
        if (Array.isArray(this.graphs)) {
            data["Graphs"] = [];
            for (let item of this.graphs)
                data["Graphs"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.triggers)) {
            data["Triggers"] = [];
            for (let item of this.triggers)
                data["Triggers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.interactionTranslations)) {
            data["InteractionTranslations"] = [];
            for (let item of this.interactionTranslations)
                data["InteractionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionModel {
    interactionID: number;
    name?: string | undefined;
    interactionType: InteractionType;
    interactionSecurityType: InteractionSecurityType;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    siteID: string;
    siteName?: string | undefined;
    studyID: string;
    studyName?: string | undefined;
    canEdit: boolean;
    canExport: boolean;
    description?: string | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    /** For FaxAttachment type */
    faxNumberId?: string | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    autoScheduleDescription?: string | undefined;
    autoScheduleIntervalName?: string | undefined;
    ages?: string | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    isActive: boolean;
    questions?: Question[] | undefined;
    patientInteractions?: PatientInteraction[] | undefined;
    questionCount: number;
    instances: number;
    scoreType: ScoreType;
    scoringSections?: ScoringSectionModel[] | undefined;
    graphType: PatientGraphType;
    noteType: InteractionNoteType;
    variablePrefix?: string | undefined;
    rescore: boolean;
    isPriority: boolean;
    requiresInternalSignature: boolean;
    isSystemType: boolean;
    categoryID?: string | undefined;
    timepoints?: NewInteractionTimepointModel[] | undefined;
    scheduledTimepoints?: number[] | undefined;
    graphs?: Graph[] | undefined;
    triggers?: TriggerModel[] | undefined;
    interactionTranslations?: InteractionTranslationModel[] | undefined;
}

export enum InteractionType {
    Registration = 1,
    System = 2,
    Standard = 3,
    Signed = 4,
    EmailParticipant = 5,
    FaxPhysician = 6,
    FaxAttachment = 7,
}

export enum InteractionSecurityType {
    Private = 1,
    Shared = 2,
    Public = 3,
}

export class Question implements IQuestion {
    questionID!: number;
    interactionID!: number;
    questionTranslations?: QuestionTranslationModel[] | undefined;
    uniqueCode?: string | undefined;
    subCodes?: string[] | undefined;
    position!: number;
    grouping!: Grouping;
    groupWithPrevious!: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    questionType!: QuestionType;
    visibility!: QuestionVisibility;
    questionTypeDescription?: string | undefined;
    required!: boolean;
    isRange!: boolean;
    options?: string | undefined;
    optionsArray?: QuestionOptionMigration[] | undefined;
    includeOther!: boolean;
    otherLabel?: string | undefined;
    extendedOptionsObject?: ExtendedOptionsObjectMigration | undefined;
    ruleObject?: RuleObject | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    decimals?: number | undefined;
    isIdentifying!: boolean;
    isAlwaysIdentifying!: boolean;
    isInstruction!: boolean;
    dependantOn?: number | undefined;
    defaultValueType?: DefaultValueType | undefined;
    dependantOperator?: CompareOperator | undefined;
    dependantValue?: string | undefined;
    isRepeatable!: boolean;
    displayCode!: boolean;
    displayLabel!: boolean;
    displayInstruction!: boolean;
    displayMandatory!: boolean;
    displayMinMax!: boolean;
    displayDecimals!: boolean;
    displayIsRange!: boolean;
    displayValidation!: boolean;
    displayDefaultOptions!: boolean;
    displayOptions!: boolean;
    displayIncludeOther!: boolean;
    displayExtendedOptions!: boolean;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionID = _data["QuestionID"];
            this.interactionID = _data["InteractionID"];
            if (Array.isArray(_data["QuestionTranslations"])) {
                this.questionTranslations = [] as any;
                for (let item of _data["QuestionTranslations"])
                    this.questionTranslations!.push(QuestionTranslationModel.fromJS(item));
            }
            this.uniqueCode = _data["UniqueCode"];
            if (Array.isArray(_data["SubCodes"])) {
                this.subCodes = [] as any;
                for (let item of _data["SubCodes"])
                    this.subCodes!.push(item);
            }
            this.position = _data["Position"];
            this.grouping = _data["Grouping"];
            this.groupWithPrevious = _data["GroupWithPrevious"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.questionType = _data["QuestionType"];
            this.visibility = _data["Visibility"];
            this.questionTypeDescription = _data["QuestionTypeDescription"];
            this.required = _data["Required"];
            this.isRange = _data["IsRange"];
            this.options = _data["Options"];
            if (Array.isArray(_data["OptionsArray"])) {
                this.optionsArray = [] as any;
                for (let item of _data["OptionsArray"])
                    this.optionsArray!.push(QuestionOptionMigration.fromJS(item));
            }
            this.includeOther = _data["IncludeOther"];
            this.otherLabel = _data["OtherLabel"];
            this.extendedOptionsObject = _data["ExtendedOptionsObject"] ? ExtendedOptionsObjectMigration.fromJS(_data["ExtendedOptionsObject"]) : <any>undefined;
            this.ruleObject = _data["RuleObject"] ? RuleObject.fromJS(_data["RuleObject"]) : <any>undefined;
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.validationMessage = _data["ValidationMessage"];
            this.minValue = _data["MinValue"];
            this.maxValue = _data["MaxValue"];
            this.decimals = _data["Decimals"];
            this.isIdentifying = _data["IsIdentifying"];
            this.isAlwaysIdentifying = _data["IsAlwaysIdentifying"];
            this.isInstruction = _data["IsInstruction"];
            this.dependantOn = _data["DependantOn"];
            this.defaultValueType = _data["DefaultValueType"];
            this.dependantOperator = _data["DependantOperator"];
            this.dependantValue = _data["DependantValue"];
            this.isRepeatable = _data["IsRepeatable"];
            this.displayCode = _data["DisplayCode"];
            this.displayLabel = _data["DisplayLabel"];
            this.displayInstruction = _data["DisplayInstruction"];
            this.displayMandatory = _data["DisplayMandatory"];
            this.displayMinMax = _data["DisplayMinMax"];
            this.displayDecimals = _data["DisplayDecimals"];
            this.displayIsRange = _data["DisplayIsRange"];
            this.displayValidation = _data["DisplayValidation"];
            this.displayDefaultOptions = _data["DisplayDefaultOptions"];
            this.displayOptions = _data["DisplayOptions"];
            this.displayIncludeOther = _data["DisplayIncludeOther"];
            this.displayExtendedOptions = _data["DisplayExtendedOptions"];
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionID"] = this.questionID;
        data["InteractionID"] = this.interactionID;
        if (Array.isArray(this.questionTranslations)) {
            data["QuestionTranslations"] = [];
            for (let item of this.questionTranslations)
                data["QuestionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["UniqueCode"] = this.uniqueCode;
        if (Array.isArray(this.subCodes)) {
            data["SubCodes"] = [];
            for (let item of this.subCodes)
                data["SubCodes"].push(item);
        }
        data["Position"] = this.position;
        data["Grouping"] = this.grouping;
        data["GroupWithPrevious"] = this.groupWithPrevious;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["QuestionType"] = this.questionType;
        data["Visibility"] = this.visibility;
        data["QuestionTypeDescription"] = this.questionTypeDescription;
        data["Required"] = this.required;
        data["IsRange"] = this.isRange;
        data["Options"] = this.options;
        if (Array.isArray(this.optionsArray)) {
            data["OptionsArray"] = [];
            for (let item of this.optionsArray)
                data["OptionsArray"].push(item ? item.toJSON() : <any>undefined);
        }
        data["IncludeOther"] = this.includeOther;
        data["OtherLabel"] = this.otherLabel;
        data["ExtendedOptionsObject"] = this.extendedOptionsObject ? this.extendedOptionsObject.toJSON() : <any>undefined;
        data["RuleObject"] = this.ruleObject ? this.ruleObject.toJSON() : <any>undefined;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ValidationMessage"] = this.validationMessage;
        data["MinValue"] = this.minValue;
        data["MaxValue"] = this.maxValue;
        data["Decimals"] = this.decimals;
        data["IsIdentifying"] = this.isIdentifying;
        data["IsAlwaysIdentifying"] = this.isAlwaysIdentifying;
        data["IsInstruction"] = this.isInstruction;
        data["DependantOn"] = this.dependantOn;
        data["DefaultValueType"] = this.defaultValueType;
        data["DependantOperator"] = this.dependantOperator;
        data["DependantValue"] = this.dependantValue;
        data["IsRepeatable"] = this.isRepeatable;
        data["DisplayCode"] = this.displayCode;
        data["DisplayLabel"] = this.displayLabel;
        data["DisplayInstruction"] = this.displayInstruction;
        data["DisplayMandatory"] = this.displayMandatory;
        data["DisplayMinMax"] = this.displayMinMax;
        data["DisplayDecimals"] = this.displayDecimals;
        data["DisplayIsRange"] = this.displayIsRange;
        data["DisplayValidation"] = this.displayValidation;
        data["DisplayDefaultOptions"] = this.displayDefaultOptions;
        data["DisplayOptions"] = this.displayOptions;
        data["DisplayIncludeOther"] = this.displayIncludeOther;
        data["DisplayExtendedOptions"] = this.displayExtendedOptions;
        return data;
    }
}

export interface IQuestion {
    questionID: number;
    interactionID: number;
    questionTranslations?: QuestionTranslationModel[] | undefined;
    uniqueCode?: string | undefined;
    subCodes?: string[] | undefined;
    position: number;
    grouping: Grouping;
    groupWithPrevious: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    questionType: QuestionType;
    visibility: QuestionVisibility;
    questionTypeDescription?: string | undefined;
    required: boolean;
    isRange: boolean;
    options?: string | undefined;
    optionsArray?: QuestionOptionMigration[] | undefined;
    includeOther: boolean;
    otherLabel?: string | undefined;
    extendedOptionsObject?: ExtendedOptionsObjectMigration | undefined;
    ruleObject?: RuleObject | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    decimals?: number | undefined;
    isIdentifying: boolean;
    isAlwaysIdentifying: boolean;
    isInstruction: boolean;
    dependantOn?: number | undefined;
    defaultValueType?: DefaultValueType | undefined;
    dependantOperator?: CompareOperator | undefined;
    dependantValue?: string | undefined;
    isRepeatable: boolean;
    displayCode: boolean;
    displayLabel: boolean;
    displayInstruction: boolean;
    displayMandatory: boolean;
    displayMinMax: boolean;
    displayDecimals: boolean;
    displayIsRange: boolean;
    displayValidation: boolean;
    displayDefaultOptions: boolean;
    displayOptions: boolean;
    displayIncludeOther: boolean;
    displayExtendedOptions: boolean;
}

export class QuestionTranslationModel implements IQuestionTranslationModel {
    languageID!: number;
    language?: string | undefined;
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    optionsArray?: QuestionOptionMigration[] | undefined;
    extendedOptionsObject?: ExtendedOptionsObjectMigration | undefined;
    otherLabel?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IQuestionTranslationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageID = _data["LanguageID"];
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.validationMessage = _data["ValidationMessage"];
            if (Array.isArray(_data["OptionsArray"])) {
                this.optionsArray = [] as any;
                for (let item of _data["OptionsArray"])
                    this.optionsArray!.push(QuestionOptionMigration.fromJS(item));
            }
            this.extendedOptionsObject = _data["ExtendedOptionsObject"] ? ExtendedOptionsObjectMigration.fromJS(_data["ExtendedOptionsObject"]) : <any>undefined;
            this.otherLabel = _data["OtherLabel"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): QuestionTranslationModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTranslationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageID"] = this.languageID;
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["ValidationMessage"] = this.validationMessage;
        if (Array.isArray(this.optionsArray)) {
            data["OptionsArray"] = [];
            for (let item of this.optionsArray)
                data["OptionsArray"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ExtendedOptionsObject"] = this.extendedOptionsObject ? this.extendedOptionsObject.toJSON() : <any>undefined;
        data["OtherLabel"] = this.otherLabel;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IQuestionTranslationModel {
    languageID: number;
    language?: string | undefined;
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    optionsArray?: QuestionOptionMigration[] | undefined;
    extendedOptionsObject?: ExtendedOptionsObjectMigration | undefined;
    otherLabel?: string | undefined;
    isDefault: boolean;
}

export class QuestionOptionMigration implements IQuestionOptionMigration {
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    label?: string | undefined;
    score!: number;

    constructor(data?: IQuestionOptionMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            this.label = _data["Label"];
            this.score = _data["Score"];
        }
    }

    static fromJS(data: any): QuestionOptionMigration {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOptionMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Label"] = this.label;
        data["Score"] = this.score;
        return data;
    }
}

export interface IQuestionOptionMigration {
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    label?: string | undefined;
    score: number;
}

export class LabelTranslation implements ILabelTranslation {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault!: boolean;

    constructor(data?: ILabelTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.value = _data["Value"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): LabelTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LabelTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["Value"] = this.value;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface ILabelTranslation {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault: boolean;
}

export class ExtendedOptionsObjectMigration implements IExtendedOptionsObjectMigration {
    optionGroups?: OptionGroupMigration[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration[] | undefined;

    constructor(data?: IExtendedOptionsObjectMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["OptionGroups"])) {
                this.optionGroups = [] as any;
                for (let item of _data["OptionGroups"])
                    this.optionGroups!.push(OptionGroupMigration.fromJS(item));
            }
            if (Array.isArray(_data["ExtendedQuestionOptions"])) {
                this.extendedQuestionOptions = [] as any;
                for (let item of _data["ExtendedQuestionOptions"])
                    this.extendedQuestionOptions!.push(ExtendedQuestionOptionMigration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtendedOptionsObjectMigration {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedOptionsObjectMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionGroups)) {
            data["OptionGroups"] = [];
            for (let item of this.optionGroups)
                data["OptionGroups"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.extendedQuestionOptions)) {
            data["ExtendedQuestionOptions"] = [];
            for (let item of this.extendedQuestionOptions)
                data["ExtendedQuestionOptions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IExtendedOptionsObjectMigration {
    optionGroups?: OptionGroupMigration[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration[] | undefined;
}

export class OptionGroupMigration implements IOptionGroupMigration {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    options?: QuestionOptionMigration[] | undefined;
    value?: string | undefined;
    required!: boolean;
    validationMessages?: LabelTranslation[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;

    constructor(data?: IOptionGroupMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueCode = _data["UniqueCode"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(QuestionOptionMigration.fromJS(item));
            }
            this.value = _data["Value"];
            this.required = _data["Required"];
            if (Array.isArray(_data["ValidationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["ValidationMessages"])
                    this.validationMessages!.push(LabelTranslation.fromJS(item));
            }
            this.validationMessage = _data["ValidationMessage"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): OptionGroupMigration {
        data = typeof data === 'object' ? data : {};
        let result = new OptionGroupMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UniqueCode"] = this.uniqueCode;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Value"] = this.value;
        data["Required"] = this.required;
        if (Array.isArray(this.validationMessages)) {
            data["ValidationMessages"] = [];
            for (let item of this.validationMessages)
                data["ValidationMessages"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ValidationMessage"] = this.validationMessage;
        data["Label"] = this.label;
        return data;
    }
}

export interface IOptionGroupMigration {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    options?: QuestionOptionMigration[] | undefined;
    value?: string | undefined;
    required: boolean;
    validationMessages?: LabelTranslation[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;
}

export class ExtendedQuestionOptionMigration implements IExtendedQuestionOptionMigration {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    score!: number;
    scoreOptions?: Score[] | undefined;

    constructor(data?: IExtendedQuestionOptionMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["Label"];
            this.code = _data["Code"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            this.score = _data["Score"];
            if (Array.isArray(_data["ScoreOptions"])) {
                this.scoreOptions = [] as any;
                for (let item of _data["ScoreOptions"])
                    this.scoreOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtendedQuestionOptionMigration {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedQuestionOptionMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Label"] = this.label;
        data["Code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Score"] = this.score;
        if (Array.isArray(this.scoreOptions)) {
            data["ScoreOptions"] = [];
            for (let item of this.scoreOptions)
                data["ScoreOptions"].push(item);
        }
        return data;
    }
}

export interface IExtendedQuestionOptionMigration {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    score: number;
    scoreOptions?: Score[] | undefined;
}

export enum Score {
    Ignore = 0,
    Include = 1,
    Reverse = 2,
}

export enum Grouping {
    NotGrouped = 0,
    WithPrevious = 1,
}

export enum QuestionType {
    Instruction = 0,
    Identifier = 1,
    Text = 2,
    Number = 3,
    Date = 4,
    Time = 5,
    SingleChoice = 6,
    MultipleChoice = 7,
    Matrix = 8,
    MultiLineText = 9,
    InteractionNote = 10,
    Attachment = 11,
    Score = 12,
    Checkbox = 13,
    InteractionSummary = 14,
    Name = 20,
    Language = 21,
    Email = 22,
    MailingAddress = 23,
    PhoneInformation = 24,
    Height = 25,
    Weight = 26,
    Gender = 27,
    DateOfBirth = 28,
    ContactConsent = 29,
    Physician = 30,
    Guardian = 31,
    EnrollmentDate = 32,
    PatientStatus = 33,
    Frequency = 34,
    DropDown = 35,
    Avatar = 36,
    Initials = 37,
    CareMember = 38,
    Signature = 39,
    ActigraphMinuteData = 40,
    EMA = 41,
    AdverseEffectEvent = 42,
    ConcomitantMedicationDetails = 43,
    PhysicianListPhysician = 44,
    SelectDocument = 45,
    SelectAttachment = 46,
    Hidden = 47,
    PatientEmail = 48,
    PatientPhone = 49,
    CBSScore = 50,
    CBSReactionTime = 51,
    ThirdPartyReference = 52,
    MedicalHistoryDetails = 53,
    NovoNordiskToolsAndConsent = 54,
    ConcomitantMedicationDetailsShort = 55,
    BodyMassIndex = 56,
    AdverseEventCCGlow = 57,
    AdverseEventLink = 58,
    Pharmacy = 1001,
    ObesityModules = 1002,
    LabWork = 1003,
    Medications = 1004,
    Prescriptions = 1005,
    AomReview = 1006,
    AomReviewMedication = 1007,
}

export enum QuestionVisibility {
    Always = 0,
    ResearchTeamOnly = 1,
    Never = 2,
}

export class RuleObject implements IRuleObject {
    timepoints?: number[] | undefined;
    dependencies?: RuleDependency[] | undefined;

    constructor(data?: IRuleObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Timepoints"])) {
                this.timepoints = [] as any;
                for (let item of _data["Timepoints"])
                    this.timepoints!.push(item);
            }
            if (Array.isArray(_data["Dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["Dependencies"])
                    this.dependencies!.push(RuleDependency.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleObject {
        data = typeof data === 'object' ? data : {};
        let result = new RuleObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timepoints)) {
            data["Timepoints"] = [];
            for (let item of this.timepoints)
                data["Timepoints"].push(item);
        }
        if (Array.isArray(this.dependencies)) {
            data["Dependencies"] = [];
            for (let item of this.dependencies)
                data["Dependencies"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRuleObject {
    timepoints?: number[] | undefined;
    dependencies?: RuleDependency[] | undefined;
}

export class RuleDependency implements IRuleDependency {
    dependentOn?: number | undefined;
    dependentOperator?: number | undefined;
    dependentValue?: string | undefined;

    constructor(data?: IRuleDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dependentOn = _data["DependentOn"];
            this.dependentOperator = _data["DependentOperator"];
            this.dependentValue = _data["DependentValue"];
        }
    }

    static fromJS(data: any): RuleDependency {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDependency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DependentOn"] = this.dependentOn;
        data["DependentOperator"] = this.dependentOperator;
        data["DependentValue"] = this.dependentValue;
        return data;
    }
}

export interface IRuleDependency {
    dependentOn?: number | undefined;
    dependentOperator?: number | undefined;
    dependentValue?: string | undefined;
}

export enum DefaultValueType {
    None = 0,
    CurrentDate = 1,
    DateOfBirth = 2,
    EnrollmentDate = 3,
    StudyID = 4,
    HubRelationship = 5,
    HubAccountEmail = 6,
    Gender = 7,
    Name = 8,
    ParticipantEmail = 9,
    PhysicianFax = 10,
    AdverseEventFax = 11,
}

export enum CompareOperator {
    None = 0,
    Blank = 1,
    NotBlank = 2,
    StartsWith = 3,
    EndsWith = 4,
    Contains = 5,
    Equals = 6,
    GreaterThan = 7,
    LessThan = 8,
    NotContain = 9,
    NotEqual = 10,
}

export class PatientInteraction implements IPatientInteraction {
    patientInteractionID!: number;
    supercededByID?: number | undefined;
    isSuperceded!: boolean;
    isEditable!: boolean;
    interactionDate!: Date;
    patientID!: string;
    interactionID!: number;
    createdOn!: Date;
    createdBy!: string;
    modifiedOn!: Date;
    modifiedBy!: string;
    notes!: string;
    name!: string;
    tabName?: string | undefined;
    timepointID?: number | undefined;
    interactionType!: InteractionType;
    interactionName?: string | undefined;
    timepointLabel?: string | undefined;
    iPAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    groups?: AnswerGroup[] | undefined;
    comments?: string | undefined;
    dataFlag!: boolean;

    constructor(data?: IPatientInteraction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientInteractionID = _data["PatientInteractionID"];
            this.supercededByID = _data["SupercededByID"];
            this.isSuperceded = _data["IsSuperceded"];
            this.isEditable = _data["IsEditable"];
            this.interactionDate = _data["InteractionDate"] ? new Date(_data["InteractionDate"].toString()) : <any>undefined;
            this.patientID = _data["PatientID"];
            this.interactionID = _data["InteractionID"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.notes = _data["Notes"];
            this.name = _data["Name"];
            this.tabName = _data["TabName"];
            this.timepointID = _data["TimepointID"];
            this.interactionType = _data["InteractionType"];
            this.interactionName = _data["InteractionName"];
            this.timepointLabel = _data["TimepointLabel"];
            this.iPAddress = _data["IPAddress"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(AnswerGroup.fromJS(item));
            }
            this.comments = _data["Comments"];
            this.dataFlag = _data["DataFlag"];
        }
    }

    static fromJS(data: any): PatientInteraction {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInteraction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientInteractionID"] = this.patientInteractionID;
        data["SupercededByID"] = this.supercededByID;
        data["IsSuperceded"] = this.isSuperceded;
        data["IsEditable"] = this.isEditable;
        data["InteractionDate"] = this.interactionDate ? this.interactionDate.toISOString() : <any>undefined;
        data["PatientID"] = this.patientID;
        data["InteractionID"] = this.interactionID;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["Notes"] = this.notes;
        data["Name"] = this.name;
        data["TabName"] = this.tabName;
        data["TimepointID"] = this.timepointID;
        data["InteractionType"] = this.interactionType;
        data["InteractionName"] = this.interactionName;
        data["TimepointLabel"] = this.timepointLabel;
        data["IPAddress"] = this.iPAddress;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Comments"] = this.comments;
        data["DataFlag"] = this.dataFlag;
        return data;
    }
}

export interface IPatientInteraction {
    patientInteractionID: number;
    supercededByID?: number | undefined;
    isSuperceded: boolean;
    isEditable: boolean;
    interactionDate: Date;
    patientID: string;
    interactionID: number;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date;
    modifiedBy: string;
    notes: string;
    name: string;
    tabName?: string | undefined;
    timepointID?: number | undefined;
    interactionType: InteractionType;
    interactionName?: string | undefined;
    timepointLabel?: string | undefined;
    iPAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    groups?: AnswerGroup[] | undefined;
    comments?: string | undefined;
    dataFlag: boolean;
}

export class AnswerGroup implements IAnswerGroup {
    questionID!: number;
    label?: string | undefined;
    isRepeatable!: boolean;
    questionType!: QuestionType;
    subGroups?: AnswerSubGroup[] | undefined;

    constructor(data?: IAnswerGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionID = _data["QuestionID"];
            this.label = _data["Label"];
            this.isRepeatable = _data["IsRepeatable"];
            this.questionType = _data["QuestionType"];
            if (Array.isArray(_data["SubGroups"])) {
                this.subGroups = [] as any;
                for (let item of _data["SubGroups"])
                    this.subGroups!.push(AnswerSubGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswerGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionID"] = this.questionID;
        data["Label"] = this.label;
        data["IsRepeatable"] = this.isRepeatable;
        data["QuestionType"] = this.questionType;
        if (Array.isArray(this.subGroups)) {
            data["SubGroups"] = [];
            for (let item of this.subGroups)
                data["SubGroups"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAnswerGroup {
    questionID: number;
    label?: string | undefined;
    isRepeatable: boolean;
    questionType: QuestionType;
    subGroups?: AnswerSubGroup[] | undefined;
}

export class AnswerSubGroup implements IAnswerSubGroup {
    label?: string | undefined;
    items?: AnswerItem[] | undefined;

    constructor(data?: IAnswerSubGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["Label"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AnswerItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswerSubGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerSubGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Label"] = this.label;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAnswerSubGroup {
    label?: string | undefined;
    items?: AnswerItem[] | undefined;
}

export class AnswerItem implements IAnswerItem {
    answerID!: number;
    label?: string | undefined;
    value?: string | undefined;
    displayValue?: string | undefined;
    sequence!: number;

    constructor(data?: IAnswerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerID = _data["AnswerID"];
            this.label = _data["Label"];
            this.value = _data["Value"];
            this.displayValue = _data["DisplayValue"];
            this.sequence = _data["Sequence"];
        }
    }

    static fromJS(data: any): AnswerItem {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AnswerID"] = this.answerID;
        data["Label"] = this.label;
        data["Value"] = this.value;
        data["DisplayValue"] = this.displayValue;
        data["Sequence"] = this.sequence;
        return data;
    }
}

export interface IAnswerItem {
    answerID: number;
    label?: string | undefined;
    value?: string | undefined;
    displayValue?: string | undefined;
    sequence: number;
}

export enum ScoreType {
    NotScored = 0,
    Scored = 1,
}

export class ScoringSectionModel implements IScoringSectionModel {
    scoringSectionID!: number;
    uniqueCode?: string | undefined;
    interactionID!: number;
    maxMissing?: number | undefined;
    scoringSectionTranslations?: ScoringSectionTranslationModel[] | undefined;
    missingScoreCalculationType!: MissingScoreCalculation;
    scoreDescriptions?: ScoreDescriptionModel[] | undefined;
    position!: number;
    selectedFieldsArray?: string[] | undefined;

    constructor(data?: IScoringSectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoringSectionID = _data["ScoringSectionID"];
            this.uniqueCode = _data["UniqueCode"];
            this.interactionID = _data["InteractionID"];
            this.maxMissing = _data["MaxMissing"];
            if (Array.isArray(_data["ScoringSectionTranslations"])) {
                this.scoringSectionTranslations = [] as any;
                for (let item of _data["ScoringSectionTranslations"])
                    this.scoringSectionTranslations!.push(ScoringSectionTranslationModel.fromJS(item));
            }
            this.missingScoreCalculationType = _data["MissingScoreCalculationType"];
            if (Array.isArray(_data["ScoreDescriptions"])) {
                this.scoreDescriptions = [] as any;
                for (let item of _data["ScoreDescriptions"])
                    this.scoreDescriptions!.push(ScoreDescriptionModel.fromJS(item));
            }
            this.position = _data["Position"];
            if (Array.isArray(_data["SelectedFieldsArray"])) {
                this.selectedFieldsArray = [] as any;
                for (let item of _data["SelectedFieldsArray"])
                    this.selectedFieldsArray!.push(item);
            }
        }
    }

    static fromJS(data: any): ScoringSectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringSectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScoringSectionID"] = this.scoringSectionID;
        data["UniqueCode"] = this.uniqueCode;
        data["InteractionID"] = this.interactionID;
        data["MaxMissing"] = this.maxMissing;
        if (Array.isArray(this.scoringSectionTranslations)) {
            data["ScoringSectionTranslations"] = [];
            for (let item of this.scoringSectionTranslations)
                data["ScoringSectionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["MissingScoreCalculationType"] = this.missingScoreCalculationType;
        if (Array.isArray(this.scoreDescriptions)) {
            data["ScoreDescriptions"] = [];
            for (let item of this.scoreDescriptions)
                data["ScoreDescriptions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Position"] = this.position;
        if (Array.isArray(this.selectedFieldsArray)) {
            data["SelectedFieldsArray"] = [];
            for (let item of this.selectedFieldsArray)
                data["SelectedFieldsArray"].push(item);
        }
        return data;
    }
}

export interface IScoringSectionModel {
    scoringSectionID: number;
    uniqueCode?: string | undefined;
    interactionID: number;
    maxMissing?: number | undefined;
    scoringSectionTranslations?: ScoringSectionTranslationModel[] | undefined;
    missingScoreCalculationType: MissingScoreCalculation;
    scoreDescriptions?: ScoreDescriptionModel[] | undefined;
    position: number;
    selectedFieldsArray?: string[] | undefined;
}

export class ScoringSectionTranslationModel implements IScoringSectionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    label?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IScoringSectionTranslationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.language = _data["Language"];
            this.label = _data["Label"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): ScoringSectionTranslationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringSectionTranslationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Language"] = this.language;
        data["Label"] = this.label;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IScoringSectionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    label?: string | undefined;
    isDefault: boolean;
}

export enum MissingScoreCalculation {
    Ignore = 0,
    SectionAverage = 1,
    TotalScoreAverage = 2,
    OptionGroupAverage = 3,
}

export class ScoreDescriptionModel implements IScoreDescriptionModel {
    scoreDescriptionID!: number;
    minScore!: number;
    maxScore!: number;
    scoreDescriptionTranslations?: ScoreDescriptionTranslationModel[] | undefined;

    constructor(data?: IScoreDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreDescriptionID = _data["ScoreDescriptionID"];
            this.minScore = _data["MinScore"];
            this.maxScore = _data["MaxScore"];
            if (Array.isArray(_data["ScoreDescriptionTranslations"])) {
                this.scoreDescriptionTranslations = [] as any;
                for (let item of _data["ScoreDescriptionTranslations"])
                    this.scoreDescriptionTranslations!.push(ScoreDescriptionTranslationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScoreDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScoreDescriptionID"] = this.scoreDescriptionID;
        data["MinScore"] = this.minScore;
        data["MaxScore"] = this.maxScore;
        if (Array.isArray(this.scoreDescriptionTranslations)) {
            data["ScoreDescriptionTranslations"] = [];
            for (let item of this.scoreDescriptionTranslations)
                data["ScoreDescriptionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IScoreDescriptionModel {
    scoreDescriptionID: number;
    minScore: number;
    maxScore: number;
    scoreDescriptionTranslations?: ScoreDescriptionTranslationModel[] | undefined;
}

export class ScoreDescriptionTranslationModel implements IScoreDescriptionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    description?: string | undefined;
    isDefault!: boolean;
    selected!: boolean;

    constructor(data?: IScoreDescriptionTranslationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.language = _data["Language"];
            this.description = _data["Description"];
            this.isDefault = _data["IsDefault"];
            this.selected = _data["Selected"];
        }
    }

    static fromJS(data: any): ScoreDescriptionTranslationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDescriptionTranslationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Language"] = this.language;
        data["Description"] = this.description;
        data["IsDefault"] = this.isDefault;
        data["Selected"] = this.selected;
        return data;
    }
}

export interface IScoreDescriptionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
    selected: boolean;
}

export enum InteractionNoteType {
    Optional = 1,
    Required = 2,
    Hidden = 3,
    HiddenForPatients = 4,
}

export class NewInteractionTimepointModel implements INewInteractionTimepointModel {
    label?: string | undefined;
    timepointID!: number;

    constructor(data?: INewInteractionTimepointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["Label"];
            this.timepointID = _data["TimepointID"];
        }
    }

    static fromJS(data: any): NewInteractionTimepointModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewInteractionTimepointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Label"] = this.label;
        data["TimepointID"] = this.timepointID;
        return data;
    }
}

export interface INewInteractionTimepointModel {
    label?: string | undefined;
    timepointID: number;
}

export class Graph implements IGraph {
    graphID!: number;
    interactionID!: number;
    graphType!: PatientGraphType;
    scoreBased!: boolean;

    constructor(data?: IGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graphID = _data["GraphID"];
            this.interactionID = _data["InteractionID"];
            this.graphType = _data["GraphType"];
            this.scoreBased = _data["ScoreBased"];
        }
    }

    static fromJS(data: any): Graph {
        data = typeof data === 'object' ? data : {};
        let result = new Graph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GraphID"] = this.graphID;
        data["InteractionID"] = this.interactionID;
        data["GraphType"] = this.graphType;
        data["ScoreBased"] = this.scoreBased;
        return data;
    }
}

export interface IGraph {
    graphID: number;
    interactionID: number;
    graphType: PatientGraphType;
    scoreBased: boolean;
}

export class TriggerModel implements ITriggerModel {
    triggerId!: number;
    interactionId!: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    type!: TriggerType;
    schedule!: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isFax!: boolean;
    allowForEdited!: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments!: boolean;
    isActive!: boolean;
    createdBy?: string | undefined;
    createdOn!: Date;
    modifiedBy?: string | undefined;
    modifiedOn!: Date;
    scheduledInteractionName?: string | undefined;
    templateName?: string | undefined;
    scheduleTime?: string | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    emailRecipient?: string | undefined;

    constructor(data?: ITriggerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggerId = _data["TriggerId"];
            this.interactionId = _data["InteractionId"];
            this.scheduledInteractionId = _data["ScheduledInteractionId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.type = _data["Type"];
            this.schedule = _data["Schedule"];
            this.scheduleLength = _data["ScheduleLength"];
            this.scheduleRange = _data["ScheduleRange"];
            this.scheduleOnDate = _data["ScheduleOnDate"] ? new Date(_data["ScheduleOnDate"].toString()) : <any>undefined;
            this.isFax = _data["IsFax"];
            this.allowForEdited = _data["AllowForEdited"];
            this.attachmentStatus = _data["AttachmentStatus"];
            this.categoryID = _data["CategoryID"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
            this.isActive = _data["IsActive"];
            this.createdBy = _data["CreatedBy"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.scheduledInteractionName = _data["ScheduledInteractionName"];
            this.templateName = _data["TemplateName"];
            this.scheduleTime = _data["ScheduleTime"];
            this.emailRecipientType = _data["EmailRecipientType"];
            this.emailRecipientTypeName = _data["EmailRecipientTypeName"];
            this.emailRecipient = _data["EmailRecipient"];
        }
    }

    static fromJS(data: any): TriggerModel {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TriggerId"] = this.triggerId;
        data["InteractionId"] = this.interactionId;
        data["ScheduledInteractionId"] = this.scheduledInteractionId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["Type"] = this.type;
        data["Schedule"] = this.schedule;
        data["ScheduleLength"] = this.scheduleLength;
        data["ScheduleRange"] = this.scheduleRange;
        data["ScheduleOnDate"] = this.scheduleOnDate ? this.scheduleOnDate.toISOString() : <any>undefined;
        data["IsFax"] = this.isFax;
        data["AllowForEdited"] = this.allowForEdited;
        data["AttachmentStatus"] = this.attachmentStatus;
        data["CategoryID"] = this.categoryID;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        data["IsActive"] = this.isActive;
        data["CreatedBy"] = this.createdBy;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ScheduledInteractionName"] = this.scheduledInteractionName;
        data["TemplateName"] = this.templateName;
        data["ScheduleTime"] = this.scheduleTime;
        data["EmailRecipientType"] = this.emailRecipientType;
        data["EmailRecipientTypeName"] = this.emailRecipientTypeName;
        data["EmailRecipient"] = this.emailRecipient;
        return data;
    }
}

export interface ITriggerModel {
    triggerId: number;
    interactionId: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    type: TriggerType;
    schedule: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isFax: boolean;
    allowForEdited: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments: boolean;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn: Date;
    modifiedBy?: string | undefined;
    modifiedOn: Date;
    scheduledInteractionName?: string | undefined;
    templateName?: string | undefined;
    scheduleTime?: string | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    emailRecipient?: string | undefined;
}

export enum TriggerType {
    Email = 0,
    Report = 1,
    Schedule = 2,
    Custom = 3,
    ScheduleFollowup = 4,
    CancelFollowup = 5,
    SaxendaUpdatePatientStatus = 6,
    PatientRegister = 7,
    PatientDiscontinue = 8,
}

export enum TriggerSchedule {
    Immediately = 0,
    FromInteractionDate = 1,
    FromEnrollmentDate = 2,
    SpecificDate = 3,
}

export enum TriggerScheduleRange {
    Hours = 0,
    Days = 1,
    Weeks = 2,
    Months = 3,
}

export enum AttachmentStatus {
    All = 0,
    LumediOnly = 1,
    HubOnly = 2,
}

export class InteractionTranslationModel implements IInteractionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IInteractionTranslationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.language = _data["Language"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): InteractionTranslationModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionTranslationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Language"] = this.language;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IInteractionTranslationModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
}

export class InteractionSummaryModel implements IInteractionSummaryModel {
    interactionID!: number;
    interactionType!: InteractionType;
    name!: string;
    siteName?: string | undefined;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    instances!: number;
    questionCount!: number;
    rescore!: boolean;
    canEdit!: boolean;
    canExport!: boolean;
    isActive!: boolean;
    ages?: string | undefined;

    constructor(data?: IInteractionSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.interactionType = _data["InteractionType"];
            this.name = _data["Name"];
            this.siteName = _data["SiteName"];
            this.minAge = _data["MinAge"];
            this.maxAge = _data["MaxAge"];
            this.instances = _data["Instances"];
            this.questionCount = _data["QuestionCount"];
            this.rescore = _data["Rescore"];
            this.canEdit = _data["CanEdit"];
            this.canExport = _data["CanExport"];
            this.isActive = _data["IsActive"];
            this.ages = _data["Ages"];
        }
    }

    static fromJS(data: any): InteractionSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["InteractionType"] = this.interactionType;
        data["Name"] = this.name;
        data["SiteName"] = this.siteName;
        data["MinAge"] = this.minAge;
        data["MaxAge"] = this.maxAge;
        data["Instances"] = this.instances;
        data["QuestionCount"] = this.questionCount;
        data["Rescore"] = this.rescore;
        data["CanEdit"] = this.canEdit;
        data["CanExport"] = this.canExport;
        data["IsActive"] = this.isActive;
        data["Ages"] = this.ages;
        return data;
    }
}

export interface IInteractionSummaryModel {
    interactionID: number;
    interactionType: InteractionType;
    name: string;
    siteName?: string | undefined;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    instances: number;
    questionCount: number;
    rescore: boolean;
    canEdit: boolean;
    canExport: boolean;
    isActive: boolean;
    ages?: string | undefined;
}

export class InteractionExportModel implements IInteractionExportModel {
    interactionID!: number;
    name?: string | undefined;
    interactionType!: InteractionType;
    isActive!: boolean;
    variablePrefix?: string | undefined;
    questions?: QuestionSummary[] | undefined;
    scoringSections?: ScoringSummaryModel[] | undefined;

    constructor(data?: IInteractionExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
            this.interactionType = _data["InteractionType"];
            this.isActive = _data["IsActive"];
            this.variablePrefix = _data["VariablePrefix"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(QuestionSummary.fromJS(item));
            }
            if (Array.isArray(_data["ScoringSections"])) {
                this.scoringSections = [] as any;
                for (let item of _data["ScoringSections"])
                    this.scoringSections!.push(ScoringSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        data["InteractionType"] = this.interactionType;
        data["IsActive"] = this.isActive;
        data["VariablePrefix"] = this.variablePrefix;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.scoringSections)) {
            data["ScoringSections"] = [];
            for (let item of this.scoringSections)
                data["ScoringSections"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionExportModel {
    interactionID: number;
    name?: string | undefined;
    interactionType: InteractionType;
    isActive: boolean;
    variablePrefix?: string | undefined;
    questions?: QuestionSummary[] | undefined;
    scoringSections?: ScoringSummaryModel[] | undefined;
}

export class QuestionSummary implements IQuestionSummary {
    questionID!: number;
    questionType!: QuestionType;
    isIdentifying!: boolean;
    isInstruction!: boolean;
    label?: string | undefined;
    uniqueCode?: string | undefined;
    subCodes?: string[] | undefined;

    constructor(data?: IQuestionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionID = _data["QuestionID"];
            this.questionType = _data["QuestionType"];
            this.isIdentifying = _data["IsIdentifying"];
            this.isInstruction = _data["IsInstruction"];
            this.label = _data["Label"];
            this.uniqueCode = _data["UniqueCode"];
            if (Array.isArray(_data["SubCodes"])) {
                this.subCodes = [] as any;
                for (let item of _data["SubCodes"])
                    this.subCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionID"] = this.questionID;
        data["QuestionType"] = this.questionType;
        data["IsIdentifying"] = this.isIdentifying;
        data["IsInstruction"] = this.isInstruction;
        data["Label"] = this.label;
        data["UniqueCode"] = this.uniqueCode;
        if (Array.isArray(this.subCodes)) {
            data["SubCodes"] = [];
            for (let item of this.subCodes)
                data["SubCodes"].push(item);
        }
        return data;
    }
}

export interface IQuestionSummary {
    questionID: number;
    questionType: QuestionType;
    isIdentifying: boolean;
    isInstruction: boolean;
    label?: string | undefined;
    uniqueCode?: string | undefined;
    subCodes?: string[] | undefined;
}

export class ScoringSummaryModel implements IScoringSummaryModel {
    scoringSectionID!: number;
    label?: string | undefined;
    uniqueCode?: string | undefined;

    constructor(data?: IScoringSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoringSectionID = _data["ScoringSectionID"];
            this.label = _data["Label"];
            this.uniqueCode = _data["UniqueCode"];
        }
    }

    static fromJS(data: any): ScoringSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScoringSectionID"] = this.scoringSectionID;
        data["Label"] = this.label;
        data["UniqueCode"] = this.uniqueCode;
        return data;
    }
}

export interface IScoringSummaryModel {
    scoringSectionID: number;
    label?: string | undefined;
    uniqueCode?: string | undefined;
}

export class LumediMWMInteractionIds implements ILumediMWMInteractionIds {
    paymentLinkOnGoingSupportInteractionId!: number;
    paymentLinkInteractionId!: number;
    labWorkInteractionId!: number;
    medicationsInteractionId!: number;
    prescriptionInteractionId!: number;
    publicRegistrationInteractionId!: number;
    publicRegistrationAssessmentInteractionId!: number;
    publicEnrollmentPart1InteractionId!: number;
    registrationInteractionId!: number;
    weightHistoryInteractionId!: number;
    medicalHistoryInteractionId!: number;
    appointmentScheduledInteractionId!: number;
    appointmentCancelledInteractionId!: number;
    programOverviewMdInteractionId!: number;
    programOverviewAdminInteractionId!: number;

    constructor(data?: ILumediMWMInteractionIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLinkOnGoingSupportInteractionId = _data["PaymentLinkOnGoingSupportInteractionId"];
            this.paymentLinkInteractionId = _data["PaymentLinkInteractionId"];
            this.labWorkInteractionId = _data["LabWorkInteractionId"];
            this.medicationsInteractionId = _data["MedicationsInteractionId"];
            this.prescriptionInteractionId = _data["PrescriptionInteractionId"];
            this.publicRegistrationInteractionId = _data["PublicRegistrationInteractionId"];
            this.publicRegistrationAssessmentInteractionId = _data["PublicRegistrationAssessmentInteractionId"];
            this.publicEnrollmentPart1InteractionId = _data["PublicEnrollmentPart1InteractionId"];
            this.registrationInteractionId = _data["RegistrationInteractionId"];
            this.weightHistoryInteractionId = _data["WeightHistoryInteractionId"];
            this.medicalHistoryInteractionId = _data["MedicalHistoryInteractionId"];
            this.appointmentScheduledInteractionId = _data["AppointmentScheduledInteractionId"];
            this.appointmentCancelledInteractionId = _data["AppointmentCancelledInteractionId"];
            this.programOverviewMdInteractionId = _data["ProgramOverviewMdInteractionId"];
            this.programOverviewAdminInteractionId = _data["ProgramOverviewAdminInteractionId"];
        }
    }

    static fromJS(data: any): LumediMWMInteractionIds {
        data = typeof data === 'object' ? data : {};
        let result = new LumediMWMInteractionIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaymentLinkOnGoingSupportInteractionId"] = this.paymentLinkOnGoingSupportInteractionId;
        data["PaymentLinkInteractionId"] = this.paymentLinkInteractionId;
        data["LabWorkInteractionId"] = this.labWorkInteractionId;
        data["MedicationsInteractionId"] = this.medicationsInteractionId;
        data["PrescriptionInteractionId"] = this.prescriptionInteractionId;
        data["PublicRegistrationInteractionId"] = this.publicRegistrationInteractionId;
        data["PublicRegistrationAssessmentInteractionId"] = this.publicRegistrationAssessmentInteractionId;
        data["PublicEnrollmentPart1InteractionId"] = this.publicEnrollmentPart1InteractionId;
        data["RegistrationInteractionId"] = this.registrationInteractionId;
        data["WeightHistoryInteractionId"] = this.weightHistoryInteractionId;
        data["MedicalHistoryInteractionId"] = this.medicalHistoryInteractionId;
        data["AppointmentScheduledInteractionId"] = this.appointmentScheduledInteractionId;
        data["AppointmentCancelledInteractionId"] = this.appointmentCancelledInteractionId;
        data["ProgramOverviewMdInteractionId"] = this.programOverviewMdInteractionId;
        data["ProgramOverviewAdminInteractionId"] = this.programOverviewAdminInteractionId;
        return data;
    }
}

export interface ILumediMWMInteractionIds {
    paymentLinkOnGoingSupportInteractionId: number;
    paymentLinkInteractionId: number;
    labWorkInteractionId: number;
    medicationsInteractionId: number;
    prescriptionInteractionId: number;
    publicRegistrationInteractionId: number;
    publicRegistrationAssessmentInteractionId: number;
    publicEnrollmentPart1InteractionId: number;
    registrationInteractionId: number;
    weightHistoryInteractionId: number;
    medicalHistoryInteractionId: number;
    appointmentScheduledInteractionId: number;
    appointmentCancelledInteractionId: number;
    programOverviewMdInteractionId: number;
    programOverviewAdminInteractionId: number;
}

export class InteractionJsonExportModel implements IInteractionJsonExportModel {
    /** The json of the exported interaction. */
    json?: string | undefined;

    constructor(data?: IInteractionJsonExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.json = _data["Json"];
        }
    }

    static fromJS(data: any): InteractionJsonExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionJsonExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Json"] = this.json;
        return data;
    }
}

export interface IInteractionJsonExportModel {
    /** The json of the exported interaction. */
    json?: string | undefined;
}

export class InteractionJsonImportModel implements IInteractionJsonImportModel {
    studyId!: string;
    siteId!: string;
    /** The json of the interaction to import. */
    json?: string | undefined;
    variablePrefix?: string | undefined;

    constructor(data?: IInteractionJsonImportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.siteId = _data["SiteId"];
            this.json = _data["Json"];
            this.variablePrefix = _data["VariablePrefix"];
        }
    }

    static fromJS(data: any): InteractionJsonImportModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionJsonImportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["SiteId"] = this.siteId;
        data["Json"] = this.json;
        data["VariablePrefix"] = this.variablePrefix;
        return data;
    }
}

export interface IInteractionJsonImportModel {
    studyId: string;
    siteId: string;
    /** The json of the interaction to import. */
    json?: string | undefined;
    variablePrefix?: string | undefined;
}

export class InteractionUpdatePreview implements IInteractionUpdatePreview {
    interactionName?: string | undefined;
    variablePrefix?: string | undefined;
    questionChanges?: QuestionChange[] | undefined;
    interactionPropertyChanges?: PropertyChange[] | undefined;

    constructor(data?: IInteractionUpdatePreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionName = _data["InteractionName"];
            this.variablePrefix = _data["VariablePrefix"];
            if (Array.isArray(_data["QuestionChanges"])) {
                this.questionChanges = [] as any;
                for (let item of _data["QuestionChanges"])
                    this.questionChanges!.push(QuestionChange.fromJS(item));
            }
            if (Array.isArray(_data["InteractionPropertyChanges"])) {
                this.interactionPropertyChanges = [] as any;
                for (let item of _data["InteractionPropertyChanges"])
                    this.interactionPropertyChanges!.push(PropertyChange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionUpdatePreview {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionUpdatePreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionName"] = this.interactionName;
        data["VariablePrefix"] = this.variablePrefix;
        if (Array.isArray(this.questionChanges)) {
            data["QuestionChanges"] = [];
            for (let item of this.questionChanges)
                data["QuestionChanges"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.interactionPropertyChanges)) {
            data["InteractionPropertyChanges"] = [];
            for (let item of this.interactionPropertyChanges)
                data["InteractionPropertyChanges"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionUpdatePreview {
    interactionName?: string | undefined;
    variablePrefix?: string | undefined;
    questionChanges?: QuestionChange[] | undefined;
    interactionPropertyChanges?: PropertyChange[] | undefined;
}

export class QuestionChange implements IQuestionChange {
    type!: ChangeType;
    existingQuestionId?: number | undefined;
    uniqueCode?: string | undefined;
    label?: string | undefined;
    position!: number;
    propertyChanges?: PropertyChange[] | undefined;

    constructor(data?: IQuestionChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.existingQuestionId = _data["ExistingQuestionId"];
            this.uniqueCode = _data["UniqueCode"];
            this.label = _data["Label"];
            this.position = _data["Position"];
            if (Array.isArray(_data["PropertyChanges"])) {
                this.propertyChanges = [] as any;
                for (let item of _data["PropertyChanges"])
                    this.propertyChanges!.push(PropertyChange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionChange {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["ExistingQuestionId"] = this.existingQuestionId;
        data["UniqueCode"] = this.uniqueCode;
        data["Label"] = this.label;
        data["Position"] = this.position;
        if (Array.isArray(this.propertyChanges)) {
            data["PropertyChanges"] = [];
            for (let item of this.propertyChanges)
                data["PropertyChanges"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQuestionChange {
    type: ChangeType;
    existingQuestionId?: number | undefined;
    uniqueCode?: string | undefined;
    label?: string | undefined;
    position: number;
    propertyChanges?: PropertyChange[] | undefined;
}

export enum ChangeType {
    Add = 0,
    Update = 1,
    Delete = 2,
}

export class PropertyChange implements IPropertyChange {
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPropertyChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["PropertyName"];
            this.oldValue = _data["OldValue"];
            this.newValue = _data["NewValue"];
        }
    }

    static fromJS(data: any): PropertyChange {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PropertyName"] = this.propertyName;
        data["OldValue"] = this.oldValue;
        data["NewValue"] = this.newValue;
        return data;
    }
}

export interface IPropertyChange {
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class InvestigationModel implements IInvestigationModel {
    investigationID!: string;
    createdOn!: Date;
    createdBy?: string | undefined;
    createdByID!: string;
    resolvedByID?: string | undefined;
    resolvedBy?: string | undefined;
    verifiedByID?: string | undefined;
    verifiedBy?: string | undefined;
    initialTaskID?: string | undefined;
    resolveTaskID?: string | undefined;
    verifyTaskID?: string | undefined;
    patientID!: string;
    patientName?: string | undefined;
    patientStudyID?: string | undefined;
    investigationStatus!: InvestigationStatus;
    title?: string | undefined;
    description?: string | undefined;
    statusDescription?: string | undefined;
    initialTask?: TaskModel | undefined;
    resolveTask?: TaskModel | undefined;
    verifyTask?: TaskModel | undefined;

    constructor(data?: IInvestigationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investigationID = _data["InvestigationID"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.createdByID = _data["CreatedByID"];
            this.resolvedByID = _data["ResolvedByID"];
            this.resolvedBy = _data["ResolvedBy"];
            this.verifiedByID = _data["VerifiedByID"];
            this.verifiedBy = _data["VerifiedBy"];
            this.initialTaskID = _data["InitialTaskID"];
            this.resolveTaskID = _data["ResolveTaskID"];
            this.verifyTaskID = _data["VerifyTaskID"];
            this.patientID = _data["PatientID"];
            this.patientName = _data["PatientName"];
            this.patientStudyID = _data["PatientStudyID"];
            this.investigationStatus = _data["InvestigationStatus"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.statusDescription = _data["StatusDescription"];
            this.initialTask = _data["InitialTask"] ? TaskModel.fromJS(_data["InitialTask"]) : <any>undefined;
            this.resolveTask = _data["ResolveTask"] ? TaskModel.fromJS(_data["ResolveTask"]) : <any>undefined;
            this.verifyTask = _data["VerifyTask"] ? TaskModel.fromJS(_data["VerifyTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestigationModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestigationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvestigationID"] = this.investigationID;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["CreatedByID"] = this.createdByID;
        data["ResolvedByID"] = this.resolvedByID;
        data["ResolvedBy"] = this.resolvedBy;
        data["VerifiedByID"] = this.verifiedByID;
        data["VerifiedBy"] = this.verifiedBy;
        data["InitialTaskID"] = this.initialTaskID;
        data["ResolveTaskID"] = this.resolveTaskID;
        data["VerifyTaskID"] = this.verifyTaskID;
        data["PatientID"] = this.patientID;
        data["PatientName"] = this.patientName;
        data["PatientStudyID"] = this.patientStudyID;
        data["InvestigationStatus"] = this.investigationStatus;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["StatusDescription"] = this.statusDescription;
        data["InitialTask"] = this.initialTask ? this.initialTask.toJSON() : <any>undefined;
        data["ResolveTask"] = this.resolveTask ? this.resolveTask.toJSON() : <any>undefined;
        data["VerifyTask"] = this.verifyTask ? this.verifyTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestigationModel {
    investigationID: string;
    createdOn: Date;
    createdBy?: string | undefined;
    createdByID: string;
    resolvedByID?: string | undefined;
    resolvedBy?: string | undefined;
    verifiedByID?: string | undefined;
    verifiedBy?: string | undefined;
    initialTaskID?: string | undefined;
    resolveTaskID?: string | undefined;
    verifyTaskID?: string | undefined;
    patientID: string;
    patientName?: string | undefined;
    patientStudyID?: string | undefined;
    investigationStatus: InvestigationStatus;
    title?: string | undefined;
    description?: string | undefined;
    statusDescription?: string | undefined;
    initialTask?: TaskModel | undefined;
    resolveTask?: TaskModel | undefined;
    verifyTask?: TaskModel | undefined;
}

export enum InvestigationStatus {
    Any = 0,
    Pending = 1,
    Resolved = 2,
    Verified = 3,
    Cancelled = -1,
}

export class TaskModel implements ITaskModel {
    patientStudyID?: string | undefined;
    isFuture!: boolean;
    canComplete!: boolean;
    taskID?: string | undefined;
    patientID!: string;
    patientName?: string | undefined;
    taskType!: TaskType;
    taskTypeDescription?: string | undefined;
    status!: TaskStatus;
    statusDescription?: string | undefined;
    interactionID?: number | undefined;
    interactionType?: InteractionType | undefined;
    timepointID?: number | undefined;
    timepointLabel?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    domain?: string | undefined;
    description?: string | undefined;
    scheduledOnDate!: string;
    scheduledOnTime?: string | undefined;
    scheduledOnTimeDisplay?: string | undefined;
    durationInMinutes?: number | undefined;
    durationInMinutesDisplay?: string | undefined;
    expiresOn?: string | undefined;
    assignedAccountID?: string | undefined;
    assignedAccountName?: string | undefined;
    assignedAccountEmail?: string | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    completedOn?: Date | undefined;
    completedBy?: string | undefined;
    patientInteractionID?: number | undefined;
    hubPatientConsentID?: string | undefined;
    investigationID?: string | undefined;
    attempts?: TaskAttempt[] | undefined;
    attemptCount!: number;
    lastAttempt?: Date | undefined;

    constructor(data?: ITaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientStudyID = _data["PatientStudyID"];
            this.isFuture = _data["IsFuture"];
            this.canComplete = _data["CanComplete"];
            this.taskID = _data["TaskID"];
            this.patientID = _data["PatientID"];
            this.patientName = _data["PatientName"];
            this.taskType = _data["TaskType"];
            this.taskTypeDescription = _data["TaskTypeDescription"];
            this.status = _data["Status"];
            this.statusDescription = _data["StatusDescription"];
            this.interactionID = _data["InteractionID"];
            this.interactionType = _data["InteractionType"];
            this.timepointID = _data["TimepointID"];
            this.timepointLabel = _data["TimepointLabel"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.domain = _data["Domain"];
            this.description = _data["Description"];
            this.scheduledOnDate = _data["ScheduledOnDate"];
            this.scheduledOnTime = _data["ScheduledOnTime"];
            this.scheduledOnTimeDisplay = _data["ScheduledOnTimeDisplay"];
            this.durationInMinutes = _data["DurationInMinutes"];
            this.durationInMinutesDisplay = _data["DurationInMinutesDisplay"];
            this.expiresOn = _data["ExpiresOn"];
            this.assignedAccountID = _data["AssignedAccountID"];
            this.assignedAccountName = _data["AssignedAccountName"];
            this.assignedAccountEmail = _data["AssignedAccountEmail"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.completedBy = _data["CompletedBy"];
            this.patientInteractionID = _data["PatientInteractionID"];
            this.hubPatientConsentID = _data["HubPatientConsentID"];
            this.investigationID = _data["InvestigationID"];
            if (Array.isArray(_data["Attempts"])) {
                this.attempts = [] as any;
                for (let item of _data["Attempts"])
                    this.attempts!.push(TaskAttempt.fromJS(item));
            }
            this.attemptCount = _data["AttemptCount"];
            this.lastAttempt = _data["LastAttempt"] ? new Date(_data["LastAttempt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientStudyID"] = this.patientStudyID;
        data["IsFuture"] = this.isFuture;
        data["CanComplete"] = this.canComplete;
        data["TaskID"] = this.taskID;
        data["PatientID"] = this.patientID;
        data["PatientName"] = this.patientName;
        data["TaskType"] = this.taskType;
        data["TaskTypeDescription"] = this.taskTypeDescription;
        data["Status"] = this.status;
        data["StatusDescription"] = this.statusDescription;
        data["InteractionID"] = this.interactionID;
        data["InteractionType"] = this.interactionType;
        data["TimepointID"] = this.timepointID;
        data["TimepointLabel"] = this.timepointLabel;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Domain"] = this.domain;
        data["Description"] = this.description;
        data["ScheduledOnDate"] = this.scheduledOnDate;
        data["ScheduledOnTime"] = this.scheduledOnTime;
        data["ScheduledOnTimeDisplay"] = this.scheduledOnTimeDisplay;
        data["DurationInMinutes"] = this.durationInMinutes;
        data["DurationInMinutesDisplay"] = this.durationInMinutesDisplay;
        data["ExpiresOn"] = this.expiresOn;
        data["AssignedAccountID"] = this.assignedAccountID;
        data["AssignedAccountName"] = this.assignedAccountName;
        data["AssignedAccountEmail"] = this.assignedAccountEmail;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["CompletedBy"] = this.completedBy;
        data["PatientInteractionID"] = this.patientInteractionID;
        data["HubPatientConsentID"] = this.hubPatientConsentID;
        data["InvestigationID"] = this.investigationID;
        if (Array.isArray(this.attempts)) {
            data["Attempts"] = [];
            for (let item of this.attempts)
                data["Attempts"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AttemptCount"] = this.attemptCount;
        data["LastAttempt"] = this.lastAttempt ? this.lastAttempt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITaskModel {
    patientStudyID?: string | undefined;
    isFuture: boolean;
    canComplete: boolean;
    taskID?: string | undefined;
    patientID: string;
    patientName?: string | undefined;
    taskType: TaskType;
    taskTypeDescription?: string | undefined;
    status: TaskStatus;
    statusDescription?: string | undefined;
    interactionID?: number | undefined;
    interactionType?: InteractionType | undefined;
    timepointID?: number | undefined;
    timepointLabel?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    domain?: string | undefined;
    description?: string | undefined;
    scheduledOnDate: string;
    scheduledOnTime?: string | undefined;
    scheduledOnTimeDisplay?: string | undefined;
    durationInMinutes?: number | undefined;
    durationInMinutesDisplay?: string | undefined;
    expiresOn?: string | undefined;
    assignedAccountID?: string | undefined;
    assignedAccountName?: string | undefined;
    assignedAccountEmail?: string | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    completedOn?: Date | undefined;
    completedBy?: string | undefined;
    patientInteractionID?: number | undefined;
    hubPatientConsentID?: string | undefined;
    investigationID?: string | undefined;
    attempts?: TaskAttempt[] | undefined;
    attemptCount: number;
    lastAttempt?: Date | undefined;
}

export enum TaskType {
    Phone = 0,
    Email = 1,
    Questionnaire = 2,
    MailOutPackage = 3,
    Reimbursement = 4,
    Automated = 5,
    QuestionnairePackage = 6,
    InternalSignature = 7,
    HubInteraction = 8,
    EnrollmentPackage = 9,
    ScheduledAccess = 10,
    Investigation = 11,
    ClinicalVisit = 12,
    Any = -1,
}

export enum TaskStatus {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    Failed = 3,
    Any = -1,
}

export class TaskAttempt implements ITaskAttempt {
    attemptedOn!: Date;
    attemptStatus!: TaskStatus;
    attemptStatusDescription?: string | undefined;

    constructor(data?: ITaskAttempt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptedOn = _data["AttemptedOn"] ? new Date(_data["AttemptedOn"].toString()) : <any>undefined;
            this.attemptStatus = _data["AttemptStatus"];
            this.attemptStatusDescription = _data["AttemptStatusDescription"];
        }
    }

    static fromJS(data: any): TaskAttempt {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAttempt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttemptedOn"] = this.attemptedOn ? this.attemptedOn.toISOString() : <any>undefined;
        data["AttemptStatus"] = this.attemptStatus;
        data["AttemptStatusDescription"] = this.attemptStatusDescription;
        return data;
    }
}

export interface ITaskAttempt {
    attemptedOn: Date;
    attemptStatus: TaskStatus;
    attemptStatusDescription?: string | undefined;
}

export class NewInvestigationModel implements INewInvestigationModel {
    patientID!: string;
    title?: string | undefined;
    description?: string | undefined;
    taskDaysUntilDue!: number;

    constructor(data?: INewInvestigationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.title = _data["Title"];
            this.description = _data["Description"];
            this.taskDaysUntilDue = _data["TaskDaysUntilDue"];
        }
    }

    static fromJS(data: any): NewInvestigationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewInvestigationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["Title"] = this.title;
        data["Description"] = this.description;
        data["TaskDaysUntilDue"] = this.taskDaysUntilDue;
        return data;
    }
}

export interface INewInvestigationModel {
    patientID: string;
    title?: string | undefined;
    description?: string | undefined;
    taskDaysUntilDue: number;
}

export class LabWorkSummaryModel implements ILabWorkSummaryModel {
    labDate?: string | undefined;
    results?: { [key: string]: LabWorkSummaryResult; } | undefined;
    patientInteractionId!: number;

    constructor(data?: ILabWorkSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labDate = _data["LabDate"];
            if (_data["Results"]) {
                this.results = {} as any;
                for (let key in _data["Results"]) {
                    if (_data["Results"].hasOwnProperty(key))
                        (<any>this.results)![key] = _data["Results"][key] ? LabWorkSummaryResult.fromJS(_data["Results"][key]) : new LabWorkSummaryResult();
                }
            }
            this.patientInteractionId = _data["PatientInteractionId"];
        }
    }

    static fromJS(data: any): LabWorkSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new LabWorkSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LabDate"] = this.labDate;
        if (this.results) {
            data["Results"] = {};
            for (let key in this.results) {
                if (this.results.hasOwnProperty(key))
                    (<any>data["Results"])[key] = this.results[key] ? this.results[key].toJSON() : <any>undefined;
            }
        }
        data["PatientInteractionId"] = this.patientInteractionId;
        return data;
    }
}

export interface ILabWorkSummaryModel {
    labDate?: string | undefined;
    results?: { [key: string]: LabWorkSummaryResult; } | undefined;
    patientInteractionId: number;
}

export class LabWorkSummaryResult implements ILabWorkSummaryResult {
    result?: string | undefined;
    unit?: string | undefined;
    interpretation?: string | undefined;

    constructor(data?: ILabWorkSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.unit = _data["Unit"];
            this.interpretation = _data["Interpretation"];
        }
    }

    static fromJS(data: any): LabWorkSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new LabWorkSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Unit"] = this.unit;
        data["Interpretation"] = this.interpretation;
        return data;
    }
}

export interface ILabWorkSummaryResult {
    result?: string | undefined;
    unit?: string | undefined;
    interpretation?: string | undefined;
}

export class MedicationListModel implements IMedicationListModel {
    allergies?: string | undefined;
    medications?: MedicationDisplayModel[] | undefined;

    constructor(data?: IMedicationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergies = _data["Allergies"];
            if (Array.isArray(_data["Medications"])) {
                this.medications = [] as any;
                for (let item of _data["Medications"])
                    this.medications!.push(MedicationDisplayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Allergies"] = this.allergies;
        if (Array.isArray(this.medications)) {
            data["Medications"] = [];
            for (let item of this.medications)
                data["Medications"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMedicationListModel {
    allergies?: string | undefined;
    medications?: MedicationDisplayModel[] | undefined;
}

export class MedicationDisplayModel implements IMedicationDisplayModel {
    medicationId?: string | undefined;
    productType?: string | undefined;
    name?: string | undefined;
    startDate?: string | undefined;
    dose!: number;
    units?: string | undefined;
    frequency?: string | undefined;
    route?: string | undefined;
    discontinued!: boolean;
    stopDate?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IMedicationDisplayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationId = _data["MedicationId"];
            this.productType = _data["ProductType"];
            this.name = _data["Name"];
            this.startDate = _data["StartDate"];
            this.dose = _data["Dose"];
            this.units = _data["Units"];
            this.frequency = _data["Frequency"];
            this.route = _data["Route"];
            this.discontinued = _data["Discontinued"];
            this.stopDate = _data["StopDate"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): MedicationDisplayModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDisplayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MedicationId"] = this.medicationId;
        data["ProductType"] = this.productType;
        data["Name"] = this.name;
        data["StartDate"] = this.startDate;
        data["Dose"] = this.dose;
        data["Units"] = this.units;
        data["Frequency"] = this.frequency;
        data["Route"] = this.route;
        data["Discontinued"] = this.discontinued;
        data["StopDate"] = this.stopDate;
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IMedicationDisplayModel {
    medicationId?: string | undefined;
    productType?: string | undefined;
    name?: string | undefined;
    startDate?: string | undefined;
    dose: number;
    units?: string | undefined;
    frequency?: string | undefined;
    route?: string | undefined;
    discontinued: boolean;
    stopDate?: string | undefined;
    notes?: string | undefined;
}

export class MenuInfo implements IMenuInfo {
    accountID!: string;
    name?: string | undefined;
    menus?: MenuOptionsModel[] | undefined;

    constructor(data?: IMenuInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountID = _data["AccountID"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Menus"])) {
                this.menus = [] as any;
                for (let item of _data["Menus"])
                    this.menus!.push(MenuOptionsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MenuInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountID"] = this.accountID;
        data["Name"] = this.name;
        if (Array.isArray(this.menus)) {
            data["Menus"] = [];
            for (let item of this.menus)
                data["Menus"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMenuInfo {
    accountID: string;
    name?: string | undefined;
    menus?: MenuOptionsModel[] | undefined;
}

export class MenuOptionsModel implements IMenuOptionsModel {
    name?: string | undefined;
    activeCss?: string | undefined;
    url?: string | undefined;
    target?: string | undefined;
    items?: MenuOptionsItem[] | undefined;

    constructor(data?: IMenuOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.activeCss = _data["ActiveCss"];
            this.url = _data["Url"];
            this.target = _data["Target"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(MenuOptionsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MenuOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ActiveCss"] = this.activeCss;
        data["Url"] = this.url;
        data["Target"] = this.target;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMenuOptionsModel {
    name?: string | undefined;
    activeCss?: string | undefined;
    url?: string | undefined;
    target?: string | undefined;
    items?: MenuOptionsItem[] | undefined;
}

export class MenuOptionsItem implements IMenuOptionsItem {
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: IMenuOptionsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.url = _data["Url"];
        }
    }

    static fromJS(data: any): MenuOptionsItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuOptionsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Url"] = this.url;
        return data;
    }
}

export interface IMenuOptionsItem {
    name?: string | undefined;
    url?: string | undefined;
}

export class OfflineInteractionModel implements IOfflineInteractionModel {
    offlineInteractionID!: string;
    patientID!: string;
    interactionID!: number;
    name?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    expiresOn!: Date;
    usedOn?: Date | undefined;
    patientInteractionID?: number | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    timepointID?: number | undefined;
    clientID!: string;
    clientName?: string | undefined;
    studyID!: string;
    studyName?: string | undefined;

    constructor(data?: IOfflineInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offlineInteractionID = _data["OfflineInteractionID"];
            this.patientID = _data["PatientID"];
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.message = _data["Message"];
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
            this.usedOn = _data["UsedOn"] ? new Date(_data["UsedOn"].toString()) : <any>undefined;
            this.patientInteractionID = _data["PatientInteractionID"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.timepointID = _data["TimepointID"];
            this.clientID = _data["ClientID"];
            this.clientName = _data["ClientName"];
            this.studyID = _data["StudyID"];
            this.studyName = _data["StudyName"];
        }
    }

    static fromJS(data: any): OfflineInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OfflineInteractionID"] = this.offlineInteractionID;
        data["PatientID"] = this.patientID;
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Message"] = this.message;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["UsedOn"] = this.usedOn ? this.usedOn.toISOString() : <any>undefined;
        data["PatientInteractionID"] = this.patientInteractionID;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["TimepointID"] = this.timepointID;
        data["ClientID"] = this.clientID;
        data["ClientName"] = this.clientName;
        data["StudyID"] = this.studyID;
        data["StudyName"] = this.studyName;
        return data;
    }
}

export interface IOfflineInteractionModel {
    offlineInteractionID: string;
    patientID: string;
    interactionID: number;
    name?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    expiresOn: Date;
    usedOn?: Date | undefined;
    patientInteractionID?: number | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    timepointID?: number | undefined;
    clientID: string;
    clientName?: string | undefined;
    studyID: string;
    studyName?: string | undefined;
}

export class NewOfflineInteractionModel implements INewOfflineInteractionModel {
    patientID!: string;
    interactionID!: number;
    expiresOn!: Date;
    name!: string;
    email!: string;
    message!: string;
    domain!: string;
    suppressEmail!: boolean;
    timepointID?: number | undefined;

    constructor(data?: INewOfflineInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.interactionID = _data["InteractionID"];
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.message = _data["Message"];
            this.domain = _data["Domain"];
            this.suppressEmail = _data["SuppressEmail"];
            this.timepointID = _data["TimepointID"];
        }
    }

    static fromJS(data: any): NewOfflineInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewOfflineInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["InteractionID"] = this.interactionID;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Message"] = this.message;
        data["Domain"] = this.domain;
        data["SuppressEmail"] = this.suppressEmail;
        data["TimepointID"] = this.timepointID;
        return data;
    }
}

export interface INewOfflineInteractionModel {
    patientID: string;
    interactionID: number;
    expiresOn: Date;
    name: string;
    email: string;
    message: string;
    domain: string;
    suppressEmail: boolean;
    timepointID?: number | undefined;
}

export class CompleteOfflineInteractionModel implements ICompleteOfflineInteractionModel {
    offlineInteractionID!: string;
    patientInteractionID!: number;

    constructor(data?: ICompleteOfflineInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offlineInteractionID = _data["OfflineInteractionID"];
            this.patientInteractionID = _data["PatientInteractionID"];
        }
    }

    static fromJS(data: any): CompleteOfflineInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteOfflineInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OfflineInteractionID"] = this.offlineInteractionID;
        data["PatientInteractionID"] = this.patientInteractionID;
        return data;
    }
}

export interface ICompleteOfflineInteractionModel {
    offlineInteractionID: string;
    patientInteractionID: number;
}

export class TokenResponse implements ITokenResponse {
    accountID!: string;
    userName?: string | undefined;
    fullName?: string | undefined;
    access_token?: string | undefined;
    studyId?: string | undefined;
    studyName?: string | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    redirectToPayment!: boolean;
    redirectToPage!: boolean;

    constructor(data?: ITokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountID = _data["AccountID"];
            this.userName = _data["UserName"];
            this.fullName = _data["FullName"];
            this.access_token = _data["Access_token"];
            this.studyId = _data["StudyId"];
            this.studyName = _data["StudyName"];
            this.clientId = _data["ClientId"];
            this.clientName = _data["ClientName"];
            this.redirectToPayment = _data["RedirectToPayment"];
            this.redirectToPage = _data["RedirectToPage"];
        }
    }

    static fromJS(data: any): TokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountID"] = this.accountID;
        data["UserName"] = this.userName;
        data["FullName"] = this.fullName;
        data["Access_token"] = this.access_token;
        data["StudyId"] = this.studyId;
        data["StudyName"] = this.studyName;
        data["ClientId"] = this.clientId;
        data["ClientName"] = this.clientName;
        data["RedirectToPayment"] = this.redirectToPayment;
        data["RedirectToPage"] = this.redirectToPage;
        return data;
    }
}

export interface ITokenResponse {
    accountID: string;
    userName?: string | undefined;
    fullName?: string | undefined;
    access_token?: string | undefined;
    studyId?: string | undefined;
    studyName?: string | undefined;
    clientId?: string | undefined;
    clientName?: string | undefined;
    redirectToPayment: boolean;
    redirectToPage: boolean;
}

export class PatientInteractionVerify implements IPatientInteractionVerify {
    patientInteractionID!: number;
    isVerified!: boolean;

    constructor(data?: IPatientInteractionVerify) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientInteractionID = _data["PatientInteractionID"];
            this.isVerified = _data["IsVerified"];
        }
    }

    static fromJS(data: any): PatientInteractionVerify {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInteractionVerify();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientInteractionID"] = this.patientInteractionID;
        data["IsVerified"] = this.isVerified;
        return data;
    }
}

export interface IPatientInteractionVerify {
    patientInteractionID: number;
    isVerified: boolean;
}

export class PatientModel implements IPatientModel {
    patientID!: string;
    siteID!: string;
    siteName?: string | undefined;
    siteCode?: string | undefined;
    uniqueID?: string | undefined;
    firstName!: string;
    lastName!: string;
    middleName?: string | undefined;
    fullName?: string | undefined;
    criticalInformation?: string | undefined;
    allergies?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    avatar?: string | undefined;
    phone?: string | undefined;
    age?: number | undefined;
    ageYears?: number | undefined;
    ageMonths?: number | undefined;
    displayAge?: string | undefined;
    status!: PatientStatus;
    statusText?: string | undefined;
    dateOfBirth?: Date | undefined;
    enrollmentDate?: Date | undefined;
    registeredOn?: Date | undefined;
    createdOn!: Date;
    createdBy!: string;
    modifiedOn!: Date;
    modifiedBy!: string;
    completedForms!: number;
    verifiedForms!: number;
    patientInteractions?: PatientInteractionSummary[] | undefined;
    profile?: PatientInteraction | undefined;
    tabbedInteractions?: PatientInteraction[] | undefined;
    tasks?: TaskModel[] | undefined;
    investigations?: InvestigationModel[] | undefined;
    fileNoteCount!: number;
    availableInteractions?: AvailableInteraction[] | undefined;
    attachments?: FileAttachment[] | undefined;
    hubAttachments?: HubReportModel[] | undefined;
    graphs?: PatientGraphModel[] | undefined;
    hubAccounts?: PatientHubAccountModel[] | undefined;

    constructor(data?: IPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.siteID = _data["SiteID"];
            this.siteName = _data["SiteName"];
            this.siteCode = _data["SiteCode"];
            this.uniqueID = _data["UniqueID"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.middleName = _data["MiddleName"];
            this.fullName = _data["FullName"];
            this.criticalInformation = _data["CriticalInformation"];
            this.allergies = _data["Allergies"];
            this.preferredLanguage = _data["PreferredLanguage"];
            this.preferredLanguageCode = _data["PreferredLanguageCode"];
            this.avatar = _data["Avatar"];
            this.phone = _data["Phone"];
            this.age = _data["Age"];
            this.ageYears = _data["AgeYears"];
            this.ageMonths = _data["AgeMonths"];
            this.displayAge = _data["DisplayAge"];
            this.status = _data["Status"];
            this.statusText = _data["StatusText"];
            this.dateOfBirth = _data["DateOfBirth"] ? new Date(_data["DateOfBirth"].toString()) : <any>undefined;
            this.enrollmentDate = _data["EnrollmentDate"] ? new Date(_data["EnrollmentDate"].toString()) : <any>undefined;
            this.registeredOn = _data["RegisteredOn"] ? new Date(_data["RegisteredOn"].toString()) : <any>undefined;
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.completedForms = _data["CompletedForms"];
            this.verifiedForms = _data["VerifiedForms"];
            if (Array.isArray(_data["PatientInteractions"])) {
                this.patientInteractions = [] as any;
                for (let item of _data["PatientInteractions"])
                    this.patientInteractions!.push(PatientInteractionSummary.fromJS(item));
            }
            this.profile = _data["Profile"] ? PatientInteraction.fromJS(_data["Profile"]) : <any>undefined;
            if (Array.isArray(_data["TabbedInteractions"])) {
                this.tabbedInteractions = [] as any;
                for (let item of _data["TabbedInteractions"])
                    this.tabbedInteractions!.push(PatientInteraction.fromJS(item));
            }
            if (Array.isArray(_data["Tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["Tasks"])
                    this.tasks!.push(TaskModel.fromJS(item));
            }
            if (Array.isArray(_data["Investigations"])) {
                this.investigations = [] as any;
                for (let item of _data["Investigations"])
                    this.investigations!.push(InvestigationModel.fromJS(item));
            }
            this.fileNoteCount = _data["FileNoteCount"];
            if (Array.isArray(_data["AvailableInteractions"])) {
                this.availableInteractions = [] as any;
                for (let item of _data["AvailableInteractions"])
                    this.availableInteractions!.push(AvailableInteraction.fromJS(item));
            }
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(FileAttachment.fromJS(item));
            }
            if (Array.isArray(_data["HubAttachments"])) {
                this.hubAttachments = [] as any;
                for (let item of _data["HubAttachments"])
                    this.hubAttachments!.push(HubReportModel.fromJS(item));
            }
            if (Array.isArray(_data["Graphs"])) {
                this.graphs = [] as any;
                for (let item of _data["Graphs"])
                    this.graphs!.push(PatientGraphModel.fromJS(item));
            }
            if (Array.isArray(_data["HubAccounts"])) {
                this.hubAccounts = [] as any;
                for (let item of _data["HubAccounts"])
                    this.hubAccounts!.push(PatientHubAccountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["SiteID"] = this.siteID;
        data["SiteName"] = this.siteName;
        data["SiteCode"] = this.siteCode;
        data["UniqueID"] = this.uniqueID;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["MiddleName"] = this.middleName;
        data["FullName"] = this.fullName;
        data["CriticalInformation"] = this.criticalInformation;
        data["Allergies"] = this.allergies;
        data["PreferredLanguage"] = this.preferredLanguage;
        data["PreferredLanguageCode"] = this.preferredLanguageCode;
        data["Avatar"] = this.avatar;
        data["Phone"] = this.phone;
        data["Age"] = this.age;
        data["AgeYears"] = this.ageYears;
        data["AgeMonths"] = this.ageMonths;
        data["DisplayAge"] = this.displayAge;
        data["Status"] = this.status;
        data["StatusText"] = this.statusText;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["EnrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : <any>undefined;
        data["RegisteredOn"] = this.registeredOn ? this.registeredOn.toISOString() : <any>undefined;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["CompletedForms"] = this.completedForms;
        data["VerifiedForms"] = this.verifiedForms;
        if (Array.isArray(this.patientInteractions)) {
            data["PatientInteractions"] = [];
            for (let item of this.patientInteractions)
                data["PatientInteractions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        if (Array.isArray(this.tabbedInteractions)) {
            data["TabbedInteractions"] = [];
            for (let item of this.tabbedInteractions)
                data["TabbedInteractions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.tasks)) {
            data["Tasks"] = [];
            for (let item of this.tasks)
                data["Tasks"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.investigations)) {
            data["Investigations"] = [];
            for (let item of this.investigations)
                data["Investigations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["FileNoteCount"] = this.fileNoteCount;
        if (Array.isArray(this.availableInteractions)) {
            data["AvailableInteractions"] = [];
            for (let item of this.availableInteractions)
                data["AvailableInteractions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hubAttachments)) {
            data["HubAttachments"] = [];
            for (let item of this.hubAttachments)
                data["HubAttachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.graphs)) {
            data["Graphs"] = [];
            for (let item of this.graphs)
                data["Graphs"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hubAccounts)) {
            data["HubAccounts"] = [];
            for (let item of this.hubAccounts)
                data["HubAccounts"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPatientModel {
    patientID: string;
    siteID: string;
    siteName?: string | undefined;
    siteCode?: string | undefined;
    uniqueID?: string | undefined;
    firstName: string;
    lastName: string;
    middleName?: string | undefined;
    fullName?: string | undefined;
    criticalInformation?: string | undefined;
    allergies?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    avatar?: string | undefined;
    phone?: string | undefined;
    age?: number | undefined;
    ageYears?: number | undefined;
    ageMonths?: number | undefined;
    displayAge?: string | undefined;
    status: PatientStatus;
    statusText?: string | undefined;
    dateOfBirth?: Date | undefined;
    enrollmentDate?: Date | undefined;
    registeredOn?: Date | undefined;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date;
    modifiedBy: string;
    completedForms: number;
    verifiedForms: number;
    patientInteractions?: PatientInteractionSummary[] | undefined;
    profile?: PatientInteraction | undefined;
    tabbedInteractions?: PatientInteraction[] | undefined;
    tasks?: TaskModel[] | undefined;
    investigations?: InvestigationModel[] | undefined;
    fileNoteCount: number;
    availableInteractions?: AvailableInteraction[] | undefined;
    attachments?: FileAttachment[] | undefined;
    hubAttachments?: HubReportModel[] | undefined;
    graphs?: PatientGraphModel[] | undefined;
    hubAccounts?: PatientHubAccountModel[] | undefined;
}

export enum PatientStatus {
    PartialEnrolled = 0,
    Enrolled = 1,
    Inactive = 2,
    Ineligible = 4,
    NotInterested = 5,
    PermanentlyIncomplete = 6,
    TestData = 7,
    Waitlist = 8,
    Paused = 9,
    OngoingSupport = 10,
    HoldingTank = 11,
    PreEnrollment = 12,
    Completed = 13,
    Assessment = 14,
    Enrolled12 = 15,
    Essentials = 16,
}

export class PatientInteractionSummary implements IPatientInteractionSummary {
    interactionDate!: Date;
    patientInteractionID!: number;
    supercededByID?: number | undefined;
    isSuperceded!: boolean;
    patientID!: string;
    interactionID!: number;
    createdOn!: Date;
    createdBy!: string;
    modifiedOn!: Date;
    modifiedBy!: string;
    verifiedOn?: Date | undefined;
    verifiedBy?: string | undefined;
    notes!: string;
    name!: string;
    timepointLabel?: string | undefined;
    dataFlag!: boolean;

    constructor(data?: IPatientInteractionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionDate = _data["InteractionDate"] ? new Date(_data["InteractionDate"].toString()) : <any>undefined;
            this.patientInteractionID = _data["PatientInteractionID"];
            this.supercededByID = _data["SupercededByID"];
            this.isSuperceded = _data["IsSuperceded"];
            this.patientID = _data["PatientID"];
            this.interactionID = _data["InteractionID"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.verifiedOn = _data["VerifiedOn"] ? new Date(_data["VerifiedOn"].toString()) : <any>undefined;
            this.verifiedBy = _data["VerifiedBy"];
            this.notes = _data["Notes"];
            this.name = _data["Name"];
            this.timepointLabel = _data["TimepointLabel"];
            this.dataFlag = _data["DataFlag"];
        }
    }

    static fromJS(data: any): PatientInteractionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInteractionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionDate"] = this.interactionDate ? this.interactionDate.toISOString() : <any>undefined;
        data["PatientInteractionID"] = this.patientInteractionID;
        data["SupercededByID"] = this.supercededByID;
        data["IsSuperceded"] = this.isSuperceded;
        data["PatientID"] = this.patientID;
        data["InteractionID"] = this.interactionID;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["VerifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : <any>undefined;
        data["VerifiedBy"] = this.verifiedBy;
        data["Notes"] = this.notes;
        data["Name"] = this.name;
        data["TimepointLabel"] = this.timepointLabel;
        data["DataFlag"] = this.dataFlag;
        return data;
    }
}

export interface IPatientInteractionSummary {
    interactionDate: Date;
    patientInteractionID: number;
    supercededByID?: number | undefined;
    isSuperceded: boolean;
    patientID: string;
    interactionID: number;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date;
    modifiedBy: string;
    verifiedOn?: Date | undefined;
    verifiedBy?: string | undefined;
    notes: string;
    name: string;
    timepointLabel?: string | undefined;
    dataFlag: boolean;
}

export class AvailableInteraction implements IAvailableInteraction {
    interactionID!: number;
    interactionType!: InteractionType;
    name?: string | undefined;
    hasDraft!: boolean;
    heading?: string | undefined;
    group?: string | undefined;

    constructor(data?: IAvailableInteraction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.interactionType = _data["InteractionType"];
            this.name = _data["Name"];
            this.hasDraft = _data["HasDraft"];
            this.heading = _data["Heading"];
            this.group = _data["Group"];
        }
    }

    static fromJS(data: any): AvailableInteraction {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableInteraction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["InteractionType"] = this.interactionType;
        data["Name"] = this.name;
        data["HasDraft"] = this.hasDraft;
        data["Heading"] = this.heading;
        data["Group"] = this.group;
        return data;
    }
}

export interface IAvailableInteraction {
    interactionID: number;
    interactionType: InteractionType;
    name?: string | undefined;
    hasDraft: boolean;
    heading?: string | undefined;
    group?: string | undefined;
}

export class FileAttachment implements IFileAttachment {
    file?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    attachmentID?: string | undefined;
    date!: Date;

    constructor(data?: IFileAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["File"];
            this.name = _data["Name"];
            this.category = _data["Category"];
            this.attachmentID = _data["AttachmentID"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["File"] = this.file;
        data["Name"] = this.name;
        data["Category"] = this.category;
        data["AttachmentID"] = this.attachmentID;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileAttachment {
    file?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    attachmentID?: string | undefined;
    date: Date;
}

export class HubReportModel implements IHubReportModel {
    attachmentID!: string;
    fileName?: string | undefined;
    originalFileName?: string | undefined;
    name?: string | undefined;
    categoryName?: string | undefined;
    description?: string | undefined;
    createdOn!: Date;

    constructor(data?: IHubReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentID = _data["AttachmentID"];
            this.fileName = _data["FileName"];
            this.originalFileName = _data["OriginalFileName"];
            this.name = _data["Name"];
            this.categoryName = _data["CategoryName"];
            this.description = _data["Description"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HubReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new HubReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AttachmentID"] = this.attachmentID;
        data["FileName"] = this.fileName;
        data["OriginalFileName"] = this.originalFileName;
        data["Name"] = this.name;
        data["CategoryName"] = this.categoryName;
        data["Description"] = this.description;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHubReportModel {
    attachmentID: string;
    fileName?: string | undefined;
    originalFileName?: string | undefined;
    name?: string | undefined;
    categoryName?: string | undefined;
    description?: string | undefined;
    createdOn: Date;
}

export class PatientHubAccountModel implements IPatientHubAccountModel {
    relationshipTypeName?: string | undefined;
    patientID!: string;
    hubAccountID!: string;
    hubAccountPatientID!: string;
    accountName?: string | undefined;
    email?: string | undefined;
    consentStatus?: string | undefined;
    relationshipType!: RelationshipType;
    relationshipDescription?: string | undefined;
    status!: HubAccountPatientStatus;
    accountStatus!: AccountStatus;
    canResendInvite!: boolean;

    constructor(data?: IPatientHubAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relationshipTypeName = _data["RelationshipTypeName"];
            this.patientID = _data["PatientID"];
            this.hubAccountID = _data["HubAccountID"];
            this.hubAccountPatientID = _data["HubAccountPatientID"];
            this.accountName = _data["AccountName"];
            this.email = _data["Email"];
            this.consentStatus = _data["ConsentStatus"];
            this.relationshipType = _data["RelationshipType"];
            this.relationshipDescription = _data["RelationshipDescription"];
            this.status = _data["Status"];
            this.accountStatus = _data["AccountStatus"];
            this.canResendInvite = _data["CanResendInvite"];
        }
    }

    static fromJS(data: any): PatientHubAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientHubAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RelationshipTypeName"] = this.relationshipTypeName;
        data["PatientID"] = this.patientID;
        data["HubAccountID"] = this.hubAccountID;
        data["HubAccountPatientID"] = this.hubAccountPatientID;
        data["AccountName"] = this.accountName;
        data["Email"] = this.email;
        data["ConsentStatus"] = this.consentStatus;
        data["RelationshipType"] = this.relationshipType;
        data["RelationshipDescription"] = this.relationshipDescription;
        data["Status"] = this.status;
        data["AccountStatus"] = this.accountStatus;
        data["CanResendInvite"] = this.canResendInvite;
        return data;
    }
}

export interface IPatientHubAccountModel {
    relationshipTypeName?: string | undefined;
    patientID: string;
    hubAccountID: string;
    hubAccountPatientID: string;
    accountName?: string | undefined;
    email?: string | undefined;
    consentStatus?: string | undefined;
    relationshipType: RelationshipType;
    relationshipDescription?: string | undefined;
    status: HubAccountPatientStatus;
    accountStatus: AccountStatus;
    canResendInvite: boolean;
}

export enum HubAccountPatientStatus {
    Deleted = 0,
    Active = 1,
    Inactive = 2,
}

export class PatientViewModel implements IPatientViewModel {
    patientID!: string;
    patientInteractionID?: number | undefined;
    taskID?: string | undefined;
    reportID?: string | undefined;
    investigationID?: string | undefined;
    attachmentID?: string | undefined;
    url!: string;
    viewType!: PatientViewType;

    constructor(data?: IPatientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.patientInteractionID = _data["PatientInteractionID"];
            this.taskID = _data["TaskID"];
            this.reportID = _data["ReportID"];
            this.investigationID = _data["InvestigationID"];
            this.attachmentID = _data["AttachmentID"];
            this.url = _data["Url"];
            this.viewType = _data["ViewType"];
        }
    }

    static fromJS(data: any): PatientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["PatientInteractionID"] = this.patientInteractionID;
        data["TaskID"] = this.taskID;
        data["ReportID"] = this.reportID;
        data["InvestigationID"] = this.investigationID;
        data["AttachmentID"] = this.attachmentID;
        data["Url"] = this.url;
        data["ViewType"] = this.viewType;
        return data;
    }
}

export interface IPatientViewModel {
    patientID: string;
    patientInteractionID?: number | undefined;
    taskID?: string | undefined;
    reportID?: string | undefined;
    investigationID?: string | undefined;
    attachmentID?: string | undefined;
    url: string;
    viewType: PatientViewType;
}

export enum PatientViewType {
    Chart = 0,
    Questionnaire = 1,
    Task = 2,
    Report = 3,
    Investigation = 4,
    Attachments = 5,
    Attachment = 6,
    Receipt = 7,
}

export class AutomatedOfflineInteractionModel implements IAutomatedOfflineInteractionModel {
    interactionName?: string | undefined;
    appCode?: string | undefined;
    offlineInteraction?: MobileOfflineInteractionModel | undefined;
    startDate!: Date;

    constructor(data?: IAutomatedOfflineInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionName = _data["InteractionName"];
            this.appCode = _data["AppCode"];
            this.offlineInteraction = _data["OfflineInteraction"] ? MobileOfflineInteractionModel.fromJS(_data["OfflineInteraction"]) : <any>undefined;
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AutomatedOfflineInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutomatedOfflineInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionName"] = this.interactionName;
        data["AppCode"] = this.appCode;
        data["OfflineInteraction"] = this.offlineInteraction ? this.offlineInteraction.toJSON() : <any>undefined;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAutomatedOfflineInteractionModel {
    interactionName?: string | undefined;
    appCode?: string | undefined;
    offlineInteraction?: MobileOfflineInteractionModel | undefined;
    startDate: Date;
}

export class MobileOfflineInteractionModel implements IMobileOfflineInteractionModel {
    offlineInteractionID!: string;
    expiresOn!: Date;

    constructor(data?: IMobileOfflineInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offlineInteractionID = _data["OfflineInteractionID"];
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileOfflineInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileOfflineInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OfflineInteractionID"] = this.offlineInteractionID;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMobileOfflineInteractionModel {
    offlineInteractionID: string;
    expiresOn: Date;
}

export class PatientStubModel implements IPatientStubModel {
    siteID!: string;
    languageCode?: string | undefined;

    constructor(data?: IPatientStubModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteID = _data["SiteID"];
            this.languageCode = _data["LanguageCode"];
        }
    }

    static fromJS(data: any): PatientStubModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStubModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SiteID"] = this.siteID;
        data["LanguageCode"] = this.languageCode;
        return data;
    }
}

export interface IPatientStubModel {
    siteID: string;
    languageCode?: string | undefined;
}

export class PatientObesityModuleSummary implements IPatientObesityModuleSummary {
    obesityModuleValuesCounter!: number;
    obesityModuleBiasCounter!: number;
    obesityModuleExpectationsCounter!: number;
    obesityModuleCalorieDeficitCounter!: number;
    obesityModuleRestraintCounter!: number;
    obesityModuleWantingCounter!: number;
    obesityModuleResilienceCounter!: number;
    obesityModuleModulatorsCounter!: number;

    constructor(data?: IPatientObesityModuleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obesityModuleValuesCounter = _data["ObesityModuleValuesCounter"];
            this.obesityModuleBiasCounter = _data["ObesityModuleBiasCounter"];
            this.obesityModuleExpectationsCounter = _data["ObesityModuleExpectationsCounter"];
            this.obesityModuleCalorieDeficitCounter = _data["ObesityModuleCalorieDeficitCounter"];
            this.obesityModuleRestraintCounter = _data["ObesityModuleRestraintCounter"];
            this.obesityModuleWantingCounter = _data["ObesityModuleWantingCounter"];
            this.obesityModuleResilienceCounter = _data["ObesityModuleResilienceCounter"];
            this.obesityModuleModulatorsCounter = _data["ObesityModuleModulatorsCounter"];
        }
    }

    static fromJS(data: any): PatientObesityModuleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientObesityModuleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ObesityModuleValuesCounter"] = this.obesityModuleValuesCounter;
        data["ObesityModuleBiasCounter"] = this.obesityModuleBiasCounter;
        data["ObesityModuleExpectationsCounter"] = this.obesityModuleExpectationsCounter;
        data["ObesityModuleCalorieDeficitCounter"] = this.obesityModuleCalorieDeficitCounter;
        data["ObesityModuleRestraintCounter"] = this.obesityModuleRestraintCounter;
        data["ObesityModuleWantingCounter"] = this.obesityModuleWantingCounter;
        data["ObesityModuleResilienceCounter"] = this.obesityModuleResilienceCounter;
        data["ObesityModuleModulatorsCounter"] = this.obesityModuleModulatorsCounter;
        return data;
    }
}

export interface IPatientObesityModuleSummary {
    obesityModuleValuesCounter: number;
    obesityModuleBiasCounter: number;
    obesityModuleExpectationsCounter: number;
    obesityModuleCalorieDeficitCounter: number;
    obesityModuleRestraintCounter: number;
    obesityModuleWantingCounter: number;
    obesityModuleResilienceCounter: number;
    obesityModuleModulatorsCounter: number;
}

export class PatientVisitSummary implements IPatientVisitSummary {
    patientId!: string;
    visits?: PatientVisitSummaryDetail[] | undefined;

    constructor(data?: IPatientVisitSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
            if (Array.isArray(_data["Visits"])) {
                this.visits = [] as any;
                for (let item of _data["Visits"])
                    this.visits!.push(PatientVisitSummaryDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientVisitSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientVisitSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        if (Array.isArray(this.visits)) {
            data["Visits"] = [];
            for (let item of this.visits)
                data["Visits"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPatientVisitSummary {
    patientId: string;
    visits?: PatientVisitSummaryDetail[] | undefined;
}

export class PatientVisitSummaryDetail implements IPatientVisitSummaryDetail {
    visitNumber?: number | undefined;
    visitState!: VisitState;
    completedOn?: Date | undefined;
    forfeitedOn?: Date | undefined;
    scheduledFor?: Date | undefined;

    constructor(data?: IPatientVisitSummaryDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitNumber = _data["VisitNumber"];
            this.visitState = _data["VisitState"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.forfeitedOn = _data["ForfeitedOn"] ? new Date(_data["ForfeitedOn"].toString()) : <any>undefined;
            this.scheduledFor = _data["ScheduledFor"] ? new Date(_data["ScheduledFor"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientVisitSummaryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PatientVisitSummaryDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VisitNumber"] = this.visitNumber;
        data["VisitState"] = this.visitState;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["ForfeitedOn"] = this.forfeitedOn ? this.forfeitedOn.toISOString() : <any>undefined;
        data["ScheduledFor"] = this.scheduledFor ? this.scheduledFor.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientVisitSummaryDetail {
    visitNumber?: number | undefined;
    visitState: VisitState;
    completedOn?: Date | undefined;
    forfeitedOn?: Date | undefined;
    scheduledFor?: Date | undefined;
}

export enum VisitState {
    Incomplete = 0,
    Completed = 1,
    Forfeited = 2,
}

export class PublicPatientAppointmentModel implements IPublicPatientAppointmentModel {
    id!: string;
    appointmentMethod!: CallType;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date!: Date;
    duration!: number;
    joinUrl?: string | undefined;
    appointmentStatus!: PublicAppointmentStatus;

    constructor(data?: IPublicPatientAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.appointmentMethod = _data["AppointmentMethod"];
            this.agentName = _data["AgentName"];
            this.appointmentType = _data["AppointmentType"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.duration = _data["Duration"];
            this.joinUrl = _data["JoinUrl"];
            this.appointmentStatus = _data["AppointmentStatus"];
        }
    }

    static fromJS(data: any): PublicPatientAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AppointmentMethod"] = this.appointmentMethod;
        data["AgentName"] = this.agentName;
        data["AppointmentType"] = this.appointmentType;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Duration"] = this.duration;
        data["JoinUrl"] = this.joinUrl;
        data["AppointmentStatus"] = this.appointmentStatus;
        return data;
    }
}

export interface IPublicPatientAppointmentModel {
    id: string;
    appointmentMethod: CallType;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date: Date;
    duration: number;
    joinUrl?: string | undefined;
    appointmentStatus: PublicAppointmentStatus;
}

export enum CallType {
    Phone = 1,
    Video = 2,
}

export enum PublicAppointmentStatus {
    Unknown = 0,
    Upcoming = 1,
    Completed = 2,
    Archived = 3,
}

export class GetPatientFaceSheetStatsResponse implements IGetPatientFaceSheetStatsResponse {
    weightInformation?: GetPatientFaceSheetStatsResponseWeight | undefined;
    medicalInformation?: GetPatientFaceSheetStatsResponseMedical | undefined;

    constructor(data?: IGetPatientFaceSheetStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weightInformation = _data["WeightInformation"] ? GetPatientFaceSheetStatsResponseWeight.fromJS(_data["WeightInformation"]) : <any>undefined;
            this.medicalInformation = _data["MedicalInformation"] ? GetPatientFaceSheetStatsResponseMedical.fromJS(_data["MedicalInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPatientFaceSheetStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFaceSheetStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WeightInformation"] = this.weightInformation ? this.weightInformation.toJSON() : <any>undefined;
        data["MedicalInformation"] = this.medicalInformation ? this.medicalInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPatientFaceSheetStatsResponse {
    weightInformation?: GetPatientFaceSheetStatsResponseWeight | undefined;
    medicalInformation?: GetPatientFaceSheetStatsResponseMedical | undefined;
}

export class GetPatientFaceSheetStatsResponseWeight implements IGetPatientFaceSheetStatsResponseWeight {
    caloricDeficit!: number;
    causesOfWeightGain?: string | undefined;
    heightInCm!: number;
    weightInKg!: number;
    currentBmi!: number;
    percentageWeightLostAllTime?: number | undefined;
    percentageWeightLostSinceProgramStart?: number | undefined;
    percentageWeightLostSinceAomStart?: number | undefined;
    aomStartDate?: Date | undefined;
    programStartDate?: Date | undefined;
    weightHistory?: GetPatientFaceSheetStatsResponseWeightLine[] | undefined;

    constructor(data?: IGetPatientFaceSheetStatsResponseWeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caloricDeficit = _data["CaloricDeficit"];
            this.causesOfWeightGain = _data["CausesOfWeightGain"];
            this.heightInCm = _data["HeightInCm"];
            this.weightInKg = _data["WeightInKg"];
            this.currentBmi = _data["CurrentBmi"];
            this.percentageWeightLostAllTime = _data["PercentageWeightLostAllTime"];
            this.percentageWeightLostSinceProgramStart = _data["PercentageWeightLostSinceProgramStart"];
            this.percentageWeightLostSinceAomStart = _data["PercentageWeightLostSinceAomStart"];
            this.aomStartDate = _data["AomStartDate"] ? new Date(_data["AomStartDate"].toString()) : <any>undefined;
            this.programStartDate = _data["ProgramStartDate"] ? new Date(_data["ProgramStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["WeightHistory"])) {
                this.weightHistory = [] as any;
                for (let item of _data["WeightHistory"])
                    this.weightHistory!.push(GetPatientFaceSheetStatsResponseWeightLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPatientFaceSheetStatsResponseWeight {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFaceSheetStatsResponseWeight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaloricDeficit"] = this.caloricDeficit;
        data["CausesOfWeightGain"] = this.causesOfWeightGain;
        data["HeightInCm"] = this.heightInCm;
        data["WeightInKg"] = this.weightInKg;
        data["CurrentBmi"] = this.currentBmi;
        data["PercentageWeightLostAllTime"] = this.percentageWeightLostAllTime;
        data["PercentageWeightLostSinceProgramStart"] = this.percentageWeightLostSinceProgramStart;
        data["PercentageWeightLostSinceAomStart"] = this.percentageWeightLostSinceAomStart;
        data["AomStartDate"] = this.aomStartDate ? this.aomStartDate.toISOString() : <any>undefined;
        data["ProgramStartDate"] = this.programStartDate ? this.programStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.weightHistory)) {
            data["WeightHistory"] = [];
            for (let item of this.weightHistory)
                data["WeightHistory"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetPatientFaceSheetStatsResponseWeight {
    caloricDeficit: number;
    causesOfWeightGain?: string | undefined;
    heightInCm: number;
    weightInKg: number;
    currentBmi: number;
    percentageWeightLostAllTime?: number | undefined;
    percentageWeightLostSinceProgramStart?: number | undefined;
    percentageWeightLostSinceAomStart?: number | undefined;
    aomStartDate?: Date | undefined;
    programStartDate?: Date | undefined;
    weightHistory?: GetPatientFaceSheetStatsResponseWeightLine[] | undefined;
}

export class GetPatientFaceSheetStatsResponseWeightLine implements IGetPatientFaceSheetStatsResponseWeightLine {
    date!: Date;
    weight!: number;
    visitNumber?: number | undefined;
    weightHistoryType!: WeightHistoryType;

    constructor(data?: IGetPatientFaceSheetStatsResponseWeightLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.weight = _data["Weight"];
            this.visitNumber = _data["VisitNumber"];
            this.weightHistoryType = _data["WeightHistoryType"];
        }
    }

    static fromJS(data: any): GetPatientFaceSheetStatsResponseWeightLine {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFaceSheetStatsResponseWeightLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Weight"] = this.weight;
        data["VisitNumber"] = this.visitNumber;
        data["WeightHistoryType"] = this.weightHistoryType;
        return data;
    }
}

export interface IGetPatientFaceSheetStatsResponseWeightLine {
    date: Date;
    weight: number;
    visitNumber?: number | undefined;
    weightHistoryType: WeightHistoryType;
}

export enum WeightHistoryType {
    Highest = 0,
    Lowest = 1,
    Enrollment = 2,
    WeightHistory = 3,
    Visit = 4,
    OngoingSupport = 5,
    Assessment = 6,
}

export class GetPatientFaceSheetStatsResponseMedical implements IGetPatientFaceSheetStatsResponseMedical {
    valueStatement?: string | undefined;
    aomMedications?: MedicationSummaryModel[] | undefined;
    currentAomStatus?: AomReview | undefined;
    familyHxOfThyroid?: boolean | undefined;
    comorbidities?: string[] | undefined;
    allergies?: string | undefined;
    eossPhysical?: string | undefined;
    eossPsychological?: string | undefined;
    eossMetabolicDisease?: string | undefined;
    medicalHistoryScores?: PatientMedicalHistoryScoreItem[] | undefined;
    confidences?: GetPatientFaceSheetStatsResponseConfidence[] | undefined;

    constructor(data?: IGetPatientFaceSheetStatsResponseMedical) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueStatement = _data["ValueStatement"];
            if (Array.isArray(_data["AomMedications"])) {
                this.aomMedications = [] as any;
                for (let item of _data["AomMedications"])
                    this.aomMedications!.push(MedicationSummaryModel.fromJS(item));
            }
            this.currentAomStatus = _data["CurrentAomStatus"] ? AomReview.fromJS(_data["CurrentAomStatus"]) : <any>undefined;
            this.familyHxOfThyroid = _data["FamilyHxOfThyroid"];
            if (Array.isArray(_data["Comorbidities"])) {
                this.comorbidities = [] as any;
                for (let item of _data["Comorbidities"])
                    this.comorbidities!.push(item);
            }
            this.allergies = _data["Allergies"];
            this.eossPhysical = _data["EossPhysical"];
            this.eossPsychological = _data["EossPsychological"];
            this.eossMetabolicDisease = _data["EossMetabolicDisease"];
            if (Array.isArray(_data["MedicalHistoryScores"])) {
                this.medicalHistoryScores = [] as any;
                for (let item of _data["MedicalHistoryScores"])
                    this.medicalHistoryScores!.push(PatientMedicalHistoryScoreItem.fromJS(item));
            }
            if (Array.isArray(_data["Confidences"])) {
                this.confidences = [] as any;
                for (let item of _data["Confidences"])
                    this.confidences!.push(GetPatientFaceSheetStatsResponseConfidence.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPatientFaceSheetStatsResponseMedical {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFaceSheetStatsResponseMedical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ValueStatement"] = this.valueStatement;
        if (Array.isArray(this.aomMedications)) {
            data["AomMedications"] = [];
            for (let item of this.aomMedications)
                data["AomMedications"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CurrentAomStatus"] = this.currentAomStatus ? this.currentAomStatus.toJSON() : <any>undefined;
        data["FamilyHxOfThyroid"] = this.familyHxOfThyroid;
        if (Array.isArray(this.comorbidities)) {
            data["Comorbidities"] = [];
            for (let item of this.comorbidities)
                data["Comorbidities"].push(item);
        }
        data["Allergies"] = this.allergies;
        data["EossPhysical"] = this.eossPhysical;
        data["EossPsychological"] = this.eossPsychological;
        data["EossMetabolicDisease"] = this.eossMetabolicDisease;
        if (Array.isArray(this.medicalHistoryScores)) {
            data["MedicalHistoryScores"] = [];
            for (let item of this.medicalHistoryScores)
                data["MedicalHistoryScores"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.confidences)) {
            data["Confidences"] = [];
            for (let item of this.confidences)
                data["Confidences"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetPatientFaceSheetStatsResponseMedical {
    valueStatement?: string | undefined;
    aomMedications?: MedicationSummaryModel[] | undefined;
    currentAomStatus?: AomReview | undefined;
    familyHxOfThyroid?: boolean | undefined;
    comorbidities?: string[] | undefined;
    allergies?: string | undefined;
    eossPhysical?: string | undefined;
    eossPsychological?: string | undefined;
    eossMetabolicDisease?: string | undefined;
    medicalHistoryScores?: PatientMedicalHistoryScoreItem[] | undefined;
    confidences?: GetPatientFaceSheetStatsResponseConfidence[] | undefined;
}

export class MedicationSummaryModel implements IMedicationSummaryModel {
    name?: string | undefined;
    dose!: number;
    units?: string | undefined;
    frequency?: string | undefined;

    constructor(data?: IMedicationSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.dose = _data["Dose"];
            this.units = _data["Units"];
            this.frequency = _data["Frequency"];
        }
    }

    static fromJS(data: any): MedicationSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Dose"] = this.dose;
        data["Units"] = this.units;
        data["Frequency"] = this.frequency;
        return data;
    }
}

export interface IMedicationSummaryModel {
    name?: string | undefined;
    dose: number;
    units?: string | undefined;
    frequency?: string | undefined;
}

export class AomReview implements IAomReview {
    prescribed?: string | undefined;
    interested?: string | undefined;
    barriers?: string | undefined;
    barriersOther?: string | undefined;
    medications?: AomReviewMedication[] | undefined;

    constructor(data?: IAomReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescribed = _data["Prescribed"];
            this.interested = _data["Interested"];
            this.barriers = _data["Barriers"];
            this.barriersOther = _data["BarriersOther"];
            if (Array.isArray(_data["Medications"])) {
                this.medications = [] as any;
                for (let item of _data["Medications"])
                    this.medications!.push(AomReviewMedication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AomReview {
        data = typeof data === 'object' ? data : {};
        let result = new AomReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Prescribed"] = this.prescribed;
        data["Interested"] = this.interested;
        data["Barriers"] = this.barriers;
        data["BarriersOther"] = this.barriersOther;
        if (Array.isArray(this.medications)) {
            data["Medications"] = [];
            for (let item of this.medications)
                data["Medications"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAomReview {
    prescribed?: string | undefined;
    interested?: string | undefined;
    barriers?: string | undefined;
    barriersOther?: string | undefined;
    medications?: AomReviewMedication[] | undefined;
}

export class AomReviewMedication implements IAomReviewMedication {
    name?: string | undefined;
    nameOther?: string | undefined;
    ongoing?: string | undefined;
    discontinued?: string | undefined;
    discontinuedOther?: string | undefined;
    dose?: string | undefined;
    units?: string | undefined;
    freq?: string | undefined;
    freqOther?: string | undefined;
    sideEffects?: string | undefined;
    titration?: string | undefined;
    benefits?: string | undefined;
    benefitsOther?: string | undefined;
    affordability?: string | undefined;
    durability?: string | undefined;
    durabilityOther?: string | undefined;

    constructor(data?: IAomReviewMedication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.nameOther = _data["NameOther"];
            this.ongoing = _data["Ongoing"];
            this.discontinued = _data["Discontinued"];
            this.discontinuedOther = _data["DiscontinuedOther"];
            this.dose = _data["Dose"];
            this.units = _data["Units"];
            this.freq = _data["Freq"];
            this.freqOther = _data["FreqOther"];
            this.sideEffects = _data["SideEffects"];
            this.titration = _data["Titration"];
            this.benefits = _data["Benefits"];
            this.benefitsOther = _data["BenefitsOther"];
            this.affordability = _data["Affordability"];
            this.durability = _data["Durability"];
            this.durabilityOther = _data["DurabilityOther"];
        }
    }

    static fromJS(data: any): AomReviewMedication {
        data = typeof data === 'object' ? data : {};
        let result = new AomReviewMedication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["NameOther"] = this.nameOther;
        data["Ongoing"] = this.ongoing;
        data["Discontinued"] = this.discontinued;
        data["DiscontinuedOther"] = this.discontinuedOther;
        data["Dose"] = this.dose;
        data["Units"] = this.units;
        data["Freq"] = this.freq;
        data["FreqOther"] = this.freqOther;
        data["SideEffects"] = this.sideEffects;
        data["Titration"] = this.titration;
        data["Benefits"] = this.benefits;
        data["BenefitsOther"] = this.benefitsOther;
        data["Affordability"] = this.affordability;
        data["Durability"] = this.durability;
        data["DurabilityOther"] = this.durabilityOther;
        return data;
    }
}

export interface IAomReviewMedication {
    name?: string | undefined;
    nameOther?: string | undefined;
    ongoing?: string | undefined;
    discontinued?: string | undefined;
    discontinuedOther?: string | undefined;
    dose?: string | undefined;
    units?: string | undefined;
    freq?: string | undefined;
    freqOther?: string | undefined;
    sideEffects?: string | undefined;
    titration?: string | undefined;
    benefits?: string | undefined;
    benefitsOther?: string | undefined;
    affordability?: string | undefined;
    durability?: string | undefined;
    durabilityOther?: string | undefined;
}

export class PatientMedicalHistoryScoreItem implements IPatientMedicalHistoryScoreItem {
    identifier?: string | undefined;
    name?: string | undefined;
    score!: number;
    interpretation?: string | undefined;

    constructor(data?: IPatientMedicalHistoryScoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["Identifier"];
            this.name = _data["Name"];
            this.score = _data["Score"];
            this.interpretation = _data["Interpretation"];
        }
    }

    static fromJS(data: any): PatientMedicalHistoryScoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistoryScoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Identifier"] = this.identifier;
        data["Name"] = this.name;
        data["Score"] = this.score;
        data["Interpretation"] = this.interpretation;
        return data;
    }
}

export interface IPatientMedicalHistoryScoreItem {
    identifier?: string | undefined;
    name?: string | undefined;
    score: number;
    interpretation?: string | undefined;
}

export class GetPatientFaceSheetStatsResponseConfidence implements IGetPatientFaceSheetStatsResponseConfidence {
    visitNumber?: number | undefined;
    visitType!: VisitType;
    date?: Date | undefined;
    score?: number | undefined;

    constructor(data?: IGetPatientFaceSheetStatsResponseConfidence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitNumber = _data["VisitNumber"];
            this.visitType = _data["VisitType"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.score = _data["Score"];
        }
    }

    static fromJS(data: any): GetPatientFaceSheetStatsResponseConfidence {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientFaceSheetStatsResponseConfidence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VisitNumber"] = this.visitNumber;
        data["VisitType"] = this.visitType;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Score"] = this.score;
        return data;
    }
}

export interface IGetPatientFaceSheetStatsResponseConfidence {
    visitNumber?: number | undefined;
    visitType: VisitType;
    date?: Date | undefined;
    score?: number | undefined;
}

export enum VisitType {
    Visit = 0,
    OngoingSupport = 1,
    Assessment = 2,
}

export class GetPatientProfileResponse implements IGetPatientProfileResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    patientStatus!: PatientStatus;
    paymentStatus!: PaymentStatus;
    language?: string | undefined;
    birthDate!: Date;
    height!: number;
    weight!: number;
    bmi!: number;
    comorbidities?: string[] | undefined;
    hasPhysician!: boolean;
    childbearing!: boolean;
    eatingDisorder!: boolean;
    mentalHealthCondition!: boolean;
    mentalHealthFollowup!: boolean;
    bariatricSurgery!: boolean;
    province?: string | undefined;
    gender?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    phonePreference?: string | undefined;
    voicemail!: boolean;
    enrollConsent!: boolean;
    waitlistConsent!: boolean;
    physicianFirstName?: string | undefined;
    physicianLastName?: string | undefined;
    physicianAddressStreet?: string | undefined;
    physicianAddressUnit?: string | undefined;
    physicianAddressPostalCode?: string | undefined;
    physicianAddressCity?: string | undefined;
    physicianAddressProvince?: string | undefined;
    physicianAddressCountry?: string | undefined;
    physicianPhoneNumber?: string | undefined;
    physicianFaxNumber?: string | undefined;
    physicianEmail?: string | undefined;
    pharmacyName?: string | undefined;
    pharmacyAddressStreet?: string | undefined;
    pharmacyAddressPostalCode?: string | undefined;
    pharmacyAddressCity?: string | undefined;
    pharmacyAddressProvince?: string | undefined;
    pharmacyAddressCountry?: string | undefined;
    pharmacyPhoneNumber?: string | undefined;
    pharmacyFaxNumber?: string | undefined;
    privateInsurance!: boolean;
    addressStreet?: string | undefined;
    addressUnit?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressProvince?: string | undefined;
    addressCountry?: string | undefined;
    billingAddressSameAsHome!: boolean;
    billingAddressStreet?: string | undefined;
    billingAddressUnit?: string | undefined;
    billingAddressCity?: string | undefined;
    billingAddressPostalCode?: string | undefined;
    healthCardNumber?: string | undefined;
    healthCardExpiry?: string | undefined;
    healthCardVersionCode?: string | undefined;

    constructor(data?: IGetPatientProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.patientStatus = _data["PatientStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.language = _data["Language"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.height = _data["Height"];
            this.weight = _data["Weight"];
            this.bmi = _data["Bmi"];
            if (Array.isArray(_data["Comorbidities"])) {
                this.comorbidities = [] as any;
                for (let item of _data["Comorbidities"])
                    this.comorbidities!.push(item);
            }
            this.hasPhysician = _data["HasPhysician"];
            this.childbearing = _data["Childbearing"];
            this.eatingDisorder = _data["EatingDisorder"];
            this.mentalHealthCondition = _data["MentalHealthCondition"];
            this.mentalHealthFollowup = _data["MentalHealthFollowup"];
            this.bariatricSurgery = _data["BariatricSurgery"];
            this.province = _data["Province"];
            this.gender = _data["Gender"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.phonePreference = _data["PhonePreference"];
            this.voicemail = _data["Voicemail"];
            this.enrollConsent = _data["EnrollConsent"];
            this.waitlistConsent = _data["WaitlistConsent"];
            this.physicianFirstName = _data["PhysicianFirstName"];
            this.physicianLastName = _data["PhysicianLastName"];
            this.physicianAddressStreet = _data["PhysicianAddressStreet"];
            this.physicianAddressUnit = _data["PhysicianAddressUnit"];
            this.physicianAddressPostalCode = _data["PhysicianAddressPostalCode"];
            this.physicianAddressCity = _data["PhysicianAddressCity"];
            this.physicianAddressProvince = _data["PhysicianAddressProvince"];
            this.physicianAddressCountry = _data["PhysicianAddressCountry"];
            this.physicianPhoneNumber = _data["PhysicianPhoneNumber"];
            this.physicianFaxNumber = _data["PhysicianFaxNumber"];
            this.physicianEmail = _data["PhysicianEmail"];
            this.pharmacyName = _data["PharmacyName"];
            this.pharmacyAddressStreet = _data["PharmacyAddressStreet"];
            this.pharmacyAddressPostalCode = _data["PharmacyAddressPostalCode"];
            this.pharmacyAddressCity = _data["PharmacyAddressCity"];
            this.pharmacyAddressProvince = _data["PharmacyAddressProvince"];
            this.pharmacyAddressCountry = _data["PharmacyAddressCountry"];
            this.pharmacyPhoneNumber = _data["PharmacyPhoneNumber"];
            this.pharmacyFaxNumber = _data["PharmacyFaxNumber"];
            this.privateInsurance = _data["PrivateInsurance"];
            this.addressStreet = _data["AddressStreet"];
            this.addressUnit = _data["AddressUnit"];
            this.addressPostalCode = _data["AddressPostalCode"];
            this.addressCity = _data["AddressCity"];
            this.addressProvince = _data["AddressProvince"];
            this.addressCountry = _data["AddressCountry"];
            this.billingAddressSameAsHome = _data["BillingAddressSameAsHome"];
            this.billingAddressStreet = _data["BillingAddressStreet"];
            this.billingAddressUnit = _data["BillingAddressUnit"];
            this.billingAddressCity = _data["BillingAddressCity"];
            this.billingAddressPostalCode = _data["BillingAddressPostalCode"];
            this.healthCardNumber = _data["HealthCardNumber"];
            this.healthCardExpiry = _data["HealthCardExpiry"];
            this.healthCardVersionCode = _data["HealthCardVersionCode"];
        }
    }

    static fromJS(data: any): GetPatientProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["PatientStatus"] = this.patientStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Language"] = this.language;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Height"] = this.height;
        data["Weight"] = this.weight;
        data["Bmi"] = this.bmi;
        if (Array.isArray(this.comorbidities)) {
            data["Comorbidities"] = [];
            for (let item of this.comorbidities)
                data["Comorbidities"].push(item);
        }
        data["HasPhysician"] = this.hasPhysician;
        data["Childbearing"] = this.childbearing;
        data["EatingDisorder"] = this.eatingDisorder;
        data["MentalHealthCondition"] = this.mentalHealthCondition;
        data["MentalHealthFollowup"] = this.mentalHealthFollowup;
        data["BariatricSurgery"] = this.bariatricSurgery;
        data["Province"] = this.province;
        data["Gender"] = this.gender;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["PhonePreference"] = this.phonePreference;
        data["Voicemail"] = this.voicemail;
        data["EnrollConsent"] = this.enrollConsent;
        data["WaitlistConsent"] = this.waitlistConsent;
        data["PhysicianFirstName"] = this.physicianFirstName;
        data["PhysicianLastName"] = this.physicianLastName;
        data["PhysicianAddressStreet"] = this.physicianAddressStreet;
        data["PhysicianAddressUnit"] = this.physicianAddressUnit;
        data["PhysicianAddressPostalCode"] = this.physicianAddressPostalCode;
        data["PhysicianAddressCity"] = this.physicianAddressCity;
        data["PhysicianAddressProvince"] = this.physicianAddressProvince;
        data["PhysicianAddressCountry"] = this.physicianAddressCountry;
        data["PhysicianPhoneNumber"] = this.physicianPhoneNumber;
        data["PhysicianFaxNumber"] = this.physicianFaxNumber;
        data["PhysicianEmail"] = this.physicianEmail;
        data["PharmacyName"] = this.pharmacyName;
        data["PharmacyAddressStreet"] = this.pharmacyAddressStreet;
        data["PharmacyAddressPostalCode"] = this.pharmacyAddressPostalCode;
        data["PharmacyAddressCity"] = this.pharmacyAddressCity;
        data["PharmacyAddressProvince"] = this.pharmacyAddressProvince;
        data["PharmacyAddressCountry"] = this.pharmacyAddressCountry;
        data["PharmacyPhoneNumber"] = this.pharmacyPhoneNumber;
        data["PharmacyFaxNumber"] = this.pharmacyFaxNumber;
        data["PrivateInsurance"] = this.privateInsurance;
        data["AddressStreet"] = this.addressStreet;
        data["AddressUnit"] = this.addressUnit;
        data["AddressPostalCode"] = this.addressPostalCode;
        data["AddressCity"] = this.addressCity;
        data["AddressProvince"] = this.addressProvince;
        data["AddressCountry"] = this.addressCountry;
        data["BillingAddressSameAsHome"] = this.billingAddressSameAsHome;
        data["BillingAddressStreet"] = this.billingAddressStreet;
        data["BillingAddressUnit"] = this.billingAddressUnit;
        data["BillingAddressCity"] = this.billingAddressCity;
        data["BillingAddressPostalCode"] = this.billingAddressPostalCode;
        data["HealthCardNumber"] = this.healthCardNumber;
        data["HealthCardExpiry"] = this.healthCardExpiry;
        data["HealthCardVersionCode"] = this.healthCardVersionCode;
        return data;
    }
}

export interface IGetPatientProfileResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    patientStatus: PatientStatus;
    paymentStatus: PaymentStatus;
    language?: string | undefined;
    birthDate: Date;
    height: number;
    weight: number;
    bmi: number;
    comorbidities?: string[] | undefined;
    hasPhysician: boolean;
    childbearing: boolean;
    eatingDisorder: boolean;
    mentalHealthCondition: boolean;
    mentalHealthFollowup: boolean;
    bariatricSurgery: boolean;
    province?: string | undefined;
    gender?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    phonePreference?: string | undefined;
    voicemail: boolean;
    enrollConsent: boolean;
    waitlistConsent: boolean;
    physicianFirstName?: string | undefined;
    physicianLastName?: string | undefined;
    physicianAddressStreet?: string | undefined;
    physicianAddressUnit?: string | undefined;
    physicianAddressPostalCode?: string | undefined;
    physicianAddressCity?: string | undefined;
    physicianAddressProvince?: string | undefined;
    physicianAddressCountry?: string | undefined;
    physicianPhoneNumber?: string | undefined;
    physicianFaxNumber?: string | undefined;
    physicianEmail?: string | undefined;
    pharmacyName?: string | undefined;
    pharmacyAddressStreet?: string | undefined;
    pharmacyAddressPostalCode?: string | undefined;
    pharmacyAddressCity?: string | undefined;
    pharmacyAddressProvince?: string | undefined;
    pharmacyAddressCountry?: string | undefined;
    pharmacyPhoneNumber?: string | undefined;
    pharmacyFaxNumber?: string | undefined;
    privateInsurance: boolean;
    addressStreet?: string | undefined;
    addressUnit?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressProvince?: string | undefined;
    addressCountry?: string | undefined;
    billingAddressSameAsHome: boolean;
    billingAddressStreet?: string | undefined;
    billingAddressUnit?: string | undefined;
    billingAddressCity?: string | undefined;
    billingAddressPostalCode?: string | undefined;
    healthCardNumber?: string | undefined;
    healthCardExpiry?: string | undefined;
    healthCardVersionCode?: string | undefined;
}

export enum PaymentStatus {
    Performant = 1,
    Due = 2,
    ManualPerformant = 3,
}

export class GetPendingAdminOverviewCallResponse implements IGetPendingAdminOverviewCallResponse {
    patientGuid!: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    programOverviewCallDate!: Date;

    constructor(data?: IGetPendingAdminOverviewCallResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientGuid = _data["PatientGuid"];
            this.patientUniqueId = _data["PatientUniqueId"];
            this.patientFirstName = _data["PatientFirstName"];
            this.patientLastName = _data["PatientLastName"];
            this.programOverviewCallDate = _data["ProgramOverviewCallDate"] ? new Date(_data["ProgramOverviewCallDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPendingAdminOverviewCallResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendingAdminOverviewCallResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientGuid"] = this.patientGuid;
        data["PatientUniqueId"] = this.patientUniqueId;
        data["PatientFirstName"] = this.patientFirstName;
        data["PatientLastName"] = this.patientLastName;
        data["ProgramOverviewCallDate"] = this.programOverviewCallDate ? this.programOverviewCallDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPendingAdminOverviewCallResponse {
    patientGuid: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    programOverviewCallDate: Date;
}

export class GetNonPerformantPaymentResponse implements IGetNonPerformantPaymentResponse {
    patientGuid!: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientStatus!: PatientStatus;

    constructor(data?: IGetNonPerformantPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientGuid = _data["PatientGuid"];
            this.patientUniqueId = _data["PatientUniqueId"];
            this.patientFirstName = _data["PatientFirstName"];
            this.patientLastName = _data["PatientLastName"];
            this.patientStatus = _data["PatientStatus"];
        }
    }

    static fromJS(data: any): GetNonPerformantPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNonPerformantPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientGuid"] = this.patientGuid;
        data["PatientUniqueId"] = this.patientUniqueId;
        data["PatientFirstName"] = this.patientFirstName;
        data["PatientLastName"] = this.patientLastName;
        data["PatientStatus"] = this.patientStatus;
        return data;
    }
}

export interface IGetNonPerformantPaymentResponse {
    patientGuid: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientStatus: PatientStatus;
}

export class GetMissedAppointmentsResponse implements IGetMissedAppointmentsResponse {
    patientGuid!: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    visitNumber?: number | undefined;
    timesIncomplete!: number;

    constructor(data?: IGetMissedAppointmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientGuid = _data["PatientGuid"];
            this.patientUniqueId = _data["PatientUniqueId"];
            this.patientFirstName = _data["PatientFirstName"];
            this.patientLastName = _data["PatientLastName"];
            this.visitNumber = _data["VisitNumber"];
            this.timesIncomplete = _data["TimesIncomplete"];
        }
    }

    static fromJS(data: any): GetMissedAppointmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissedAppointmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientGuid"] = this.patientGuid;
        data["PatientUniqueId"] = this.patientUniqueId;
        data["PatientFirstName"] = this.patientFirstName;
        data["PatientLastName"] = this.patientLastName;
        data["VisitNumber"] = this.visitNumber;
        data["TimesIncomplete"] = this.timesIncomplete;
        return data;
    }
}

export interface IGetMissedAppointmentsResponse {
    patientGuid: string;
    patientUniqueId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    visitNumber?: number | undefined;
    timesIncomplete: number;
}

export class MercadoPagoWebhookEvent implements IMercadoPagoWebhookEvent {
    action?: string | undefined;
    data?: MercadoPagoWebhookData | undefined;
    dateCreated!: Date;
    id!: number;
    liveMode!: boolean;
    type?: string | undefined;
    userId!: number;

    constructor(data?: IMercadoPagoWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["Action"];
            this.data = _data["Data"] ? MercadoPagoWebhookData.fromJS(_data["Data"]) : <any>undefined;
            this.dateCreated = _data["DateCreated"] ? new Date(_data["DateCreated"].toString()) : <any>undefined;
            this.id = _data["Id"];
            this.liveMode = _data["LiveMode"];
            this.type = _data["Type"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): MercadoPagoWebhookEvent {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoPagoWebhookEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Action"] = this.action;
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["Id"] = this.id;
        data["LiveMode"] = this.liveMode;
        data["Type"] = this.type;
        data["UserId"] = this.userId;
        return data;
    }
}

export interface IMercadoPagoWebhookEvent {
    action?: string | undefined;
    data?: MercadoPagoWebhookData | undefined;
    dateCreated: Date;
    id: number;
    liveMode: boolean;
    type?: string | undefined;
    userId: number;
}

export class MercadoPagoWebhookData implements IMercadoPagoWebhookData {
    id?: string | undefined;

    constructor(data?: IMercadoPagoWebhookData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): MercadoPagoWebhookData {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoPagoWebhookData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data;
    }
}

export interface IMercadoPagoWebhookData {
    id?: string | undefined;
}

export class PhysicianModel implements IPhysicianModel {
    physicianID!: string;
    internalReferenceId?: string | undefined;
    externalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    address?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified!: boolean;

    constructor(data?: IPhysicianModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.physicianID = _data["PhysicianID"];
            this.internalReferenceId = _data["InternalReferenceId"];
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.organization = _data["Organization"];
            this.specialtyGroup = _data["SpecialtyGroup"];
            this.specialtyType = _data["SpecialtyType"];
            this.address = _data["Address"];
            this.apartment = _data["Apartment"];
            this.city = _data["City"];
            this.provinceState = _data["ProvinceState"];
            this.postalZipCode = _data["PostalZipCode"];
            this.country = _data["Country"];
            this.phoneNumber = _data["PhoneNumber"];
            this.faxNumber = _data["FaxNumber"];
            this.email = _data["Email"];
            this.isVerified = _data["IsVerified"];
        }
    }

    static fromJS(data: any): PhysicianModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicianModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhysicianID"] = this.physicianID;
        data["InternalReferenceId"] = this.internalReferenceId;
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Organization"] = this.organization;
        data["SpecialtyGroup"] = this.specialtyGroup;
        data["SpecialtyType"] = this.specialtyType;
        data["Address"] = this.address;
        data["Apartment"] = this.apartment;
        data["City"] = this.city;
        data["ProvinceState"] = this.provinceState;
        data["PostalZipCode"] = this.postalZipCode;
        data["Country"] = this.country;
        data["PhoneNumber"] = this.phoneNumber;
        data["FaxNumber"] = this.faxNumber;
        data["Email"] = this.email;
        data["IsVerified"] = this.isVerified;
        return data;
    }
}

export interface IPhysicianModel {
    physicianID: string;
    internalReferenceId?: string | undefined;
    externalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    address?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified: boolean;
}

/** Request model for creating and updating a physician. */
export class CreatePhysicianModel implements ICreatePhysicianModel {
    externalReferenceId?: string | undefined;
    internalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName!: string;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    organization?: string | undefined;
    address?: string | undefined;
    city!: string;
    provinceState!: string;
    postalZipCode?: string | undefined;
    country!: string;
    apartment?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified!: boolean;

    constructor(data?: ICreatePhysicianModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalReferenceId = _data["ExternalReferenceId"];
            this.internalReferenceId = _data["InternalReferenceId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.specialtyGroup = _data["SpecialtyGroup"];
            this.specialtyType = _data["SpecialtyType"];
            this.organization = _data["Organization"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.provinceState = _data["ProvinceState"];
            this.postalZipCode = _data["PostalZipCode"];
            this.country = _data["Country"];
            this.apartment = _data["Apartment"];
            this.phoneNumber = _data["PhoneNumber"];
            this.faxNumber = _data["FaxNumber"];
            this.email = _data["Email"];
            this.isVerified = _data["IsVerified"];
        }
    }

    static fromJS(data: any): CreatePhysicianModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhysicianModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalReferenceId"] = this.externalReferenceId;
        data["InternalReferenceId"] = this.internalReferenceId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["SpecialtyGroup"] = this.specialtyGroup;
        data["SpecialtyType"] = this.specialtyType;
        data["Organization"] = this.organization;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["ProvinceState"] = this.provinceState;
        data["PostalZipCode"] = this.postalZipCode;
        data["Country"] = this.country;
        data["Apartment"] = this.apartment;
        data["PhoneNumber"] = this.phoneNumber;
        data["FaxNumber"] = this.faxNumber;
        data["Email"] = this.email;
        data["IsVerified"] = this.isVerified;
        return data;
    }
}

/** Request model for creating and updating a physician. */
export interface ICreatePhysicianModel {
    externalReferenceId?: string | undefined;
    internalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName: string;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    organization?: string | undefined;
    address?: string | undefined;
    city: string;
    provinceState: string;
    postalZipCode?: string | undefined;
    country: string;
    apartment?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified: boolean;
}

export class PaginatedResponseOfProductDto implements IPaginatedResponseOfProductDto {
    results?: ProductDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ProductDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfProductDto {
    results?: ProductDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ProductDto implements IProductDto {
    productId!: string;
    name?: string | undefined;
    description?: string | undefined;
    onlyAfterAssessment!: boolean;
    onlyBeforeAssessment!: boolean;
    productKind!: ProductKind;
    productIdentifier?: string | undefined;
    cancelAfterMonths!: number;
    isActive!: boolean;
    forPatientStatus?: PatientStatus | undefined;
    productPaymentOptions?: ProductPaymentOptionDto[] | undefined;
    patientPartnerChannel?: PatientPartnerChannel | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.onlyAfterAssessment = _data["OnlyAfterAssessment"];
            this.onlyBeforeAssessment = _data["OnlyBeforeAssessment"];
            this.productKind = _data["ProductKind"];
            this.productIdentifier = _data["ProductIdentifier"];
            this.cancelAfterMonths = _data["CancelAfterMonths"];
            this.isActive = _data["IsActive"];
            this.forPatientStatus = _data["ForPatientStatus"];
            if (Array.isArray(_data["ProductPaymentOptions"])) {
                this.productPaymentOptions = [] as any;
                for (let item of _data["ProductPaymentOptions"])
                    this.productPaymentOptions!.push(ProductPaymentOptionDto.fromJS(item));
            }
            this.patientPartnerChannel = _data["PatientPartnerChannel"];
            this.label = _data["Label"];
            this.displayPrice = _data["DisplayPrice"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["OnlyAfterAssessment"] = this.onlyAfterAssessment;
        data["OnlyBeforeAssessment"] = this.onlyBeforeAssessment;
        data["ProductKind"] = this.productKind;
        data["ProductIdentifier"] = this.productIdentifier;
        data["CancelAfterMonths"] = this.cancelAfterMonths;
        data["IsActive"] = this.isActive;
        data["ForPatientStatus"] = this.forPatientStatus;
        if (Array.isArray(this.productPaymentOptions)) {
            data["ProductPaymentOptions"] = [];
            for (let item of this.productPaymentOptions)
                data["ProductPaymentOptions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["PatientPartnerChannel"] = this.patientPartnerChannel;
        data["Label"] = this.label;
        data["DisplayPrice"] = this.displayPrice;
        return data;
    }
}

export interface IProductDto {
    productId: string;
    name?: string | undefined;
    description?: string | undefined;
    onlyAfterAssessment: boolean;
    onlyBeforeAssessment: boolean;
    productKind: ProductKind;
    productIdentifier?: string | undefined;
    cancelAfterMonths: number;
    isActive: boolean;
    forPatientStatus?: PatientStatus | undefined;
    productPaymentOptions?: ProductPaymentOptionDto[] | undefined;
    patientPartnerChannel?: PatientPartnerChannel | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;
}

export enum ProductKind {
    Maintenance = 1,
    Program = 2,
    OneTimeAppointment = 3,
}

export class ProductPaymentOptionDto implements IProductPaymentOptionDto {
    productPaymentOptionId!: string;
    paymentProvider!: PaymentProvider;
    description?: string | undefined;
    isActive!: boolean;
    externalProviderPriceId?: string | undefined;
    externalProviderProductId?: string | undefined;
    forPatientStatuses?: PatientStatus[] | undefined;

    constructor(data?: IProductPaymentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productPaymentOptionId = _data["ProductPaymentOptionId"];
            this.paymentProvider = _data["PaymentProvider"];
            this.description = _data["Description"];
            this.isActive = _data["IsActive"];
            this.externalProviderPriceId = _data["ExternalProviderPriceId"];
            this.externalProviderProductId = _data["ExternalProviderProductId"];
            if (Array.isArray(_data["ForPatientStatuses"])) {
                this.forPatientStatuses = [] as any;
                for (let item of _data["ForPatientStatuses"])
                    this.forPatientStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductPaymentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPaymentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductPaymentOptionId"] = this.productPaymentOptionId;
        data["PaymentProvider"] = this.paymentProvider;
        data["Description"] = this.description;
        data["IsActive"] = this.isActive;
        data["ExternalProviderPriceId"] = this.externalProviderPriceId;
        data["ExternalProviderProductId"] = this.externalProviderProductId;
        if (Array.isArray(this.forPatientStatuses)) {
            data["ForPatientStatuses"] = [];
            for (let item of this.forPatientStatuses)
                data["ForPatientStatuses"].push(item);
        }
        return data;
    }
}

export interface IProductPaymentOptionDto {
    productPaymentOptionId: string;
    paymentProvider: PaymentProvider;
    description?: string | undefined;
    isActive: boolean;
    externalProviderPriceId?: string | undefined;
    externalProviderProductId?: string | undefined;
    forPatientStatuses?: PatientStatus[] | undefined;
}

export enum PaymentProvider {
    Stripe = 1,
    MercadoPago = 2,
    Manual = 3,
}

export enum PatientPartnerChannel {
    UNKNOWN = 0,
    MWM = 1,
    LAUNCHIT_HEALTH = 2,
}

export abstract class PaginatedRequest implements IPaginatedRequest {
    returnCounters!: boolean;
    skip?: number | undefined;
    take!: number;
    returnAll!: boolean;

    constructor(data?: IPaginatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnCounters = _data["ReturnCounters"];
            this.skip = _data["Skip"];
            this.take = _data["Take"];
            this.returnAll = _data["ReturnAll"];
        }
    }

    static fromJS(data: any): PaginatedRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PaginatedRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReturnCounters"] = this.returnCounters;
        data["Skip"] = this.skip;
        data["Take"] = this.take;
        data["ReturnAll"] = this.returnAll;
        return data;
    }
}

export interface IPaginatedRequest {
    returnCounters: boolean;
    skip?: number | undefined;
    take: number;
    returnAll: boolean;
}

export class ParameterlessPaginatedRequest extends PaginatedRequest implements IParameterlessPaginatedRequest {

    constructor(data?: IParameterlessPaginatedRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ParameterlessPaginatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterlessPaginatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IParameterlessPaginatedRequest extends IPaginatedRequest {
}

export class ProvinceStateModel implements IProvinceStateModel {
    provinceStateID!: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;

    constructor(data?: IProvinceStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provinceStateID = _data["ProvinceStateID"];
            this.code = _data["Code"];
            this.countryCode = _data["CountryCode"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ProvinceStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProvinceStateID"] = this.provinceStateID;
        data["Code"] = this.code;
        data["CountryCode"] = this.countryCode;
        data["Name"] = this.name;
        return data;
    }
}

export interface IProvinceStateModel {
    provinceStateID: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
}

export class ReportModel implements IReportModel {
    reportID!: string;
    emailTemplateID?: number | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    name!: string;
    documentType!: DocumentType;
    documentTypeName?: string | undefined;
    reportType!: ReportType;
    reportTypeName?: string | undefined;
    createdOn!: Date;
    createdBy?: string | undefined;
    modifiedOn!: Date;
    modifiedBy?: string | undefined;
    languageCode?: string | undefined;
    reportFileName?: string | undefined;

    constructor(data?: IReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportID = _data["ReportID"];
            this.emailTemplateID = _data["EmailTemplateID"];
            this.emailRecipientType = _data["EmailRecipientType"];
            this.emailRecipientTypeName = _data["EmailRecipientTypeName"];
            this.name = _data["Name"];
            this.documentType = _data["DocumentType"];
            this.documentTypeName = _data["DocumentTypeName"];
            this.reportType = _data["ReportType"];
            this.reportTypeName = _data["ReportTypeName"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.languageCode = _data["LanguageCode"];
            this.reportFileName = _data["ReportFileName"];
        }
    }

    static fromJS(data: any): ReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportID"] = this.reportID;
        data["EmailTemplateID"] = this.emailTemplateID;
        data["EmailRecipientType"] = this.emailRecipientType;
        data["EmailRecipientTypeName"] = this.emailRecipientTypeName;
        data["Name"] = this.name;
        data["DocumentType"] = this.documentType;
        data["DocumentTypeName"] = this.documentTypeName;
        data["ReportType"] = this.reportType;
        data["ReportTypeName"] = this.reportTypeName;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["LanguageCode"] = this.languageCode;
        data["ReportFileName"] = this.reportFileName;
        return data;
    }
}

export interface IReportModel {
    reportID: string;
    emailTemplateID?: number | undefined;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    name: string;
    documentType: DocumentType;
    documentTypeName?: string | undefined;
    reportType: ReportType;
    reportTypeName?: string | undefined;
    createdOn: Date;
    createdBy?: string | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    languageCode?: string | undefined;
    reportFileName?: string | undefined;
}

export enum ReportType {
    Patient = 1,
}

export class WelcomeStudyInteractionModel implements IWelcomeStudyInteractionModel {
    interactionID!: number;
    name?: string | undefined;
    description?: string | undefined;
    interactionType!: InteractionType;
    variablePrefix?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IWelcomeStudyInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.interactionType = _data["InteractionType"];
            this.variablePrefix = _data["VariablePrefix"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): WelcomeStudyInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new WelcomeStudyInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["InteractionType"] = this.interactionType;
        data["VariablePrefix"] = this.variablePrefix;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IWelcomeStudyInteractionModel {
    interactionID: number;
    name?: string | undefined;
    description?: string | undefined;
    interactionType: InteractionType;
    variablePrefix?: string | undefined;
    isDefault: boolean;
}

export class FeedbackModel implements IFeedbackModel {
    feedbackType?: string | undefined;
    requiresResponse!: boolean;
    message?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;

    constructor(data?: IFeedbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedbackType = _data["FeedbackType"];
            this.requiresResponse = _data["RequiresResponse"];
            this.message = _data["Message"];
            this.contactEmail = _data["ContactEmail"];
            this.contactPhone = _data["ContactPhone"];
        }
    }

    static fromJS(data: any): FeedbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FeedbackType"] = this.feedbackType;
        data["RequiresResponse"] = this.requiresResponse;
        data["Message"] = this.message;
        data["ContactEmail"] = this.contactEmail;
        data["ContactPhone"] = this.contactPhone;
        return data;
    }
}

export interface IFeedbackModel {
    feedbackType?: string | undefined;
    requiresResponse: boolean;
    message?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
}

export class CalendarEventFeedModel implements ICalendarEventFeedModel {
    start!: Date;
    end!: Date;
    title?: string | undefined;
    uRL?: string | undefined;
    allDay!: boolean;
    extendedProps?: { [key: string]: any; } | undefined;

    constructor(data?: ICalendarEventFeedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["Start"] ? new Date(_data["Start"].toString()) : <any>undefined;
            this.end = _data["End"] ? new Date(_data["End"].toString()) : <any>undefined;
            this.title = _data["Title"];
            this.uRL = _data["URL"];
            this.allDay = _data["AllDay"];
            if (_data["ExtendedProps"]) {
                this.extendedProps = {} as any;
                for (let key in _data["ExtendedProps"]) {
                    if (_data["ExtendedProps"].hasOwnProperty(key))
                        (<any>this.extendedProps)![key] = _data["ExtendedProps"][key];
                }
            }
        }
    }

    static fromJS(data: any): CalendarEventFeedModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventFeedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["End"] = this.end ? this.end.toISOString() : <any>undefined;
        data["Title"] = this.title;
        data["URL"] = this.uRL;
        data["AllDay"] = this.allDay;
        if (this.extendedProps) {
            data["ExtendedProps"] = {};
            for (let key in this.extendedProps) {
                if (this.extendedProps.hasOwnProperty(key))
                    (<any>data["ExtendedProps"])[key] = (<any>this.extendedProps)[key];
            }
        }
        return data;
    }
}

export interface ICalendarEventFeedModel {
    start: Date;
    end: Date;
    title?: string | undefined;
    uRL?: string | undefined;
    allDay: boolean;
    extendedProps?: { [key: string]: any; } | undefined;
}

export class CompletePackageModel implements ICompletePackageModel {
    selectedTasks?: TaskModel[] | undefined;
    emailTemplate?: PackageEmailTemplate | undefined;
    timepointID!: number;

    constructor(data?: ICompletePackageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SelectedTasks"])) {
                this.selectedTasks = [] as any;
                for (let item of _data["SelectedTasks"])
                    this.selectedTasks!.push(TaskModel.fromJS(item));
            }
            this.emailTemplate = _data["EmailTemplate"] ? PackageEmailTemplate.fromJS(_data["EmailTemplate"]) : <any>undefined;
            this.timepointID = _data["TimepointID"];
        }
    }

    static fromJS(data: any): CompletePackageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePackageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedTasks)) {
            data["SelectedTasks"] = [];
            for (let item of this.selectedTasks)
                data["SelectedTasks"].push(item ? item.toJSON() : <any>undefined);
        }
        data["EmailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["TimepointID"] = this.timepointID;
        return data;
    }
}

export interface ICompletePackageModel {
    selectedTasks?: TaskModel[] | undefined;
    emailTemplate?: PackageEmailTemplate | undefined;
    timepointID: number;
}

export class PackageEmailTemplate implements IPackageEmailTemplate {
    subjectLine?: string | undefined;
    template?: string | undefined;
    emailTemplateID!: number;

    constructor(data?: IPackageEmailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectLine = _data["SubjectLine"];
            this.template = _data["Template"];
            this.emailTemplateID = _data["EmailTemplateID"];
        }
    }

    static fromJS(data: any): PackageEmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PackageEmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubjectLine"] = this.subjectLine;
        data["Template"] = this.template;
        data["EmailTemplateID"] = this.emailTemplateID;
        return data;
    }
}

export interface IPackageEmailTemplate {
    subjectLine?: string | undefined;
    template?: string | undefined;
    emailTemplateID: number;
}

export class EmailInteractionModel implements IEmailInteractionModel {
    emailTemplate?: PackageEmailTemplate | undefined;
    timepointID?: number | undefined;
    interactionID!: number;
    expiresOn!: Date;
    patientID!: string;

    constructor(data?: IEmailInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data["EmailTemplate"] ? PackageEmailTemplate.fromJS(_data["EmailTemplate"]) : <any>undefined;
            this.timepointID = _data["TimepointID"];
            this.interactionID = _data["InteractionID"];
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
            this.patientID = _data["PatientID"];
        }
    }

    static fromJS(data: any): EmailInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["TimepointID"] = this.timepointID;
        data["InteractionID"] = this.interactionID;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["PatientID"] = this.patientID;
        return data;
    }
}

export interface IEmailInteractionModel {
    emailTemplate?: PackageEmailTemplate | undefined;
    timepointID?: number | undefined;
    interactionID: number;
    expiresOn: Date;
    patientID: string;
}

export class CreateTriggerModel implements ICreateTriggerModel {
    interactionId!: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    emailRecipient?: string | undefined;
    type!: TriggerType;
    schedule!: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isActive!: boolean;
    isFax!: boolean;
    allowForEdited!: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments!: boolean;

    constructor(data?: ICreateTriggerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.scheduledInteractionId = _data["ScheduledInteractionId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.emailRecipient = _data["EmailRecipient"];
            this.type = _data["Type"];
            this.schedule = _data["Schedule"];
            this.scheduleLength = _data["ScheduleLength"];
            this.scheduleRange = _data["ScheduleRange"];
            this.scheduleOnDate = _data["ScheduleOnDate"] ? new Date(_data["ScheduleOnDate"].toString()) : <any>undefined;
            this.isActive = _data["IsActive"];
            this.isFax = _data["IsFax"];
            this.allowForEdited = _data["AllowForEdited"];
            this.attachmentStatus = _data["AttachmentStatus"];
            this.categoryID = _data["CategoryID"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
        }
    }

    static fromJS(data: any): CreateTriggerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTriggerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["ScheduledInteractionId"] = this.scheduledInteractionId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["EmailRecipient"] = this.emailRecipient;
        data["Type"] = this.type;
        data["Schedule"] = this.schedule;
        data["ScheduleLength"] = this.scheduleLength;
        data["ScheduleRange"] = this.scheduleRange;
        data["ScheduleOnDate"] = this.scheduleOnDate ? this.scheduleOnDate.toISOString() : <any>undefined;
        data["IsActive"] = this.isActive;
        data["IsFax"] = this.isFax;
        data["AllowForEdited"] = this.allowForEdited;
        data["AttachmentStatus"] = this.attachmentStatus;
        data["CategoryID"] = this.categoryID;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        return data;
    }
}

export interface ICreateTriggerModel {
    interactionId: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    emailRecipient?: string | undefined;
    type: TriggerType;
    schedule: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isActive: boolean;
    isFax: boolean;
    allowForEdited: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments: boolean;
}

export class UpdateTriggerModel implements IUpdateTriggerModel {
    triggerId!: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    emailRecipient?: string | undefined;
    type!: TriggerType;
    schedule!: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isActive!: boolean;
    isFax!: boolean;
    allowForEdited!: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments!: boolean;

    constructor(data?: IUpdateTriggerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggerId = _data["TriggerId"];
            this.scheduledInteractionId = _data["ScheduledInteractionId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.emailRecipient = _data["EmailRecipient"];
            this.type = _data["Type"];
            this.schedule = _data["Schedule"];
            this.scheduleLength = _data["ScheduleLength"];
            this.scheduleRange = _data["ScheduleRange"];
            this.scheduleOnDate = _data["ScheduleOnDate"] ? new Date(_data["ScheduleOnDate"].toString()) : <any>undefined;
            this.isActive = _data["IsActive"];
            this.isFax = _data["IsFax"];
            this.allowForEdited = _data["AllowForEdited"];
            this.attachmentStatus = _data["AttachmentStatus"];
            this.categoryID = _data["CategoryID"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
        }
    }

    static fromJS(data: any): UpdateTriggerModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTriggerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TriggerId"] = this.triggerId;
        data["ScheduledInteractionId"] = this.scheduledInteractionId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["EmailRecipient"] = this.emailRecipient;
        data["Type"] = this.type;
        data["Schedule"] = this.schedule;
        data["ScheduleLength"] = this.scheduleLength;
        data["ScheduleRange"] = this.scheduleRange;
        data["ScheduleOnDate"] = this.scheduleOnDate ? this.scheduleOnDate.toISOString() : <any>undefined;
        data["IsActive"] = this.isActive;
        data["IsFax"] = this.isFax;
        data["AllowForEdited"] = this.allowForEdited;
        data["AttachmentStatus"] = this.attachmentStatus;
        data["CategoryID"] = this.categoryID;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        return data;
    }
}

export interface IUpdateTriggerModel {
    triggerId: number;
    scheduledInteractionId?: number | undefined;
    emailTemplateId?: number | undefined;
    reportTemplateId?: string | undefined;
    emailRecipient?: string | undefined;
    type: TriggerType;
    schedule: TriggerSchedule;
    scheduleLength?: number | undefined;
    scheduleRange?: TriggerScheduleRange | undefined;
    scheduleOnDate?: Date | undefined;
    isActive: boolean;
    isFax: boolean;
    allowForEdited: boolean;
    attachmentStatus?: AttachmentStatus | undefined;
    categoryID?: string | undefined;
    softDeletePreviouslyCreatedAttachments: boolean;
}

export class StudyBrandingModel implements IStudyBrandingModel {
    primaryColor?: string | undefined;

    constructor(data?: IStudyBrandingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["PrimaryColor"];
        }
    }

    static fromJS(data: any): StudyBrandingModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyBrandingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryColor"] = this.primaryColor;
        return data;
    }
}

export interface IStudyBrandingModel {
    primaryColor?: string | undefined;
}

export class UpdateStudyBrandingModel implements IUpdateStudyBrandingModel {
    primaryColor!: string;

    constructor(data?: IUpdateStudyBrandingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["PrimaryColor"];
        }
    }

    static fromJS(data: any): UpdateStudyBrandingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyBrandingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryColor"] = this.primaryColor;
        return data;
    }
}

export interface IUpdateStudyBrandingModel {
    primaryColor: string;
}

export class StudyLanguageResult implements IStudyLanguageResult {
    language!: LanguageResult;
    isEnabled!: boolean;

    constructor(data?: IStudyLanguageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new LanguageResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["Language"] ? LanguageResult.fromJS(_data["Language"]) : new LanguageResult();
            this.isEnabled = _data["IsEnabled"];
        }
    }

    static fromJS(data: any): StudyLanguageResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyLanguageResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["IsEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IStudyLanguageResult {
    language: LanguageResult;
    isEnabled: boolean;
}

export class LanguageResultQModel implements ILanguageResultQModel {
    code!: string;
    name?: string | undefined;

    constructor(data?: ILanguageResultQModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): LanguageResultQModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageResultQModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        return data;
    }
}

export interface ILanguageResultQModel {
    code: string;
    name?: string | undefined;
}

export class LanguageResult extends LanguageResultQModel implements ILanguageResult {
    code!: string;
    name?: string | undefined;

    constructor(data?: ILanguageResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): LanguageResult {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageResult extends ILanguageResultQModel {
    code: string;
    name?: string | undefined;
}

export class StudyLanguageApiModel implements IStudyLanguageApiModel {
    /** The new set of languages that the study will support.
Languages in this list will be enabled, missing languages will be disabled. */
    languageCodes?: string[] | undefined;

    constructor(data?: IStudyLanguageApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LanguageCodes"])) {
                this.languageCodes = [] as any;
                for (let item of _data["LanguageCodes"])
                    this.languageCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyLanguageApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyLanguageApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languageCodes)) {
            data["LanguageCodes"] = [];
            for (let item of this.languageCodes)
                data["LanguageCodes"].push(item);
        }
        return data;
    }
}

export interface IStudyLanguageApiModel {
    /** The new set of languages that the study will support.
Languages in this list will be enabled, missing languages will be disabled. */
    languageCodes?: string[] | undefined;
}

export class UpdateFaxModel implements IUpdateFaxModel {
    id?: string | undefined;
    studyId!: string;
    faxNumber!: string;
    label!: string;

    constructor(data?: IUpdateFaxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.faxNumber = _data["FaxNumber"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): UpdateFaxModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFaxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["FaxNumber"] = this.faxNumber;
        data["Label"] = this.label;
        return data;
    }
}

export interface IUpdateFaxModel {
    id?: string | undefined;
    studyId: string;
    faxNumber: string;
    label: string;
}

export enum InteractionHeading {
    Visit = 1,
    Utility = 2,
    PatientProfileManagement = 3,
}

export class GetInteractionHeadingsResponse implements IGetInteractionHeadingsResponse {
    interactionID!: number;
    interactionTitle?: string | undefined;
    heading!: InteractionHeading;

    constructor(data?: IGetInteractionHeadingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.interactionTitle = _data["InteractionTitle"];
            this.heading = _data["Heading"];
        }
    }

    static fromJS(data: any): GetInteractionHeadingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractionHeadingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["InteractionTitle"] = this.interactionTitle;
        data["Heading"] = this.heading;
        return data;
    }
}

export interface IGetInteractionHeadingsResponse {
    interactionID: number;
    interactionTitle?: string | undefined;
    heading: InteractionHeading;
}

export class GetInteractionsResponse implements IGetInteractionsResponse {
    interactionID!: number;
    interactionTitle?: string | undefined;
    behaviourName?: string | undefined;

    constructor(data?: IGetInteractionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.interactionTitle = _data["InteractionTitle"];
            this.behaviourName = _data["BehaviourName"];
        }
    }

    static fromJS(data: any): GetInteractionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["InteractionTitle"] = this.interactionTitle;
        data["BehaviourName"] = this.behaviourName;
        return data;
    }
}

export interface IGetInteractionsResponse {
    interactionID: number;
    interactionTitle?: string | undefined;
    behaviourName?: string | undefined;
}

export class GetAvailableBehavioursResponse implements IGetAvailableBehavioursResponse {
    name?: string | undefined;
    fullClassName?: string | undefined;

    constructor(data?: IGetAvailableBehavioursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.fullClassName = _data["FullClassName"];
        }
    }

    static fromJS(data: any): GetAvailableBehavioursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableBehavioursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["FullClassName"] = this.fullClassName;
        return data;
    }
}

export interface IGetAvailableBehavioursResponse {
    name?: string | undefined;
    fullClassName?: string | undefined;
}

export class GetInteractionPatientStatusVisibilityResponse implements IGetInteractionPatientStatusVisibilityResponse {
    interactionID!: number;
    interactionTitle?: string | undefined;
    visibleToPatientStatuses?: PatientStatus[] | undefined;

    constructor(data?: IGetInteractionPatientStatusVisibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.interactionTitle = _data["InteractionTitle"];
            if (Array.isArray(_data["VisibleToPatientStatuses"])) {
                this.visibleToPatientStatuses = [] as any;
                for (let item of _data["VisibleToPatientStatuses"])
                    this.visibleToPatientStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): GetInteractionPatientStatusVisibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractionPatientStatusVisibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["InteractionTitle"] = this.interactionTitle;
        if (Array.isArray(this.visibleToPatientStatuses)) {
            data["VisibleToPatientStatuses"] = [];
            for (let item of this.visibleToPatientStatuses)
                data["VisibleToPatientStatuses"].push(item);
        }
        return data;
    }
}

export interface IGetInteractionPatientStatusVisibilityResponse {
    interactionID: number;
    interactionTitle?: string | undefined;
    visibleToPatientStatuses?: PatientStatus[] | undefined;
}

export class PharmacyModel implements IPharmacyModel {
    pharmacyID!: string;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified!: boolean;

    constructor(data?: IPharmacyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyID = _data["PharmacyID"];
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.provinceState = _data["ProvinceState"];
            this.postalZipCode = _data["PostalZipCode"];
            this.country = _data["Country"];
            this.phoneNumber = _data["PhoneNumber"];
            this.faxNumber = _data["FaxNumber"];
            this.email = _data["Email"];
            this.isVerified = _data["IsVerified"];
        }
    }

    static fromJS(data: any): PharmacyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PharmacyID"] = this.pharmacyID;
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["ProvinceState"] = this.provinceState;
        data["PostalZipCode"] = this.postalZipCode;
        data["Country"] = this.country;
        data["PhoneNumber"] = this.phoneNumber;
        data["FaxNumber"] = this.faxNumber;
        data["Email"] = this.email;
        data["IsVerified"] = this.isVerified;
        return data;
    }
}

export interface IPharmacyModel {
    pharmacyID: string;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified: boolean;
}

export class CreatePharmacyModel implements ICreatePharmacyModel {
    name!: string;
    address?: string | undefined;
    city!: string;
    provinceState!: string;
    postalZipCode?: string | undefined;
    country!: string;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified!: boolean;

    constructor(data?: ICreatePharmacyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.provinceState = _data["ProvinceState"];
            this.postalZipCode = _data["PostalZipCode"];
            this.country = _data["Country"];
            this.phoneNumber = _data["PhoneNumber"];
            this.faxNumber = _data["FaxNumber"];
            this.email = _data["Email"];
            this.isVerified = _data["IsVerified"];
        }
    }

    static fromJS(data: any): CreatePharmacyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePharmacyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["ProvinceState"] = this.provinceState;
        data["PostalZipCode"] = this.postalZipCode;
        data["Country"] = this.country;
        data["PhoneNumber"] = this.phoneNumber;
        data["FaxNumber"] = this.faxNumber;
        data["Email"] = this.email;
        data["IsVerified"] = this.isVerified;
        return data;
    }
}

export interface ICreatePharmacyModel {
    name: string;
    address?: string | undefined;
    city: string;
    provinceState: string;
    postalZipCode?: string | undefined;
    country: string;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified: boolean;
}

export class PaginatedResponseOfPatientPaymentTransactionHistory implements IPaginatedResponseOfPatientPaymentTransactionHistory {
    results?: PatientPaymentTransactionHistory[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfPatientPaymentTransactionHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(PatientPaymentTransactionHistory.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPatientPaymentTransactionHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPatientPaymentTransactionHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfPatientPaymentTransactionHistory {
    results?: PatientPaymentTransactionHistory[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PatientPaymentTransactionHistory implements IPatientPaymentTransactionHistory {
    paymentTransactionId!: string;
    identifier?: string | undefined;
    createdOn!: Date;
    amount!: number;
    success!: boolean;
    transactionType!: TransactionTypePayment;
    message?: string | undefined;
    transactionDescription?: string | undefined;

    constructor(data?: IPatientPaymentTransactionHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentTransactionId = _data["PaymentTransactionId"];
            this.identifier = _data["Identifier"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.success = _data["Success"];
            this.transactionType = _data["TransactionType"];
            this.message = _data["Message"];
            this.transactionDescription = _data["TransactionDescription"];
        }
    }

    static fromJS(data: any): PatientPaymentTransactionHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPaymentTransactionHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaymentTransactionId"] = this.paymentTransactionId;
        data["Identifier"] = this.identifier;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Success"] = this.success;
        data["TransactionType"] = this.transactionType;
        data["Message"] = this.message;
        data["TransactionDescription"] = this.transactionDescription;
        return data;
    }
}

export interface IPatientPaymentTransactionHistory {
    paymentTransactionId: string;
    identifier?: string | undefined;
    createdOn: Date;
    amount: number;
    success: boolean;
    transactionType: TransactionTypePayment;
    message?: string | undefined;
    transactionDescription?: string | undefined;
}

export enum TransactionTypePayment {
    Purchase = 1,
    Refund = 2,
}

export class PaginatedRequestOfGuid extends PaginatedRequest implements IPaginatedRequestOfGuid {
    filters!: string;

    constructor(data?: IPaginatedRequestOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filters = _data["Filters"];
        }
    }

    static fromJS(data: any): PaginatedRequestOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequestOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filters"] = this.filters;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedRequestOfGuid extends IPaginatedRequest {
    filters: string;
}

export class PaginatedResponseOfPatientPaymentTransactionLinkHistory implements IPaginatedResponseOfPatientPaymentTransactionLinkHistory {
    results?: PatientPaymentTransactionLinkHistory[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfPatientPaymentTransactionLinkHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(PatientPaymentTransactionLinkHistory.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPatientPaymentTransactionLinkHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPatientPaymentTransactionLinkHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfPatientPaymentTransactionLinkHistory {
    results?: PatientPaymentTransactionLinkHistory[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PatientPaymentTransactionLinkHistory implements IPatientPaymentTransactionLinkHistory {
    paymentLinkId!: string;
    createdOn!: Date;
    amount!: number;
    success!: boolean;

    constructor(data?: IPatientPaymentTransactionLinkHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLinkId = _data["PaymentLinkId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): PatientPaymentTransactionLinkHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPaymentTransactionLinkHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaymentLinkId"] = this.paymentLinkId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Success"] = this.success;
        return data;
    }
}

export interface IPatientPaymentTransactionLinkHistory {
    paymentLinkId: string;
    createdOn: Date;
    amount: number;
    success: boolean;
}

export class PatientSubscriptionStatusDto implements IPatientSubscriptionStatusDto {
    startDateUtc!: Date;
    status?: string | undefined;
    planName?: string | undefined;
    amount?: string | undefined;
    interval?: string | undefined;

    constructor(data?: IPatientSubscriptionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateUtc = _data["StartDateUtc"] ? new Date(_data["StartDateUtc"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.planName = _data["PlanName"];
            this.amount = _data["Amount"];
            this.interval = _data["Interval"];
        }
    }

    static fromJS(data: any): PatientSubscriptionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSubscriptionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDateUtc"] = this.startDateUtc ? this.startDateUtc.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["PlanName"] = this.planName;
        data["Amount"] = this.amount;
        data["Interval"] = this.interval;
        return data;
    }
}

export interface IPatientSubscriptionStatusDto {
    startDateUtc: Date;
    status?: string | undefined;
    planName?: string | undefined;
    amount?: string | undefined;
    interval?: string | undefined;
}

export class CreateInteractionResponseModel implements ICreateInteractionResponseModel {
    interactionId!: number;

    constructor(data?: ICreateInteractionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
        }
    }

    static fromJS(data: any): CreateInteractionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInteractionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        return data;
    }
}

export interface ICreateInteractionResponseModel {
    interactionId: number;
}

export class CreateInteractionRequestModel implements ICreateInteractionRequestModel {
    studyId!: string;
    interactionName?: string | undefined;

    constructor(data?: ICreateInteractionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.interactionName = _data["InteractionName"];
        }
    }

    static fromJS(data: any): CreateInteractionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInteractionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["InteractionName"] = this.interactionName;
        return data;
    }
}

export interface ICreateInteractionRequestModel {
    studyId: string;
    interactionName?: string | undefined;
}

export class InteractionEditModel implements IInteractionEditModel {
    interactionID!: number;
    studyID!: string;
    name?: string | undefined;
    interactionType!: InteractionType;
    variablePrefix?: string | undefined;
    noteType!: InteractionNoteType;
    faxNumberId?: string | undefined;
    questions!: QuestionEditModel[];
    studyLanguages?: LanguageResultQModel[] | undefined;
    interactionTranslations!: InteractionTranslationEditModel[];
    triggers!: TriggerEditModel[];

    constructor(data?: IInteractionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
            this.interactionTranslations = [];
            this.triggers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionID = _data["InteractionID"];
            this.studyID = _data["StudyID"];
            this.name = _data["Name"];
            this.interactionType = _data["InteractionType"];
            this.variablePrefix = _data["VariablePrefix"];
            this.noteType = _data["NoteType"];
            this.faxNumberId = _data["FaxNumberId"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(QuestionEditModel.fromJS(item));
            }
            if (Array.isArray(_data["StudyLanguages"])) {
                this.studyLanguages = [] as any;
                for (let item of _data["StudyLanguages"])
                    this.studyLanguages!.push(LanguageResultQModel.fromJS(item));
            }
            if (Array.isArray(_data["InteractionTranslations"])) {
                this.interactionTranslations = [] as any;
                for (let item of _data["InteractionTranslations"])
                    this.interactionTranslations!.push(InteractionTranslationEditModel.fromJS(item));
            }
            if (Array.isArray(_data["Triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["Triggers"])
                    this.triggers!.push(TriggerEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionID"] = this.interactionID;
        data["StudyID"] = this.studyID;
        data["Name"] = this.name;
        data["InteractionType"] = this.interactionType;
        data["VariablePrefix"] = this.variablePrefix;
        data["NoteType"] = this.noteType;
        data["FaxNumberId"] = this.faxNumberId;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.studyLanguages)) {
            data["StudyLanguages"] = [];
            for (let item of this.studyLanguages)
                data["StudyLanguages"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.interactionTranslations)) {
            data["InteractionTranslations"] = [];
            for (let item of this.interactionTranslations)
                data["InteractionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.triggers)) {
            data["Triggers"] = [];
            for (let item of this.triggers)
                data["Triggers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionEditModel {
    interactionID: number;
    studyID: string;
    name?: string | undefined;
    interactionType: InteractionType;
    variablePrefix?: string | undefined;
    noteType: InteractionNoteType;
    faxNumberId?: string | undefined;
    questions: QuestionEditModel[];
    studyLanguages?: LanguageResultQModel[] | undefined;
    interactionTranslations: InteractionTranslationEditModel[];
    triggers: TriggerEditModel[];
}

export class QuestionEditModel implements IQuestionEditModel {
    questionID!: number;
    interactionID!: number;
    uniqueCode?: string | undefined;
    position!: number;
    label?: string | undefined;
    instruction?: string | undefined;
    required!: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    isRange!: boolean;
    isRepeatable!: boolean;
    isIdentifying!: boolean;
    optionsJsonMigration?: string | undefined;
    defaultValueType?: DefaultValueType | undefined;
    options!: QuestionOptionMigration[];
    hasOptions!: boolean;
    extendedOptions!: ExtendedOptionsObjectMigration;
    questionType!: QuestionType;
    visibility!: QuestionVisibility;
    grouping!: Grouping;
    questionTranslations!: QuestionTranslationEditModel[];
    displayCondition?: DisplayRuleGroupEditModel | undefined;
    subCodes!: string[];

    constructor(data?: IQuestionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
            this.extendedOptions = new ExtendedOptionsObjectMigration();
            this.questionTranslations = [];
            this.subCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionID = _data["QuestionID"];
            this.interactionID = _data["InteractionID"];
            this.uniqueCode = _data["UniqueCode"];
            this.position = _data["Position"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.required = _data["Required"];
            this.minValue = _data["MinValue"];
            this.maxValue = _data["MaxValue"];
            this.isRange = _data["IsRange"];
            this.isRepeatable = _data["IsRepeatable"];
            this.isIdentifying = _data["IsIdentifying"];
            this.optionsJsonMigration = _data["OptionsJsonMigration"];
            this.defaultValueType = _data["DefaultValueType"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(QuestionOptionMigration.fromJS(item));
            }
            this.hasOptions = _data["HasOptions"];
            this.extendedOptions = _data["ExtendedOptions"] ? ExtendedOptionsObjectMigration.fromJS(_data["ExtendedOptions"]) : new ExtendedOptionsObjectMigration();
            this.questionType = _data["QuestionType"];
            this.visibility = _data["Visibility"];
            this.grouping = _data["Grouping"];
            if (Array.isArray(_data["QuestionTranslations"])) {
                this.questionTranslations = [] as any;
                for (let item of _data["QuestionTranslations"])
                    this.questionTranslations!.push(QuestionTranslationEditModel.fromJS(item));
            }
            this.displayCondition = _data["DisplayCondition"] ? DisplayRuleGroupEditModel.fromJS(_data["DisplayCondition"]) : <any>undefined;
            if (Array.isArray(_data["SubCodes"])) {
                this.subCodes = [] as any;
                for (let item of _data["SubCodes"])
                    this.subCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionID"] = this.questionID;
        data["InteractionID"] = this.interactionID;
        data["UniqueCode"] = this.uniqueCode;
        data["Position"] = this.position;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["Required"] = this.required;
        data["MinValue"] = this.minValue;
        data["MaxValue"] = this.maxValue;
        data["IsRange"] = this.isRange;
        data["IsRepeatable"] = this.isRepeatable;
        data["IsIdentifying"] = this.isIdentifying;
        data["OptionsJsonMigration"] = this.optionsJsonMigration;
        data["DefaultValueType"] = this.defaultValueType;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : <any>undefined);
        }
        data["HasOptions"] = this.hasOptions;
        data["ExtendedOptions"] = this.extendedOptions ? this.extendedOptions.toJSON() : <any>undefined;
        data["QuestionType"] = this.questionType;
        data["Visibility"] = this.visibility;
        data["Grouping"] = this.grouping;
        if (Array.isArray(this.questionTranslations)) {
            data["QuestionTranslations"] = [];
            for (let item of this.questionTranslations)
                data["QuestionTranslations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["DisplayCondition"] = this.displayCondition ? this.displayCondition.toJSON() : <any>undefined;
        if (Array.isArray(this.subCodes)) {
            data["SubCodes"] = [];
            for (let item of this.subCodes)
                data["SubCodes"].push(item);
        }
        return data;
    }
}

export interface IQuestionEditModel {
    questionID: number;
    interactionID: number;
    uniqueCode?: string | undefined;
    position: number;
    label?: string | undefined;
    instruction?: string | undefined;
    required: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    isRange: boolean;
    isRepeatable: boolean;
    isIdentifying: boolean;
    optionsJsonMigration?: string | undefined;
    defaultValueType?: DefaultValueType | undefined;
    options: QuestionOptionMigration[];
    hasOptions: boolean;
    extendedOptions: ExtendedOptionsObjectMigration;
    questionType: QuestionType;
    visibility: QuestionVisibility;
    grouping: Grouping;
    questionTranslations: QuestionTranslationEditModel[];
    displayCondition?: DisplayRuleGroupEditModel | undefined;
    subCodes: string[];
}

export class QuestionTranslationEditModel implements IQuestionTranslationEditModel {
    language?: string | undefined;
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    otherLabel?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IQuestionTranslationEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.validationMessage = _data["ValidationMessage"];
            this.otherLabel = _data["OtherLabel"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): QuestionTranslationEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTranslationEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["ValidationMessage"] = this.validationMessage;
        data["OtherLabel"] = this.otherLabel;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IQuestionTranslationEditModel {
    language?: string | undefined;
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    otherLabel?: string | undefined;
    isDefault: boolean;
}

export class DisplayRuleGroupEditModel implements IDisplayRuleGroupEditModel {
    comparison!: RuleComparison;
    groups?: DisplayRuleGroupEditModel[] | undefined;
    conditions?: DisplayRulesEditModel[] | undefined;

    constructor(data?: IDisplayRuleGroupEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comparison = _data["Comparison"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(DisplayRuleGroupEditModel.fromJS(item));
            }
            if (Array.isArray(_data["Conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["Conditions"])
                    this.conditions!.push(DisplayRulesEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisplayRuleGroupEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayRuleGroupEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Comparison"] = this.comparison;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.conditions)) {
            data["Conditions"] = [];
            for (let item of this.conditions)
                data["Conditions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDisplayRuleGroupEditModel {
    comparison: RuleComparison;
    groups?: DisplayRuleGroupEditModel[] | undefined;
    conditions?: DisplayRulesEditModel[] | undefined;
}

export enum RuleComparison {
    And = 0,
    Or = 1,
}

export class DisplayRulesEditModel implements IDisplayRulesEditModel {
    questionId!: number;
    subCode?: string | undefined;
    operator!: RuleOperator;
    value?: string | undefined;

    constructor(data?: IDisplayRulesEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.subCode = _data["SubCode"];
            this.operator = _data["Operator"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): DisplayRulesEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayRulesEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["SubCode"] = this.subCode;
        data["Operator"] = this.operator;
        data["Value"] = this.value;
        return data;
    }
}

export interface IDisplayRulesEditModel {
    questionId: number;
    subCode?: string | undefined;
    operator: RuleOperator;
    value?: string | undefined;
}

export enum RuleOperator {
    IsBlank = 1,
    IsNotBlank = 2,
    StartsWith = 3,
    EndsWith = 4,
    Contains = 5,
    Equals = 6,
    GreaterThan = 7,
    LessThan = 8,
    DoesNotContain = 9,
    DoesNotEqual = 10,
}

export class InteractionTranslationEditModel implements IInteractionTranslationEditModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IInteractionTranslationEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.language = _data["Language"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): InteractionTranslationEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionTranslationEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Language"] = this.language;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IInteractionTranslationEditModel {
    languageCode?: string | undefined;
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
}

export class TriggerEditModel implements ITriggerEditModel {
    triggerId!: number;
    type!: TriggerType;
    reportTemplateId?: string | undefined;
    attachmentCategoryId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited!: boolean;
    isActive!: boolean;
    softDeletePreviouslyCreatedAttachments!: boolean;

    constructor(data?: ITriggerEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggerId = _data["TriggerId"];
            this.type = _data["Type"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.attachmentCategoryId = _data["AttachmentCategoryId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.allowForEdited = _data["AllowForEdited"];
            this.isActive = _data["IsActive"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
        }
    }

    static fromJS(data: any): TriggerEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TriggerId"] = this.triggerId;
        data["Type"] = this.type;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["AttachmentCategoryId"] = this.attachmentCategoryId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["AllowForEdited"] = this.allowForEdited;
        data["IsActive"] = this.isActive;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        return data;
    }
}

export interface ITriggerEditModel {
    triggerId: number;
    type: TriggerType;
    reportTemplateId?: string | undefined;
    attachmentCategoryId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited: boolean;
    isActive: boolean;
    softDeletePreviouslyCreatedAttachments: boolean;
}

export class UpdateInteractionRequestModel implements IUpdateInteractionRequestModel {
    interactionId!: number;
    interactionType!: InteractionType;
    faxNumberId?: string | undefined;
    translations?: UpdateInteractionTranslationRequestModel[] | undefined;
    variablePrefix?: string | undefined;
    noteType!: InteractionNoteType;

    constructor(data?: IUpdateInteractionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.interactionType = _data["InteractionType"];
            this.faxNumberId = _data["FaxNumberId"];
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(UpdateInteractionTranslationRequestModel.fromJS(item));
            }
            this.variablePrefix = _data["VariablePrefix"];
            this.noteType = _data["NoteType"];
        }
    }

    static fromJS(data: any): UpdateInteractionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInteractionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["InteractionType"] = this.interactionType;
        data["FaxNumberId"] = this.faxNumberId;
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["VariablePrefix"] = this.variablePrefix;
        data["NoteType"] = this.noteType;
        return data;
    }
}

export interface IUpdateInteractionRequestModel {
    interactionId: number;
    interactionType: InteractionType;
    faxNumberId?: string | undefined;
    translations?: UpdateInteractionTranslationRequestModel[] | undefined;
    variablePrefix?: string | undefined;
    noteType: InteractionNoteType;
}

export class UpdateInteractionTranslationRequestModel implements IUpdateInteractionTranslationRequestModel {
    languageCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IUpdateInteractionTranslationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): UpdateInteractionTranslationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInteractionTranslationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateInteractionTranslationRequestModel {
    languageCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault: boolean;
}

export class SaveQuestionRequestModel implements ISaveQuestionRequestModel {
    questionId!: number;
    name?: string | undefined;
    uniqueCode?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    decimals?: number | undefined;
    isRepeatable!: boolean;
    isRange!: boolean;
    isRequired!: boolean;
    grouping!: Grouping;
    options?: UpdateQuestionOptionRequestModel[] | undefined;
    translations?: UpdateQuestionTranslationRequestModel[] | undefined;
    displayRule?: UpdateQuestionRuleGroupModel | undefined;
    extendedOptions?: UpdateQuestionExtendedOptionsRequestModel | undefined;
    isIdentifying!: boolean;

    constructor(data?: ISaveQuestionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.name = _data["Name"];
            this.uniqueCode = _data["UniqueCode"];
            this.minValue = _data["MinValue"];
            this.maxValue = _data["MaxValue"];
            this.decimals = _data["Decimals"];
            this.isRepeatable = _data["IsRepeatable"];
            this.isRange = _data["IsRange"];
            this.isRequired = _data["IsRequired"];
            this.grouping = _data["Grouping"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(UpdateQuestionOptionRequestModel.fromJS(item));
            }
            if (Array.isArray(_data["Translations"])) {
                this.translations = [] as any;
                for (let item of _data["Translations"])
                    this.translations!.push(UpdateQuestionTranslationRequestModel.fromJS(item));
            }
            this.displayRule = _data["DisplayRule"] ? UpdateQuestionRuleGroupModel.fromJS(_data["DisplayRule"]) : <any>undefined;
            this.extendedOptions = _data["ExtendedOptions"] ? UpdateQuestionExtendedOptionsRequestModel.fromJS(_data["ExtendedOptions"]) : <any>undefined;
            this.isIdentifying = _data["IsIdentifying"];
        }
    }

    static fromJS(data: any): SaveQuestionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQuestionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["Name"] = this.name;
        data["UniqueCode"] = this.uniqueCode;
        data["MinValue"] = this.minValue;
        data["MaxValue"] = this.maxValue;
        data["Decimals"] = this.decimals;
        data["IsRepeatable"] = this.isRepeatable;
        data["IsRange"] = this.isRange;
        data["IsRequired"] = this.isRequired;
        data["Grouping"] = this.grouping;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.translations)) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["DisplayRule"] = this.displayRule ? this.displayRule.toJSON() : <any>undefined;
        data["ExtendedOptions"] = this.extendedOptions ? this.extendedOptions.toJSON() : <any>undefined;
        data["IsIdentifying"] = this.isIdentifying;
        return data;
    }
}

export interface ISaveQuestionRequestModel {
    questionId: number;
    name?: string | undefined;
    uniqueCode?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    decimals?: number | undefined;
    isRepeatable: boolean;
    isRange: boolean;
    isRequired: boolean;
    grouping: Grouping;
    options?: UpdateQuestionOptionRequestModel[] | undefined;
    translations?: UpdateQuestionTranslationRequestModel[] | undefined;
    displayRule?: UpdateQuestionRuleGroupModel | undefined;
    extendedOptions?: UpdateQuestionExtendedOptionsRequestModel | undefined;
    isIdentifying: boolean;
}

export class UpdateQuestionOptionRequestModel implements IUpdateQuestionOptionRequestModel {
    code?: string | undefined;
    score!: number;
    labels?: UpdateOptionLabelRequestModel[] | undefined;

    constructor(data?: IUpdateQuestionOptionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.score = _data["Score"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(UpdateOptionLabelRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionOptionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionOptionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Score"] = this.score;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateQuestionOptionRequestModel {
    code?: string | undefined;
    score: number;
    labels?: UpdateOptionLabelRequestModel[] | undefined;
}

export class UpdateOptionLabelRequestModel implements IUpdateOptionLabelRequestModel {
    languageCode?: string | undefined;
    label?: string | undefined;

    constructor(data?: IUpdateOptionLabelRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): UpdateOptionLabelRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOptionLabelRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Label"] = this.label;
        return data;
    }
}

export interface IUpdateOptionLabelRequestModel {
    languageCode?: string | undefined;
    label?: string | undefined;
}

export class UpdateQuestionTranslationRequestModel implements IUpdateQuestionTranslationRequestModel {
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    otherLabel?: string | undefined;
    isDefault!: boolean;

    constructor(data?: IUpdateQuestionTranslationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["LanguageCode"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.validationMessage = _data["ValidationMessage"];
            this.otherLabel = _data["OtherLabel"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): UpdateQuestionTranslationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionTranslationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LanguageCode"] = this.languageCode;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["ValidationMessage"] = this.validationMessage;
        data["OtherLabel"] = this.otherLabel;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateQuestionTranslationRequestModel {
    languageCode?: string | undefined;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    otherLabel?: string | undefined;
    isDefault: boolean;
}

export class UpdateQuestionRuleGroupModel implements IUpdateQuestionRuleGroupModel {
    comparison!: RuleComparison;
    groups?: UpdateQuestionRuleGroupModel[] | undefined;
    conditions?: UpdateQuestionConditionModel[] | undefined;

    constructor(data?: IUpdateQuestionRuleGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comparison = _data["Comparison"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(UpdateQuestionRuleGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["Conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["Conditions"])
                    this.conditions!.push(UpdateQuestionConditionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionRuleGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionRuleGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Comparison"] = this.comparison;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.conditions)) {
            data["Conditions"] = [];
            for (let item of this.conditions)
                data["Conditions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateQuestionRuleGroupModel {
    comparison: RuleComparison;
    groups?: UpdateQuestionRuleGroupModel[] | undefined;
    conditions?: UpdateQuestionConditionModel[] | undefined;
}

export class UpdateQuestionConditionModel implements IUpdateQuestionConditionModel {
    questionId!: number;
    subCode?: string | undefined;
    operator!: RuleOperator;
    value?: string | undefined;

    constructor(data?: IUpdateQuestionConditionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.subCode = _data["SubCode"];
            this.operator = _data["Operator"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): UpdateQuestionConditionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionConditionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["SubCode"] = this.subCode;
        data["Operator"] = this.operator;
        data["Value"] = this.value;
        return data;
    }
}

export interface IUpdateQuestionConditionModel {
    questionId: number;
    subCode?: string | undefined;
    operator: RuleOperator;
    value?: string | undefined;
}

export class UpdateQuestionExtendedOptionsRequestModel implements IUpdateQuestionExtendedOptionsRequestModel {
    optionGroups?: UpdateQuestionOptionGroupModel[] | undefined;
    lineItems?: UpdateQuestionLineItemModel[] | undefined;

    constructor(data?: IUpdateQuestionExtendedOptionsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["OptionGroups"])) {
                this.optionGroups = [] as any;
                for (let item of _data["OptionGroups"])
                    this.optionGroups!.push(UpdateQuestionOptionGroupModel.fromJS(item));
            }
            if (Array.isArray(_data["LineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["LineItems"])
                    this.lineItems!.push(UpdateQuestionLineItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionExtendedOptionsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionExtendedOptionsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionGroups)) {
            data["OptionGroups"] = [];
            for (let item of this.optionGroups)
                data["OptionGroups"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.lineItems)) {
            data["LineItems"] = [];
            for (let item of this.lineItems)
                data["LineItems"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateQuestionExtendedOptionsRequestModel {
    optionGroups?: UpdateQuestionOptionGroupModel[] | undefined;
    lineItems?: UpdateQuestionLineItemModel[] | undefined;
}

export class UpdateQuestionOptionGroupModel implements IUpdateQuestionOptionGroupModel {
    uniqueCode?: string | undefined;
    value?: string | undefined;
    required!: boolean;
    validationMessages?: UpdateOptionLabelRequestModel[] | undefined;
    labels?: UpdateOptionLabelRequestModel[] | undefined;
    options?: UpdateQuestionOptionRequestModel[] | undefined;

    constructor(data?: IUpdateQuestionOptionGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueCode = _data["UniqueCode"];
            this.value = _data["Value"];
            this.required = _data["Required"];
            if (Array.isArray(_data["ValidationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["ValidationMessages"])
                    this.validationMessages!.push(UpdateOptionLabelRequestModel.fromJS(item));
            }
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(UpdateOptionLabelRequestModel.fromJS(item));
            }
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(UpdateQuestionOptionRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionOptionGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionOptionGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UniqueCode"] = this.uniqueCode;
        data["Value"] = this.value;
        data["Required"] = this.required;
        if (Array.isArray(this.validationMessages)) {
            data["ValidationMessages"] = [];
            for (let item of this.validationMessages)
                data["ValidationMessages"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateQuestionOptionGroupModel {
    uniqueCode?: string | undefined;
    value?: string | undefined;
    required: boolean;
    validationMessages?: UpdateOptionLabelRequestModel[] | undefined;
    labels?: UpdateOptionLabelRequestModel[] | undefined;
    options?: UpdateQuestionOptionRequestModel[] | undefined;
}

export class UpdateQuestionLineItemModel implements IUpdateQuestionLineItemModel {
    code?: string | undefined;
    score!: number;
    scoreOptions?: Score[] | undefined;
    labels?: UpdateOptionLabelRequestModel[] | undefined;

    constructor(data?: IUpdateQuestionLineItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.score = _data["Score"];
            if (Array.isArray(_data["ScoreOptions"])) {
                this.scoreOptions = [] as any;
                for (let item of _data["ScoreOptions"])
                    this.scoreOptions!.push(item);
            }
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(UpdateOptionLabelRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionLineItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionLineItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Score"] = this.score;
        if (Array.isArray(this.scoreOptions)) {
            data["ScoreOptions"] = [];
            for (let item of this.scoreOptions)
                data["ScoreOptions"].push(item);
        }
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateQuestionLineItemModel {
    code?: string | undefined;
    score: number;
    scoreOptions?: Score[] | undefined;
    labels?: UpdateOptionLabelRequestModel[] | undefined;
}

export class CreateQuestionRequestModel implements ICreateQuestionRequestModel {
    interactionId!: number;
    questionType!: QuestionType;
    uniqueCode?: string | undefined;

    constructor(data?: ICreateQuestionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.questionType = _data["QuestionType"];
            this.uniqueCode = _data["UniqueCode"];
        }
    }

    static fromJS(data: any): CreateQuestionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["QuestionType"] = this.questionType;
        data["UniqueCode"] = this.uniqueCode;
        return data;
    }
}

export interface ICreateQuestionRequestModel {
    interactionId: number;
    questionType: QuestionType;
    uniqueCode?: string | undefined;
}

export class MoveQuestionToPositionRequestModel implements IMoveQuestionToPositionRequestModel {
    questionId!: number;
    position!: number;

    constructor(data?: IMoveQuestionToPositionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.position = _data["Position"];
        }
    }

    static fromJS(data: any): MoveQuestionToPositionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveQuestionToPositionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["Position"] = this.position;
        return data;
    }
}

export interface IMoveQuestionToPositionRequestModel {
    questionId: number;
    position: number;
}

export class UpdateTriggerRequestModel implements IUpdateTriggerRequestModel {
    triggerId!: number;
    type!: TriggerType;
    reportTemplateId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited!: boolean;
    isActive!: boolean;
    attachmentCategoryId?: string | undefined;
    softDeletePreviouslyCreatedAttachments!: boolean;

    constructor(data?: IUpdateTriggerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.triggerId = _data["TriggerId"];
            this.type = _data["Type"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.allowForEdited = _data["AllowForEdited"];
            this.isActive = _data["IsActive"];
            this.attachmentCategoryId = _data["AttachmentCategoryId"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
        }
    }

    static fromJS(data: any): UpdateTriggerRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTriggerRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TriggerId"] = this.triggerId;
        data["Type"] = this.type;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["AllowForEdited"] = this.allowForEdited;
        data["IsActive"] = this.isActive;
        data["AttachmentCategoryId"] = this.attachmentCategoryId;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        return data;
    }
}

export interface IUpdateTriggerRequestModel {
    triggerId: number;
    type: TriggerType;
    reportTemplateId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited: boolean;
    isActive: boolean;
    attachmentCategoryId?: string | undefined;
    softDeletePreviouslyCreatedAttachments: boolean;
}

export class AddTriggerRequestModel implements IAddTriggerRequestModel {
    interactionId!: number;
    type!: TriggerType;
    reportTemplateId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited!: boolean;
    attachmentCategoryId?: string | undefined;
    softDeletePreviouslyCreatedAttachments!: boolean;

    constructor(data?: IAddTriggerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.type = _data["Type"];
            this.reportTemplateId = _data["ReportTemplateId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.allowForEdited = _data["AllowForEdited"];
            this.attachmentCategoryId = _data["AttachmentCategoryId"];
            this.softDeletePreviouslyCreatedAttachments = _data["SoftDeletePreviouslyCreatedAttachments"];
        }
    }

    static fromJS(data: any): AddTriggerRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddTriggerRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["Type"] = this.type;
        data["ReportTemplateId"] = this.reportTemplateId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["AllowForEdited"] = this.allowForEdited;
        data["AttachmentCategoryId"] = this.attachmentCategoryId;
        data["SoftDeletePreviouslyCreatedAttachments"] = this.softDeletePreviouslyCreatedAttachments;
        return data;
    }
}

export interface IAddTriggerRequestModel {
    interactionId: number;
    type: TriggerType;
    reportTemplateId?: string | undefined;
    emailTemplateId?: number | undefined;
    allowForEdited: boolean;
    attachmentCategoryId?: string | undefined;
    softDeletePreviouslyCreatedAttachments: boolean;
}

export class ReportModel2 implements IReportModel2 {
    reportId!: string;
    studyId!: string;
    name?: string | undefined;
    type!: ReportType;
    createdBy?: string | undefined;
    createdOn!: Date;
    modifiedBy?: string | undefined;
    modifiedOn!: Date;

    constructor(data?: IReportModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["ReportId"];
            this.studyId = _data["StudyId"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.createdBy = _data["CreatedBy"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new ReportModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportId"] = this.reportId;
        data["StudyId"] = this.studyId;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["CreatedBy"] = this.createdBy;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReportModel2 {
    reportId: string;
    studyId: string;
    name?: string | undefined;
    type: ReportType;
    createdBy?: string | undefined;
    createdOn: Date;
    modifiedBy?: string | undefined;
    modifiedOn: Date;
}

export class EmailTemplateModel2 implements IEmailTemplateModel2 {
    emailTemplateID!: number;
    studyID!: string;
    name?: string | undefined;
    type!: EmailTemplateType;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    subjectLine?: string | undefined;
    template?: string | undefined;
    consentRequiredInfo?: string | undefined;
    consentNotRequiredInfo?: string | undefined;
    createdBy?: string | undefined;
    createdOn!: Date;
    modifiedBy?: string | undefined;
    modifiedOn!: Date;
    languageCode?: string | undefined;
    templateTypeName?: string | undefined;

    constructor(data?: IEmailTemplateModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplateID = _data["EmailTemplateID"];
            this.studyID = _data["StudyID"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.emailRecipientType = _data["EmailRecipientType"];
            this.emailRecipientTypeName = _data["EmailRecipientTypeName"];
            this.subjectLine = _data["SubjectLine"];
            this.template = _data["Template"];
            this.consentRequiredInfo = _data["ConsentRequiredInfo"];
            this.consentNotRequiredInfo = _data["ConsentNotRequiredInfo"];
            this.createdBy = _data["CreatedBy"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.languageCode = _data["LanguageCode"];
            this.templateTypeName = _data["TemplateTypeName"];
        }
    }

    static fromJS(data: any): EmailTemplateModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailTemplateID"] = this.emailTemplateID;
        data["StudyID"] = this.studyID;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["EmailRecipientType"] = this.emailRecipientType;
        data["EmailRecipientTypeName"] = this.emailRecipientTypeName;
        data["SubjectLine"] = this.subjectLine;
        data["Template"] = this.template;
        data["ConsentRequiredInfo"] = this.consentRequiredInfo;
        data["ConsentNotRequiredInfo"] = this.consentNotRequiredInfo;
        data["CreatedBy"] = this.createdBy;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["LanguageCode"] = this.languageCode;
        data["TemplateTypeName"] = this.templateTypeName;
        return data;
    }
}

export interface IEmailTemplateModel2 {
    emailTemplateID: number;
    studyID: string;
    name?: string | undefined;
    type: EmailTemplateType;
    emailRecipientType?: EmailTemplateRecipientType | undefined;
    emailRecipientTypeName?: string | undefined;
    subjectLine?: string | undefined;
    template?: string | undefined;
    consentRequiredInfo?: string | undefined;
    consentNotRequiredInfo?: string | undefined;
    createdBy?: string | undefined;
    createdOn: Date;
    modifiedBy?: string | undefined;
    modifiedOn: Date;
    languageCode?: string | undefined;
    templateTypeName?: string | undefined;
}

export class ReminderIntervalResult implements IReminderIntervalResult {
    id!: string;
    interval!: string;

    constructor(data?: IReminderIntervalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.interval = _data["Interval"];
        }
    }

    static fromJS(data: any): ReminderIntervalResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderIntervalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Interval"] = this.interval;
        return data;
    }
}

export interface IReminderIntervalResult {
    id: string;
    interval: string;
}

export class UpdateReminderIntervalsModel implements IUpdateReminderIntervalsModel {
    interval!: string;

    constructor(data?: IUpdateReminderIntervalsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interval = _data["Interval"];
        }
    }

    static fromJS(data: any): UpdateReminderIntervalsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReminderIntervalsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Interval"] = this.interval;
        return data;
    }
}

export interface IUpdateReminderIntervalsModel {
    interval: string;
}

export class InteractionResult implements IInteractionResult {
    id!: number;
    name?: string | undefined;

    constructor(data?: IInteractionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): InteractionResult {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IInteractionResult {
    id: number;
    name?: string | undefined;
}

export class EmaStudyResult implements IEmaStudyResult {
    studyId!: string;
    isActive!: boolean;
    numberOfDays!: number;
    expirationTime!: string;
    interaction?: InteractionResult | undefined;
    timeWindows?: TimeWindowResult[] | undefined;
    reminderIntervals?: ReminderIntervalResult[] | undefined;

    constructor(data?: IEmaStudyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.isActive = _data["IsActive"];
            this.numberOfDays = _data["NumberOfDays"];
            this.expirationTime = _data["ExpirationTime"];
            this.interaction = _data["Interaction"] ? InteractionResult.fromJS(_data["Interaction"]) : <any>undefined;
            if (Array.isArray(_data["TimeWindows"])) {
                this.timeWindows = [] as any;
                for (let item of _data["TimeWindows"])
                    this.timeWindows!.push(TimeWindowResult.fromJS(item));
            }
            if (Array.isArray(_data["ReminderIntervals"])) {
                this.reminderIntervals = [] as any;
                for (let item of _data["ReminderIntervals"])
                    this.reminderIntervals!.push(ReminderIntervalResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmaStudyResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmaStudyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["IsActive"] = this.isActive;
        data["NumberOfDays"] = this.numberOfDays;
        data["ExpirationTime"] = this.expirationTime;
        data["Interaction"] = this.interaction ? this.interaction.toJSON() : <any>undefined;
        if (Array.isArray(this.timeWindows)) {
            data["TimeWindows"] = [];
            for (let item of this.timeWindows)
                data["TimeWindows"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.reminderIntervals)) {
            data["ReminderIntervals"] = [];
            for (let item of this.reminderIntervals)
                data["ReminderIntervals"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEmaStudyResult {
    studyId: string;
    isActive: boolean;
    numberOfDays: number;
    expirationTime: string;
    interaction?: InteractionResult | undefined;
    timeWindows?: TimeWindowResult[] | undefined;
    reminderIntervals?: ReminderIntervalResult[] | undefined;
}

export class TimeWindowResult implements ITimeWindowResult {
    id!: string;
    startTime!: string;
    endTime!: string;

    constructor(data?: ITimeWindowResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
        }
    }

    static fromJS(data: any): TimeWindowResult {
        data = typeof data === 'object' ? data : {};
        let result = new TimeWindowResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        return data;
    }
}

export interface ITimeWindowResult {
    id: string;
    startTime: string;
    endTime: string;
}

export class UpdateEmaStudyModel implements IUpdateEmaStudyModel {
    numberOfDays!: number;
    interactionId?: number | undefined;
    expirationTime!: string;

    constructor(data?: IUpdateEmaStudyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfDays = _data["NumberOfDays"];
            this.interactionId = _data["InteractionId"];
            this.expirationTime = _data["ExpirationTime"];
        }
    }

    static fromJS(data: any): UpdateEmaStudyModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmaStudyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NumberOfDays"] = this.numberOfDays;
        data["InteractionId"] = this.interactionId;
        data["ExpirationTime"] = this.expirationTime;
        return data;
    }
}

export interface IUpdateEmaStudyModel {
    numberOfDays: number;
    interactionId?: number | undefined;
    expirationTime: string;
}

export class UpdateStudyInteractionModel implements IUpdateStudyInteractionModel {
    interactionId!: number;

    constructor(data?: IUpdateStudyInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
        }
    }

    static fromJS(data: any): UpdateStudyInteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyInteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        return data;
    }
}

export interface IUpdateStudyInteractionModel {
    interactionId: number;
}

export class UpdateTimeWindowModel implements IUpdateTimeWindowModel {
    /** The time when the window begins. */
    startTime!: string;
    /** The time when the window ends. */
    endTime!: string;

    constructor(data?: IUpdateTimeWindowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["StartTime"];
            this.endTime = _data["EndTime"];
        }
    }

    static fromJS(data: any): UpdateTimeWindowModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimeWindowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartTime"] = this.startTime;
        data["EndTime"] = this.endTime;
        return data;
    }
}

export interface IUpdateTimeWindowModel {
    /** The time when the window begins. */
    startTime: string;
    /** The time when the window ends. */
    endTime: string;
}

export class CreateEmailTemplateModel implements ICreateEmailTemplateModel {
    consentNotRequiredInfo?: string | undefined;
    consentRequiredInfo?: string | undefined;
    name!: string;
    recipientType?: EmailTemplateRecipientType | undefined;
    subjectLine!: string;
    template!: string;
    type!: EmailTemplateType;
    languageCode!: string;

    constructor(data?: ICreateEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentNotRequiredInfo = _data["ConsentNotRequiredInfo"];
            this.consentRequiredInfo = _data["ConsentRequiredInfo"];
            this.name = _data["Name"];
            this.recipientType = _data["RecipientType"];
            this.subjectLine = _data["SubjectLine"];
            this.template = _data["Template"];
            this.type = _data["Type"];
            this.languageCode = _data["LanguageCode"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConsentNotRequiredInfo"] = this.consentNotRequiredInfo;
        data["ConsentRequiredInfo"] = this.consentRequiredInfo;
        data["Name"] = this.name;
        data["RecipientType"] = this.recipientType;
        data["SubjectLine"] = this.subjectLine;
        data["Template"] = this.template;
        data["Type"] = this.type;
        data["LanguageCode"] = this.languageCode;
        return data;
    }
}

export interface ICreateEmailTemplateModel {
    consentNotRequiredInfo?: string | undefined;
    consentRequiredInfo?: string | undefined;
    name: string;
    recipientType?: EmailTemplateRecipientType | undefined;
    subjectLine: string;
    template: string;
    type: EmailTemplateType;
    languageCode: string;
}

export class UpdateEmailTemplateModel implements IUpdateEmailTemplateModel {
    consentNotRequiredInfo?: string | undefined;
    consentRequiredInfo?: string | undefined;
    emailTemplateID!: number;
    name!: string;
    recipientType?: EmailTemplateRecipientType | undefined;
    subjectLine!: string;
    template!: string;
    languageCode!: string;
    type!: EmailTemplateType;

    constructor(data?: IUpdateEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consentNotRequiredInfo = _data["ConsentNotRequiredInfo"];
            this.consentRequiredInfo = _data["ConsentRequiredInfo"];
            this.emailTemplateID = _data["EmailTemplateID"];
            this.name = _data["Name"];
            this.recipientType = _data["RecipientType"];
            this.subjectLine = _data["SubjectLine"];
            this.template = _data["Template"];
            this.languageCode = _data["LanguageCode"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConsentNotRequiredInfo"] = this.consentNotRequiredInfo;
        data["ConsentRequiredInfo"] = this.consentRequiredInfo;
        data["EmailTemplateID"] = this.emailTemplateID;
        data["Name"] = this.name;
        data["RecipientType"] = this.recipientType;
        data["SubjectLine"] = this.subjectLine;
        data["Template"] = this.template;
        data["LanguageCode"] = this.languageCode;
        data["Type"] = this.type;
        return data;
    }
}

export interface IUpdateEmailTemplateModel {
    consentNotRequiredInfo?: string | undefined;
    consentRequiredInfo?: string | undefined;
    emailTemplateID: number;
    name: string;
    recipientType?: EmailTemplateRecipientType | undefined;
    subjectLine: string;
    template: string;
    languageCode: string;
    type: EmailTemplateType;
}

export class AsteriskStatusModel implements IAsteriskStatusModel {
    isConnected!: boolean;

    constructor(data?: IAsteriskStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConnected = _data["IsConnected"];
        }
    }

    static fromJS(data: any): AsteriskStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsConnected"] = this.isConnected;
        return data;
    }
}

export interface IAsteriskStatusModel {
    isConnected: boolean;
}

export class AsteriskStartResponse implements IAsteriskStartResponse {
    success!: boolean;

    constructor(data?: IAsteriskStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): AsteriskStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        return data;
    }
}

export interface IAsteriskStartResponse {
    success: boolean;
}

export class PatientLoginDto implements IPatientLoginDto {
    patientLoginId!: string;
    loginEmail?: string | undefined;
    patientName?: string | undefined;
    patientVisits?: PatientLoginVisitDto[] | undefined;
    emailConfirmed!: boolean;

    constructor(data?: IPatientLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["PatientLoginId"];
            this.loginEmail = _data["LoginEmail"];
            this.patientName = _data["PatientName"];
            if (Array.isArray(_data["PatientVisits"])) {
                this.patientVisits = [] as any;
                for (let item of _data["PatientVisits"])
                    this.patientVisits!.push(PatientLoginVisitDto.fromJS(item));
            }
            this.emailConfirmed = _data["EmailConfirmed"];
        }
    }

    static fromJS(data: any): PatientLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientLoginId"] = this.patientLoginId;
        data["LoginEmail"] = this.loginEmail;
        data["PatientName"] = this.patientName;
        if (Array.isArray(this.patientVisits)) {
            data["PatientVisits"] = [];
            for (let item of this.patientVisits)
                data["PatientVisits"].push(item ? item.toJSON() : <any>undefined);
        }
        data["EmailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IPatientLoginDto {
    patientLoginId: string;
    loginEmail?: string | undefined;
    patientName?: string | undefined;
    patientVisits?: PatientLoginVisitDto[] | undefined;
    emailConfirmed: boolean;
}

export class PatientLoginVisitDto implements IPatientLoginVisitDto {
    patientVisitID!: string;
    visitNumber?: number | undefined;
    completedOn!: Date;
    isCompleted!: boolean;
    weight?: number | undefined;
    confidenceScore?: number | undefined;

    constructor(data?: IPatientLoginVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientVisitID = _data["PatientVisitID"];
            this.visitNumber = _data["VisitNumber"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.isCompleted = _data["IsCompleted"];
            this.weight = _data["Weight"];
            this.confidenceScore = _data["ConfidenceScore"];
        }
    }

    static fromJS(data: any): PatientLoginVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLoginVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientVisitID"] = this.patientVisitID;
        data["VisitNumber"] = this.visitNumber;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["IsCompleted"] = this.isCompleted;
        data["Weight"] = this.weight;
        data["ConfidenceScore"] = this.confidenceScore;
        return data;
    }
}

export interface IPatientLoginVisitDto {
    patientVisitID: string;
    visitNumber?: number | undefined;
    completedOn: Date;
    isCompleted: boolean;
    weight?: number | undefined;
    confidenceScore?: number | undefined;
}

export class GetPublicInteractionRequestsInPendingStatusItem implements IGetPublicInteractionRequestsInPendingStatusItem {
    publicInteractionRequestId!: string;
    interactionName?: string | undefined;

    constructor(data?: IGetPublicInteractionRequestsInPendingStatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicInteractionRequestId = _data["PublicInteractionRequestId"];
            this.interactionName = _data["InteractionName"];
        }
    }

    static fromJS(data: any): GetPublicInteractionRequestsInPendingStatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicInteractionRequestsInPendingStatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PublicInteractionRequestId"] = this.publicInteractionRequestId;
        data["InteractionName"] = this.interactionName;
        return data;
    }
}

export interface IGetPublicInteractionRequestsInPendingStatusItem {
    publicInteractionRequestId: string;
    interactionName?: string | undefined;
}

export class GetPatientResourcesResponse implements IGetPatientResourcesResponse {
    resourceId!: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType!: PatientResourceType;

    constructor(data?: IGetPatientResourcesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.author = _data["Author"];
            this.resourceType = _data["ResourceType"];
        }
    }

    static fromJS(data: any): GetPatientResourcesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientResourcesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Author"] = this.author;
        data["ResourceType"] = this.resourceType;
        return data;
    }
}

export interface IGetPatientResourcesResponse {
    resourceId: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType: PatientResourceType;
}

export enum PatientResourceType {
    PdfDocument = 1,
    Video = 2,
    Other = 3,
}

export class GetVideoResourceSasUrlResponse implements IGetVideoResourceSasUrlResponse {
    sasUrl?: string | undefined;
    validUntil!: Date;

    constructor(data?: IGetVideoResourceSasUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sasUrl = _data["SasUrl"];
            this.validUntil = _data["ValidUntil"] ? new Date(_data["ValidUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVideoResourceSasUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoResourceSasUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SasUrl"] = this.sasUrl;
        data["ValidUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetVideoResourceSasUrlResponse {
    sasUrl?: string | undefined;
    validUntil: Date;
}

export class GetPatientResourceDetailsResponse implements IGetPatientResourceDetailsResponse {
    resourceId!: number;
    filename?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetPatientResourceDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.filename = _data["Filename"];
            this.description = _data["Description"];
            this.contentType = _data["ContentType"];
        }
    }

    static fromJS(data: any): GetPatientResourceDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientResourceDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Filename"] = this.filename;
        data["Description"] = this.description;
        data["ContentType"] = this.contentType;
        return data;
    }
}

export interface IGetPatientResourceDetailsResponse {
    resourceId: number;
    filename?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
}

export class ProgramDetailsResponse implements IProgramDetailsResponse {
    status!: PatientStatus;
    sinceDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;

    constructor(data?: IProgramDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.sinceDate = _data["SinceDate"] ? new Date(_data["SinceDate"].toString()) : <any>undefined;
            this.programProductDisplayPrice = _data["ProgramProductDisplayPrice"];
        }
    }

    static fromJS(data: any): ProgramDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["SinceDate"] = this.sinceDate ? this.sinceDate.toISOString() : <any>undefined;
        data["ProgramProductDisplayPrice"] = this.programProductDisplayPrice;
        return data;
    }
}

export interface IProgramDetailsResponse {
    status: PatientStatus;
    sinceDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;
}

export class PatientSummaryResult implements IPatientSummaryResult {
    patientId!: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IPatientSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
            this.uniqueId = _data["UniqueId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
        }
    }

    static fromJS(data: any): PatientSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        data["UniqueId"] = this.uniqueId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        return data;
    }
}

export interface IPatientSummaryResult {
    patientId: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class AeCcglowSummary implements IAeCcglowSummary {
    aeWithoutCcglowCount!: number;
    aeContainingCcglowCount!: number;

    constructor(data?: IAeCcglowSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aeWithoutCcglowCount = _data["AeWithoutCcglowCount"];
            this.aeContainingCcglowCount = _data["AeContainingCcglowCount"];
        }
    }

    static fromJS(data: any): AeCcglowSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AeCcglowSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AeWithoutCcglowCount"] = this.aeWithoutCcglowCount;
        data["AeContainingCcglowCount"] = this.aeContainingCcglowCount;
        return data;
    }
}

export interface IAeCcglowSummary {
    aeWithoutCcglowCount: number;
    aeContainingCcglowCount: number;
}

export class AeSummary implements IAeSummary {
    filedCount!: number;
    faxedCount!: number;

    constructor(data?: IAeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filedCount = _data["FiledCount"];
            this.faxedCount = _data["FaxedCount"];
        }
    }

    static fromJS(data: any): AeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FiledCount"] = this.filedCount;
        data["FaxedCount"] = this.faxedCount;
        return data;
    }
}

export interface IAeSummary {
    filedCount: number;
    faxedCount: number;
}

export class StoppedTakingSummary implements IStoppedTakingSummary {
    week3StoppedTakingCount!: number;
    week2StoppedTakingCount!: number;
    distinctStoppedTaking!: number;
    completedStoppingCallInteractions!: number;

    constructor(data?: IStoppedTakingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week3StoppedTakingCount = _data["Week3StoppedTakingCount"];
            this.week2StoppedTakingCount = _data["Week2StoppedTakingCount"];
            this.distinctStoppedTaking = _data["DistinctStoppedTaking"];
            this.completedStoppingCallInteractions = _data["CompletedStoppingCallInteractions"];
        }
    }

    static fromJS(data: any): StoppedTakingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new StoppedTakingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Week3StoppedTakingCount"] = this.week3StoppedTakingCount;
        data["Week2StoppedTakingCount"] = this.week2StoppedTakingCount;
        data["DistinctStoppedTaking"] = this.distinctStoppedTaking;
        data["CompletedStoppingCallInteractions"] = this.completedStoppingCallInteractions;
        return data;
    }
}

export interface IStoppedTakingSummary {
    week3StoppedTakingCount: number;
    week2StoppedTakingCount: number;
    distinctStoppedTaking: number;
    completedStoppingCallInteractions: number;
}

export class RegisterDeviceRequest implements IRegisterDeviceRequest {
    deviceToken?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IRegisterDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceToken = _data["DeviceToken"];
            this.platform = _data["Platform"];
        }
    }

    static fromJS(data: any): RegisterDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceToken"] = this.deviceToken;
        data["Platform"] = this.platform;
        return data;
    }
}

export interface IRegisterDeviceRequest {
    deviceToken?: string | undefined;
    platform?: string | undefined;
}

export class PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto implements IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
    results?: PatientAvailableProductForPurchaseResponseDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(PatientAvailableProductForPurchaseResponseDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
    results?: PatientAvailableProductForPurchaseResponseDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PatientAvailableProductForPurchaseResponseDto implements IPatientAvailableProductForPurchaseResponseDto {
    productId!: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;

    constructor(data?: IPatientAvailableProductForPurchaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.name = _data["Name"];
            this.label = _data["Label"];
            this.displayPrice = _data["DisplayPrice"];
        }
    }

    static fromJS(data: any): PatientAvailableProductForPurchaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAvailableProductForPurchaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["Name"] = this.name;
        data["Label"] = this.label;
        data["DisplayPrice"] = this.displayPrice;
        return data;
    }
}

export interface IPatientAvailableProductForPurchaseResponseDto {
    productId: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;
}

export class PublicPatientReceiptModel implements IPublicPatientReceiptModel {
    id!: number;
    interactionDate!: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;

    constructor(data?: IPublicPatientReceiptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.interactionDate = _data["InteractionDate"] ? new Date(_data["InteractionDate"].toString()) : <any>undefined;
            this.serviceDate = _data["ServiceDate"];
            this.serviceType = _data["ServiceType"];
            this.serviceCost = _data["ServiceCost"];
            this.agentName = _data["AgentName"];
        }
    }

    static fromJS(data: any): PublicPatientReceiptModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientReceiptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InteractionDate"] = this.interactionDate ? this.interactionDate.toISOString() : <any>undefined;
        data["ServiceDate"] = this.serviceDate;
        data["ServiceType"] = this.serviceType;
        data["ServiceCost"] = this.serviceCost;
        data["AgentName"] = this.agentName;
        return data;
    }
}

export interface IPublicPatientReceiptModel {
    id: number;
    interactionDate: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;
}

export class DownloadReceiptRequest implements IDownloadReceiptRequest {
    url?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IDownloadReceiptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["Url"];
            this.ipAddress = _data["IpAddress"];
        }
    }

    static fromJS(data: any): DownloadReceiptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadReceiptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Url"] = this.url;
        data["IpAddress"] = this.ipAddress;
        return data;
    }
}

export interface IDownloadReceiptRequest {
    url?: string | undefined;
    ipAddress?: string | undefined;
}

export class PublicSitePatientConversationModel implements IPublicSitePatientConversationModel {
    state!: ConversationState;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel[] | undefined;

    constructor(data?: IPublicSitePatientConversationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["State"];
            this.lastReadOn = _data["LastReadOn"] ? new Date(_data["LastReadOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(PublicSitePatientMessageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicSitePatientConversationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientConversationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State"] = this.state;
        data["LastReadOn"] = this.lastReadOn ? this.lastReadOn.toISOString() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPublicSitePatientConversationModel {
    state: ConversationState;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel[] | undefined;
}

export class PublicSitePatientMessageModel implements IPublicSitePatientMessageModel {
    id!: string;
    sentOn!: Date;
    senderType!: ChatSender;
    senderName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IPublicSitePatientMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sentOn = _data["SentOn"] ? new Date(_data["SentOn"].toString()) : <any>undefined;
            this.senderType = _data["SenderType"];
            this.senderName = _data["SenderName"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): PublicSitePatientMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SentOn"] = this.sentOn ? this.sentOn.toISOString() : <any>undefined;
        data["SenderType"] = this.senderType;
        data["SenderName"] = this.senderName;
        data["Message"] = this.message;
        return data;
    }
}

export interface IPublicSitePatientMessageModel {
    id: string;
    sentOn: Date;
    senderType: ChatSender;
    senderName?: string | undefined;
    message?: string | undefined;
}

export class UnreadMessagesResponse implements IUnreadMessagesResponse {
    unreadMessages!: number;

    constructor(data?: IUnreadMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadMessages = _data["UnreadMessages"];
        }
    }

    static fromJS(data: any): UnreadMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnreadMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IUnreadMessagesResponse {
    unreadMessages: number;
}

export class SendChatMessageRequest implements ISendChatMessageRequest {
    message?: string | undefined;

    constructor(data?: ISendChatMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): SendChatMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendChatMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        return data;
    }
}

export interface ISendChatMessageRequest {
    message?: string | undefined;
}

export class GetNymbleEnrollData implements IGetNymbleEnrollData {
    name?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: IGetNymbleEnrollData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.customerId = _data["CustomerId"];
        }
    }

    static fromJS(data: any): GetNymbleEnrollData {
        data = typeof data === 'object' ? data : {};
        let result = new GetNymbleEnrollData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["CustomerId"] = this.customerId;
        return data;
    }
}

export interface IGetNymbleEnrollData {
    name?: string | undefined;
    customerId?: string | undefined;
}

export class GetSystemPatientModel implements IGetSystemPatientModel {
    systemPatient?: SystemPatientSummaryModel | undefined;

    constructor(data?: IGetSystemPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemPatient = _data["SystemPatient"] ? SystemPatientSummaryModel.fromJS(_data["SystemPatient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSystemPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemPatient"] = this.systemPatient ? this.systemPatient.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSystemPatientModel {
    systemPatient?: SystemPatientSummaryModel | undefined;
}

export class SystemPatientSummaryModel implements ISystemPatientSummaryModel {
    patientId!: string;
    uniqueId?: string | undefined;

    constructor(data?: ISystemPatientSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
            this.uniqueId = _data["UniqueId"];
        }
    }

    static fromJS(data: any): SystemPatientSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPatientSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        data["UniqueId"] = this.uniqueId;
        return data;
    }
}

export interface ISystemPatientSummaryModel {
    patientId: string;
    uniqueId?: string | undefined;
}

export class UpdateStudyPspSystemPatientModel implements IUpdateStudyPspSystemPatientModel {
    patientId?: string | undefined;

    constructor(data?: IUpdateStudyPspSystemPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
        }
    }

    static fromJS(data: any): UpdateStudyPspSystemPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyPspSystemPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        return data;
    }
}

export interface IUpdateStudyPspSystemPatientModel {
    patientId?: string | undefined;
}

export class ParticipantsSummaryResult implements IParticipantsSummaryResult {
    statusCounts?: PatientStatusResult[] | undefined;

    constructor(data?: IParticipantsSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["StatusCounts"])) {
                this.statusCounts = [] as any;
                for (let item of _data["StatusCounts"])
                    this.statusCounts!.push(PatientStatusResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantsSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusCounts)) {
            data["StatusCounts"] = [];
            for (let item of this.statusCounts)
                data["StatusCounts"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IParticipantsSummaryResult {
    statusCounts?: PatientStatusResult[] | undefined;
}

export class PatientStatusResult implements IPatientStatusResult {
    patientStatus!: PatientStatus;
    name?: string | undefined;
    count!: number;

    constructor(data?: IPatientStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientStatus = _data["PatientStatus"];
            this.name = _data["Name"];
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): PatientStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientStatus"] = this.patientStatus;
        data["Name"] = this.name;
        data["Count"] = this.count;
        return data;
    }
}

export interface IPatientStatusResult {
    patientStatus: PatientStatus;
    name?: string | undefined;
    count: number;
}

export class PatientSummaryStatusResult implements IPatientSummaryStatusResult {
    patientId!: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status!: PatientStatus;
    enrolledSubStatus?: string | undefined;

    constructor(data?: IPatientSummaryStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
            this.uniqueId = _data["UniqueId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.status = _data["Status"];
            this.enrolledSubStatus = _data["EnrolledSubStatus"];
        }
    }

    static fromJS(data: any): PatientSummaryStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSummaryStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        data["UniqueId"] = this.uniqueId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Status"] = this.status;
        data["EnrolledSubStatus"] = this.enrolledSubStatus;
        return data;
    }
}

export interface IPatientSummaryStatusResult {
    patientId: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status: PatientStatus;
    enrolledSubStatus?: string | undefined;
}

export class EnrollmentCountModel implements IEnrollmentCountModel {
    enrollments!: number;

    constructor(data?: IEnrollmentCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollments = _data["Enrollments"];
        }
    }

    static fromJS(data: any): EnrollmentCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enrollments"] = this.enrollments;
        return data;
    }
}

export interface IEnrollmentCountModel {
    enrollments: number;
}

export class QueueMetricsModel implements IQueueMetricsModel {
    averageWaitTime?: string | undefined;
    englishQueuedCallers!: number;
    frenchQueuedCallers!: number;
    englishAvailableAgents!: number;
    frenchAvailableAgents!: number;
    totalAvailableAgents!: number;

    constructor(data?: IQueueMetricsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageWaitTime = _data["AverageWaitTime"];
            this.englishQueuedCallers = _data["EnglishQueuedCallers"];
            this.frenchQueuedCallers = _data["FrenchQueuedCallers"];
            this.englishAvailableAgents = _data["EnglishAvailableAgents"];
            this.frenchAvailableAgents = _data["FrenchAvailableAgents"];
            this.totalAvailableAgents = _data["TotalAvailableAgents"];
        }
    }

    static fromJS(data: any): QueueMetricsModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueueMetricsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AverageWaitTime"] = this.averageWaitTime;
        data["EnglishQueuedCallers"] = this.englishQueuedCallers;
        data["FrenchQueuedCallers"] = this.frenchQueuedCallers;
        data["EnglishAvailableAgents"] = this.englishAvailableAgents;
        data["FrenchAvailableAgents"] = this.frenchAvailableAgents;
        data["TotalAvailableAgents"] = this.totalAvailableAgents;
        return data;
    }
}

export interface IQueueMetricsModel {
    averageWaitTime?: string | undefined;
    englishQueuedCallers: number;
    frenchQueuedCallers: number;
    englishAvailableAgents: number;
    frenchAvailableAgents: number;
    totalAvailableAgents: number;
}

export class AccountSummaryResult implements IAccountSummaryResult {
    accountId!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IAccountSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
        }
    }

    static fromJS(data: any): AccountSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        return data;
    }
}

export interface IAccountSummaryResult {
    accountId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class PatientInteractionSummaryResult implements IPatientInteractionSummaryResult {
    interaction?: InteractionSummaryResult | undefined;
    patientInteractionId!: number;
    createdOn!: Date;
    patient?: PatientSummaryResult | undefined;
    account?: AccountSummaryResult | undefined;

    constructor(data?: IPatientInteractionSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interaction = _data["Interaction"] ? InteractionSummaryResult.fromJS(_data["Interaction"]) : <any>undefined;
            this.patientInteractionId = _data["PatientInteractionId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.patient = _data["Patient"] ? PatientSummaryResult.fromJS(_data["Patient"]) : <any>undefined;
            this.account = _data["Account"] ? AccountSummaryResult.fromJS(_data["Account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientInteractionSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInteractionSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Interaction"] = this.interaction ? this.interaction.toJSON() : <any>undefined;
        data["PatientInteractionId"] = this.patientInteractionId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["Account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientInteractionSummaryResult {
    interaction?: InteractionSummaryResult | undefined;
    patientInteractionId: number;
    createdOn: Date;
    patient?: PatientSummaryResult | undefined;
    account?: AccountSummaryResult | undefined;
}

export class InteractionSummaryResult implements IInteractionSummaryResult {
    interactionId!: number;
    name?: string | undefined;

    constructor(data?: IInteractionSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): InteractionSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["Name"] = this.name;
        return data;
    }
}

export interface IInteractionSummaryResult {
    interactionId: number;
    name?: string | undefined;
}

export class AsteriskSummaryModel implements IAsteriskSummaryModel {
    averageLengthOfCalls!: string;
    dailyInboundVideoCalls!: number;
    dailyInboundPhoneCalls!: number;
    abandonedCalls!: number;
    averageAgentInbound!: number;
    averageAgentOutbound!: number;

    constructor(data?: IAsteriskSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageLengthOfCalls = _data["AverageLengthOfCalls"];
            this.dailyInboundVideoCalls = _data["DailyInboundVideoCalls"];
            this.dailyInboundPhoneCalls = _data["DailyInboundPhoneCalls"];
            this.abandonedCalls = _data["AbandonedCalls"];
            this.averageAgentInbound = _data["AverageAgentInbound"];
            this.averageAgentOutbound = _data["AverageAgentOutbound"];
        }
    }

    static fromJS(data: any): AsteriskSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AverageLengthOfCalls"] = this.averageLengthOfCalls;
        data["DailyInboundVideoCalls"] = this.dailyInboundVideoCalls;
        data["DailyInboundPhoneCalls"] = this.dailyInboundPhoneCalls;
        data["AbandonedCalls"] = this.abandonedCalls;
        data["AverageAgentInbound"] = this.averageAgentInbound;
        data["AverageAgentOutbound"] = this.averageAgentOutbound;
        return data;
    }
}

export interface IAsteriskSummaryModel {
    averageLengthOfCalls: string;
    dailyInboundVideoCalls: number;
    dailyInboundPhoneCalls: number;
    abandonedCalls: number;
    averageAgentInbound: number;
    averageAgentOutbound: number;
}

export class CreateAppointmentAndPaymentLinkResponse implements ICreateAppointmentAndPaymentLinkResponse {
    patientServicePurchaseId!: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse[] | undefined;

    constructor(data?: ICreateAppointmentAndPaymentLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientServicePurchaseId = _data["PatientServicePurchaseId"];
            if (Array.isArray(_data["PaymentAlternatives"])) {
                this.paymentAlternatives = [] as any;
                for (let item of _data["PaymentAlternatives"])
                    this.paymentAlternatives!.push(CreateAppointmentPaymentAlternativeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAppointmentAndPaymentLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentAndPaymentLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientServicePurchaseId"] = this.patientServicePurchaseId;
        if (Array.isArray(this.paymentAlternatives)) {
            data["PaymentAlternatives"] = [];
            for (let item of this.paymentAlternatives)
                data["PaymentAlternatives"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateAppointmentAndPaymentLinkResponse {
    patientServicePurchaseId: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse[] | undefined;
}

export class CreateAppointmentPaymentAlternativeResponse implements ICreateAppointmentPaymentAlternativeResponse {
    paymentLink?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICreateAppointmentPaymentAlternativeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLink = _data["PaymentLink"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CreateAppointmentPaymentAlternativeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentPaymentAlternativeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaymentLink"] = this.paymentLink;
        data["Name"] = this.name;
        return data;
    }
}

export interface ICreateAppointmentPaymentAlternativeResponse {
    paymentLink?: string | undefined;
    name?: string | undefined;
}

export class AppointmentAndPaymentLinkRequest implements IAppointmentAndPaymentLinkRequest {
    patientLoginId!: string;
    productId!: string;

    constructor(data?: IAppointmentAndPaymentLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["PatientLoginId"];
            this.productId = _data["ProductId"];
        }
    }

    static fromJS(data: any): AppointmentAndPaymentLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAndPaymentLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientLoginId"] = this.patientLoginId;
        data["ProductId"] = this.productId;
        return data;
    }
}

export interface IAppointmentAndPaymentLinkRequest {
    patientLoginId: string;
    productId: string;
}

export class AppointmentPurchasedConfirmRequest implements IAppointmentPurchasedConfirmRequest {
    patientLoginId!: string;
    productId!: string;
    patientServicePurchaseId!: string;

    constructor(data?: IAppointmentPurchasedConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["PatientLoginId"];
            this.productId = _data["ProductId"];
            this.patientServicePurchaseId = _data["PatientServicePurchaseId"];
        }
    }

    static fromJS(data: any): AppointmentPurchasedConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPurchasedConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientLoginId"] = this.patientLoginId;
        data["ProductId"] = this.productId;
        data["PatientServicePurchaseId"] = this.patientServicePurchaseId;
        return data;
    }
}

export interface IAppointmentPurchasedConfirmRequest {
    patientLoginId: string;
    productId: string;
    patientServicePurchaseId: string;
}

export class ProvinceState implements IProvinceState {
    provinceStateID!: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    timeZone?: string | undefined;

    constructor(data?: IProvinceState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provinceStateID = _data["ProvinceStateID"];
            this.code = _data["Code"];
            this.countryCode = _data["CountryCode"];
            this.name = _data["Name"];
            this.timeZone = _data["TimeZone"];
        }
    }

    static fromJS(data: any): ProvinceState {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProvinceStateID"] = this.provinceStateID;
        data["Code"] = this.code;
        data["CountryCode"] = this.countryCode;
        data["Name"] = this.name;
        data["TimeZone"] = this.timeZone;
        return data;
    }
}

export interface IProvinceState {
    provinceStateID: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    timeZone?: string | undefined;
}

export class GetPharmaciesRequest implements IGetPharmaciesRequest {
    studyId!: string;
    name?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;

    constructor(data?: IGetPharmaciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.name = _data["Name"];
            this.province = _data["Province"];
            this.city = _data["City"];
        }
    }

    static fromJS(data: any): GetPharmaciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPharmaciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["Name"] = this.name;
        data["Province"] = this.province;
        data["City"] = this.city;
        return data;
    }
}

export interface IGetPharmaciesRequest {
    studyId: string;
    name?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
}

export class GetPhysicianRequest implements IGetPhysicianRequest {
    studyId!: string;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IGetPhysicianRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.country = _data["Country"];
            this.province = _data["Province"];
            this.city = _data["City"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
        }
    }

    static fromJS(data: any): GetPhysicianRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhysicianRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["Country"] = this.country;
        data["Province"] = this.province;
        data["City"] = this.city;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        return data;
    }
}

export interface IGetPhysicianRequest {
    studyId: string;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class InteractionRenderModel implements IInteractionRenderModel {
    heartBeatSend!: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType!: InteractionType;
    callbackToken?: string | undefined;
    name?: string | undefined;
    questions?: InteractionQuestion[] | undefined;
    groups?: InteractionQuestionGroup[] | undefined;
    interactionNote?: InteractionNoteModel | undefined;
    rules?: { [key: string]: InteractionRulesGroup; } | undefined;

    constructor(data?: IInteractionRenderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heartBeatSend = _data["HeartBeatSend"];
            this.heartBeatEndpoint = _data["HeartBeatEndpoint"];
            this.interactionType = _data["InteractionType"];
            this.callbackToken = _data["CallbackToken"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(InteractionQuestion.fromJS(item));
            }
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(InteractionQuestionGroup.fromJS(item));
            }
            this.interactionNote = _data["InteractionNote"] ? InteractionNoteModel.fromJS(_data["InteractionNote"]) : <any>undefined;
            if (_data["Rules"]) {
                this.rules = {} as any;
                for (let key in _data["Rules"]) {
                    if (_data["Rules"].hasOwnProperty(key))
                        (<any>this.rules)![key] = _data["Rules"][key] ? InteractionRulesGroup.fromJS(_data["Rules"][key]) : new InteractionRulesGroup();
                }
            }
        }
    }

    static fromJS(data: any): InteractionRenderModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRenderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HeartBeatSend"] = this.heartBeatSend;
        data["HeartBeatEndpoint"] = this.heartBeatEndpoint;
        data["InteractionType"] = this.interactionType;
        data["CallbackToken"] = this.callbackToken;
        data["Name"] = this.name;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : <any>undefined);
        }
        data["InteractionNote"] = this.interactionNote ? this.interactionNote.toJSON() : <any>undefined;
        if (this.rules) {
            data["Rules"] = {};
            for (let key in this.rules) {
                if (this.rules.hasOwnProperty(key))
                    (<any>data["Rules"])[key] = this.rules[key] ? this.rules[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IInteractionRenderModel {
    heartBeatSend: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType: InteractionType;
    callbackToken?: string | undefined;
    name?: string | undefined;
    questions?: InteractionQuestion[] | undefined;
    groups?: InteractionQuestionGroup[] | undefined;
    interactionNote?: InteractionNoteModel | undefined;
    rules?: { [key: string]: InteractionRulesGroup; } | undefined;
}

export class InteractionQuestion implements IInteractionQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId!: number;
    uniqueCode?: string | undefined;
    isRepeatable!: boolean;
    items?: InteractionQuestionItem[] | undefined;

    constructor(data?: IInteractionQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Answers"])) {
                this.answers = [] as any;
                for (let item of _data["Answers"])
                    this.answers!.push(QuestionAnswerModel.fromJS(item));
            }
            this.interactionQuestionId = _data["InteractionQuestionId"];
            this.uniqueCode = _data["UniqueCode"];
            this.isRepeatable = _data["IsRepeatable"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InteractionQuestionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["Answers"] = [];
            for (let item of this.answers)
                data["Answers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["InteractionQuestionId"] = this.interactionQuestionId;
        data["UniqueCode"] = this.uniqueCode;
        data["IsRepeatable"] = this.isRepeatable;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId: number;
    uniqueCode?: string | undefined;
    isRepeatable: boolean;
    items?: InteractionQuestionItem[] | undefined;
}

export class QuestionAnswerModel implements IQuestionAnswerModel {
    answerValues?: QuestionAnswerValue[] | undefined;

    constructor(data?: IQuestionAnswerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AnswerValues"])) {
                this.answerValues = [] as any;
                for (let item of _data["AnswerValues"])
                    this.answerValues!.push(QuestionAnswerValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answerValues)) {
            data["AnswerValues"] = [];
            for (let item of this.answerValues)
                data["AnswerValues"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQuestionAnswerModel {
    answerValues?: QuestionAnswerValue[] | undefined;
}

export class QuestionAnswerValue implements IQuestionAnswerValue {
    subCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: IQuestionAnswerValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCode = _data["SubCode"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): QuestionAnswerValue {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubCode"] = this.subCode;
        data["Value"] = this.value;
        return data;
    }
}

export interface IQuestionAnswerValue {
    subCode?: string | undefined;
    value?: string | undefined;
}

export class InteractionQuestionItem implements IInteractionQuestionItem {
    questionId!: string;
    subCode?: string | undefined;
    position!: number;
    questionType!: QuestionType;
    required!: boolean;
    readOnly!: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration | undefined;

    constructor(data?: IInteractionQuestionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.subCode = _data["SubCode"];
            this.position = _data["Position"];
            this.questionType = _data["QuestionType"];
            this.required = _data["Required"];
            this.readOnly = _data["ReadOnly"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.validationMessage = _data["ValidationMessage"];
            if (Array.isArray(_data["QuestionOptions"])) {
                this.questionOptions = [] as any;
                for (let item of _data["QuestionOptions"])
                    this.questionOptions!.push(QuestionOption.fromJS(item));
            }
            this.extendedOptions = _data["ExtendedOptions"] ? ExtendedOptionsObjectMigration.fromJS(_data["ExtendedOptions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InteractionQuestionItem {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["SubCode"] = this.subCode;
        data["Position"] = this.position;
        data["QuestionType"] = this.questionType;
        data["Required"] = this.required;
        data["ReadOnly"] = this.readOnly;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["ValidationMessage"] = this.validationMessage;
        if (Array.isArray(this.questionOptions)) {
            data["QuestionOptions"] = [];
            for (let item of this.questionOptions)
                data["QuestionOptions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ExtendedOptions"] = this.extendedOptions ? this.extendedOptions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInteractionQuestionItem {
    questionId: string;
    subCode?: string | undefined;
    position: number;
    questionType: QuestionType;
    required: boolean;
    readOnly: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration | undefined;
}

export class QuestionOption implements IQuestionOption {
    code?: string | undefined;
    label?: string | undefined;
    score!: number;

    constructor(data?: IQuestionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.label = _data["Label"];
            this.score = _data["Score"];
        }
    }

    static fromJS(data: any): QuestionOption {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Label"] = this.label;
        data["Score"] = this.score;
        return data;
    }
}

export interface IQuestionOption {
    code?: string | undefined;
    label?: string | undefined;
    score: number;
}

export class InteractionQuestionGroup implements IInteractionQuestionGroup {
    groupId!: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;

    constructor(data?: IInteractionQuestionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["GroupId"];
            this.label = _data["Label"];
            if (Array.isArray(_data["QuestionIds"])) {
                this.questionIds = [] as any;
                for (let item of _data["QuestionIds"])
                    this.questionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InteractionQuestionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroupId"] = this.groupId;
        data["Label"] = this.label;
        if (Array.isArray(this.questionIds)) {
            data["QuestionIds"] = [];
            for (let item of this.questionIds)
                data["QuestionIds"].push(item);
        }
        return data;
    }
}

export interface IInteractionQuestionGroup {
    groupId: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;
}

export class InteractionNoteModel implements IInteractionNoteModel {
    noteType!: InteractionNoteType;
    notes?: string | undefined;

    constructor(data?: IInteractionNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["NoteType"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InteractionNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NoteType"] = this.noteType;
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IInteractionNoteModel {
    noteType: InteractionNoteType;
    notes?: string | undefined;
}

export class InteractionRulesGroup implements IInteractionRulesGroup {
    rules?: InteractionRule[] | undefined;
    comparisor?: InteractionRuleComparisor | undefined;
    groups?: InteractionRulesGroup[] | undefined;

    constructor(data?: IInteractionRulesGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Rules"])) {
                this.rules = [] as any;
                for (let item of _data["Rules"])
                    this.rules!.push(InteractionRule.fromJS(item));
            }
            this.comparisor = _data["Comparisor"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(InteractionRulesGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionRulesGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRulesGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["Rules"] = [];
            for (let item of this.rules)
                data["Rules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Comparisor"] = this.comparisor;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInteractionRulesGroup {
    rules?: InteractionRule[] | undefined;
    comparisor?: InteractionRuleComparisor | undefined;
    groups?: InteractionRulesGroup[] | undefined;
}

export class InteractionRule implements IInteractionRule {
    ruleId?: string | undefined;
    dependOnQuestionId!: number;
    operator!: InteractionRuleOperator;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;

    constructor(data?: IInteractionRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["RuleId"];
            this.dependOnQuestionId = _data["DependOnQuestionId"];
            this.operator = _data["Operator"];
            this.evaluatedValue = _data["EvaluatedValue"];
            this.evaluationSubCode = _data["EvaluationSubCode"];
        }
    }

    static fromJS(data: any): InteractionRule {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RuleId"] = this.ruleId;
        data["DependOnQuestionId"] = this.dependOnQuestionId;
        data["Operator"] = this.operator;
        data["EvaluatedValue"] = this.evaluatedValue;
        data["EvaluationSubCode"] = this.evaluationSubCode;
        return data;
    }
}

export interface IInteractionRule {
    ruleId?: string | undefined;
    dependOnQuestionId: number;
    operator: InteractionRuleOperator;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;
}

export enum InteractionRuleOperator {
    IsBlank = 1,
    IsNotBlank = 2,
    StartsWith = 3,
    EndsWith = 4,
    Contains = 5,
    Equals = 6,
    GreaterThan = 7,
    LessThan = 8,
    DoesNotContain = 9,
    DoesNotEqual = 10,
}

export enum InteractionRuleComparisor {
    And = 0,
    Or = 1,
}

export class PostEnrollmentInteractionResponse implements IPostEnrollmentInteractionResponse {
    status!: PostEnrollmentInteractionStatus;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;

    constructor(data?: IPostEnrollmentInteractionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.patientIdentifier = _data["PatientIdentifier"];
            this.errorType = _data["ErrorType"];
            this.errorDescription = _data["ErrorDescription"];
            this.redirectToUrl = _data["RedirectToUrl"];
            this.isRegistration = _data["IsRegistration"];
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["PatientIdentifier"] = this.patientIdentifier;
        data["ErrorType"] = this.errorType;
        data["ErrorDescription"] = this.errorDescription;
        data["RedirectToUrl"] = this.redirectToUrl;
        data["IsRegistration"] = this.isRegistration;
        return data;
    }
}

export interface IPostEnrollmentInteractionResponse {
    status: PostEnrollmentInteractionStatus;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;
}

export enum PostEnrollmentInteractionStatus {
    Ok = 0,
    PaymentFail = 1,
    PaymentSuccess = 2,
    PatientFailed = 3,
    RouteToPayment = 4,
    RouteToScheduler = 5,
    PatientSuccess = 6,
}

export class PostGenericInteractionPublicRequest implements IPostGenericInteractionPublicRequest {
    requestKey!: string;
    interactionResponse?: InteractionResponseModel | undefined;

    constructor(data?: IPostGenericInteractionPublicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestKey = _data["RequestKey"];
            this.interactionResponse = _data["InteractionResponse"] ? InteractionResponseModel.fromJS(_data["InteractionResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostGenericInteractionPublicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostGenericInteractionPublicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RequestKey"] = this.requestKey;
        data["InteractionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostGenericInteractionPublicRequest {
    requestKey: string;
    interactionResponse?: InteractionResponseModel | undefined;
}

export class InteractionResponseModel implements IInteractionResponseModel {
    iPAddress?: string | undefined;
    saveAsDraft!: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion[] | undefined;
    notes?: string | undefined;

    constructor(data?: IInteractionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iPAddress = _data["IPAddress"];
            this.saveAsDraft = _data["SaveAsDraft"];
            this.callBackToken = _data["CallBackToken"];
            if (Array.isArray(_data["Responses"])) {
                this.responses = [] as any;
                for (let item of _data["Responses"])
                    this.responses!.push(InteractionResponseQuestion.fromJS(item));
            }
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InteractionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IPAddress"] = this.iPAddress;
        data["SaveAsDraft"] = this.saveAsDraft;
        data["CallBackToken"] = this.callBackToken;
        if (Array.isArray(this.responses)) {
            data["Responses"] = [];
            for (let item of this.responses)
                data["Responses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IInteractionResponseModel {
    iPAddress?: string | undefined;
    saveAsDraft: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion[] | undefined;
    notes?: string | undefined;
}

export class InteractionResponseQuestion implements IInteractionResponseQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId!: number;

    constructor(data?: IInteractionResponseQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Answers"])) {
                this.answers = [] as any;
                for (let item of _data["Answers"])
                    this.answers!.push(QuestionAnswerModel.fromJS(item));
            }
            this.interactionQuestionId = _data["InteractionQuestionId"];
        }
    }

    static fromJS(data: any): InteractionResponseQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["Answers"] = [];
            for (let item of this.answers)
                data["Answers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["InteractionQuestionId"] = this.interactionQuestionId;
        return data;
    }
}

export interface IInteractionResponseQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId: number;
}

export class PostEnrollmentInteractionRequest implements IPostEnrollmentInteractionRequest {
    interactionResponse?: InteractionResponseModel | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation | undefined;

    constructor(data?: IPostEnrollmentInteractionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionResponse = _data["InteractionResponse"] ? InteractionResponseModel.fromJS(_data["InteractionResponse"]) : <any>undefined;
            this.enrollmentPaymentInformation = _data["EnrollmentPaymentInformation"] ? EnrollmentPaymentInformation.fromJS(_data["EnrollmentPaymentInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : <any>undefined;
        data["EnrollmentPaymentInformation"] = this.enrollmentPaymentInformation ? this.enrollmentPaymentInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostEnrollmentInteractionRequest {
    interactionResponse?: InteractionResponseModel | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation | undefined;
}

export class EnrollmentPaymentInformation implements IEnrollmentPaymentInformation {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IEnrollmentPaymentInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["CardNumber"];
            this.cvv = _data["Cvv"];
            this.expiration = _data["Expiration"];
            this.streetNumber = _data["StreetNumber"];
            this.streetName = _data["StreetName"];
            this.postalCode = _data["PostalCode"];
        }
    }

    static fromJS(data: any): EnrollmentPaymentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentPaymentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CardNumber"] = this.cardNumber;
        data["Cvv"] = this.cvv;
        data["Expiration"] = this.expiration;
        data["StreetNumber"] = this.streetNumber;
        data["StreetName"] = this.streetName;
        data["PostalCode"] = this.postalCode;
        return data;
    }
}

export interface IEnrollmentPaymentInformation {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;
}

export class InteractionModel2 implements IInteractionModel2 {
    interactionId!: number;
    siteId!: string;
    studyId!: string;
    categoryId?: string | undefined;
    name?: string | undefined;
    type!: InteractionType;
    securityType!: InteractionSecurityType;
    scoreType!: ScoreType;
    noteType!: InteractionNoteType;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    variablePrefix?: string | undefined;
    rescore!: boolean;
    requireInternalSignature!: boolean;
    isPriority!: boolean;
    isActive!: boolean;
    createdBy?: string | undefined;
    createdOn!: Date;
    modifiedBy?: string | undefined;
    modifiedOn!: Date;
    faxNumberId?: string | undefined;

    constructor(data?: IInteractionModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["InteractionId"];
            this.siteId = _data["SiteId"];
            this.studyId = _data["StudyId"];
            this.categoryId = _data["CategoryId"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.securityType = _data["SecurityType"];
            this.scoreType = _data["ScoreType"];
            this.noteType = _data["NoteType"];
            this.minAge = _data["MinAge"];
            this.maxAge = _data["MaxAge"];
            this.autoScheduleLength = _data["AutoScheduleLength"];
            this.autoScheduleInterval = _data["AutoScheduleInterval"];
            this.tabPosition = _data["TabPosition"];
            this.tabName = _data["TabName"];
            this.variablePrefix = _data["VariablePrefix"];
            this.rescore = _data["Rescore"];
            this.requireInternalSignature = _data["RequireInternalSignature"];
            this.isPriority = _data["IsPriority"];
            this.isActive = _data["IsActive"];
            this.createdBy = _data["CreatedBy"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["ModifiedBy"];
            this.modifiedOn = _data["ModifiedOn"] ? new Date(_data["ModifiedOn"].toString()) : <any>undefined;
            this.faxNumberId = _data["FaxNumberId"];
        }
    }

    static fromJS(data: any): InteractionModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionId"] = this.interactionId;
        data["SiteId"] = this.siteId;
        data["StudyId"] = this.studyId;
        data["CategoryId"] = this.categoryId;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SecurityType"] = this.securityType;
        data["ScoreType"] = this.scoreType;
        data["NoteType"] = this.noteType;
        data["MinAge"] = this.minAge;
        data["MaxAge"] = this.maxAge;
        data["AutoScheduleLength"] = this.autoScheduleLength;
        data["AutoScheduleInterval"] = this.autoScheduleInterval;
        data["TabPosition"] = this.tabPosition;
        data["TabName"] = this.tabName;
        data["VariablePrefix"] = this.variablePrefix;
        data["Rescore"] = this.rescore;
        data["RequireInternalSignature"] = this.requireInternalSignature;
        data["IsPriority"] = this.isPriority;
        data["IsActive"] = this.isActive;
        data["CreatedBy"] = this.createdBy;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["ModifiedBy"] = this.modifiedBy;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["FaxNumberId"] = this.faxNumberId;
        return data;
    }
}

export interface IInteractionModel2 {
    interactionId: number;
    siteId: string;
    studyId: string;
    categoryId?: string | undefined;
    name?: string | undefined;
    type: InteractionType;
    securityType: InteractionSecurityType;
    scoreType: ScoreType;
    noteType: InteractionNoteType;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    variablePrefix?: string | undefined;
    rescore: boolean;
    requireInternalSignature: boolean;
    isPriority: boolean;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn: Date;
    modifiedBy?: string | undefined;
    modifiedOn: Date;
    faxNumberId?: string | undefined;
}

export class AccountDto implements IAccountDto {
    name?: string | undefined;
    email?: string | undefined;
    accountId?: string | undefined;
    agentId?: string | undefined;
    isVerified!: boolean;
    culture!: string;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.accountId = _data["AccountId"];
            this.agentId = _data["AgentId"];
            this.isVerified = _data["IsVerified"];
            this.culture = _data["Culture"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["AccountId"] = this.accountId;
        data["AgentId"] = this.agentId;
        data["IsVerified"] = this.isVerified;
        data["Culture"] = this.culture;
        return data;
    }
}

export interface IAccountDto {
    name?: string | undefined;
    email?: string | undefined;
    accountId?: string | undefined;
    agentId?: string | undefined;
    isVerified: boolean;
    culture: string;
}

export class AccountCultureResponseDto implements IAccountCultureResponseDto {
    cultureId!: string;
    name!: string;

    constructor(data?: IAccountCultureResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureId = _data["CultureId"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): AccountCultureResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCultureResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CultureId"] = this.cultureId;
        data["Name"] = this.name;
        return data;
    }
}

export interface IAccountCultureResponseDto {
    cultureId: string;
    name: string;
}

export class AccountCultureSetRequest implements IAccountCultureSetRequest {
    accountId!: string;
    cultureId!: string;

    constructor(data?: IAccountCultureSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            this.cultureId = _data["CultureId"];
        }
    }

    static fromJS(data: any): AccountCultureSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCultureSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        data["CultureId"] = this.cultureId;
        return data;
    }
}

export interface IAccountCultureSetRequest {
    accountId: string;
    cultureId: string;
}

export class AdminRegisterResponseModel implements IAdminRegisterResponseModel {
    success!: boolean;

    constructor(data?: IAdminRegisterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): AdminRegisterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRegisterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        return data;
    }
}

export interface IAdminRegisterResponseModel {
    success: boolean;
}

export class AdminRegisterRequestModel implements IAdminRegisterRequestModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IAdminRegisterRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.ipAddress = _data["IpAddress"];
        }
    }

    static fromJS(data: any): AdminRegisterRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRegisterRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["IpAddress"] = this.ipAddress;
        return data;
    }
}

export interface IAdminRegisterRequestModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ipAddress?: string | undefined;
}

export class CurrentUserRole implements ICurrentUserRole {
    isAdmin!: boolean;

    constructor(data?: ICurrentUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAdmin = _data["IsAdmin"];
        }
    }

    static fromJS(data: any): CurrentUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsAdmin"] = this.isAdmin;
        return data;
    }
}

export interface ICurrentUserRole {
    isAdmin: boolean;
}

export class BaseAgentDto implements IBaseAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles!: AgentFileServiceModel[];
    name!: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress!: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus!: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;

    constructor(data?: IBaseAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agentFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.personalEmail = _data["PersonalEmail"];
            this.phoneNumber = _data["PhoneNumber"];
            this.bankTransitNumber = _data["BankTransitNumber"];
            this.branchTransitNumber = _data["BranchTransitNumber"];
            this.accountTransitNumber = _data["AccountTransitNumber"];
            if (Array.isArray(_data["AgentFiles"])) {
                this.agentFiles = [] as any;
                for (let item of _data["AgentFiles"])
                    this.agentFiles!.push(AgentFileServiceModel.fromJS(item));
            }
            this.name = _data["Name"];
            this.personalAddress = _data["PersonalAddress"] ? AgentAddressDto.fromJS(_data["PersonalAddress"]) : <any>undefined;
            this.billingEntityName = _data["BillingEntityName"];
            this.billingAddress = _data["BillingAddress"] ? AgentAddressDto.fromJS(_data["BillingAddress"]) : <any>undefined;
            this.billingSamePersonalAddress = _data["BillingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["SalesTaxIdentifier"];
            this.salesTaxRate = _data["SalesTaxRate"];
            this.hourRate = _data["HourRate"];
            if (Array.isArray(_data["LicencedProvinces"])) {
                this.licencedProvinces = [] as any;
                for (let item of _data["LicencedProvinces"])
                    this.licencedProvinces!.push(AgentLicenceProvinceDto.fromJS(item));
            }
            this.liabilityInsuranceProvider = _data["LiabilityInsuranceProvider"];
            this.liabilityInsuranceExpirationDate = _data["LiabilityInsuranceExpirationDate"] ? new Date(_data["LiabilityInsuranceExpirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["Languages"])) {
                this.languages = [] as any;
                for (let item of _data["Languages"])
                    this.languages!.push(item);
            }
            this.scheduleNotes = _data["ScheduleNotes"];
            this.professionalDesignation = _data["ProfessionalDesignation"];
            this.accountEmail = _data["AccountEmail"];
            this.startingOn = _data["StartingOn"] ? new Date(_data["StartingOn"].toString()) : <any>undefined;
            this.agentStatus = _data["AgentStatus"];
            if (Array.isArray(_data["AgentAdminNotes"])) {
                this.agentAdminNotes = [] as any;
                for (let item of _data["AgentAdminNotes"])
                    this.agentAdminNotes!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.agentDevice = _data["AgentDevice"] ? AgentDtoDeviceSummary.fromJS(_data["AgentDevice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["PersonalEmail"] = this.personalEmail;
        data["PhoneNumber"] = this.phoneNumber;
        data["BankTransitNumber"] = this.bankTransitNumber;
        data["BranchTransitNumber"] = this.branchTransitNumber;
        data["AccountTransitNumber"] = this.accountTransitNumber;
        if (Array.isArray(this.agentFiles)) {
            data["AgentFiles"] = [];
            for (let item of this.agentFiles)
                data["AgentFiles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Name"] = this.name;
        data["PersonalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : <any>undefined;
        data["BillingEntityName"] = this.billingEntityName;
        data["BillingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["BillingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["SalesTaxIdentifier"] = this.salesTaxIdentifier;
        data["SalesTaxRate"] = this.salesTaxRate;
        data["HourRate"] = this.hourRate;
        if (Array.isArray(this.licencedProvinces)) {
            data["LicencedProvinces"] = [];
            for (let item of this.licencedProvinces)
                data["LicencedProvinces"].push(item ? item.toJSON() : <any>undefined);
        }
        data["LiabilityInsuranceProvider"] = this.liabilityInsuranceProvider;
        data["LiabilityInsuranceExpirationDate"] = this.liabilityInsuranceExpirationDate ? this.liabilityInsuranceExpirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item);
        }
        data["ScheduleNotes"] = this.scheduleNotes;
        data["ProfessionalDesignation"] = this.professionalDesignation;
        data["AccountEmail"] = this.accountEmail;
        data["StartingOn"] = this.startingOn ? this.startingOn.toISOString() : <any>undefined;
        data["AgentStatus"] = this.agentStatus;
        if (Array.isArray(this.agentAdminNotes)) {
            data["AgentAdminNotes"] = [];
            for (let item of this.agentAdminNotes)
                data["AgentAdminNotes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentDevice"] = this.agentDevice ? this.agentDevice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles: AgentFileServiceModel[];
    name: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
}

export class SimpleAgentDto extends BaseAgentDto implements ISimpleAgentDto {

    constructor(data?: ISimpleAgentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SimpleAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleAgentDto extends IBaseAgentDto {
}

export class AgentFileServiceModel implements IAgentFileServiceModel {
    fileName?: string | undefined;
    type!: AgentFileType;
    blobId!: string;

    constructor(data?: IAgentFileServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.type = _data["Type"];
            this.blobId = _data["BlobId"];
        }
    }

    static fromJS(data: any): AgentFileServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFileServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Type"] = this.type;
        data["BlobId"] = this.blobId;
        return data;
    }
}

export interface IAgentFileServiceModel {
    fileName?: string | undefined;
    type: AgentFileType;
    blobId: string;
}

export enum AgentFileType {
    Insurance = 1,
    ProfilePicture = 2,
    Signature = 3,
    Resume = 4,
    Interview = 5,
    References = 6,
    ContractorsAgreement = 7,
    VoidCheque = 8,
}

export class AgentAddressDto implements IAgentAddressDto {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceStateID?: number | undefined;

    constructor(data?: IAgentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["Address"];
            this.city = _data["City"];
            this.postalCode = _data["PostalCode"];
            this.provinceStateID = _data["ProvinceStateID"];
        }
    }

    static fromJS(data: any): AgentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Address"] = this.address;
        data["City"] = this.city;
        data["PostalCode"] = this.postalCode;
        data["ProvinceStateID"] = this.provinceStateID;
        return data;
    }
}

export interface IAgentAddressDto {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceStateID?: number | undefined;
}

export class AgentLicenceProvinceDto implements IAgentLicenceProvinceDto {
    stateProvinceId!: number;
    licenceIdentifier?: string | undefined;
    healthInsuranceBillingNumber?: string | undefined;

    constructor(data?: IAgentLicenceProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateProvinceId = _data["StateProvinceId"];
            this.licenceIdentifier = _data["LicenceIdentifier"];
            this.healthInsuranceBillingNumber = _data["HealthInsuranceBillingNumber"];
        }
    }

    static fromJS(data: any): AgentLicenceProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentLicenceProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StateProvinceId"] = this.stateProvinceId;
        data["LicenceIdentifier"] = this.licenceIdentifier;
        data["HealthInsuranceBillingNumber"] = this.healthInsuranceBillingNumber;
        return data;
    }
}

export interface IAgentLicenceProvinceDto {
    stateProvinceId: number;
    licenceIdentifier?: string | undefined;
    healthInsuranceBillingNumber?: string | undefined;
}

export enum Languages {
    English = 0,
    French = 1,
    Portuguese = 2,
    Mandarin = 3,
    Cantonese = 4,
    Punjabi = 5,
    Tagalog = 6,
    Spanish = 7,
    Arabic = 8,
    Italian = 9,
    German = 10,
}

export enum AgentStatus {
    Onboarding = 0,
    Active = 1,
    Inactive = 2,
}

export class AgentAdminNoteDto implements IAgentAdminNoteDto {
    agentAdminNoteId!: string;
    subject?: string | undefined;
    body?: string | undefined;
    reviewedOn?: Date | undefined;
    createdOn?: Date | undefined;
    agentId!: string;
    agentName?: string | undefined;
    accountAuthorId!: string;

    constructor(data?: IAgentAdminNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentAdminNoteId = _data["AgentAdminNoteId"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.reviewedOn = _data["ReviewedOn"] ? new Date(_data["ReviewedOn"].toString()) : <any>undefined;
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.agentId = _data["AgentId"];
            this.agentName = _data["AgentName"];
            this.accountAuthorId = _data["AccountAuthorId"];
        }
    }

    static fromJS(data: any): AgentAdminNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAdminNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentAdminNoteId"] = this.agentAdminNoteId;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["ReviewedOn"] = this.reviewedOn ? this.reviewedOn.toISOString() : <any>undefined;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["AgentId"] = this.agentId;
        data["AgentName"] = this.agentName;
        data["AccountAuthorId"] = this.accountAuthorId;
        return data;
    }
}

export interface IAgentAdminNoteDto {
    agentAdminNoteId: string;
    subject?: string | undefined;
    body?: string | undefined;
    reviewedOn?: Date | undefined;
    createdOn?: Date | undefined;
    agentId: string;
    agentName?: string | undefined;
    accountAuthorId: string;
}

export class AgentDtoDeviceSummary implements IAgentDtoDeviceSummary {
    deviceId?: string | undefined;
    hasPendingDevices!: boolean;
    deviceInfo?: AgentDeviceInfo | undefined;
    agentDeviceModelType?: string | undefined;
    agentDeviceOperatingSystem?: string | undefined;
    deviceChecks?: DeviceCheck[] | undefined;

    constructor(data?: IAgentDtoDeviceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["DeviceId"];
            this.hasPendingDevices = _data["HasPendingDevices"];
            this.deviceInfo = _data["DeviceInfo"] ? AgentDeviceInfo.fromJS(_data["DeviceInfo"]) : <any>undefined;
            this.agentDeviceModelType = _data["AgentDeviceModelType"];
            this.agentDeviceOperatingSystem = _data["AgentDeviceOperatingSystem"];
            if (Array.isArray(_data["DeviceChecks"])) {
                this.deviceChecks = [] as any;
                for (let item of _data["DeviceChecks"])
                    this.deviceChecks!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentDtoDeviceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDtoDeviceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceId"] = this.deviceId;
        data["HasPendingDevices"] = this.hasPendingDevices;
        data["DeviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : <any>undefined;
        data["AgentDeviceModelType"] = this.agentDeviceModelType;
        data["AgentDeviceOperatingSystem"] = this.agentDeviceOperatingSystem;
        if (Array.isArray(this.deviceChecks)) {
            data["DeviceChecks"] = [];
            for (let item of this.deviceChecks)
                data["DeviceChecks"].push(item);
        }
        return data;
    }
}

export interface IAgentDtoDeviceSummary {
    deviceId?: string | undefined;
    hasPendingDevices: boolean;
    deviceInfo?: AgentDeviceInfo | undefined;
    agentDeviceModelType?: string | undefined;
    agentDeviceOperatingSystem?: string | undefined;
    deviceChecks?: DeviceCheck[] | undefined;
}

export class AgentDeviceInfo implements IAgentDeviceInfo {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
    deviceIdentifier?: string | undefined;
    deviceModelType?: string | undefined;
    deviceOperatingSystem?: string | undefined;

    constructor(data?: IAgentDeviceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelType = _data["ModelType"];
            this.operatingSystem = _data["OperatingSystem"];
            this.deviceIdentifier = _data["DeviceIdentifier"];
            this.deviceModelType = _data["DeviceModelType"];
            this.deviceOperatingSystem = _data["DeviceOperatingSystem"];
        }
    }

    static fromJS(data: any): AgentDeviceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDeviceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModelType"] = this.modelType;
        data["OperatingSystem"] = this.operatingSystem;
        data["DeviceIdentifier"] = this.deviceIdentifier;
        data["DeviceModelType"] = this.deviceModelType;
        data["DeviceOperatingSystem"] = this.deviceOperatingSystem;
        return data;
    }
}

export interface IAgentDeviceInfo {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
    deviceIdentifier?: string | undefined;
    deviceModelType?: string | undefined;
    deviceOperatingSystem?: string | undefined;
}

export enum DeviceCheck {
    MeetsRequirements = 0,
    OpenVpnInstalled = 1,
    AsteriskClientInstalled = 2,
    MsOfficeInstalled = 3,
}

export enum AgentRole {
    Admin = 0,
    Dietitian = 1,
    MD = 2,
}

export class FullAgentDto implements IFullAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles!: AgentFileServiceModel[];
    name!: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress!: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus!: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
    agentRole!: AgentRole;
    agentNotes?: AgentNoteDto[] | undefined;
    hasUnreviewedAgentAdminNotes?: boolean | undefined;

    constructor(data?: IFullAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agentFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.personalEmail = _data["PersonalEmail"];
            this.phoneNumber = _data["PhoneNumber"];
            this.bankTransitNumber = _data["BankTransitNumber"];
            this.branchTransitNumber = _data["BranchTransitNumber"];
            this.accountTransitNumber = _data["AccountTransitNumber"];
            if (Array.isArray(_data["AgentFiles"])) {
                this.agentFiles = [] as any;
                for (let item of _data["AgentFiles"])
                    this.agentFiles!.push(AgentFileServiceModel.fromJS(item));
            }
            this.name = _data["Name"];
            this.personalAddress = _data["PersonalAddress"] ? AgentAddressDto.fromJS(_data["PersonalAddress"]) : <any>undefined;
            this.billingEntityName = _data["BillingEntityName"];
            this.billingAddress = _data["BillingAddress"] ? AgentAddressDto.fromJS(_data["BillingAddress"]) : <any>undefined;
            this.billingSamePersonalAddress = _data["BillingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["SalesTaxIdentifier"];
            this.salesTaxRate = _data["SalesTaxRate"];
            this.hourRate = _data["HourRate"];
            if (Array.isArray(_data["LicencedProvinces"])) {
                this.licencedProvinces = [] as any;
                for (let item of _data["LicencedProvinces"])
                    this.licencedProvinces!.push(AgentLicenceProvinceDto.fromJS(item));
            }
            this.liabilityInsuranceProvider = _data["LiabilityInsuranceProvider"];
            this.liabilityInsuranceExpirationDate = _data["LiabilityInsuranceExpirationDate"] ? new Date(_data["LiabilityInsuranceExpirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["Languages"])) {
                this.languages = [] as any;
                for (let item of _data["Languages"])
                    this.languages!.push(item);
            }
            this.scheduleNotes = _data["ScheduleNotes"];
            this.professionalDesignation = _data["ProfessionalDesignation"];
            this.accountEmail = _data["AccountEmail"];
            this.startingOn = _data["StartingOn"] ? new Date(_data["StartingOn"].toString()) : <any>undefined;
            this.agentStatus = _data["AgentStatus"];
            if (Array.isArray(_data["AgentAdminNotes"])) {
                this.agentAdminNotes = [] as any;
                for (let item of _data["AgentAdminNotes"])
                    this.agentAdminNotes!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.agentDevice = _data["AgentDevice"] ? AgentDtoDeviceSummary.fromJS(_data["AgentDevice"]) : <any>undefined;
            this.agentRole = _data["AgentRole"];
            if (Array.isArray(_data["AgentNotes"])) {
                this.agentNotes = [] as any;
                for (let item of _data["AgentNotes"])
                    this.agentNotes!.push(AgentNoteDto.fromJS(item));
            }
            this.hasUnreviewedAgentAdminNotes = _data["HasUnreviewedAgentAdminNotes"];
        }
    }

    static fromJS(data: any): FullAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["PersonalEmail"] = this.personalEmail;
        data["PhoneNumber"] = this.phoneNumber;
        data["BankTransitNumber"] = this.bankTransitNumber;
        data["BranchTransitNumber"] = this.branchTransitNumber;
        data["AccountTransitNumber"] = this.accountTransitNumber;
        if (Array.isArray(this.agentFiles)) {
            data["AgentFiles"] = [];
            for (let item of this.agentFiles)
                data["AgentFiles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Name"] = this.name;
        data["PersonalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : <any>undefined;
        data["BillingEntityName"] = this.billingEntityName;
        data["BillingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["BillingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["SalesTaxIdentifier"] = this.salesTaxIdentifier;
        data["SalesTaxRate"] = this.salesTaxRate;
        data["HourRate"] = this.hourRate;
        if (Array.isArray(this.licencedProvinces)) {
            data["LicencedProvinces"] = [];
            for (let item of this.licencedProvinces)
                data["LicencedProvinces"].push(item ? item.toJSON() : <any>undefined);
        }
        data["LiabilityInsuranceProvider"] = this.liabilityInsuranceProvider;
        data["LiabilityInsuranceExpirationDate"] = this.liabilityInsuranceExpirationDate ? this.liabilityInsuranceExpirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item);
        }
        data["ScheduleNotes"] = this.scheduleNotes;
        data["ProfessionalDesignation"] = this.professionalDesignation;
        data["AccountEmail"] = this.accountEmail;
        data["StartingOn"] = this.startingOn ? this.startingOn.toISOString() : <any>undefined;
        data["AgentStatus"] = this.agentStatus;
        if (Array.isArray(this.agentAdminNotes)) {
            data["AgentAdminNotes"] = [];
            for (let item of this.agentAdminNotes)
                data["AgentAdminNotes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentDevice"] = this.agentDevice ? this.agentDevice.toJSON() : <any>undefined;
        data["AgentRole"] = this.agentRole;
        if (Array.isArray(this.agentNotes)) {
            data["AgentNotes"] = [];
            for (let item of this.agentNotes)
                data["AgentNotes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["HasUnreviewedAgentAdminNotes"] = this.hasUnreviewedAgentAdminNotes;
        return data;
    }
}

export interface IFullAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles: AgentFileServiceModel[];
    name: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
    agentRole: AgentRole;
    agentNotes?: AgentNoteDto[] | undefined;
    hasUnreviewedAgentAdminNotes?: boolean | undefined;
}

export class AgentNoteDto implements IAgentNoteDto {
    agentNoteId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    agentId!: string;
    authorName!: string;
    authorAccountId!: string;
    createdOn?: Date | undefined;

    constructor(data?: IAgentNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentNoteId = _data["AgentNoteId"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.agentId = _data["AgentId"];
            this.authorName = _data["AuthorName"];
            this.authorAccountId = _data["AuthorAccountId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentNoteId"] = this.agentNoteId;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["AgentId"] = this.agentId;
        data["AuthorName"] = this.authorName;
        data["AuthorAccountId"] = this.authorAccountId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgentNoteDto {
    agentNoteId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    agentId: string;
    authorName: string;
    authorAccountId: string;
    createdOn?: Date | undefined;
}

export class PaginatedResponseOfSummaryAgentDto implements IPaginatedResponseOfSummaryAgentDto {
    results?: SummaryAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfSummaryAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(SummaryAgentDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfSummaryAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfSummaryAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfSummaryAgentDto {
    results?: SummaryAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class SummaryAgentDto implements ISummaryAgentDto {
    agentId!: string;
    name!: string;
    agentRole?: AgentRole | undefined;

    constructor(data?: ISummaryAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.name = _data["Name"];
            this.agentRole = _data["AgentRole"];
        }
    }

    static fromJS(data: any): SummaryAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["Name"] = this.name;
        data["AgentRole"] = this.agentRole;
        return data;
    }
}

export interface ISummaryAgentDto {
    agentId: string;
    name: string;
    agentRole?: AgentRole | undefined;
}

export class PaginatedResponseOfFullAgentDto implements IPaginatedResponseOfFullAgentDto {
    results?: FullAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfFullAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(FullAgentDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfFullAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfFullAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfFullAgentDto {
    results?: FullAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class GetListRequest implements IGetListRequest {

    constructor(data?: IGetListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetListRequest {
}

export class PaginatedResponseOfAgentNoteDto implements IPaginatedResponseOfAgentNoteDto {
    results?: AgentNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(AgentNoteDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentNoteDto {
    results?: AgentNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PaginatedResponseOfAgentAdminNoteDto implements IPaginatedResponseOfAgentAdminNoteDto {
    results?: AgentAdminNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentAdminNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentAdminNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentAdminNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentAdminNoteDto {
    results?: AgentAdminNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class DoReviewAgentAdminNoteModelRequest implements IDoReviewAgentAdminNoteModelRequest {
    agentAdminNoteId!: string;

    constructor(data?: IDoReviewAgentAdminNoteModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentAdminNoteId = _data["AgentAdminNoteId"];
        }
    }

    static fromJS(data: any): DoReviewAgentAdminNoteModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoReviewAgentAdminNoteModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentAdminNoteId"] = this.agentAdminNoteId;
        return data;
    }
}

export interface IDoReviewAgentAdminNoteModelRequest {
    agentAdminNoteId: string;
}

export class DoSetActiveDeviceRequest implements IDoSetActiveDeviceRequest {
    agentId!: string;
    deviceId?: string | undefined;
    deviceDefinition?: DoSetActiveDeviceRequestDeviceDefinition | undefined;

    constructor(data?: IDoSetActiveDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.deviceId = _data["DeviceId"];
            this.deviceDefinition = _data["DeviceDefinition"] ? DoSetActiveDeviceRequestDeviceDefinition.fromJS(_data["DeviceDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DoSetActiveDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSetActiveDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["DeviceId"] = this.deviceId;
        data["DeviceDefinition"] = this.deviceDefinition ? this.deviceDefinition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDoSetActiveDeviceRequest {
    agentId: string;
    deviceId?: string | undefined;
    deviceDefinition?: DoSetActiveDeviceRequestDeviceDefinition | undefined;
}

export class DoSetActiveDeviceRequestDeviceDefinition implements IDoSetActiveDeviceRequestDeviceDefinition {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;

    constructor(data?: IDoSetActiveDeviceRequestDeviceDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelType = _data["ModelType"];
            this.operatingSystem = _data["OperatingSystem"];
        }
    }

    static fromJS(data: any): DoSetActiveDeviceRequestDeviceDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new DoSetActiveDeviceRequestDeviceDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModelType"] = this.modelType;
        data["OperatingSystem"] = this.operatingSystem;
        return data;
    }
}

export interface IDoSetActiveDeviceRequestDeviceDefinition {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
}

export class PaginatedResponseOfDeviceDto implements IPaginatedResponseOfDeviceDto {
    results?: DeviceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(DeviceDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfDeviceDto {
    results?: DeviceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class DeviceDto implements IDeviceDto {
    deviceId?: string | undefined;
    identifier!: string;
    modelType!: string;
    modelYear!: string;
    serialNumber?: string | undefined;
    operatingSystem?: string | undefined;
    purchaseDate!: Date;
    deviceStatus!: DeviceStatus;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["DeviceId"];
            this.identifier = _data["Identifier"];
            this.modelType = _data["ModelType"];
            this.modelYear = _data["ModelYear"];
            this.serialNumber = _data["SerialNumber"];
            this.operatingSystem = _data["OperatingSystem"];
            this.purchaseDate = _data["PurchaseDate"] ? new Date(_data["PurchaseDate"].toString()) : <any>undefined;
            this.deviceStatus = _data["DeviceStatus"];
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceId"] = this.deviceId;
        data["Identifier"] = this.identifier;
        data["ModelType"] = this.modelType;
        data["ModelYear"] = this.modelYear;
        data["SerialNumber"] = this.serialNumber;
        data["OperatingSystem"] = this.operatingSystem;
        data["PurchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["DeviceStatus"] = this.deviceStatus;
        return data;
    }
}

export interface IDeviceDto {
    deviceId?: string | undefined;
    identifier: string;
    modelType: string;
    modelYear: string;
    serialNumber?: string | undefined;
    operatingSystem?: string | undefined;
    purchaseDate: Date;
    deviceStatus: DeviceStatus;
}

export enum DeviceStatus {
    Available = 1,
    Busy = 2,
    Disabled = 3,
}

export class AgentDeviceCheckDto implements IAgentDeviceCheckDto {
    deviceChecks?: DeviceCheck[] | undefined;
    agentId!: string;
    openVpnAccountName?: string | undefined;
    asteriskIdentifier?: string | undefined;

    constructor(data?: IAgentDeviceCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DeviceChecks"])) {
                this.deviceChecks = [] as any;
                for (let item of _data["DeviceChecks"])
                    this.deviceChecks!.push(item);
            }
            this.agentId = _data["AgentId"];
            this.openVpnAccountName = _data["OpenVpnAccountName"];
            this.asteriskIdentifier = _data["AsteriskIdentifier"];
        }
    }

    static fromJS(data: any): AgentDeviceCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDeviceCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deviceChecks)) {
            data["DeviceChecks"] = [];
            for (let item of this.deviceChecks)
                data["DeviceChecks"].push(item);
        }
        data["AgentId"] = this.agentId;
        data["OpenVpnAccountName"] = this.openVpnAccountName;
        data["AsteriskIdentifier"] = this.asteriskIdentifier;
        return data;
    }
}

export interface IAgentDeviceCheckDto {
    deviceChecks?: DeviceCheck[] | undefined;
    agentId: string;
    openVpnAccountName?: string | undefined;
    asteriskIdentifier?: string | undefined;
}

export class AgentRegisterResponseModel implements IAgentRegisterResponseModel {
    accountId!: string;
    success!: boolean;

    constructor(data?: IAgentRegisterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): AgentRegisterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        data["Success"] = this.success;
        return data;
    }
}

export interface IAgentRegisterResponseModel {
    accountId: string;
    success: boolean;
}

export class AgentRegisterRequestModel implements IAgentRegisterRequestModel {
    email!: string;
    firstName!: string;
    lastName!: string;
    ipAddress?: string | undefined;
    agentId!: string;

    constructor(data?: IAgentRegisterRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.ipAddress = _data["IpAddress"];
            this.agentId = _data["AgentId"];
        }
    }

    static fromJS(data: any): AgentRegisterRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisterRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["IpAddress"] = this.ipAddress;
        data["AgentId"] = this.agentId;
        return data;
    }
}

export interface IAgentRegisterRequestModel {
    email: string;
    firstName: string;
    lastName: string;
    ipAddress?: string | undefined;
    agentId: string;
}

export class DashboardResponseModel implements IDashboardResponseModel {
    activeAgents!: number;
    onboardingAgents!: number;
    totalAgents!: number;
    activePhysicianAgents!: number;
    activeDietitianAgents!: number;
    activeBilingualAgents!: number;
    unassignedEquipment!: number;
    pendingEquipment!: number;
    pendingAdminInvoices!: number;
    physicianInvoicesDueForCreation!: number;
    disputedPhysicianInvoices!: number;
    approvedPhysicianInvoices!: number;
    notesForReview!: number;
    trainingSupportRequests!: number;

    constructor(data?: IDashboardResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeAgents = _data["ActiveAgents"];
            this.onboardingAgents = _data["OnboardingAgents"];
            this.totalAgents = _data["TotalAgents"];
            this.activePhysicianAgents = _data["ActivePhysicianAgents"];
            this.activeDietitianAgents = _data["ActiveDietitianAgents"];
            this.activeBilingualAgents = _data["ActiveBilingualAgents"];
            this.unassignedEquipment = _data["UnassignedEquipment"];
            this.pendingEquipment = _data["PendingEquipment"];
            this.pendingAdminInvoices = _data["PendingAdminInvoices"];
            this.physicianInvoicesDueForCreation = _data["PhysicianInvoicesDueForCreation"];
            this.disputedPhysicianInvoices = _data["DisputedPhysicianInvoices"];
            this.approvedPhysicianInvoices = _data["ApprovedPhysicianInvoices"];
            this.notesForReview = _data["NotesForReview"];
            this.trainingSupportRequests = _data["TrainingSupportRequests"];
        }
    }

    static fromJS(data: any): DashboardResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ActiveAgents"] = this.activeAgents;
        data["OnboardingAgents"] = this.onboardingAgents;
        data["TotalAgents"] = this.totalAgents;
        data["ActivePhysicianAgents"] = this.activePhysicianAgents;
        data["ActiveDietitianAgents"] = this.activeDietitianAgents;
        data["ActiveBilingualAgents"] = this.activeBilingualAgents;
        data["UnassignedEquipment"] = this.unassignedEquipment;
        data["PendingEquipment"] = this.pendingEquipment;
        data["PendingAdminInvoices"] = this.pendingAdminInvoices;
        data["PhysicianInvoicesDueForCreation"] = this.physicianInvoicesDueForCreation;
        data["DisputedPhysicianInvoices"] = this.disputedPhysicianInvoices;
        data["ApprovedPhysicianInvoices"] = this.approvedPhysicianInvoices;
        data["NotesForReview"] = this.notesForReview;
        data["TrainingSupportRequests"] = this.trainingSupportRequests;
        return data;
    }
}

export interface IDashboardResponseModel {
    activeAgents: number;
    onboardingAgents: number;
    totalAgents: number;
    activePhysicianAgents: number;
    activeDietitianAgents: number;
    activeBilingualAgents: number;
    unassignedEquipment: number;
    pendingEquipment: number;
    pendingAdminInvoices: number;
    physicianInvoicesDueForCreation: number;
    disputedPhysicianInvoices: number;
    approvedPhysicianInvoices: number;
    notesForReview: number;
    trainingSupportRequests: number;
}

export class DeviceAgentDto extends DeviceDto implements IDeviceAgentDto {
    pendingAgentName?: string | undefined;

    constructor(data?: IDeviceAgentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pendingAgentName = _data["PendingAgentName"];
        }
    }

    static fromJS(data: any): DeviceAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PendingAgentName"] = this.pendingAgentName;
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceAgentDto extends IDeviceDto {
    pendingAgentName?: string | undefined;
}

export class PaginatedResponseOfInvoicingStatusDto implements IPaginatedResponseOfInvoicingStatusDto {
    results?: InvoicingStatusDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfInvoicingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(InvoicingStatusDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfInvoicingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfInvoicingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfInvoicingStatusDto {
    results?: InvoicingStatusDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class InvoicingStatusDto implements IInvoicingStatusDto {
    agentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    periods?: InvoicingStatusPeriodDto[] | undefined;

    constructor(data?: IInvoicingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            if (Array.isArray(_data["Periods"])) {
                this.periods = [] as any;
                for (let item of _data["Periods"])
                    this.periods!.push(InvoicingStatusPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["Name"] = this.name;
        data["Email"] = this.email;
        if (Array.isArray(this.periods)) {
            data["Periods"] = [];
            for (let item of this.periods)
                data["Periods"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInvoicingStatusDto {
    agentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    periods?: InvoicingStatusPeriodDto[] | undefined;
}

export class InvoicingStatusPeriodDto implements IInvoicingStatusPeriodDto {
    period?: Date | undefined;
    invoices?: InvoicingStatusInvoiceDto[] | undefined;

    constructor(data?: IInvoicingStatusPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["Period"] ? new Date(_data["Period"].toString()) : <any>undefined;
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(InvoicingStatusInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicingStatusPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Period"] = this.period ? this.period.toISOString() : <any>undefined;
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInvoicingStatusPeriodDto {
    period?: Date | undefined;
    invoices?: InvoicingStatusInvoiceDto[] | undefined;
}

export class InvoicingStatusInvoiceDto implements IInvoicingStatusInvoiceDto {
    invoiceId?: string | undefined;
    invoiceFlow!: InvoiceFlow;
    invoiceStatus!: InvoiceStatus;
    number!: number;
    latestDispute!: string;
    invoiceDate!: Date;

    constructor(data?: IInvoicingStatusInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.invoiceFlow = _data["InvoiceFlow"];
            this.invoiceStatus = _data["InvoiceStatus"];
            this.number = _data["Number"];
            this.latestDispute = _data["LatestDispute"];
            this.invoiceDate = _data["InvoiceDate"] ? new Date(_data["InvoiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicingStatusInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["InvoiceFlow"] = this.invoiceFlow;
        data["InvoiceStatus"] = this.invoiceStatus;
        data["Number"] = this.number;
        data["LatestDispute"] = this.latestDispute;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoicingStatusInvoiceDto {
    invoiceId?: string | undefined;
    invoiceFlow: InvoiceFlow;
    invoiceStatus: InvoiceStatus;
    number: number;
    latestDispute: string;
    invoiceDate: Date;
}

export enum InvoiceFlow {
    AgentApproval = 0,
    AdminApproval = 1,
    AutoApproval = 2,
}

export enum InvoiceStatus {
    Draft = 0,
    InReview = 1,
    Disputed = 2,
    ApprovedByAgent = 3,
    ApprovedByAdmin = 4,
    Completed = 5,
}

export class PaginatedResponseOfInvoiceDto implements IPaginatedResponseOfInvoiceDto {
    results?: InvoiceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(InvoiceDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfInvoiceDto {
    results?: InvoiceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    invoice!: InvoiceBaseDto;
    extendedData?: InvoiceExtendedDto | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invoice = new InvoiceBaseDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["Invoice"] ? InvoiceBaseDto.fromJS(_data["Invoice"]) : new InvoiceBaseDto();
            this.extendedData = _data["ExtendedData"] ? InvoiceExtendedDto.fromJS(_data["ExtendedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["ExtendedData"] = this.extendedData ? this.extendedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoiceDto {
    invoice: InvoiceBaseDto;
    extendedData?: InvoiceExtendedDto | undefined;
}

export class InvoiceBaseDto implements IInvoiceBaseDto {
    invoiceId!: string;
    invoiceStatus!: InvoiceStatus;
    invoiceNumber!: number;
    invoiceDate!: Date;
    invoiceFlow!: InvoiceFlow;
    agent!: AgentInvoiceDto;
    servicePeriodFrom!: Date;
    servicePeriodTo!: Date;
    latestDispute?: string | undefined;

    constructor(data?: IInvoiceBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agent = new AgentInvoiceDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.invoiceStatus = _data["InvoiceStatus"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.invoiceDate = _data["InvoiceDate"] ? new Date(_data["InvoiceDate"].toString()) : <any>undefined;
            this.invoiceFlow = _data["InvoiceFlow"];
            this.agent = _data["Agent"] ? AgentInvoiceDto.fromJS(_data["Agent"]) : new AgentInvoiceDto();
            this.servicePeriodFrom = _data["ServicePeriodFrom"] ? new Date(_data["ServicePeriodFrom"].toString()) : <any>undefined;
            this.servicePeriodTo = _data["ServicePeriodTo"] ? new Date(_data["ServicePeriodTo"].toString()) : <any>undefined;
            this.latestDispute = _data["LatestDispute"];
        }
    }

    static fromJS(data: any): InvoiceBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["InvoiceStatus"] = this.invoiceStatus;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["InvoiceFlow"] = this.invoiceFlow;
        data["Agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["ServicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : <any>undefined;
        data["ServicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : <any>undefined;
        data["LatestDispute"] = this.latestDispute;
        return data;
    }
}

export interface IInvoiceBaseDto {
    invoiceId: string;
    invoiceStatus: InvoiceStatus;
    invoiceNumber: number;
    invoiceDate: Date;
    invoiceFlow: InvoiceFlow;
    agent: AgentInvoiceDto;
    servicePeriodFrom: Date;
    servicePeriodTo: Date;
    latestDispute?: string | undefined;
}

export class AgentInvoiceDto implements IAgentInvoiceDto {
    agentId!: string;
    billingEntityName?: string | undefined;
    accountEmail?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    personalAddress?: AgentAddressDto | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress!: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    name?: string | undefined;

    constructor(data?: IAgentInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.billingEntityName = _data["BillingEntityName"];
            this.accountEmail = _data["AccountEmail"];
            this.personalEmail = _data["PersonalEmail"];
            this.phoneNumber = _data["PhoneNumber"];
            this.personalAddress = _data["PersonalAddress"] ? AgentAddressDto.fromJS(_data["PersonalAddress"]) : <any>undefined;
            this.billingAddress = _data["BillingAddress"] ? AgentAddressDto.fromJS(_data["BillingAddress"]) : <any>undefined;
            this.billingSamePersonalAddress = _data["BillingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["SalesTaxIdentifier"];
            this.salesTaxRate = _data["SalesTaxRate"];
            this.hourRate = _data["HourRate"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): AgentInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["BillingEntityName"] = this.billingEntityName;
        data["AccountEmail"] = this.accountEmail;
        data["PersonalEmail"] = this.personalEmail;
        data["PhoneNumber"] = this.phoneNumber;
        data["PersonalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : <any>undefined;
        data["BillingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["BillingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["SalesTaxIdentifier"] = this.salesTaxIdentifier;
        data["SalesTaxRate"] = this.salesTaxRate;
        data["HourRate"] = this.hourRate;
        data["Name"] = this.name;
        return data;
    }
}

export interface IAgentInvoiceDto {
    agentId: string;
    billingEntityName?: string | undefined;
    accountEmail?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    personalAddress?: AgentAddressDto | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    name?: string | undefined;
}

export class InvoiceExtendedDto implements IInvoiceExtendedDto {
    serviceDescription!: string;
    invoiceItems!: InvoiceItemDto[];
    disputes!: InvoiceDisputeDto[];

    constructor(data?: IInvoiceExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invoiceItems = [];
            this.disputes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDescription = _data["ServiceDescription"];
            if (Array.isArray(_data["InvoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["InvoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["Disputes"])) {
                this.disputes = [] as any;
                for (let item of _data["Disputes"])
                    this.disputes!.push(InvoiceDisputeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServiceDescription"] = this.serviceDescription;
        if (Array.isArray(this.invoiceItems)) {
            data["InvoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["InvoiceItems"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.disputes)) {
            data["Disputes"] = [];
            for (let item of this.disputes)
                data["Disputes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInvoiceExtendedDto {
    serviceDescription: string;
    invoiceItems: InvoiceItemDto[];
    disputes: InvoiceDisputeDto[];
}

export class InvoiceItemDto implements IInvoiceItemDto {
    invoiceItemId!: string;
    date!: Date;
    minutes!: number;
    notes?: string | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["InvoiceItemId"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.minutes = _data["Minutes"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceItemId"] = this.invoiceItemId;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Minutes"] = this.minutes;
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IInvoiceItemDto {
    invoiceItemId: string;
    date: Date;
    minutes: number;
    notes?: string | undefined;
}

export class InvoiceDisputeDto implements IInvoiceDisputeDto {
    disputedOn!: Date;
    comment!: string;

    constructor(data?: IInvoiceDisputeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disputedOn = _data["DisputedOn"] ? new Date(_data["DisputedOn"].toString()) : <any>undefined;
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): InvoiceDisputeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDisputeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisputedOn"] = this.disputedOn ? this.disputedOn.toISOString() : <any>undefined;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface IInvoiceDisputeDto {
    disputedOn: Date;
    comment: string;
}

export class DoDisputeRequest implements IDoDisputeRequest {
    invoiceId!: string;
    comment!: string;

    constructor(data?: IDoDisputeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): DoDisputeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoDisputeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface IDoDisputeRequest {
    invoiceId: string;
    comment: string;
}

export class CreateInvoiceRequest implements ICreateInvoiceRequest {
    invoiceFlow!: InvoiceFlow;
    agentId?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    servicePeriodFrom!: Date;
    servicePeriodTo!: Date;

    constructor(data?: ICreateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceFlow = _data["InvoiceFlow"];
            this.agentId = _data["AgentId"];
            if (Array.isArray(_data["InvoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["InvoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            this.servicePeriodFrom = _data["ServicePeriodFrom"] ? new Date(_data["ServicePeriodFrom"].toString()) : <any>undefined;
            this.servicePeriodTo = _data["ServicePeriodTo"] ? new Date(_data["ServicePeriodTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceFlow"] = this.invoiceFlow;
        data["AgentId"] = this.agentId;
        if (Array.isArray(this.invoiceItems)) {
            data["InvoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["InvoiceItems"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ServicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : <any>undefined;
        data["ServicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateInvoiceRequest {
    invoiceFlow: InvoiceFlow;
    agentId?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    servicePeriodFrom: Date;
    servicePeriodTo: Date;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    invoiceId!: string;
    invoiceItems!: InvoiceItemDto[];
    servicePeriodFrom!: Date;
    servicePeriodTo!: Date;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invoiceItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            if (Array.isArray(_data["InvoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["InvoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            this.servicePeriodFrom = _data["ServicePeriodFrom"] ? new Date(_data["ServicePeriodFrom"].toString()) : <any>undefined;
            this.servicePeriodTo = _data["ServicePeriodTo"] ? new Date(_data["ServicePeriodTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        if (Array.isArray(this.invoiceItems)) {
            data["InvoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["InvoiceItems"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ServicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : <any>undefined;
        data["ServicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    invoiceId: string;
    invoiceItems: InvoiceItemDto[];
    servicePeriodFrom: Date;
    servicePeriodTo: Date;
}

export class AccountVerifyRequest implements IAccountVerifyRequest {
    email!: string;
    token!: string;
    password!: string;

    constructor(data?: IAccountVerifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.token = _data["Token"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): AccountVerifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVerifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Token"] = this.token;
        data["Password"] = this.password;
        return data;
    }
}

export interface IAccountVerifyRequest {
    email: string;
    token: string;
    password: string;
}

export class DoForgotPasswordStartModel implements IDoForgotPasswordStartModel {
    email!: string;

    constructor(data?: IDoForgotPasswordStartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): DoForgotPasswordStartModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoForgotPasswordStartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        return data;
    }
}

export interface IDoForgotPasswordStartModel {
    email: string;
}

export class DoCompleteForgotPasswordRequest implements IDoCompleteForgotPasswordRequest {
    email!: string;
    token!: string;
    password!: string;

    constructor(data?: IDoCompleteForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.token = _data["Token"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): DoCompleteForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoCompleteForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["Token"] = this.token;
        data["Password"] = this.password;
        return data;
    }
}

export interface IDoCompleteForgotPasswordRequest {
    email: string;
    token: string;
    password: string;
}

export class AccountAuthenticateModelResponse implements IAccountAuthenticateModelResponse {
    success!: boolean;
    displayName?: string | undefined;
    culture!: string;

    constructor(data?: IAccountAuthenticateModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.displayName = _data["DisplayName"];
            this.culture = _data["Culture"];
        }
    }

    static fromJS(data: any): AccountAuthenticateModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAuthenticateModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["DisplayName"] = this.displayName;
        data["Culture"] = this.culture;
        return data;
    }
}

export interface IAccountAuthenticateModelResponse {
    success: boolean;
    displayName?: string | undefined;
    culture: string;
}

export class AccountAuthenticateModel implements IAccountAuthenticateModel {
    username!: string;
    password!: string;

    constructor(data?: IAccountAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): AccountAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        return data;
    }
}

export interface IAccountAuthenticateModel {
    username: string;
    password: string;
}

export class MWMSettings implements IMWMSettings {
    emailTemplateSettings!: EmailTemplateSettings;
    accountsEmail!: EmailSettings;
    fileUploadSettings!: FileUploadSettings;

    constructor(data?: IMWMSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.emailTemplateSettings = new EmailTemplateSettings();
            this.accountsEmail = new EmailSettings();
            this.fileUploadSettings = new FileUploadSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplateSettings = _data["EmailTemplateSettings"] ? EmailTemplateSettings.fromJS(_data["EmailTemplateSettings"]) : new EmailTemplateSettings();
            this.accountsEmail = _data["AccountsEmail"] ? EmailSettings.fromJS(_data["AccountsEmail"]) : new EmailSettings();
            this.fileUploadSettings = _data["FileUploadSettings"] ? FileUploadSettings.fromJS(_data["FileUploadSettings"]) : new FileUploadSettings();
        }
    }

    static fromJS(data: any): MWMSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MWMSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailTemplateSettings"] = this.emailTemplateSettings ? this.emailTemplateSettings.toJSON() : <any>undefined;
        data["AccountsEmail"] = this.accountsEmail ? this.accountsEmail.toJSON() : <any>undefined;
        data["FileUploadSettings"] = this.fileUploadSettings ? this.fileUploadSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMWMSettings {
    emailTemplateSettings: EmailTemplateSettings;
    accountsEmail: EmailSettings;
    fileUploadSettings: FileUploadSettings;
}

export class EmailTemplateSettings implements IEmailTemplateSettings {
    forgotPassword?: string | undefined;
    verifyAccountPath?: string | undefined;
    agentInvoicePath?: string | undefined;
    adminInvoicePath?: string | undefined;
    paymentProcessingRecipient?: string | undefined;

    constructor(data?: IEmailTemplateSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forgotPassword = _data["ForgotPassword"];
            this.verifyAccountPath = _data["VerifyAccountPath"];
            this.agentInvoicePath = _data["AgentInvoicePath"];
            this.adminInvoicePath = _data["AdminInvoicePath"];
            this.paymentProcessingRecipient = _data["PaymentProcessingRecipient"];
        }
    }

    static fromJS(data: any): EmailTemplateSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ForgotPassword"] = this.forgotPassword;
        data["VerifyAccountPath"] = this.verifyAccountPath;
        data["AgentInvoicePath"] = this.agentInvoicePath;
        data["AdminInvoicePath"] = this.adminInvoicePath;
        data["PaymentProcessingRecipient"] = this.paymentProcessingRecipient;
        return data;
    }
}

export interface IEmailTemplateSettings {
    forgotPassword?: string | undefined;
    verifyAccountPath?: string | undefined;
    agentInvoicePath?: string | undefined;
    adminInvoicePath?: string | undefined;
    paymentProcessingRecipient?: string | undefined;
}

export class EmailSettings implements IEmailSettings {
    applicationName?: string | undefined;
    defaultFromEmail?: string | undefined;
    password?: string | undefined;
    emailServer?: string | undefined;
    port!: number;
    useSSL!: boolean;
    useAuthentication!: boolean;
    customFromEmail?: string | undefined;
    customFromPassword?: string | undefined;
    faxFromEmail?: string | undefined;
    faxToEmailDomain?: string | undefined;
    faxEmailPassword?: string | undefined;
    adverseEventRecipient?: string | undefined;

    constructor(data?: IEmailSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["ApplicationName"];
            this.defaultFromEmail = _data["DefaultFromEmail"];
            this.password = _data["Password"];
            this.emailServer = _data["EmailServer"];
            this.port = _data["Port"];
            this.useSSL = _data["UseSSL"];
            this.useAuthentication = _data["UseAuthentication"];
            this.customFromEmail = _data["CustomFromEmail"];
            this.customFromPassword = _data["CustomFromPassword"];
            this.faxFromEmail = _data["FaxFromEmail"];
            this.faxToEmailDomain = _data["FaxToEmailDomain"];
            this.faxEmailPassword = _data["FaxEmailPassword"];
            this.adverseEventRecipient = _data["AdverseEventRecipient"];
        }
    }

    static fromJS(data: any): EmailSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ApplicationName"] = this.applicationName;
        data["DefaultFromEmail"] = this.defaultFromEmail;
        data["Password"] = this.password;
        data["EmailServer"] = this.emailServer;
        data["Port"] = this.port;
        data["UseSSL"] = this.useSSL;
        data["UseAuthentication"] = this.useAuthentication;
        data["CustomFromEmail"] = this.customFromEmail;
        data["CustomFromPassword"] = this.customFromPassword;
        data["FaxFromEmail"] = this.faxFromEmail;
        data["FaxToEmailDomain"] = this.faxToEmailDomain;
        data["FaxEmailPassword"] = this.faxEmailPassword;
        data["AdverseEventRecipient"] = this.adverseEventRecipient;
        return data;
    }
}

export interface IEmailSettings {
    applicationName?: string | undefined;
    defaultFromEmail?: string | undefined;
    password?: string | undefined;
    emailServer?: string | undefined;
    port: number;
    useSSL: boolean;
    useAuthentication: boolean;
    customFromEmail?: string | undefined;
    customFromPassword?: string | undefined;
    faxFromEmail?: string | undefined;
    faxToEmailDomain?: string | undefined;
    faxEmailPassword?: string | undefined;
    adverseEventRecipient?: string | undefined;
}

export class FileUploadSettings implements IFileUploadSettings {
    maxSize!: number;

    constructor(data?: IFileUploadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxSize = _data["MaxSize"];
        }
    }

    static fromJS(data: any): FileUploadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaxSize"] = this.maxSize;
        return data;
    }
}

export interface IFileUploadSettings {
    maxSize: number;
}

export class MWMPublicSettings implements IMWMPublicSettings {
    fileUploadSettings!: FileUploadSettings;

    constructor(data?: IMWMPublicSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fileUploadSettings = new FileUploadSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUploadSettings = _data["FileUploadSettings"] ? FileUploadSettings.fromJS(_data["FileUploadSettings"]) : new FileUploadSettings();
        }
    }

    static fromJS(data: any): MWMPublicSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MWMPublicSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileUploadSettings"] = this.fileUploadSettings ? this.fileUploadSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMWMPublicSettings {
    fileUploadSettings: FileUploadSettings;
}

export enum ResourceType2 {
    Documentation = 1,
    Resource = 2,
}

export class DoSortTasksRequest implements IDoSortTasksRequest {
    taskIds!: string[];

    constructor(data?: IDoSortTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["TaskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["TaskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["TaskIds"] = [];
            for (let item of this.taskIds)
                data["TaskIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortTasksRequest {
    taskIds: string[];
}

export class DoSortModulesRequest implements IDoSortModulesRequest {
    moduleIds!: string[];

    constructor(data?: IDoSortModulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.moduleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ModuleIds"])) {
                this.moduleIds = [] as any;
                for (let item of _data["ModuleIds"])
                    this.moduleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortModulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortModulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleIds)) {
            data["ModuleIds"] = [];
            for (let item of this.moduleIds)
                data["ModuleIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortModulesRequest {
    moduleIds: string[];
}

export class DoSortTopicsRequest implements IDoSortTopicsRequest {
    topicIds!: string[];

    constructor(data?: IDoSortTopicsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.topicIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["TopicIds"])) {
                this.topicIds = [] as any;
                for (let item of _data["TopicIds"])
                    this.topicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortTopicsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortTopicsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topicIds)) {
            data["TopicIds"] = [];
            for (let item of this.topicIds)
                data["TopicIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortTopicsRequest {
    topicIds: string[];
}

export abstract class HelpRequestBaseDto implements IHelpRequestBaseDto {
    helpRequestId!: string;
    agentId!: string;
    subject?: string | undefined;
    notes?: string | undefined;
    completedOn?: Date | undefined;
    createdOn?: Date | undefined;

    constructor(data?: IHelpRequestBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpRequestId = _data["HelpRequestId"];
            this.agentId = _data["AgentId"];
            this.subject = _data["Subject"];
            this.notes = _data["Notes"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HelpRequestBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HelpRequestBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HelpRequestId"] = this.helpRequestId;
        data["AgentId"] = this.agentId;
        data["Subject"] = this.subject;
        data["Notes"] = this.notes;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHelpRequestBaseDto {
    helpRequestId: string;
    agentId: string;
    subject?: string | undefined;
    notes?: string | undefined;
    completedOn?: Date | undefined;
    createdOn?: Date | undefined;
}

export class HelpRequestDto extends HelpRequestBaseDto implements IHelpRequestDto {

    constructor(data?: IHelpRequestDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HelpRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHelpRequestDto extends IHelpRequestBaseDto {
}

export class SaveModuleRequest implements ISaveModuleRequest {
    moduleId!: string;
    name!: string;
    description!: string;
    moduleType!: ModuleType;
    role!: AgentRole;

    constructor(data?: ISaveModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["ModuleId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.moduleType = _data["ModuleType"];
            this.role = _data["Role"];
        }
    }

    static fromJS(data: any): SaveModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModuleId"] = this.moduleId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ModuleType"] = this.moduleType;
        data["Role"] = this.role;
        return data;
    }
}

export interface ISaveModuleRequest {
    moduleId: string;
    name: string;
    description: string;
    moduleType: ModuleType;
    role: AgentRole;
}

export enum ModuleType {
    Regular = 1,
    ContinuingEducation = 2,
}

export class SaveTopicRequest implements ISaveTopicRequest {
    topicId!: string;
    moduleId!: string;
    name!: string;
    description!: string;

    constructor(data?: ISaveTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["TopicId"];
            this.moduleId = _data["ModuleId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): SaveTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TopicId"] = this.topicId;
        data["ModuleId"] = this.moduleId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        return data;
    }
}

export interface ISaveTopicRequest {
    topicId: string;
    moduleId: string;
    name: string;
    description: string;
}

export enum TaskType2 {
    Video = 1,
    Article = 2,
    Assignment = 3,
    Quiz = 4,
}

export class AgentCompleteTaskRequest implements IAgentCompleteTaskRequest {
    agentId!: string;
    taskId!: string;
    completionType!: AgentTaskCompletionType;

    constructor(data?: IAgentCompleteTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.taskId = _data["TaskId"];
            this.completionType = _data["CompletionType"];
        }
    }

    static fromJS(data: any): AgentCompleteTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCompleteTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["TaskId"] = this.taskId;
        data["CompletionType"] = this.completionType;
        return data;
    }
}

export interface IAgentCompleteTaskRequest {
    agentId: string;
    taskId: string;
    completionType: AgentTaskCompletionType;
}

export enum AgentTaskCompletionType {
    Regular = 1,
    Manual = 2,
}

export class PaginatedResponseOfResourceDto implements IPaginatedResponseOfResourceDto {
    results?: ResourceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ResourceDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfResourceDto {
    results?: ResourceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ResourceDto implements IResourceDto {
    resourceId!: string;
    name?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    blobId?: string | undefined;
    resourceType!: ResourceType2;
    externalLink?: string | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.fileName = _data["FileName"];
            this.blobId = _data["BlobId"];
            this.resourceType = _data["ResourceType"];
            this.externalLink = _data["ExternalLink"];
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["FileName"] = this.fileName;
        data["BlobId"] = this.blobId;
        data["ResourceType"] = this.resourceType;
        data["ExternalLink"] = this.externalLink;
        return data;
    }
}

export interface IResourceDto {
    resourceId: string;
    name?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    blobId?: string | undefined;
    resourceType: ResourceType2;
    externalLink?: string | undefined;
}

export class PaginatedResponseOfHelpRequestSummaryDto implements IPaginatedResponseOfHelpRequestSummaryDto {
    results?: HelpRequestSummaryDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfHelpRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(HelpRequestSummaryDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfHelpRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfHelpRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfHelpRequestSummaryDto {
    results?: HelpRequestSummaryDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class HelpRequestSummaryDto extends HelpRequestBaseDto implements IHelpRequestSummaryDto {
    agentIdentifier?: string | undefined;
    agentName?: string | undefined;
    agentEmail?: string | undefined;
    agentRole?: AgentRole | undefined;

    constructor(data?: IHelpRequestSummaryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentIdentifier = _data["AgentIdentifier"];
            this.agentName = _data["AgentName"];
            this.agentEmail = _data["AgentEmail"];
            this.agentRole = _data["AgentRole"];
        }
    }

    static fromJS(data: any): HelpRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentIdentifier"] = this.agentIdentifier;
        data["AgentName"] = this.agentName;
        data["AgentEmail"] = this.agentEmail;
        data["AgentRole"] = this.agentRole;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpRequestSummaryDto extends IHelpRequestBaseDto {
    agentIdentifier?: string | undefined;
    agentName?: string | undefined;
    agentEmail?: string | undefined;
    agentRole?: AgentRole | undefined;
}

export class AgentTaskCompletionStatusSummary implements IAgentTaskCompletionStatusSummary {
    agentId!: string;
    agentTaskCompletionStatusSummaryModules!: AgentTaskCompletionStatusSummaryModule[];
    totalTasks!: number;
    completedTasks!: number;

    constructor(data?: IAgentTaskCompletionStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agentTaskCompletionStatusSummaryModules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            if (Array.isArray(_data["AgentTaskCompletionStatusSummaryModules"])) {
                this.agentTaskCompletionStatusSummaryModules = [] as any;
                for (let item of _data["AgentTaskCompletionStatusSummaryModules"])
                    this.agentTaskCompletionStatusSummaryModules!.push(AgentTaskCompletionStatusSummaryModule.fromJS(item));
            }
            this.totalTasks = _data["TotalTasks"];
            this.completedTasks = _data["CompletedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryModules)) {
            data["AgentTaskCompletionStatusSummaryModules"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryModules)
                data["AgentTaskCompletionStatusSummaryModules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["TotalTasks"] = this.totalTasks;
        data["CompletedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummary {
    agentId: string;
    agentTaskCompletionStatusSummaryModules: AgentTaskCompletionStatusSummaryModule[];
    totalTasks: number;
    completedTasks: number;
}

export class AgentTaskCompletionStatusSummaryModule implements IAgentTaskCompletionStatusSummaryModule {
    moduleId!: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTopics!: AgentTaskCompletionStatusSummaryTopic[];
    completionRate!: number;
    totalTasks!: number;
    completedTasks!: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agentTaskCompletionStatusSummaryTopics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["ModuleId"];
            this.name = _data["Name"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["AgentTaskCompletionStatusSummaryTopics"])) {
                this.agentTaskCompletionStatusSummaryTopics = [] as any;
                for (let item of _data["AgentTaskCompletionStatusSummaryTopics"])
                    this.agentTaskCompletionStatusSummaryTopics!.push(AgentTaskCompletionStatusSummaryTopic.fromJS(item));
            }
            this.completionRate = _data["CompletionRate"];
            this.totalTasks = _data["TotalTasks"];
            this.completedTasks = _data["CompletedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryModule {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModuleId"] = this.moduleId;
        data["Name"] = this.name;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryTopics)) {
            data["AgentTaskCompletionStatusSummaryTopics"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryTopics)
                data["AgentTaskCompletionStatusSummaryTopics"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CompletionRate"] = this.completionRate;
        data["TotalTasks"] = this.totalTasks;
        data["CompletedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryModule {
    moduleId: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTopics: AgentTaskCompletionStatusSummaryTopic[];
    completionRate: number;
    totalTasks: number;
    completedTasks: number;
}

export class AgentTaskCompletionStatusSummaryTopic implements IAgentTaskCompletionStatusSummaryTopic {
    topicId!: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTasks!: AgentTaskCompletionStatusSummaryTask[];
    completionRate!: number;
    totalTasks!: number;
    completedTasks!: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agentTaskCompletionStatusSummaryTasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["TopicId"];
            this.name = _data["Name"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["AgentTaskCompletionStatusSummaryTasks"])) {
                this.agentTaskCompletionStatusSummaryTasks = [] as any;
                for (let item of _data["AgentTaskCompletionStatusSummaryTasks"])
                    this.agentTaskCompletionStatusSummaryTasks!.push(AgentTaskCompletionStatusSummaryTask.fromJS(item));
            }
            this.completionRate = _data["CompletionRate"];
            this.totalTasks = _data["TotalTasks"];
            this.completedTasks = _data["CompletedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryTopic {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TopicId"] = this.topicId;
        data["Name"] = this.name;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryTasks)) {
            data["AgentTaskCompletionStatusSummaryTasks"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryTasks)
                data["AgentTaskCompletionStatusSummaryTasks"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CompletionRate"] = this.completionRate;
        data["TotalTasks"] = this.totalTasks;
        data["CompletedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryTopic {
    topicId: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTasks: AgentTaskCompletionStatusSummaryTask[];
    completionRate: number;
    totalTasks: number;
    completedTasks: number;
}

export class AgentTaskCompletionStatusSummaryTask implements IAgentTaskCompletionStatusSummaryTask {
    taskId!: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    completionRate!: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["TaskId"];
            this.name = _data["Name"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.completionRate = _data["CompletionRate"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryTask {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TaskId"] = this.taskId;
        data["Name"] = this.name;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["CompletionRate"] = this.completionRate;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryTask {
    taskId: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    completionRate: number;
}

export class PaginatedResponseOfReadModuleDto implements IPaginatedResponseOfReadModuleDto {
    results?: ReadModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ReadModuleDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadModuleDto {
    results?: ReadModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadModuleDto implements IReadModuleDto {
    moduleId!: string;
    role?: AgentRole | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moduleType!: ModuleType;
    order!: number;
    deletedOn?: Date | undefined;

    constructor(data?: IReadModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["ModuleId"];
            this.role = _data["Role"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.moduleType = _data["ModuleType"];
            this.order = _data["Order"];
            this.deletedOn = _data["DeletedOn"] ? new Date(_data["DeletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReadModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModuleId"] = this.moduleId;
        data["Role"] = this.role;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["ModuleType"] = this.moduleType;
        data["Order"] = this.order;
        data["DeletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReadModuleDto {
    moduleId: string;
    role?: AgentRole | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moduleType: ModuleType;
    order: number;
    deletedOn?: Date | undefined;
}

export class PaginatedResponseOfReadTopicDto implements IPaginatedResponseOfReadTopicDto {
    results?: ReadTopicDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ReadTopicDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadTopicDto {
    results?: ReadTopicDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadTopicDto implements IReadTopicDto {
    topicId!: string;
    moduleId!: string;
    name?: string | undefined;
    description?: string | undefined;
    order!: number;
    deletedOn?: Date | undefined;

    constructor(data?: IReadTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["TopicId"];
            this.moduleId = _data["ModuleId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.order = _data["Order"];
            this.deletedOn = _data["DeletedOn"] ? new Date(_data["DeletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReadTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TopicId"] = this.topicId;
        data["ModuleId"] = this.moduleId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Order"] = this.order;
        data["DeletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReadTopicDto {
    topicId: string;
    moduleId: string;
    name?: string | undefined;
    description?: string | undefined;
    order: number;
    deletedOn?: Date | undefined;
}

export class PaginatedResponseOfReadTaskDto implements IPaginatedResponseOfReadTaskDto {
    results?: ReadTaskDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(ReadTaskDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadTaskDto {
    results?: ReadTaskDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadTaskDto implements IReadTaskDto {
    topicId!: string;
    taskId!: string;
    name?: string | undefined;
    description?: string | undefined;
    order!: number;
    taskType!: TaskType2;
    blobId?: string | undefined;
    content?: string | undefined;
    externalUrl?: string | undefined;
    deletedOn?: Date | undefined;
    isEmbedded!: boolean;

    constructor(data?: IReadTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["TopicId"];
            this.taskId = _data["TaskId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.order = _data["Order"];
            this.taskType = _data["TaskType"];
            this.blobId = _data["BlobId"];
            this.content = _data["Content"];
            this.externalUrl = _data["ExternalUrl"];
            this.deletedOn = _data["DeletedOn"] ? new Date(_data["DeletedOn"].toString()) : <any>undefined;
            this.isEmbedded = _data["IsEmbedded"];
        }
    }

    static fromJS(data: any): ReadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TopicId"] = this.topicId;
        data["TaskId"] = this.taskId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Order"] = this.order;
        data["TaskType"] = this.taskType;
        data["BlobId"] = this.blobId;
        data["Content"] = this.content;
        data["ExternalUrl"] = this.externalUrl;
        data["DeletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["IsEmbedded"] = this.isEmbedded;
        return data;
    }
}

export interface IReadTaskDto {
    topicId: string;
    taskId: string;
    name?: string | undefined;
    description?: string | undefined;
    order: number;
    taskType: TaskType2;
    blobId?: string | undefined;
    content?: string | undefined;
    externalUrl?: string | undefined;
    deletedOn?: Date | undefined;
    isEmbedded: boolean;
}

export class AgentTaskViewCompleteDto implements IAgentTaskViewCompleteDto {
    tasksStatus?: TasksStatusDto | undefined;
    taskBasic?: AgentTaskViewDto | undefined;
    taskExtra?: AgentTaskViewExtraDto | undefined;

    constructor(data?: IAgentTaskViewCompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tasksStatus = _data["TasksStatus"] ? TasksStatusDto.fromJS(_data["TasksStatus"]) : <any>undefined;
            this.taskBasic = _data["TaskBasic"] ? AgentTaskViewDto.fromJS(_data["TaskBasic"]) : <any>undefined;
            this.taskExtra = _data["TaskExtra"] ? AgentTaskViewExtraDto.fromJS(_data["TaskExtra"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentTaskViewCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TasksStatus"] = this.tasksStatus ? this.tasksStatus.toJSON() : <any>undefined;
        data["TaskBasic"] = this.taskBasic ? this.taskBasic.toJSON() : <any>undefined;
        data["TaskExtra"] = this.taskExtra ? this.taskExtra.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgentTaskViewCompleteDto {
    tasksStatus?: TasksStatusDto | undefined;
    taskBasic?: AgentTaskViewDto | undefined;
    taskExtra?: AgentTaskViewExtraDto | undefined;
}

export class TasksStatusDto implements ITasksStatusDto {
    totalTasks!: number;
    completedTasks!: number;

    constructor(data?: ITasksStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTasks = _data["TotalTasks"];
            this.completedTasks = _data["CompletedTasks"];
        }
    }

    static fromJS(data: any): TasksStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TasksStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TotalTasks"] = this.totalTasks;
        data["CompletedTasks"] = this.completedTasks;
        return data;
    }
}

export interface ITasksStatusDto {
    totalTasks: number;
    completedTasks: number;
}

export class AgentTaskViewDto implements IAgentTaskViewDto {
    taskId!: string;
    name?: string | undefined;
    description?: string | undefined;
    taskType!: TaskType2;
    order!: number;
    completed!: boolean;

    constructor(data?: IAgentTaskViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["TaskId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.taskType = _data["TaskType"];
            this.order = _data["Order"];
            this.completed = _data["Completed"];
        }
    }

    static fromJS(data: any): AgentTaskViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TaskId"] = this.taskId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["TaskType"] = this.taskType;
        data["Order"] = this.order;
        data["Completed"] = this.completed;
        return data;
    }
}

export interface IAgentTaskViewDto {
    taskId: string;
    name?: string | undefined;
    description?: string | undefined;
    taskType: TaskType2;
    order: number;
    completed: boolean;
}

export class AgentTaskViewExtraDto implements IAgentTaskViewExtraDto {
    blobId?: string | undefined;
    externalUrl?: string | undefined;
    moduleName?: string | undefined;
    topicName?: string | undefined;
    isEmbedded!: boolean;

    constructor(data?: IAgentTaskViewExtraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobId = _data["BlobId"];
            this.externalUrl = _data["ExternalUrl"];
            this.moduleName = _data["ModuleName"];
            this.topicName = _data["TopicName"];
            this.isEmbedded = _data["IsEmbedded"];
        }
    }

    static fromJS(data: any): AgentTaskViewExtraDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewExtraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BlobId"] = this.blobId;
        data["ExternalUrl"] = this.externalUrl;
        data["ModuleName"] = this.moduleName;
        data["TopicName"] = this.topicName;
        data["IsEmbedded"] = this.isEmbedded;
        return data;
    }
}

export interface IAgentTaskViewExtraDto {
    blobId?: string | undefined;
    externalUrl?: string | undefined;
    moduleName?: string | undefined;
    topicName?: string | undefined;
    isEmbedded: boolean;
}

export class PaginatedResponseOfAgentModuleDto implements IPaginatedResponseOfAgentModuleDto {
    results?: AgentModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(AgentModuleDto.fromJS(item));
            }
            this.total = _data["Total"];
            this.taken = _data["Taken"];
            this.skipped = _data["Skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Total"] = this.total;
        data["Taken"] = this.taken;
        data["Skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentModuleDto {
    results?: AgentModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class AgentModuleDto implements IAgentModuleDto {
    module?: AgentModuleViewDto | undefined;
    tasksStatus?: TasksStatusDto | undefined;
    moduleStatus?: AgentModuleCompletionStatusDto | undefined;

    constructor(data?: IAgentModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["Module"] ? AgentModuleViewDto.fromJS(_data["Module"]) : <any>undefined;
            this.tasksStatus = _data["TasksStatus"] ? TasksStatusDto.fromJS(_data["TasksStatus"]) : <any>undefined;
            this.moduleStatus = _data["ModuleStatus"] ? AgentModuleCompletionStatusDto.fromJS(_data["ModuleStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["TasksStatus"] = this.tasksStatus ? this.tasksStatus.toJSON() : <any>undefined;
        data["ModuleStatus"] = this.moduleStatus ? this.moduleStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgentModuleDto {
    module?: AgentModuleViewDto | undefined;
    tasksStatus?: TasksStatusDto | undefined;
    moduleStatus?: AgentModuleCompletionStatusDto | undefined;
}

export class AgentModuleViewDto implements IAgentModuleViewDto {
    moduleId!: string;
    moduleName?: string | undefined;
    moduleDescription?: string | undefined;
    moduleType?: ModuleType | undefined;
    agentModuleTopics?: AgentTopicViewDto[] | undefined;

    constructor(data?: IAgentModuleViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["ModuleId"];
            this.moduleName = _data["ModuleName"];
            this.moduleDescription = _data["ModuleDescription"];
            this.moduleType = _data["ModuleType"];
            if (Array.isArray(_data["AgentModuleTopics"])) {
                this.agentModuleTopics = [] as any;
                for (let item of _data["AgentModuleTopics"])
                    this.agentModuleTopics!.push(AgentTopicViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentModuleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModuleId"] = this.moduleId;
        data["ModuleName"] = this.moduleName;
        data["ModuleDescription"] = this.moduleDescription;
        data["ModuleType"] = this.moduleType;
        if (Array.isArray(this.agentModuleTopics)) {
            data["AgentModuleTopics"] = [];
            for (let item of this.agentModuleTopics)
                data["AgentModuleTopics"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAgentModuleViewDto {
    moduleId: string;
    moduleName?: string | undefined;
    moduleDescription?: string | undefined;
    moduleType?: ModuleType | undefined;
    agentModuleTopics?: AgentTopicViewDto[] | undefined;
}

export class AgentTopicViewDto implements IAgentTopicViewDto {
    topicId!: string;
    topicName?: string | undefined;
    topicDescription?: string | undefined;
    tasks?: AgentTaskViewDto[] | undefined;
    completed!: boolean;

    constructor(data?: IAgentTopicViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["TopicId"];
            this.topicName = _data["TopicName"];
            this.topicDescription = _data["TopicDescription"];
            if (Array.isArray(_data["Tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["Tasks"])
                    this.tasks!.push(AgentTaskViewDto.fromJS(item));
            }
            this.completed = _data["Completed"];
        }
    }

    static fromJS(data: any): AgentTopicViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTopicViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TopicId"] = this.topicId;
        data["TopicName"] = this.topicName;
        data["TopicDescription"] = this.topicDescription;
        if (Array.isArray(this.tasks)) {
            data["Tasks"] = [];
            for (let item of this.tasks)
                data["Tasks"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Completed"] = this.completed;
        return data;
    }
}

export interface IAgentTopicViewDto {
    topicId: string;
    topicName?: string | undefined;
    topicDescription?: string | undefined;
    tasks?: AgentTaskViewDto[] | undefined;
    completed: boolean;
}

export class AgentModuleCompletionStatusDto implements IAgentModuleCompletionStatusDto {
    completed!: boolean;
    completedOn?: Date | undefined;

    constructor(data?: IAgentModuleCompletionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["Completed"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentModuleCompletionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleCompletionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Completed"] = this.completed;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgentModuleCompletionStatusDto {
    completed: boolean;
    completedOn?: Date | undefined;
}

export class CompletePhoneWrapUpModel implements ICompletePhoneWrapUpModel {
    patientId?: string | undefined;
    studyId!: string;

    constructor(data?: ICompletePhoneWrapUpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["PatientId"];
            this.studyId = _data["StudyId"];
        }
    }

    static fromJS(data: any): CompletePhoneWrapUpModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePhoneWrapUpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientId"] = this.patientId;
        data["StudyId"] = this.studyId;
        return data;
    }
}

export interface ICompletePhoneWrapUpModel {
    patientId?: string | undefined;
    studyId: string;
}

export class PhoneWrapUpPendingResult implements IPhoneWrapUpPendingResult {
    phoneCallRecordId!: string;
    createdOn!: Date;
    phoneStartedOn!: Date;
    phoneNumber?: string | undefined;

    constructor(data?: IPhoneWrapUpPendingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCallRecordId = _data["PhoneCallRecordId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.phoneStartedOn = _data["PhoneStartedOn"] ? new Date(_data["PhoneStartedOn"].toString()) : <any>undefined;
            this.phoneNumber = _data["PhoneNumber"];
        }
    }

    static fromJS(data: any): PhoneWrapUpPendingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneWrapUpPendingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneCallRecordId"] = this.phoneCallRecordId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["PhoneStartedOn"] = this.phoneStartedOn ? this.phoneStartedOn.toISOString() : <any>undefined;
        data["PhoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IPhoneWrapUpPendingResult {
    phoneCallRecordId: string;
    createdOn: Date;
    phoneStartedOn: Date;
    phoneNumber?: string | undefined;
}

export class UserContextResult implements IUserContextResult {
    id!: string;
    isAdmin!: boolean;
    isInternalAdmin!: boolean;
    status?: UserStatusResult | undefined;

    constructor(data?: IUserContextResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.isAdmin = _data["IsAdmin"];
            this.isInternalAdmin = _data["IsInternalAdmin"];
            this.status = _data["Status"] ? UserStatusResult.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserContextResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["IsAdmin"] = this.isAdmin;
        data["IsInternalAdmin"] = this.isInternalAdmin;
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserContextResult {
    id: string;
    isAdmin: boolean;
    isInternalAdmin: boolean;
    status?: UserStatusResult | undefined;
}

export class UserStatusResult implements IUserStatusResult {
    id!: string;
    statusId!: string;
    expiresOn?: Date | undefined;

    constructor(data?: IUserStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.statusId = _data["StatusId"];
            this.expiresOn = _data["ExpiresOn"] ? new Date(_data["ExpiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StatusId"] = this.statusId;
        data["ExpiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserStatusResult {
    id: string;
    statusId: string;
    expiresOn?: Date | undefined;
}

export class SetUserIsEnabledModel implements ISetUserIsEnabledModel {
    isEnabled!: boolean;

    constructor(data?: ISetUserIsEnabledModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["IsEnabled"];
        }
    }

    static fromJS(data: any): SetUserIsEnabledModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserIsEnabledModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsEnabled"] = this.isEnabled;
        return data;
    }
}

export interface ISetUserIsEnabledModel {
    isEnabled: boolean;
}

export class SetUserStatusModel implements ISetUserStatusModel {
    statusId!: string;

    constructor(data?: ISetUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["StatusId"];
        }
    }

    static fromJS(data: any): SetUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StatusId"] = this.statusId;
        return data;
    }
}

export interface ISetUserStatusModel {
    statusId: string;
}

export class ExtendExpirationModel implements IExtendExpirationModel {
    minutes!: number;

    constructor(data?: IExtendExpirationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["Minutes"];
        }
    }

    static fromJS(data: any): ExtendExpirationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendExpirationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Minutes"] = this.minutes;
        return data;
    }
}

export interface IExtendExpirationModel {
    minutes: number;
}

export class UserStatusHistoryResult extends UserStatusResult implements IUserStatusHistoryResult {
    createdOn!: Date;
    supersededByUserStatusId?: string | undefined;

    constructor(data?: IUserStatusHistoryResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.supersededByUserStatusId = _data["SupersededByUserStatusId"];
        }
    }

    static fromJS(data: any): UserStatusHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusHistoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["SupersededByUserStatusId"] = this.supersededByUserStatusId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserStatusHistoryResult extends IUserStatusResult {
    createdOn: Date;
    supersededByUserStatusId?: string | undefined;
}

export class SetUserRolesModel implements ISetUserRolesModel {
    userId!: string;
    roleIds?: string[] | undefined;

    constructor(data?: ISetUserRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            if (Array.isArray(_data["RoleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["RoleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetUserRolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserRolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        if (Array.isArray(this.roleIds)) {
            data["RoleIds"] = [];
            for (let item of this.roleIds)
                data["RoleIds"].push(item);
        }
        return data;
    }
}

export interface ISetUserRolesModel {
    userId: string;
    roleIds?: string[] | undefined;
}

export class TaskItemResult implements ITaskItemResult {
    id!: string;
    studyId!: string;
    userId?: string | undefined;
    isArchived!: boolean;
    label?: string | undefined;
    source?: TaskSourceResult | undefined;

    constructor(data?: ITaskItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.userId = _data["UserId"];
            this.isArchived = _data["IsArchived"];
            this.label = _data["Label"];
            this.source = _data["Source"] ? TaskSourceResult.fromJS(_data["Source"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["UserId"] = this.userId;
        data["IsArchived"] = this.isArchived;
        data["Label"] = this.label;
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskItemResult {
    id: string;
    studyId: string;
    userId?: string | undefined;
    isArchived: boolean;
    label?: string | undefined;
    source?: TaskSourceResult | undefined;
}

export class CallbackTaskResult extends TaskItemResult implements ICallbackTaskResult {
    studyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageCode?: string | undefined;
    callAttemptCount!: number;
    startDate!: Date;
    endDate!: Date;
    callbackType!: CallType;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
    handlingUserId?: string | undefined;
    completedUserId?: string | undefined;
    activeStateId!: string;
    patientID!: string;
    uniqueId?: string | undefined;
    isHcpCall!: boolean;
    isAsap!: boolean;
    serviceRating?: number | undefined;
    confidenceRating?: number | undefined;
    recommendationRating?: number | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented!: boolean;
    isComplete!: boolean;
    patientJoinedVideoCallOn?: Date | undefined;
    stateLastUpdateOn!: Date;
    durationOptionLabel?: string | undefined;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: ICallbackTaskResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyName = _data["StudyName"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.email = _data["Email"];
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.callAttemptCount = _data["CallAttemptCount"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            this.callbackType = _data["CallbackType"];
            this.onlineMeetingId = _data["OnlineMeetingId"];
            this.onlineMeetingJoinWebUrl = _data["OnlineMeetingJoinWebUrl"];
            this.handlingUserId = _data["HandlingUserId"];
            this.completedUserId = _data["CompletedUserId"];
            this.activeStateId = _data["ActiveStateId"];
            this.patientID = _data["PatientID"];
            this.uniqueId = _data["UniqueId"];
            this.isHcpCall = _data["IsHcpCall"];
            this.isAsap = _data["IsAsap"];
            this.serviceRating = _data["ServiceRating"];
            this.confidenceRating = _data["ConfidenceRating"];
            this.recommendationRating = _data["RecommendationRating"];
            this.timeZone = _data["TimeZone"];
            this.isVoicemailConsented = _data["IsVoicemailConsented"];
            this.isComplete = _data["IsComplete"];
            this.patientJoinedVideoCallOn = _data["PatientJoinedVideoCallOn"] ? new Date(_data["PatientJoinedVideoCallOn"].toString()) : <any>undefined;
            this.stateLastUpdateOn = _data["StateLastUpdateOn"] ? new Date(_data["StateLastUpdateOn"].toString()) : <any>undefined;
            this.durationOptionLabel = _data["DurationOptionLabel"];
            this.interactionTypeOption = _data["InteractionTypeOption"] ? StudyCallDurationOptionResult.fromJS(_data["InteractionTypeOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallbackTaskResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackTaskResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyName"] = this.studyName;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["PhoneNumber"] = this.phoneNumber;
        data["Email"] = this.email;
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["CallAttemptCount"] = this.callAttemptCount;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["CallbackType"] = this.callbackType;
        data["OnlineMeetingId"] = this.onlineMeetingId;
        data["OnlineMeetingJoinWebUrl"] = this.onlineMeetingJoinWebUrl;
        data["HandlingUserId"] = this.handlingUserId;
        data["CompletedUserId"] = this.completedUserId;
        data["ActiveStateId"] = this.activeStateId;
        data["PatientID"] = this.patientID;
        data["UniqueId"] = this.uniqueId;
        data["IsHcpCall"] = this.isHcpCall;
        data["IsAsap"] = this.isAsap;
        data["ServiceRating"] = this.serviceRating;
        data["ConfidenceRating"] = this.confidenceRating;
        data["RecommendationRating"] = this.recommendationRating;
        data["TimeZone"] = this.timeZone;
        data["IsVoicemailConsented"] = this.isVoicemailConsented;
        data["IsComplete"] = this.isComplete;
        data["PatientJoinedVideoCallOn"] = this.patientJoinedVideoCallOn ? this.patientJoinedVideoCallOn.toISOString() : <any>undefined;
        data["StateLastUpdateOn"] = this.stateLastUpdateOn ? this.stateLastUpdateOn.toISOString() : <any>undefined;
        data["DurationOptionLabel"] = this.durationOptionLabel;
        data["InteractionTypeOption"] = this.interactionTypeOption ? this.interactionTypeOption.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackTaskResult extends ITaskItemResult {
    studyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageCode?: string | undefined;
    callAttemptCount: number;
    startDate: Date;
    endDate: Date;
    callbackType: CallType;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
    handlingUserId?: string | undefined;
    completedUserId?: string | undefined;
    activeStateId: string;
    patientID: string;
    uniqueId?: string | undefined;
    isHcpCall: boolean;
    isAsap: boolean;
    serviceRating?: number | undefined;
    confidenceRating?: number | undefined;
    recommendationRating?: number | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented: boolean;
    isComplete: boolean;
    patientJoinedVideoCallOn?: Date | undefined;
    stateLastUpdateOn: Date;
    durationOptionLabel?: string | undefined;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;
}

export class StudyCallDurationOptionResult implements IStudyCallDurationOptionResult {
    id!: string;
    studyId!: string;
    callType?: CallType | undefined;
    name?: string | undefined;
    displayOrder!: number;
    durationMinutes!: number;
    schedulesPatientCallTask!: boolean;
    identifier?: string | undefined;

    constructor(data?: IStudyCallDurationOptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.callType = _data["CallType"];
            this.name = _data["Name"];
            this.displayOrder = _data["DisplayOrder"];
            this.durationMinutes = _data["DurationMinutes"];
            this.schedulesPatientCallTask = _data["SchedulesPatientCallTask"];
            this.identifier = _data["Identifier"];
        }
    }

    static fromJS(data: any): StudyCallDurationOptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyCallDurationOptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["CallType"] = this.callType;
        data["Name"] = this.name;
        data["DisplayOrder"] = this.displayOrder;
        data["DurationMinutes"] = this.durationMinutes;
        data["SchedulesPatientCallTask"] = this.schedulesPatientCallTask;
        data["Identifier"] = this.identifier;
        return data;
    }
}

export interface IStudyCallDurationOptionResult {
    id: string;
    studyId: string;
    callType?: CallType | undefined;
    name?: string | undefined;
    displayOrder: number;
    durationMinutes: number;
    schedulesPatientCallTask: boolean;
    identifier?: string | undefined;
}

export class TaskSourceResult implements ITaskSourceResult {
    sourceType!: SourceType;

    constructor(data?: ITaskSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["SourceType"];
        }
    }

    static fromJS(data: any): TaskSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SourceType"] = this.sourceType;
        return data;
    }
}

export interface ITaskSourceResult {
    sourceType: SourceType;
}

export enum SourceType {
    Other = 0,
    Microsite = 1,
}

export class UpdateTaskStateModel implements IUpdateTaskStateModel {
    note?: string | undefined;
    sendSatisfactionSurvey!: boolean;

    constructor(data?: IUpdateTaskStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["Note"];
            this.sendSatisfactionSurvey = _data["SendSatisfactionSurvey"];
        }
    }

    static fromJS(data: any): UpdateTaskStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Note"] = this.note;
        data["SendSatisfactionSurvey"] = this.sendSatisfactionSurvey;
        return data;
    }
}

export interface IUpdateTaskStateModel {
    note?: string | undefined;
    sendSatisfactionSurvey: boolean;
}

export class CreateCallbackAttemptModel extends UpdateTaskStateModel implements ICreateCallbackAttemptModel {

    constructor(data?: ICreateCallbackAttemptModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateCallbackAttemptModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallbackAttemptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCallbackAttemptModel extends IUpdateTaskStateModel {
}

export class TaskStateResult implements ITaskStateResult {
    id!: string;
    username?: string | undefined;
    createdOn!: Date;
    note?: string | undefined;
    isArchived!: boolean;
    isCallAttempt!: boolean;
    isUserHandle!: boolean;
    isComplete!: boolean;

    constructor(data?: ITaskStateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.username = _data["Username"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.note = _data["Note"];
            this.isArchived = _data["IsArchived"];
            this.isCallAttempt = _data["IsCallAttempt"];
            this.isUserHandle = _data["IsUserHandle"];
            this.isComplete = _data["IsComplete"];
        }
    }

    static fromJS(data: any): TaskStateResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Username"] = this.username;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Note"] = this.note;
        data["IsArchived"] = this.isArchived;
        data["IsCallAttempt"] = this.isCallAttempt;
        data["IsUserHandle"] = this.isUserHandle;
        data["IsComplete"] = this.isComplete;
        return data;
    }
}

export interface ITaskStateResult {
    id: string;
    username?: string | undefined;
    createdOn: Date;
    note?: string | undefined;
    isArchived: boolean;
    isCallAttempt: boolean;
    isUserHandle: boolean;
    isComplete: boolean;
}

export class ValueTupleOfStringAndBoolean implements IValueTupleOfStringAndBoolean {

    constructor(data?: IValueTupleOfStringAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueTupleOfStringAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfStringAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueTupleOfStringAndBoolean {
}

export class CallRatingModel implements ICallRatingModel {
    serviceRating!: number;
    confidenceRating!: number;
    recommendationRating!: number;

    constructor(data?: ICallRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceRating = _data["ServiceRating"];
            this.confidenceRating = _data["ConfidenceRating"];
            this.recommendationRating = _data["RecommendationRating"];
        }
    }

    static fromJS(data: any): CallRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallRatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServiceRating"] = this.serviceRating;
        data["ConfidenceRating"] = this.confidenceRating;
        data["RecommendationRating"] = this.recommendationRating;
        return data;
    }
}

export interface ICallRatingModel {
    serviceRating: number;
    confidenceRating: number;
    recommendationRating: number;
}

export class HandleTaskModel implements IHandleTaskModel {
    originalTaskItemId!: string;

    constructor(data?: IHandleTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalTaskItemId = _data["OriginalTaskItemId"];
        }
    }

    static fromJS(data: any): HandleTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new HandleTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OriginalTaskItemId"] = this.originalTaskItemId;
        return data;
    }
}

export interface IHandleTaskModel {
    originalTaskItemId: string;
}

export class CreateCallbackTaskModel implements ICreateCallbackTaskModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    timeZone?: string | undefined;
    isVoicemailConsented!: boolean;
    callbackType!: CallType;
    studyId!: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
    isAsap!: boolean;

    constructor(data?: ICreateCallbackTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.language = _data["Language"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            this.timeZone = _data["TimeZone"];
            this.isVoicemailConsented = _data["IsVoicemailConsented"];
            this.callbackType = _data["CallbackType"];
            this.studyId = _data["StudyId"];
            this.label = _data["Label"];
            if (Array.isArray(_data["ReminderIntervalsInMinutes"])) {
                this.reminderIntervalsInMinutes = [] as any;
                for (let item of _data["ReminderIntervalsInMinutes"])
                    this.reminderIntervalsInMinutes!.push(item);
            }
            this.isAsap = _data["IsAsap"];
        }
    }

    static fromJS(data: any): CreateCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallbackTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Language"] = this.language;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["TimeZone"] = this.timeZone;
        data["IsVoicemailConsented"] = this.isVoicemailConsented;
        data["CallbackType"] = this.callbackType;
        data["StudyId"] = this.studyId;
        data["Label"] = this.label;
        if (Array.isArray(this.reminderIntervalsInMinutes)) {
            data["ReminderIntervalsInMinutes"] = [];
            for (let item of this.reminderIntervalsInMinutes)
                data["ReminderIntervalsInMinutes"].push(item);
        }
        data["IsAsap"] = this.isAsap;
        return data;
    }
}

export interface ICreateCallbackTaskModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    startDate: Date;
    endDate: Date;
    timeZone?: string | undefined;
    isVoicemailConsented: boolean;
    callbackType: CallType;
    studyId: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
    isAsap: boolean;
}

export class AgentCreateCallbackTaskModel extends CreateCallbackTaskModel implements IAgentCreateCallbackTaskModel {
    agentId?: string | undefined;
    patientId?: string | undefined;
    uniqueId?: string | undefined;

    constructor(data?: IAgentCreateCallbackTaskModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["AgentId"];
            this.patientId = _data["PatientId"];
            this.uniqueId = _data["UniqueId"];
        }
    }

    static fromJS(data: any): AgentCreateCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCreateCallbackTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["PatientId"] = this.patientId;
        data["UniqueId"] = this.uniqueId;
        super.toJSON(data);
        return data;
    }
}

export interface IAgentCreateCallbackTaskModel extends ICreateCallbackTaskModel {
    agentId?: string | undefined;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
}

export class CreateHcpCallResponse implements ICreateHcpCallResponse {
    outcome!: AppointmentOutcome;
    call?: CallbackTaskResult | undefined;

    constructor(data?: ICreateHcpCallResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["Outcome"];
            this.call = _data["Call"] ? CallbackTaskResult.fromJS(_data["Call"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateHcpCallResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHcpCallResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Outcome"] = this.outcome;
        data["Call"] = this.call ? this.call.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateHcpCallResponse {
    outcome: AppointmentOutcome;
    call?: CallbackTaskResult | undefined;
}

export enum AppointmentOutcome {
    Success = 1,
    TimeNoLongerAvailable = 2,
    Error = 3,
}

export class AgentCreateHcpCallbackTaskModel implements IAgentCreateHcpCallbackTaskModel {
    appointmentid!: string;
    agentId!: string;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
    callDurationOptionId!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented!: boolean;
    callbackType!: CallType;
    studyId!: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;

    constructor(data?: IAgentCreateHcpCallbackTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentid = _data["Appointmentid"];
            this.agentId = _data["AgentId"];
            this.patientId = _data["PatientId"];
            this.uniqueId = _data["UniqueId"];
            this.callDurationOptionId = _data["CallDurationOptionId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.language = _data["Language"];
            this.timeZone = _data["TimeZone"];
            this.isVoicemailConsented = _data["IsVoicemailConsented"];
            this.callbackType = _data["CallbackType"];
            this.studyId = _data["StudyId"];
            this.label = _data["Label"];
            if (Array.isArray(_data["ReminderIntervalsInMinutes"])) {
                this.reminderIntervalsInMinutes = [] as any;
                for (let item of _data["ReminderIntervalsInMinutes"])
                    this.reminderIntervalsInMinutes!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentCreateHcpCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCreateHcpCallbackTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Appointmentid"] = this.appointmentid;
        data["AgentId"] = this.agentId;
        data["PatientId"] = this.patientId;
        data["UniqueId"] = this.uniqueId;
        data["CallDurationOptionId"] = this.callDurationOptionId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Language"] = this.language;
        data["TimeZone"] = this.timeZone;
        data["IsVoicemailConsented"] = this.isVoicemailConsented;
        data["CallbackType"] = this.callbackType;
        data["StudyId"] = this.studyId;
        data["Label"] = this.label;
        if (Array.isArray(this.reminderIntervalsInMinutes)) {
            data["ReminderIntervalsInMinutes"] = [];
            for (let item of this.reminderIntervalsInMinutes)
                data["ReminderIntervalsInMinutes"].push(item);
        }
        return data;
    }
}

export interface IAgentCreateHcpCallbackTaskModel {
    appointmentid: string;
    agentId: string;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
    callDurationOptionId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented: boolean;
    callbackType: CallType;
    studyId: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
}

export class CallAttemptConfigurationResult implements ICallAttemptConfigurationResult {
    callAttemptsBeforeArchive!: number;
    id!: string;
    name?: string | undefined;
    studyId!: string;
    callType!: CallType;
    agentType!: AgentType;
    rescheduleCallIntervalMinutes!: number;

    constructor(data?: ICallAttemptConfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callAttemptsBeforeArchive = _data["CallAttemptsBeforeArchive"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.studyId = _data["StudyId"];
            this.callType = _data["CallType"];
            this.agentType = _data["AgentType"];
            this.rescheduleCallIntervalMinutes = _data["RescheduleCallIntervalMinutes"];
        }
    }

    static fromJS(data: any): CallAttemptConfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallAttemptConfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["StudyId"] = this.studyId;
        data["CallType"] = this.callType;
        data["AgentType"] = this.agentType;
        data["RescheduleCallIntervalMinutes"] = this.rescheduleCallIntervalMinutes;
        return data;
    }
}

export interface ICallAttemptConfigurationResult {
    callAttemptsBeforeArchive: number;
    id: string;
    name?: string | undefined;
    studyId: string;
    callType: CallType;
    agentType: AgentType;
    rescheduleCallIntervalMinutes: number;
}

export enum AgentType {
    HCP = 0,
    General = 1,
}

export class StudyResult implements IStudyResult {
    id!: string;
    lumediStudyId?: string | undefined;
    name!: string;
    primaryColor!: string;

    constructor(data?: IStudyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.lumediStudyId = _data["LumediStudyId"];
            this.name = _data["Name"];
            this.primaryColor = _data["PrimaryColor"];
        }
    }

    static fromJS(data: any): StudyResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["LumediStudyId"] = this.lumediStudyId;
        data["Name"] = this.name;
        data["PrimaryColor"] = this.primaryColor;
        return data;
    }
}

export interface IStudyResult {
    id: string;
    lumediStudyId?: string | undefined;
    name: string;
    primaryColor: string;
}

export class UpdateStudyUserModel implements IUpdateStudyUserModel {
    isEnabled!: boolean;
    cultures?: string[] | undefined;
    mappings?: StudyUserMappingsModel[] | undefined;
    designations?: UpdateDesignationModel[] | undefined;

    constructor(data?: IUpdateStudyUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["IsEnabled"];
            if (Array.isArray(_data["Cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["Cultures"])
                    this.cultures!.push(item);
            }
            if (Array.isArray(_data["Mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["Mappings"])
                    this.mappings!.push(StudyUserMappingsModel.fromJS(item));
            }
            if (Array.isArray(_data["Designations"])) {
                this.designations = [] as any;
                for (let item of _data["Designations"])
                    this.designations!.push(UpdateDesignationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsEnabled"] = this.isEnabled;
        if (Array.isArray(this.cultures)) {
            data["Cultures"] = [];
            for (let item of this.cultures)
                data["Cultures"].push(item);
        }
        if (Array.isArray(this.mappings)) {
            data["Mappings"] = [];
            for (let item of this.mappings)
                data["Mappings"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.designations)) {
            data["Designations"] = [];
            for (let item of this.designations)
                data["Designations"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateStudyUserModel {
    isEnabled: boolean;
    cultures?: string[] | undefined;
    mappings?: StudyUserMappingsModel[] | undefined;
    designations?: UpdateDesignationModel[] | undefined;
}

export class StudyUserMappingsModel implements IStudyUserMappingsModel {
    studyId!: string;
    isHcp!: boolean;
    isActive!: boolean;

    constructor(data?: IStudyUserMappingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.isHcp = _data["IsHcp"];
            this.isActive = _data["IsActive"];
        }
    }

    static fromJS(data: any): StudyUserMappingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserMappingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["IsHcp"] = this.isHcp;
        data["IsActive"] = this.isActive;
        return data;
    }
}

export interface IStudyUserMappingsModel {
    studyId: string;
    isHcp: boolean;
    isActive: boolean;
}

export class UpdateDesignationModel implements IUpdateDesignationModel {
    cultureCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUpdateDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["CultureCode"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): UpdateDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDesignationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CultureCode"] = this.cultureCode;
        data["Value"] = this.value;
        return data;
    }
}

export interface IUpdateDesignationModel {
    cultureCode?: string | undefined;
    value?: string | undefined;
}

export class StudyEmailConfigurationResult implements IStudyEmailConfigurationResult {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;

    constructor(data?: IStudyEmailConfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callRatingEmailTemplateId = _data["CallRatingEmailTemplateId"];
            this.callRatingEmailSenderId = _data["CallRatingEmailSenderId"];
            this.videoAppointmentConfirmationEmailTemplateId = _data["VideoAppointmentConfirmationEmailTemplateId"];
            this.phoneAppointmentConfirmationEmailTemplateId = _data["PhoneAppointmentConfirmationEmailTemplateId"];
            this.videoAppointmentReminderEmailTemplateId = _data["VideoAppointmentReminderEmailTemplateId"];
            this.phoneAppointmentReminderEmailTemplateId = _data["PhoneAppointmentReminderEmailTemplateId"];
            this.appointmentConfirmationEmailSenderId = _data["AppointmentConfirmationEmailSenderId"];
            this.appointmentReminderEmailSenderId = _data["AppointmentReminderEmailSenderId"];
        }
    }

    static fromJS(data: any): StudyEmailConfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyEmailConfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallRatingEmailTemplateId"] = this.callRatingEmailTemplateId;
        data["CallRatingEmailSenderId"] = this.callRatingEmailSenderId;
        data["VideoAppointmentConfirmationEmailTemplateId"] = this.videoAppointmentConfirmationEmailTemplateId;
        data["PhoneAppointmentConfirmationEmailTemplateId"] = this.phoneAppointmentConfirmationEmailTemplateId;
        data["VideoAppointmentReminderEmailTemplateId"] = this.videoAppointmentReminderEmailTemplateId;
        data["PhoneAppointmentReminderEmailTemplateId"] = this.phoneAppointmentReminderEmailTemplateId;
        data["AppointmentConfirmationEmailSenderId"] = this.appointmentConfirmationEmailSenderId;
        data["AppointmentReminderEmailSenderId"] = this.appointmentReminderEmailSenderId;
        return data;
    }
}

export interface IStudyEmailConfigurationResult {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;
}

export class UpdateStudyEmailConfigurationModel implements IUpdateStudyEmailConfigurationModel {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;

    constructor(data?: IUpdateStudyEmailConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callRatingEmailTemplateId = _data["CallRatingEmailTemplateId"];
            this.callRatingEmailSenderId = _data["CallRatingEmailSenderId"];
            this.videoAppointmentConfirmationEmailTemplateId = _data["VideoAppointmentConfirmationEmailTemplateId"];
            this.phoneAppointmentConfirmationEmailTemplateId = _data["PhoneAppointmentConfirmationEmailTemplateId"];
            this.videoAppointmentReminderEmailTemplateId = _data["VideoAppointmentReminderEmailTemplateId"];
            this.phoneAppointmentReminderEmailTemplateId = _data["PhoneAppointmentReminderEmailTemplateId"];
            this.appointmentConfirmationEmailSenderId = _data["AppointmentConfirmationEmailSenderId"];
            this.appointmentReminderEmailSenderId = _data["AppointmentReminderEmailSenderId"];
        }
    }

    static fromJS(data: any): UpdateStudyEmailConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyEmailConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallRatingEmailTemplateId"] = this.callRatingEmailTemplateId;
        data["CallRatingEmailSenderId"] = this.callRatingEmailSenderId;
        data["VideoAppointmentConfirmationEmailTemplateId"] = this.videoAppointmentConfirmationEmailTemplateId;
        data["PhoneAppointmentConfirmationEmailTemplateId"] = this.phoneAppointmentConfirmationEmailTemplateId;
        data["VideoAppointmentReminderEmailTemplateId"] = this.videoAppointmentReminderEmailTemplateId;
        data["PhoneAppointmentReminderEmailTemplateId"] = this.phoneAppointmentReminderEmailTemplateId;
        data["AppointmentConfirmationEmailSenderId"] = this.appointmentConfirmationEmailSenderId;
        data["AppointmentReminderEmailSenderId"] = this.appointmentReminderEmailSenderId;
        return data;
    }
}

export interface IUpdateStudyEmailConfigurationModel {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;
}

export class RootStatusResult implements IRootStatusResult {
    id!: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order!: number;
    subStatuses?: StatusResult[] | undefined;
    duration?: string | undefined;

    constructor(data?: IRootStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.culture = _data["Culture"] ? StatusCultureResult.fromJS(_data["Culture"]) : <any>undefined;
            this.primaryColor = _data["PrimaryColor"];
            this.secondaryColor = _data["SecondaryColor"];
            this.order = _data["Order"];
            if (Array.isArray(_data["SubStatuses"])) {
                this.subStatuses = [] as any;
                for (let item of _data["SubStatuses"])
                    this.subStatuses!.push(StatusResult.fromJS(item));
            }
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): RootStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new RootStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Culture"] = this.culture ? this.culture.toJSON() : <any>undefined;
        data["PrimaryColor"] = this.primaryColor;
        data["SecondaryColor"] = this.secondaryColor;
        data["Order"] = this.order;
        if (Array.isArray(this.subStatuses)) {
            data["SubStatuses"] = [];
            for (let item of this.subStatuses)
                data["SubStatuses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Duration"] = this.duration;
        return data;
    }
}

export interface IRootStatusResult {
    id: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order: number;
    subStatuses?: StatusResult[] | undefined;
    duration?: string | undefined;
}

export class StatusCultureResult implements IStatusCultureResult {
    name?: string | undefined;
    isDefault!: boolean;
    cultureCode?: string | undefined;

    constructor(data?: IStatusCultureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.isDefault = _data["IsDefault"];
            this.cultureCode = _data["CultureCode"];
        }
    }

    static fromJS(data: any): StatusCultureResult {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCultureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["IsDefault"] = this.isDefault;
        data["CultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IStatusCultureResult {
    name?: string | undefined;
    isDefault: boolean;
    cultureCode?: string | undefined;
}

export class StatusResult implements IStatusResult {
    id!: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order!: number;
    duration?: string | undefined;

    constructor(data?: IStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.culture = _data["Culture"] ? StatusCultureResult.fromJS(_data["Culture"]) : <any>undefined;
            this.primaryColor = _data["PrimaryColor"];
            this.secondaryColor = _data["SecondaryColor"];
            this.order = _data["Order"];
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): StatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Culture"] = this.culture ? this.culture.toJSON() : <any>undefined;
        data["PrimaryColor"] = this.primaryColor;
        data["SecondaryColor"] = this.secondaryColor;
        data["Order"] = this.order;
        data["Duration"] = this.duration;
        return data;
    }
}

export interface IStatusResult {
    id: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order: number;
    duration?: string | undefined;
}

export class NewStatusViewModel implements INewStatusViewModel {
    name?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;

    constructor(data?: INewStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.primaryColor = _data["PrimaryColor"];
            this.secondaryColor = _data["SecondaryColor"];
        }
    }

    static fromJS(data: any): NewStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["PrimaryColor"] = this.primaryColor;
        data["SecondaryColor"] = this.secondaryColor;
        return data;
    }
}

export interface INewStatusViewModel {
    name?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
}

export class UpdateStatusViewModel implements IUpdateStatusViewModel {
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;

    constructor(data?: IUpdateStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["PrimaryColor"];
            this.secondaryColor = _data["SecondaryColor"];
        }
    }

    static fromJS(data: any): UpdateStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryColor"] = this.primaryColor;
        data["SecondaryColor"] = this.secondaryColor;
        return data;
    }
}

export interface IUpdateStatusViewModel {
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
}

export class UpdateDurationStatusViewModel extends UpdateStatusViewModel implements IUpdateDurationStatusViewModel {
    duration!: string;

    constructor(data?: IUpdateDurationStatusViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): UpdateDurationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDurationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDurationStatusViewModel extends IUpdateStatusViewModel {
    duration: string;
}

export class NewDurationStatusViewModel extends NewStatusViewModel implements INewDurationStatusViewModel {
    duration!: string;

    constructor(data?: INewDurationStatusViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): NewDurationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewDurationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

export interface INewDurationStatusViewModel extends INewStatusViewModel {
    duration: string;
}

export class UpdateStatusCultureViewModel implements IUpdateStatusCultureViewModel {
    name?: string | undefined;

    constructor(data?: IUpdateStatusCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): UpdateStatusCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data;
    }
}

export interface IUpdateStatusCultureViewModel {
    name?: string | undefined;
}

export class RoleResult implements IRoleResult {
    id!: string;
    name?: string | undefined;

    constructor(data?: IRoleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): RoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IRoleResult {
    id: string;
    name?: string | undefined;
}

export class CallbackRoleResult extends RoleResult implements ICallbackRoleResult {
    studyId!: string;
    permissions!: PermissionResult[];

    constructor(data?: ICallbackRoleResult) {
        super(data);
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyId = _data["StudyId"];
            if (Array.isArray(_data["Permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["Permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallbackRoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackRoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        if (Array.isArray(this.permissions)) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackRoleResult extends IRoleResult {
    studyId: string;
    permissions: PermissionResult[];
}

export class PermissionResult implements IPermissionResult {
    name?: string | undefined;
    id!: string;
    permissionType!: PermissionType;

    constructor(data?: IPermissionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.id = _data["Id"];
            this.permissionType = _data["PermissionType"];
        }
    }

    static fromJS(data: any): PermissionResult {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Id"] = this.id;
        data["PermissionType"] = this.permissionType;
        return data;
    }
}

export interface IPermissionResult {
    name?: string | undefined;
    id: string;
    permissionType: PermissionType;
}

export enum PermissionType {
    ScheduleCall = 0,
    ScheduleHCPCall = 1,
    TakeOutboundVideoCall = 2,
    TakeOutboundPhoneCall = 3,
    TakeIncomingVideoCall = 4,
    EditCall = 5,
    ManageEmail = 6,
    SubmitSupportRequest = 7,
    ManageUsers = 8,
    ManageProgramClosures = 9,
}

export class CreateRoleModel implements ICreateRoleModel {
    name?: string | undefined;
    studyId!: string;
    permissions?: PermissionResult[] | undefined;

    constructor(data?: ICreateRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.studyId = _data["StudyId"];
            if (Array.isArray(_data["Permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["Permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["StudyId"] = this.studyId;
        if (Array.isArray(this.permissions)) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateRoleModel {
    name?: string | undefined;
    studyId: string;
    permissions?: PermissionResult[] | undefined;
}

export class UpdateRoleModel implements IUpdateRoleModel {
    name?: string | undefined;
    permissions?: PermissionResult[] | undefined;

    constructor(data?: IUpdateRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["Permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["Permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateRoleModel {
    name?: string | undefined;
    permissions?: PermissionResult[] | undefined;
}

export class GetSoftphoneUserResponse implements IGetSoftphoneUserResponse {
    profileUserID!: string;
    profileName?: string | undefined;
    profilePicture?: string | undefined;
    wssServer?: string | undefined;
    webSocketPort?: string | undefined;
    serverPath?: string | undefined;
    sipDomain?: string | undefined;
    sipUsername?: string | undefined;
    sipPassword?: string | undefined;

    constructor(data?: IGetSoftphoneUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileUserID = _data["ProfileUserID"];
            this.profileName = _data["ProfileName"];
            this.profilePicture = _data["ProfilePicture"];
            this.wssServer = _data["WssServer"];
            this.webSocketPort = _data["WebSocketPort"];
            this.serverPath = _data["ServerPath"];
            this.sipDomain = _data["SipDomain"];
            this.sipUsername = _data["SipUsername"];
            this.sipPassword = _data["SipPassword"];
        }
    }

    static fromJS(data: any): GetSoftphoneUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSoftphoneUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProfileUserID"] = this.profileUserID;
        data["ProfileName"] = this.profileName;
        data["ProfilePicture"] = this.profilePicture;
        data["WssServer"] = this.wssServer;
        data["WebSocketPort"] = this.webSocketPort;
        data["ServerPath"] = this.serverPath;
        data["SipDomain"] = this.sipDomain;
        data["SipUsername"] = this.sipUsername;
        data["SipPassword"] = this.sipPassword;
        return data;
    }
}

export interface IGetSoftphoneUserResponse {
    profileUserID: string;
    profileName?: string | undefined;
    profilePicture?: string | undefined;
    wssServer?: string | undefined;
    webSocketPort?: string | undefined;
    serverPath?: string | undefined;
    sipDomain?: string | undefined;
    sipUsername?: string | undefined;
    sipPassword?: string | undefined;
}

export class SearchedPatient implements ISearchedPatient {
    patientID!: string;
    status!: PatientStatus;
    uniqueID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    isVoicemailConsented!: boolean;
    preferredTimeToCall?: string | undefined;

    constructor(data?: ISearchedPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["PatientID"];
            this.status = _data["Status"];
            this.uniqueID = _data["UniqueID"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.email = _data["Email"];
            this.preferredLanguage = _data["PreferredLanguage"];
            this.preferredLanguageCode = _data["PreferredLanguageCode"];
            this.isVoicemailConsented = _data["IsVoicemailConsented"];
            this.preferredTimeToCall = _data["PreferredTimeToCall"];
        }
    }

    static fromJS(data: any): SearchedPatient {
        data = typeof data === 'object' ? data : {};
        let result = new SearchedPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientID"] = this.patientID;
        data["Status"] = this.status;
        data["UniqueID"] = this.uniqueID;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["PhoneNumber"] = this.phoneNumber;
        data["Email"] = this.email;
        data["PreferredLanguage"] = this.preferredLanguage;
        data["PreferredLanguageCode"] = this.preferredLanguageCode;
        data["IsVoicemailConsented"] = this.isVoicemailConsented;
        data["PreferredTimeToCall"] = this.preferredTimeToCall;
        return data;
    }
}

export interface ISearchedPatient {
    patientID: string;
    status: PatientStatus;
    uniqueID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    isVoicemailConsented: boolean;
    preferredTimeToCall?: string | undefined;
}

export class IsPatientUnsubscribedModel implements IIsPatientUnsubscribedModel {
    isUnsubscribed!: boolean;

    constructor(data?: IIsPatientUnsubscribedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUnsubscribed = _data["IsUnsubscribed"];
        }
    }

    static fromJS(data: any): IsPatientUnsubscribedModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsPatientUnsubscribedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsUnsubscribed"] = this.isUnsubscribed;
        return data;
    }
}

export interface IIsPatientUnsubscribedModel {
    isUnsubscribed: boolean;
}

export class ValidateFollowUpModel implements IValidateFollowUpModel {
    patientFollowUpId!: string;

    constructor(data?: IValidateFollowUpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientFollowUpId = _data["PatientFollowUpId"];
        }
    }

    static fromJS(data: any): ValidateFollowUpModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFollowUpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientFollowUpId"] = this.patientFollowUpId;
        return data;
    }
}

export interface IValidateFollowUpModel {
    patientFollowUpId: string;
}

export class SaxendaAnswerModel implements ISaxendaAnswerModel {
    takingSaxenda?: string | undefined;
    saxendaDose?: string | undefined;

    constructor(data?: ISaxendaAnswerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.takingSaxenda = _data["TakingSaxenda"];
            this.saxendaDose = _data["SaxendaDose"];
        }
    }

    static fromJS(data: any): SaxendaAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaxendaAnswerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TakingSaxenda"] = this.takingSaxenda;
        data["SaxendaDose"] = this.saxendaDose;
        return data;
    }
}

export interface ISaxendaAnswerModel {
    takingSaxenda?: string | undefined;
    saxendaDose?: string | undefined;
}

export class StudyFollowUpScheduleResult implements IStudyFollowUpScheduleResult {
    id!: string;
    studyId!: string;
    followUpType!: FollowUpType;
    name?: string | undefined;

    constructor(data?: IStudyFollowUpScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.followUpType = _data["FollowUpType"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): StudyFollowUpScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["FollowUpType"] = this.followUpType;
        data["Name"] = this.name;
        return data;
    }
}

export interface IStudyFollowUpScheduleResult {
    id: string;
    studyId: string;
    followUpType: FollowUpType;
    name?: string | undefined;
}

export enum FollowUpType {
    Email = 0,
    PhoneCall = 1,
    VideoCall = 2,
}

export class StudyFollowUpCallScheduleResult extends StudyFollowUpScheduleResult implements IStudyFollowUpCallScheduleResult {
    scheduleTicks!: number;
    callLengthTicks!: number;
    callScheduleDays!: number;
    callLengthMinutes!: number;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: IStudyFollowUpCallScheduleResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduleTicks = _data["ScheduleTicks"];
            this.callLengthTicks = _data["CallLengthTicks"];
            this.callScheduleDays = _data["CallScheduleDays"];
            this.callLengthMinutes = _data["CallLengthMinutes"];
            this.interactionTypeOption = _data["InteractionTypeOption"] ? StudyCallDurationOptionResult.fromJS(_data["InteractionTypeOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StudyFollowUpCallScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpCallScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScheduleTicks"] = this.scheduleTicks;
        data["CallLengthTicks"] = this.callLengthTicks;
        data["CallScheduleDays"] = this.callScheduleDays;
        data["CallLengthMinutes"] = this.callLengthMinutes;
        data["InteractionTypeOption"] = this.interactionTypeOption ? this.interactionTypeOption.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStudyFollowUpCallScheduleResult extends IStudyFollowUpScheduleResult {
    scheduleTicks: number;
    callLengthTicks: number;
    callScheduleDays: number;
    callLengthMinutes: number;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;
}

export class CallScheduleModel implements ICallScheduleModel {
    name?: string | undefined;
    callIntervalDays!: number;
    callDurationMinutes!: number;
    interactionTypeOptionId!: string;

    constructor(data?: ICallScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.callIntervalDays = _data["CallIntervalDays"];
            this.callDurationMinutes = _data["CallDurationMinutes"];
            this.interactionTypeOptionId = _data["InteractionTypeOptionId"];
        }
    }

    static fromJS(data: any): CallScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["CallIntervalDays"] = this.callIntervalDays;
        data["CallDurationMinutes"] = this.callDurationMinutes;
        data["InteractionTypeOptionId"] = this.interactionTypeOptionId;
        return data;
    }
}

export interface ICallScheduleModel {
    name?: string | undefined;
    callIntervalDays: number;
    callDurationMinutes: number;
    interactionTypeOptionId: string;
}

export class StudyFollowUpEmailScheduleResult extends StudyFollowUpScheduleResult implements IStudyFollowUpEmailScheduleResult {
    surveyTitle?: string | undefined;
    sendTickInterval!: number;
    sendIntervalMinutes!: number;
    surveyUrl?: string | undefined;
    lumediInteractionId!: number;
    expiryTicks?: number | undefined;
    emailTemplateId!: string;
    emailTemplateName?: string | undefined;
    emailSenderId!: string;
    emailSenderName?: string | undefined;

    constructor(data?: IStudyFollowUpEmailScheduleResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyTitle = _data["SurveyTitle"];
            this.sendTickInterval = _data["SendTickInterval"];
            this.sendIntervalMinutes = _data["SendIntervalMinutes"];
            this.surveyUrl = _data["SurveyUrl"];
            this.lumediInteractionId = _data["LumediInteractionId"];
            this.expiryTicks = _data["ExpiryTicks"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.emailTemplateName = _data["EmailTemplateName"];
            this.emailSenderId = _data["EmailSenderId"];
            this.emailSenderName = _data["EmailSenderName"];
        }
    }

    static fromJS(data: any): StudyFollowUpEmailScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpEmailScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SurveyTitle"] = this.surveyTitle;
        data["SendTickInterval"] = this.sendTickInterval;
        data["SendIntervalMinutes"] = this.sendIntervalMinutes;
        data["SurveyUrl"] = this.surveyUrl;
        data["LumediInteractionId"] = this.lumediInteractionId;
        data["ExpiryTicks"] = this.expiryTicks;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["EmailTemplateName"] = this.emailTemplateName;
        data["EmailSenderId"] = this.emailSenderId;
        data["EmailSenderName"] = this.emailSenderName;
        super.toJSON(data);
        return data;
    }
}

export interface IStudyFollowUpEmailScheduleResult extends IStudyFollowUpScheduleResult {
    surveyTitle?: string | undefined;
    sendTickInterval: number;
    sendIntervalMinutes: number;
    surveyUrl?: string | undefined;
    lumediInteractionId: number;
    expiryTicks?: number | undefined;
    emailTemplateId: string;
    emailTemplateName?: string | undefined;
    emailSenderId: string;
    emailSenderName?: string | undefined;
}

export class EmailScheduleModel implements IEmailScheduleModel {
    title?: string | undefined;
    name?: string | undefined;
    sendIntervalMinutes!: number;
    surveyUrl?: string | undefined;
    lumediInteractionId!: number;
    emailTemplateId!: string;
    emailSenderId!: string;

    constructor(data?: IEmailScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.name = _data["Name"];
            this.sendIntervalMinutes = _data["SendIntervalMinutes"];
            this.surveyUrl = _data["SurveyUrl"];
            this.lumediInteractionId = _data["LumediInteractionId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.emailSenderId = _data["EmailSenderId"];
        }
    }

    static fromJS(data: any): EmailScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Name"] = this.name;
        data["SendIntervalMinutes"] = this.sendIntervalMinutes;
        data["SurveyUrl"] = this.surveyUrl;
        data["LumediInteractionId"] = this.lumediInteractionId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["EmailSenderId"] = this.emailSenderId;
        return data;
    }
}

export interface IEmailScheduleModel {
    title?: string | undefined;
    name?: string | undefined;
    sendIntervalMinutes: number;
    surveyUrl?: string | undefined;
    lumediInteractionId: number;
    emailTemplateId: string;
    emailSenderId: string;
}

export class MissedAppointmentEmailFollowupModel implements IMissedAppointmentEmailFollowupModel {
    name?: string | undefined;
    studyId!: string;
    callType!: CallType;
    agentType!: AgentType;
    emailSenderId!: string;
    emailTemplateId!: string;
    sendInterval!: number;

    constructor(data?: IMissedAppointmentEmailFollowupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.studyId = _data["StudyId"];
            this.callType = _data["CallType"];
            this.agentType = _data["AgentType"];
            this.emailSenderId = _data["EmailSenderId"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.sendInterval = _data["SendInterval"];
        }
    }

    static fromJS(data: any): MissedAppointmentEmailFollowupModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentEmailFollowupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["StudyId"] = this.studyId;
        data["CallType"] = this.callType;
        data["AgentType"] = this.agentType;
        data["EmailSenderId"] = this.emailSenderId;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["SendInterval"] = this.sendInterval;
        return data;
    }
}

export interface IMissedAppointmentEmailFollowupModel {
    name?: string | undefined;
    studyId: string;
    callType: CallType;
    agentType: AgentType;
    emailSenderId: string;
    emailTemplateId: string;
    sendInterval: number;
}

export class MissedAppointmentEmailScheduleResult implements IMissedAppointmentEmailScheduleResult {
    id!: string;
    name?: string | undefined;
    studyId!: string;
    callType!: CallType;
    agentType!: AgentType;
    callAttemptsBeforeArchive!: number;
    emailTemplateId!: string;
    emailTemplateName?: string | undefined;
    emailSenderId!: string;
    emailSenderAddress?: string | undefined;
    emailFollowUpIntervalMinutes!: number;

    constructor(data?: IMissedAppointmentEmailScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.studyId = _data["StudyId"];
            this.callType = _data["CallType"];
            this.agentType = _data["AgentType"];
            this.callAttemptsBeforeArchive = _data["CallAttemptsBeforeArchive"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.emailTemplateName = _data["EmailTemplateName"];
            this.emailSenderId = _data["EmailSenderId"];
            this.emailSenderAddress = _data["EmailSenderAddress"];
            this.emailFollowUpIntervalMinutes = _data["EmailFollowUpIntervalMinutes"];
        }
    }

    static fromJS(data: any): MissedAppointmentEmailScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentEmailScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["StudyId"] = this.studyId;
        data["CallType"] = this.callType;
        data["AgentType"] = this.agentType;
        data["CallAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["EmailTemplateName"] = this.emailTemplateName;
        data["EmailSenderId"] = this.emailSenderId;
        data["EmailSenderAddress"] = this.emailSenderAddress;
        data["EmailFollowUpIntervalMinutes"] = this.emailFollowUpIntervalMinutes;
        return data;
    }
}

export interface IMissedAppointmentEmailScheduleResult {
    id: string;
    name?: string | undefined;
    studyId: string;
    callType: CallType;
    agentType: AgentType;
    callAttemptsBeforeArchive: number;
    emailTemplateId: string;
    emailTemplateName?: string | undefined;
    emailSenderId: string;
    emailSenderAddress?: string | undefined;
    emailFollowUpIntervalMinutes: number;
}

export class MissedAppointmentCallConfigurationModel implements IMissedAppointmentCallConfigurationModel {
    name?: string | undefined;
    callType!: CallType;
    agentType!: AgentType;
    callAttemptsBeforeArchive!: number;
    rescheduleIntervalMinutes!: number;

    constructor(data?: IMissedAppointmentCallConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.callType = _data["CallType"];
            this.agentType = _data["AgentType"];
            this.callAttemptsBeforeArchive = _data["CallAttemptsBeforeArchive"];
            this.rescheduleIntervalMinutes = _data["RescheduleIntervalMinutes"];
        }
    }

    static fromJS(data: any): MissedAppointmentCallConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentCallConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["CallType"] = this.callType;
        data["AgentType"] = this.agentType;
        data["CallAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["RescheduleIntervalMinutes"] = this.rescheduleIntervalMinutes;
        return data;
    }
}

export interface IMissedAppointmentCallConfigurationModel {
    name?: string | undefined;
    callType: CallType;
    agentType: AgentType;
    callAttemptsBeforeArchive: number;
    rescheduleIntervalMinutes: number;
}

export class QueueMetricsModel2 implements IQueueMetricsModel2 {
    averageWaitTime?: string | undefined;
    englishQueuedCallers!: number;
    englishAvailableAgents!: number;
    frenchQueuedCallers!: number;
    frenchAvailableAgents!: number;
    totalAvailableAgents!: number;

    constructor(data?: IQueueMetricsModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageWaitTime = _data["AverageWaitTime"];
            this.englishQueuedCallers = _data["EnglishQueuedCallers"];
            this.englishAvailableAgents = _data["EnglishAvailableAgents"];
            this.frenchQueuedCallers = _data["FrenchQueuedCallers"];
            this.frenchAvailableAgents = _data["FrenchAvailableAgents"];
            this.totalAvailableAgents = _data["TotalAvailableAgents"];
        }
    }

    static fromJS(data: any): QueueMetricsModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QueueMetricsModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AverageWaitTime"] = this.averageWaitTime;
        data["EnglishQueuedCallers"] = this.englishQueuedCallers;
        data["EnglishAvailableAgents"] = this.englishAvailableAgents;
        data["FrenchQueuedCallers"] = this.frenchQueuedCallers;
        data["FrenchAvailableAgents"] = this.frenchAvailableAgents;
        data["TotalAvailableAgents"] = this.totalAvailableAgents;
        return data;
    }
}

export interface IQueueMetricsModel2 {
    averageWaitTime?: string | undefined;
    englishQueuedCallers: number;
    englishAvailableAgents: number;
    frenchQueuedCallers: number;
    frenchAvailableAgents: number;
    totalAvailableAgents: number;
}

export class CallMetricsModel implements ICallMetricsModel {
    dailyInboundVideoCallsCount!: number;
    averageInboundVideoCallsPerAgent!: number;
    averageOutboundVideoCallsPerAgent!: number;

    constructor(data?: ICallMetricsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyInboundVideoCallsCount = _data["DailyInboundVideoCallsCount"];
            this.averageInboundVideoCallsPerAgent = _data["AverageInboundVideoCallsPerAgent"];
            this.averageOutboundVideoCallsPerAgent = _data["AverageOutboundVideoCallsPerAgent"];
        }
    }

    static fromJS(data: any): CallMetricsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallMetricsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DailyInboundVideoCallsCount"] = this.dailyInboundVideoCallsCount;
        data["AverageInboundVideoCallsPerAgent"] = this.averageInboundVideoCallsPerAgent;
        data["AverageOutboundVideoCallsPerAgent"] = this.averageOutboundVideoCallsPerAgent;
        return data;
    }
}

export interface ICallMetricsModel {
    dailyInboundVideoCallsCount: number;
    averageInboundVideoCallsPerAgent: number;
    averageOutboundVideoCallsPerAgent: number;
}

export class MessageThreadSummaryResult implements IMessageThreadSummaryResult {
    messageId!: string;
    toUserId!: string;
    fromUserId!: string;
    subject?: string | undefined;
    completedOn?: Date | undefined;
    lastMessageCommentCreatedOn!: Date;
    lastMessageComment?: string | undefined;
    isUnread!: boolean;

    constructor(data?: IMessageThreadSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["MessageId"];
            this.toUserId = _data["ToUserId"];
            this.fromUserId = _data["FromUserId"];
            this.subject = _data["Subject"];
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.lastMessageCommentCreatedOn = _data["LastMessageCommentCreatedOn"] ? new Date(_data["LastMessageCommentCreatedOn"].toString()) : <any>undefined;
            this.lastMessageComment = _data["LastMessageComment"];
            this.isUnread = _data["IsUnread"];
        }
    }

    static fromJS(data: any): MessageThreadSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageId"] = this.messageId;
        data["ToUserId"] = this.toUserId;
        data["FromUserId"] = this.fromUserId;
        data["Subject"] = this.subject;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["LastMessageCommentCreatedOn"] = this.lastMessageCommentCreatedOn ? this.lastMessageCommentCreatedOn.toISOString() : <any>undefined;
        data["LastMessageComment"] = this.lastMessageComment;
        data["IsUnread"] = this.isUnread;
        return data;
    }
}

export interface IMessageThreadSummaryResult {
    messageId: string;
    toUserId: string;
    fromUserId: string;
    subject?: string | undefined;
    completedOn?: Date | undefined;
    lastMessageCommentCreatedOn: Date;
    lastMessageComment?: string | undefined;
    isUnread: boolean;
}

export class MessageThreadResult implements IMessageThreadResult {
    messageThreadId!: string;
    createdOn!: Date;
    completedOn?: Date | undefined;
    sendingUserId!: string;
    recipientUserId!: string;
    subject?: string | undefined;
    comments?: MessageThreadCommentResult[] | undefined;

    constructor(data?: IMessageThreadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["MessageThreadId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.completedOn = _data["CompletedOn"] ? new Date(_data["CompletedOn"].toString()) : <any>undefined;
            this.sendingUserId = _data["SendingUserId"];
            this.recipientUserId = _data["RecipientUserId"];
            this.subject = _data["Subject"];
            if (Array.isArray(_data["Comments"])) {
                this.comments = [] as any;
                for (let item of _data["Comments"])
                    this.comments!.push(MessageThreadCommentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageThreadResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageThreadId"] = this.messageThreadId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["CompletedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["SendingUserId"] = this.sendingUserId;
        data["RecipientUserId"] = this.recipientUserId;
        data["Subject"] = this.subject;
        if (Array.isArray(this.comments)) {
            data["Comments"] = [];
            for (let item of this.comments)
                data["Comments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IMessageThreadResult {
    messageThreadId: string;
    createdOn: Date;
    completedOn?: Date | undefined;
    sendingUserId: string;
    recipientUserId: string;
    subject?: string | undefined;
    comments?: MessageThreadCommentResult[] | undefined;
}

export class MessageThreadCommentResult implements IMessageThreadCommentResult {
    messageThreadId!: string;
    messageThreadCommentId!: string;
    createdOn!: Date;
    value?: string | undefined;
    commentingUserId!: string;

    constructor(data?: IMessageThreadCommentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["MessageThreadId"];
            this.messageThreadCommentId = _data["MessageThreadCommentId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.value = _data["Value"];
            this.commentingUserId = _data["CommentingUserId"];
        }
    }

    static fromJS(data: any): MessageThreadCommentResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadCommentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageThreadId"] = this.messageThreadId;
        data["MessageThreadCommentId"] = this.messageThreadCommentId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Value"] = this.value;
        data["CommentingUserId"] = this.commentingUserId;
        return data;
    }
}

export interface IMessageThreadCommentResult {
    messageThreadId: string;
    messageThreadCommentId: string;
    createdOn: Date;
    value?: string | undefined;
    commentingUserId: string;
}

export class CreateMessageThreadRequestModel implements ICreateMessageThreadRequestModel {
    subject!: string;
    toUserId!: string;
    initialComment!: string;

    constructor(data?: ICreateMessageThreadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["Subject"];
            this.toUserId = _data["ToUserId"];
            this.initialComment = _data["InitialComment"];
        }
    }

    static fromJS(data: any): CreateMessageThreadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageThreadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subject"] = this.subject;
        data["ToUserId"] = this.toUserId;
        data["InitialComment"] = this.initialComment;
        return data;
    }
}

export interface ICreateMessageThreadRequestModel {
    subject: string;
    toUserId: string;
    initialComment: string;
}

export class CreateCommentForMessageThreadRequestModel implements ICreateCommentForMessageThreadRequestModel {
    messageThreadId!: string;
    comment!: string;
    complete!: boolean;

    constructor(data?: ICreateCommentForMessageThreadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["MessageThreadId"];
            this.comment = _data["Comment"];
            this.complete = _data["Complete"];
        }
    }

    static fromJS(data: any): CreateCommentForMessageThreadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentForMessageThreadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageThreadId"] = this.messageThreadId;
        data["Comment"] = this.comment;
        data["Complete"] = this.complete;
        return data;
    }
}

export interface ICreateCommentForMessageThreadRequestModel {
    messageThreadId: string;
    comment: string;
    complete: boolean;
}

export class InitialStateEmailResult implements IInitialStateEmailResult {
    infoEmails?: EmailResult[] | undefined;
    faxReceipts?: EmailResult[] | undefined;

    constructor(data?: IInitialStateEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["InfoEmails"])) {
                this.infoEmails = [] as any;
                for (let item of _data["InfoEmails"])
                    this.infoEmails!.push(EmailResult.fromJS(item));
            }
            if (Array.isArray(_data["FaxReceipts"])) {
                this.faxReceipts = [] as any;
                for (let item of _data["FaxReceipts"])
                    this.faxReceipts!.push(EmailResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InitialStateEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new InitialStateEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.infoEmails)) {
            data["InfoEmails"] = [];
            for (let item of this.infoEmails)
                data["InfoEmails"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.faxReceipts)) {
            data["FaxReceipts"] = [];
            for (let item of this.faxReceipts)
                data["FaxReceipts"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInitialStateEmailResult {
    infoEmails?: EmailResult[] | undefined;
    faxReceipts?: EmailResult[] | undefined;
}

export class EmailResult implements IEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    toAll?: string | undefined;
    processed!: boolean;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    hTMLBody?: string | undefined;
    date!: Date;
    attachments?: EmailAttachmentResult[] | undefined;

    constructor(data?: IEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["MessageId"];
            this.to = _data["To"];
            this.toAll = _data["ToAll"];
            this.processed = _data["Processed"];
            this.from = _data["From"];
            this.subject = _data["Subject"];
            this.textBody = _data["TextBody"];
            this.hTMLBody = _data["HTMLBody"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(EmailAttachmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageId"] = this.messageId;
        data["To"] = this.to;
        data["ToAll"] = this.toAll;
        data["Processed"] = this.processed;
        data["From"] = this.from;
        data["Subject"] = this.subject;
        data["TextBody"] = this.textBody;
        data["HTMLBody"] = this.hTMLBody;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    toAll?: string | undefined;
    processed: boolean;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    hTMLBody?: string | undefined;
    date: Date;
    attachments?: EmailAttachmentResult[] | undefined;
}

export class EmailAttachmentResult implements IEmailAttachmentResult {
    fileName?: string | undefined;

    constructor(data?: IEmailAttachmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
        }
    }

    static fromJS(data: any): EmailAttachmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        return data;
    }
}

export interface IEmailAttachmentResult {
    fileName?: string | undefined;
}

export class AdministrativeDataResult implements IAdministrativeDataResult {
    userContext?: UserContextResult | undefined;
    cultures?: CultureResult[] | undefined;
    userStudies?: StudyResult[] | undefined;
    statuses?: RootStatusResult[] | undefined;
    agents?: UserResult[] | undefined;
    phoneQueues?: AsteriskQueueResult[] | undefined;
    permissions?: PermissionResult[] | undefined;
    roles?: CallbackRoleResult[] | undefined;

    constructor(data?: IAdministrativeDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userContext = _data["UserContext"] ? UserContextResult.fromJS(_data["UserContext"]) : <any>undefined;
            if (Array.isArray(_data["Cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["Cultures"])
                    this.cultures!.push(CultureResult.fromJS(item));
            }
            if (Array.isArray(_data["UserStudies"])) {
                this.userStudies = [] as any;
                for (let item of _data["UserStudies"])
                    this.userStudies!.push(StudyResult.fromJS(item));
            }
            if (Array.isArray(_data["Statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["Statuses"])
                    this.statuses!.push(RootStatusResult.fromJS(item));
            }
            if (Array.isArray(_data["Agents"])) {
                this.agents = [] as any;
                for (let item of _data["Agents"])
                    this.agents!.push(UserResult.fromJS(item));
            }
            if (Array.isArray(_data["PhoneQueues"])) {
                this.phoneQueues = [] as any;
                for (let item of _data["PhoneQueues"])
                    this.phoneQueues!.push(AsteriskQueueResult.fromJS(item));
            }
            if (Array.isArray(_data["Permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["Permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(CallbackRoleResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdministrativeDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrativeDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserContext"] = this.userContext ? this.userContext.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["Cultures"] = [];
            for (let item of this.cultures)
                data["Cultures"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.userStudies)) {
            data["UserStudies"] = [];
            for (let item of this.userStudies)
                data["UserStudies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.statuses)) {
            data["Statuses"] = [];
            for (let item of this.statuses)
                data["Statuses"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.agents)) {
            data["Agents"] = [];
            for (let item of this.agents)
                data["Agents"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.phoneQueues)) {
            data["PhoneQueues"] = [];
            for (let item of this.phoneQueues)
                data["PhoneQueues"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.permissions)) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAdministrativeDataResult {
    userContext?: UserContextResult | undefined;
    cultures?: CultureResult[] | undefined;
    userStudies?: StudyResult[] | undefined;
    statuses?: RootStatusResult[] | undefined;
    agents?: UserResult[] | undefined;
    phoneQueues?: AsteriskQueueResult[] | undefined;
    permissions?: PermissionResult[] | undefined;
    roles?: CallbackRoleResult[] | undefined;
}

export class CultureResult implements ICultureResult {
    code!: string;

    constructor(data?: ICultureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): CultureResult {
        data = typeof data === 'object' ? data : {};
        let result = new CultureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        return data;
    }
}

export interface ICultureResult {
    code: string;
}

export class UserResult implements IUserResult {
    id!: string;
    name?: string | undefined;
    fullName?: string | undefined;
    asteriskUsername?: string | undefined;
    isEnabled!: boolean;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    asteriskExtensionNumber?: string | undefined;
    cultures!: CultureResult[];
    status?: UserStatusResult | undefined;
    studies!: StudyUserRoleResult[];
    assignedQueues!: string[];
    temporaryAssignedQueues!: string[];
    designations!: DesignationResult[];
    agentStatus?: AgentStatus | undefined;

    constructor(data?: IUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cultures = [];
            this.studies = [];
            this.assignedQueues = [];
            this.temporaryAssignedQueues = [];
            this.designations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.fullName = _data["FullName"];
            this.asteriskUsername = _data["AsteriskUsername"];
            this.isEnabled = _data["IsEnabled"];
            if (Array.isArray(_data["AgentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["AgentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["AgentRole"];
            this.asteriskExtensionNumber = _data["AsteriskExtensionNumber"];
            if (Array.isArray(_data["Cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["Cultures"])
                    this.cultures!.push(CultureResult.fromJS(item));
            }
            this.status = _data["Status"] ? UserStatusResult.fromJS(_data["Status"]) : <any>undefined;
            if (Array.isArray(_data["Studies"])) {
                this.studies = [] as any;
                for (let item of _data["Studies"])
                    this.studies!.push(StudyUserRoleResult.fromJS(item));
            }
            if (Array.isArray(_data["AssignedQueues"])) {
                this.assignedQueues = [] as any;
                for (let item of _data["AssignedQueues"])
                    this.assignedQueues!.push(item);
            }
            if (Array.isArray(_data["TemporaryAssignedQueues"])) {
                this.temporaryAssignedQueues = [] as any;
                for (let item of _data["TemporaryAssignedQueues"])
                    this.temporaryAssignedQueues!.push(item);
            }
            if (Array.isArray(_data["Designations"])) {
                this.designations = [] as any;
                for (let item of _data["Designations"])
                    this.designations!.push(DesignationResult.fromJS(item));
            }
            this.agentStatus = _data["AgentStatus"];
        }
    }

    static fromJS(data: any): UserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["FullName"] = this.fullName;
        data["AsteriskUsername"] = this.asteriskUsername;
        data["IsEnabled"] = this.isEnabled;
        if (Array.isArray(this.agentProvinces)) {
            data["AgentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["AgentProvinces"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentRole"] = this.agentRole;
        data["AsteriskExtensionNumber"] = this.asteriskExtensionNumber;
        if (Array.isArray(this.cultures)) {
            data["Cultures"] = [];
            for (let item of this.cultures)
                data["Cultures"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.studies)) {
            data["Studies"] = [];
            for (let item of this.studies)
                data["Studies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.assignedQueues)) {
            data["AssignedQueues"] = [];
            for (let item of this.assignedQueues)
                data["AssignedQueues"].push(item);
        }
        if (Array.isArray(this.temporaryAssignedQueues)) {
            data["TemporaryAssignedQueues"] = [];
            for (let item of this.temporaryAssignedQueues)
                data["TemporaryAssignedQueues"].push(item);
        }
        if (Array.isArray(this.designations)) {
            data["Designations"] = [];
            for (let item of this.designations)
                data["Designations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentStatus"] = this.agentStatus;
        return data;
    }
}

export interface IUserResult {
    id: string;
    name?: string | undefined;
    fullName?: string | undefined;
    asteriskUsername?: string | undefined;
    isEnabled: boolean;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    asteriskExtensionNumber?: string | undefined;
    cultures: CultureResult[];
    status?: UserStatusResult | undefined;
    studies: StudyUserRoleResult[];
    assignedQueues: string[];
    temporaryAssignedQueues: string[];
    designations: DesignationResult[];
    agentStatus?: AgentStatus | undefined;
}

export class ProvinceScheduleSummary implements IProvinceScheduleSummary {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IProvinceScheduleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ProvinceScheduleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceScheduleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        return data;
    }
}

export interface IProvinceScheduleSummary {
    code?: string | undefined;
    name?: string | undefined;
}

export class StudyUserRoleResult implements IStudyUserRoleResult {
    studyUserId!: string;
    studyId!: string;
    studyName?: string | undefined;
    studyColor?: string | undefined;
    isHcp!: boolean;
    roleIds!: string[];

    constructor(data?: IStudyUserRoleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyUserId = _data["StudyUserId"];
            this.studyId = _data["StudyId"];
            this.studyName = _data["StudyName"];
            this.studyColor = _data["StudyColor"];
            this.isHcp = _data["IsHcp"];
            if (Array.isArray(_data["RoleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["RoleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyUserRoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserRoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyUserId"] = this.studyUserId;
        data["StudyId"] = this.studyId;
        data["StudyName"] = this.studyName;
        data["StudyColor"] = this.studyColor;
        data["IsHcp"] = this.isHcp;
        if (Array.isArray(this.roleIds)) {
            data["RoleIds"] = [];
            for (let item of this.roleIds)
                data["RoleIds"].push(item);
        }
        return data;
    }
}

export interface IStudyUserRoleResult {
    studyUserId: string;
    studyId: string;
    studyName?: string | undefined;
    studyColor?: string | undefined;
    isHcp: boolean;
    roleIds: string[];
}

export class DesignationResult implements IDesignationResult {
    cultureCode!: string;
    value?: string | undefined;

    constructor(data?: IDesignationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["CultureCode"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): DesignationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CultureCode"] = this.cultureCode;
        data["Value"] = this.value;
        return data;
    }
}

export interface IDesignationResult {
    cultureCode: string;
    value?: string | undefined;
}

export class AsteriskQueueResult implements IAsteriskQueueResult {
    id!: string;
    queueName!: string;
    disabled!: boolean;
    displayName?: string | undefined;
    studyId?: string | undefined;
    cultureCode?: string | undefined;

    constructor(data?: IAsteriskQueueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.queueName = _data["QueueName"];
            this.disabled = _data["Disabled"];
            this.displayName = _data["DisplayName"];
            this.studyId = _data["StudyId"];
            this.cultureCode = _data["CultureCode"];
        }
    }

    static fromJS(data: any): AsteriskQueueResult {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskQueueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["QueueName"] = this.queueName;
        data["Disabled"] = this.disabled;
        data["DisplayName"] = this.displayName;
        data["StudyId"] = this.studyId;
        data["CultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IAsteriskQueueResult {
    id: string;
    queueName: string;
    disabled: boolean;
    displayName?: string | undefined;
    studyId?: string | undefined;
    cultureCode?: string | undefined;
}

export class TaskDataResult implements ITaskDataResult {
    activeTasks?: CallbackTaskResult[] | undefined;
    activeVideos?: IncomingVideoResult[] | undefined;
    inProgressVideos?: InProgressVideoCallResult[] | undefined;
    channelSnapshot?: ChannelsStateSnapshot | undefined;
    queueSnapshot?: QueueSummariesSnapshot | undefined;
    pendingWrapUps?: PhoneWrapUpPendingResult[] | undefined;

    constructor(data?: ITaskDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ActiveTasks"])) {
                this.activeTasks = [] as any;
                for (let item of _data["ActiveTasks"])
                    this.activeTasks!.push(CallbackTaskResult.fromJS(item));
            }
            if (Array.isArray(_data["ActiveVideos"])) {
                this.activeVideos = [] as any;
                for (let item of _data["ActiveVideos"])
                    this.activeVideos!.push(IncomingVideoResult.fromJS(item));
            }
            if (Array.isArray(_data["InProgressVideos"])) {
                this.inProgressVideos = [] as any;
                for (let item of _data["InProgressVideos"])
                    this.inProgressVideos!.push(InProgressVideoCallResult.fromJS(item));
            }
            this.channelSnapshot = _data["ChannelSnapshot"] ? ChannelsStateSnapshot.fromJS(_data["ChannelSnapshot"]) : <any>undefined;
            this.queueSnapshot = _data["QueueSnapshot"] ? QueueSummariesSnapshot.fromJS(_data["QueueSnapshot"]) : <any>undefined;
            if (Array.isArray(_data["PendingWrapUps"])) {
                this.pendingWrapUps = [] as any;
                for (let item of _data["PendingWrapUps"])
                    this.pendingWrapUps!.push(PhoneWrapUpPendingResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeTasks)) {
            data["ActiveTasks"] = [];
            for (let item of this.activeTasks)
                data["ActiveTasks"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.activeVideos)) {
            data["ActiveVideos"] = [];
            for (let item of this.activeVideos)
                data["ActiveVideos"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.inProgressVideos)) {
            data["InProgressVideos"] = [];
            for (let item of this.inProgressVideos)
                data["InProgressVideos"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ChannelSnapshot"] = this.channelSnapshot ? this.channelSnapshot.toJSON() : <any>undefined;
        data["QueueSnapshot"] = this.queueSnapshot ? this.queueSnapshot.toJSON() : <any>undefined;
        if (Array.isArray(this.pendingWrapUps)) {
            data["PendingWrapUps"] = [];
            for (let item of this.pendingWrapUps)
                data["PendingWrapUps"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITaskDataResult {
    activeTasks?: CallbackTaskResult[] | undefined;
    activeVideos?: IncomingVideoResult[] | undefined;
    inProgressVideos?: InProgressVideoCallResult[] | undefined;
    channelSnapshot?: ChannelsStateSnapshot | undefined;
    queueSnapshot?: QueueSummariesSnapshot | undefined;
    pendingWrapUps?: PhoneWrapUpPendingResult[] | undefined;
}

export class IncomingVideoResult implements IIncomingVideoResult {
    id!: string;
    studyId!: string;
    createdOn!: Date;
    isArchived!: boolean;
    language?: string | undefined;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;

    constructor(data?: IIncomingVideoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.isArchived = _data["IsArchived"];
            this.language = _data["Language"];
            this.onlineMeetingId = _data["OnlineMeetingId"];
            this.onlineMeetingJoinWebUrl = _data["OnlineMeetingJoinWebUrl"];
        }
    }

    static fromJS(data: any): IncomingVideoResult {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingVideoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["IsArchived"] = this.isArchived;
        data["Language"] = this.language;
        data["OnlineMeetingId"] = this.onlineMeetingId;
        data["OnlineMeetingJoinWebUrl"] = this.onlineMeetingJoinWebUrl;
        return data;
    }
}

export interface IIncomingVideoResult {
    id: string;
    studyId: string;
    createdOn: Date;
    isArchived: boolean;
    language?: string | undefined;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
}

export class InProgressVideoCallResult implements IInProgressVideoCallResult {
    incomingVideoCallId!: string;
    studyId!: string;
    users?: UserVideoJoinResult[] | undefined;

    constructor(data?: IInProgressVideoCallResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingVideoCallId = _data["IncomingVideoCallId"];
            this.studyId = _data["StudyId"];
            if (Array.isArray(_data["Users"])) {
                this.users = [] as any;
                for (let item of _data["Users"])
                    this.users!.push(UserVideoJoinResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InProgressVideoCallResult {
        data = typeof data === 'object' ? data : {};
        let result = new InProgressVideoCallResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IncomingVideoCallId"] = this.incomingVideoCallId;
        data["StudyId"] = this.studyId;
        if (Array.isArray(this.users)) {
            data["Users"] = [];
            for (let item of this.users)
                data["Users"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInProgressVideoCallResult {
    incomingVideoCallId: string;
    studyId: string;
    users?: UserVideoJoinResult[] | undefined;
}

export class UserVideoJoinResult implements IUserVideoJoinResult {
    userId!: string;
    createdOn!: Date;

    constructor(data?: IUserVideoJoinResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVideoJoinResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserVideoJoinResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserVideoJoinResult {
    userId: string;
    createdOn: Date;
}

export class ChannelsStateSnapshot implements IChannelsStateSnapshot {
    users!: { [key: string]: UserSnapshot; };
    callers!: { [key: string]: CallerSnapshot; };

    constructor(data?: IChannelsStateSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = {};
            this.callers = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Users"]) {
                this.users = {} as any;
                for (let key in _data["Users"]) {
                    if (_data["Users"].hasOwnProperty(key))
                        (<any>this.users)![key] = _data["Users"][key] ? UserSnapshot.fromJS(_data["Users"][key]) : new UserSnapshot();
                }
            }
            if (_data["Callers"]) {
                this.callers = {} as any;
                for (let key in _data["Callers"]) {
                    if (_data["Callers"].hasOwnProperty(key))
                        (<any>this.callers)![key] = _data["Callers"][key] ? CallerSnapshot.fromJS(_data["Callers"][key]) : new CallerSnapshot();
                }
            }
        }
    }

    static fromJS(data: any): ChannelsStateSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelsStateSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.users) {
            data["Users"] = {};
            for (let key in this.users) {
                if (this.users.hasOwnProperty(key))
                    (<any>data["Users"])[key] = this.users[key] ? this.users[key].toJSON() : <any>undefined;
            }
        }
        if (this.callers) {
            data["Callers"] = {};
            for (let key in this.callers) {
                if (this.callers.hasOwnProperty(key))
                    (<any>data["Callers"])[key] = this.callers[key] ? this.callers[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IChannelsStateSnapshot {
    users: { [key: string]: UserSnapshot; };
    callers: { [key: string]: CallerSnapshot; };
}

export class ChannelSnapshot implements IChannelSnapshot {
    status!: ChannelStatus;
    startedOn!: Date;
    snapshotCreated!: Date;
    channel?: string | undefined;
    uniqueId?: string | undefined;
    linkedId?: string | undefined;

    constructor(data?: IChannelSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.startedOn = _data["StartedOn"] ? new Date(_data["StartedOn"].toString()) : <any>undefined;
            this.snapshotCreated = _data["SnapshotCreated"] ? new Date(_data["SnapshotCreated"].toString()) : <any>undefined;
            this.channel = _data["Channel"];
            this.uniqueId = _data["UniqueId"];
            this.linkedId = _data["LinkedId"];
        }
    }

    static fromJS(data: any): ChannelSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["StartedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>undefined;
        data["SnapshotCreated"] = this.snapshotCreated ? this.snapshotCreated.toISOString() : <any>undefined;
        data["Channel"] = this.channel;
        data["UniqueId"] = this.uniqueId;
        data["LinkedId"] = this.linkedId;
        return data;
    }
}

export interface IChannelSnapshot {
    status: ChannelStatus;
    startedOn: Date;
    snapshotCreated: Date;
    channel?: string | undefined;
    uniqueId?: string | undefined;
    linkedId?: string | undefined;
}

export class UserSnapshot extends ChannelSnapshot implements IUserSnapshot {
    userId!: string;
    isDialedOutbound!: boolean;
    dialedNumber?: string | undefined;

    constructor(data?: IUserSnapshot) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["UserId"];
            this.isDialedOutbound = _data["IsDialedOutbound"];
            this.dialedNumber = _data["DialedNumber"];
        }
    }

    static fromJS(data: any): UserSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new UserSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["IsDialedOutbound"] = this.isDialedOutbound;
        data["DialedNumber"] = this.dialedNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSnapshot extends IChannelSnapshot {
    userId: string;
    isDialedOutbound: boolean;
    dialedNumber?: string | undefined;
}

export enum ChannelStatus {
    DownAvailable = 0,
    DownReserved = 1,
    OffHook = 2,
    Dialed = 3,
    LineRining = 4,
    RemoteRinging = 5,
    Up = 6,
    Busy = 7,
}

export class CallerSnapshot extends ChannelSnapshot implements ICallerSnapshot {
    callerIdName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICallerSnapshot) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.callerIdName = _data["CallerIdName"];
            this.phoneNumber = _data["PhoneNumber"];
        }
    }

    static fromJS(data: any): CallerSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new CallerSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallerIdName"] = this.callerIdName;
        data["PhoneNumber"] = this.phoneNumber;
        super.toJSON(data);
        return data;
    }
}

export interface ICallerSnapshot extends IChannelSnapshot {
    callerIdName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class QueueSummariesSnapshot implements IQueueSummariesSnapshot {
    queues!: { [key: string]: QueueSnapshot; };
    userQueues!: { [key: string]: string[]; };

    constructor(data?: IQueueSummariesSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.queues = {};
            this.userQueues = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Queues"]) {
                this.queues = {} as any;
                for (let key in _data["Queues"]) {
                    if (_data["Queues"].hasOwnProperty(key))
                        (<any>this.queues)![key] = _data["Queues"][key] ? QueueSnapshot.fromJS(_data["Queues"][key]) : new QueueSnapshot();
                }
            }
            if (_data["UserQueues"]) {
                this.userQueues = {} as any;
                for (let key in _data["UserQueues"]) {
                    if (_data["UserQueues"].hasOwnProperty(key))
                        (<any>this.userQueues)![key] = _data["UserQueues"][key] !== undefined ? _data["UserQueues"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): QueueSummariesSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueueSummariesSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.queues) {
            data["Queues"] = {};
            for (let key in this.queues) {
                if (this.queues.hasOwnProperty(key))
                    (<any>data["Queues"])[key] = this.queues[key] ? this.queues[key].toJSON() : <any>undefined;
            }
        }
        if (this.userQueues) {
            data["UserQueues"] = {};
            for (let key in this.userQueues) {
                if (this.userQueues.hasOwnProperty(key))
                    (<any>data["UserQueues"])[key] = (<any>this.userQueues)[key];
            }
        }
        return data;
    }
}

export interface IQueueSummariesSnapshot {
    queues: { [key: string]: QueueSnapshot; };
    userQueues: { [key: string]: string[]; };
}

export class QueueSnapshot implements IQueueSnapshot {
    name?: string | undefined;
    holdTime!: string;
    callers!: QueuedCallerSnapshot[];

    constructor(data?: IQueueSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.callers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.holdTime = _data["HoldTime"];
            if (Array.isArray(_data["Callers"])) {
                this.callers = [] as any;
                for (let item of _data["Callers"])
                    this.callers!.push(QueuedCallerSnapshot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueueSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueueSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["HoldTime"] = this.holdTime;
        if (Array.isArray(this.callers)) {
            data["Callers"] = [];
            for (let item of this.callers)
                data["Callers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IQueueSnapshot {
    name?: string | undefined;
    holdTime: string;
    callers: QueuedCallerSnapshot[];
}

export class QueuedCallerSnapshot implements IQueuedCallerSnapshot {
    uniqueId?: string | undefined;
    position!: number;
    queuedOn!: Date;

    constructor(data?: IQueuedCallerSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["UniqueId"];
            this.position = _data["Position"];
            this.queuedOn = _data["QueuedOn"] ? new Date(_data["QueuedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QueuedCallerSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedCallerSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UniqueId"] = this.uniqueId;
        data["Position"] = this.position;
        data["QueuedOn"] = this.queuedOn ? this.queuedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQueuedCallerSnapshot {
    uniqueId?: string | undefined;
    position: number;
    queuedOn: Date;
}

export class IncomingVideoStateResult implements IIncomingVideoStateResult {
    id!: string;
    username?: string | undefined;
    createdOn!: Date;
    note?: string | undefined;
    isArchived!: boolean;

    constructor(data?: IIncomingVideoStateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.username = _data["Username"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.note = _data["Note"];
            this.isArchived = _data["IsArchived"];
        }
    }

    static fromJS(data: any): IncomingVideoStateResult {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingVideoStateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Username"] = this.username;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["Note"] = this.note;
        data["IsArchived"] = this.isArchived;
        return data;
    }
}

export interface IIncomingVideoStateResult {
    id: string;
    username?: string | undefined;
    createdOn: Date;
    note?: string | undefined;
    isArchived: boolean;
}

export class CompleteIncomingVideoModel implements ICompleteIncomingVideoModel {
    incomingVideoId!: string;
    studyId!: string;
    sendSatisfactionSurvey!: boolean;
    patientId!: string;

    constructor(data?: ICompleteIncomingVideoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingVideoId = _data["IncomingVideoId"];
            this.studyId = _data["StudyId"];
            this.sendSatisfactionSurvey = _data["SendSatisfactionSurvey"];
            this.patientId = _data["PatientId"];
        }
    }

    static fromJS(data: any): CompleteIncomingVideoModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteIncomingVideoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IncomingVideoId"] = this.incomingVideoId;
        data["StudyId"] = this.studyId;
        data["SendSatisfactionSurvey"] = this.sendSatisfactionSurvey;
        data["PatientId"] = this.patientId;
        return data;
    }
}

export interface ICompleteIncomingVideoModel {
    incomingVideoId: string;
    studyId: string;
    sendSatisfactionSurvey: boolean;
    patientId: string;
}

export class UpdateIncomingVideoStateModel implements IUpdateIncomingVideoStateModel {
    note?: string | undefined;

    constructor(data?: IUpdateIncomingVideoStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): UpdateIncomingVideoStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncomingVideoStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Note"] = this.note;
        return data;
    }
}

export interface IUpdateIncomingVideoStateModel {
    note?: string | undefined;
}

export class EmailTemplateResult implements IEmailTemplateResult {
    id!: string;
    name?: string | undefined;
    emailContents!: EmailContentResult[];
    studyId!: string;
    usedForCallRating!: boolean;
    usedForPhoneConfirmation!: boolean;
    usedForVideoConfirmation!: boolean;
    usedForPhoneReminder!: boolean;
    usedForVideoReminder!: boolean;

    constructor(data?: IEmailTemplateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.emailContents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["EmailContents"])) {
                this.emailContents = [] as any;
                for (let item of _data["EmailContents"])
                    this.emailContents!.push(EmailContentResult.fromJS(item));
            }
            this.studyId = _data["StudyId"];
            this.usedForCallRating = _data["UsedForCallRating"];
            this.usedForPhoneConfirmation = _data["UsedForPhoneConfirmation"];
            this.usedForVideoConfirmation = _data["UsedForVideoConfirmation"];
            this.usedForPhoneReminder = _data["UsedForPhoneReminder"];
            this.usedForVideoReminder = _data["UsedForVideoReminder"];
        }
    }

    static fromJS(data: any): EmailTemplateResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.emailContents)) {
            data["EmailContents"] = [];
            for (let item of this.emailContents)
                data["EmailContents"].push(item ? item.toJSON() : <any>undefined);
        }
        data["StudyId"] = this.studyId;
        data["UsedForCallRating"] = this.usedForCallRating;
        data["UsedForPhoneConfirmation"] = this.usedForPhoneConfirmation;
        data["UsedForVideoConfirmation"] = this.usedForVideoConfirmation;
        data["UsedForPhoneReminder"] = this.usedForPhoneReminder;
        data["UsedForVideoReminder"] = this.usedForVideoReminder;
        return data;
    }
}

export interface IEmailTemplateResult {
    id: string;
    name?: string | undefined;
    emailContents: EmailContentResult[];
    studyId: string;
    usedForCallRating: boolean;
    usedForPhoneConfirmation: boolean;
    usedForVideoConfirmation: boolean;
    usedForPhoneReminder: boolean;
    usedForVideoReminder: boolean;
}

export class EmailContentResult implements IEmailContentResult {
    id!: string;
    emailTemplateId!: string;
    cultureCode!: string;
    subject?: string | undefined;
    body?: string | undefined;
    isDefault!: boolean;
    attachments?: EmailAttachmentResult2[] | undefined;

    constructor(data?: IEmailContentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.emailTemplateId = _data["EmailTemplateId"];
            this.cultureCode = _data["CultureCode"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.isDefault = _data["IsDefault"];
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(EmailAttachmentResult2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailContentResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmailTemplateId"] = this.emailTemplateId;
        data["CultureCode"] = this.cultureCode;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["IsDefault"] = this.isDefault;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEmailContentResult {
    id: string;
    emailTemplateId: string;
    cultureCode: string;
    subject?: string | undefined;
    body?: string | undefined;
    isDefault: boolean;
    attachments?: EmailAttachmentResult2[] | undefined;
}

export class EmailAttachmentResult2 implements IEmailAttachmentResult2 {
    id!: string;
    fileName?: string | undefined;

    constructor(data?: IEmailAttachmentResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileName = _data["FileName"];
        }
    }

    static fromJS(data: any): EmailAttachmentResult2 {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentResult2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileName"] = this.fileName;
        return data;
    }
}

export interface IEmailAttachmentResult2 {
    id: string;
    fileName?: string | undefined;
}

export class CreateEmailTemplateModel2 implements ICreateEmailTemplateModel2 {
    name!: string;

    constructor(data?: ICreateEmailTemplateModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data;
    }
}

export interface ICreateEmailTemplateModel2 {
    name: string;
}

export class UpdateEmailTemplateModel2 implements IUpdateEmailTemplateModel2 {
    name!: string;

    constructor(data?: IUpdateEmailTemplateModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data;
    }
}

export interface IUpdateEmailTemplateModel2 {
    name: string;
}

export class CreateEmailContentModel implements ICreateEmailContentModel {
    cultureCode?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ICreateEmailContentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["CultureCode"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
        }
    }

    static fromJS(data: any): CreateEmailContentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailContentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CultureCode"] = this.cultureCode;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        return data;
    }
}

export interface ICreateEmailContentModel {
    cultureCode?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class SentEmailResult implements ISentEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    hTMLBody?: string | undefined;
    date!: Date;
    attachments?: EmailAttachmentResult[] | undefined;

    constructor(data?: ISentEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["MessageId"];
            this.to = _data["To"];
            this.from = _data["From"];
            this.subject = _data["Subject"];
            this.textBody = _data["TextBody"];
            this.hTMLBody = _data["HTMLBody"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(EmailAttachmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SentEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new SentEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MessageId"] = this.messageId;
        data["To"] = this.to;
        data["From"] = this.from;
        data["Subject"] = this.subject;
        data["TextBody"] = this.textBody;
        data["HTMLBody"] = this.hTMLBody;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISentEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    hTMLBody?: string | undefined;
    date: Date;
    attachments?: EmailAttachmentResult[] | undefined;
}

export class ProcessEmailModel implements IProcessEmailModel {
    emailAddress?: string | undefined;
    messageID?: string | undefined;

    constructor(data?: IProcessEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["EmailAddress"];
            this.messageID = _data["MessageID"];
        }
    }

    static fromJS(data: any): ProcessEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailAddress"] = this.emailAddress;
        data["MessageID"] = this.messageID;
        return data;
    }
}

export interface IProcessEmailModel {
    emailAddress?: string | undefined;
    messageID?: string | undefined;
}

export class EmailSenderServiceResult implements IEmailSenderServiceResult {
    emailSenderId!: string;
    emailAddress?: string | undefined;

    constructor(data?: IEmailSenderServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSenderId = _data["EmailSenderId"];
            this.emailAddress = _data["EmailAddress"];
        }
    }

    static fromJS(data: any): EmailSenderServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSenderServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailSenderId"] = this.emailSenderId;
        data["EmailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IEmailSenderServiceResult {
    emailSenderId: string;
    emailAddress?: string | undefined;
}

export class SurveyUIModel implements ISurveyUIModel {
    id?: string | undefined;
    studyId!: string;
    language?: string | undefined;

    constructor(data?: ISurveyUIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.studyId = _data["StudyId"];
            this.language = _data["Language"];
        }
    }

    static fromJS(data: any): SurveyUIModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyUIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StudyId"] = this.studyId;
        data["Language"] = this.language;
        return data;
    }
}

export interface ISurveyUIModel {
    id?: string | undefined;
    studyId: string;
    language?: string | undefined;
}

export class UserScheduleResult implements IUserScheduleResult {
    id!: string;
    userId!: string;
    userName?: string | undefined;
    startOn!: Date;
    endOn!: Date;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    languages?: string[] | undefined;
    studies!: ScheduleStudyAssociationResult[];
    isLocked!: boolean;

    constructor(data?: IUserScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["AgentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["AgentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["AgentRole"];
            if (Array.isArray(_data["Languages"])) {
                this.languages = [] as any;
                for (let item of _data["Languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["Studies"])) {
                this.studies = [] as any;
                for (let item of _data["Studies"])
                    this.studies!.push(ScheduleStudyAssociationResult.fromJS(item));
            }
            this.isLocked = _data["IsLocked"];
        }
    }

    static fromJS(data: any): UserScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        if (Array.isArray(this.agentProvinces)) {
            data["AgentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["AgentProvinces"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentRole"] = this.agentRole;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item);
        }
        if (Array.isArray(this.studies)) {
            data["Studies"] = [];
            for (let item of this.studies)
                data["Studies"].push(item ? item.toJSON() : <any>undefined);
        }
        data["IsLocked"] = this.isLocked;
        return data;
    }
}

export interface IUserScheduleResult {
    id: string;
    userId: string;
    userName?: string | undefined;
    startOn: Date;
    endOn: Date;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    languages?: string[] | undefined;
    studies: ScheduleStudyAssociationResult[];
    isLocked: boolean;
}

export class ScheduleStudyAssociationResult implements IScheduleStudyAssociationResult {
    studyId!: string;
    studyName?: string | undefined;
    studyPrimaryColor?: string | undefined;
    shiftSupervisor!: boolean;

    constructor(data?: IScheduleStudyAssociationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.studyName = _data["StudyName"];
            this.studyPrimaryColor = _data["StudyPrimaryColor"];
            this.shiftSupervisor = _data["ShiftSupervisor"];
        }
    }

    static fromJS(data: any): ScheduleStudyAssociationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyAssociationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["StudyName"] = this.studyName;
        data["StudyPrimaryColor"] = this.studyPrimaryColor;
        data["ShiftSupervisor"] = this.shiftSupervisor;
        return data;
    }
}

export interface IScheduleStudyAssociationResult {
    studyId: string;
    studyName?: string | undefined;
    studyPrimaryColor?: string | undefined;
    shiftSupervisor: boolean;
}

export class CreateStudyUserScheduleModel implements ICreateStudyUserScheduleModel {
    userId!: string;
    startOn!: Date;
    endOn!: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;

    constructor(data?: ICreateStudyUserScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.notes = _data["Notes"];
            if (Array.isArray(_data["StudyAssociations"])) {
                this.studyAssociations = [] as any;
                for (let item of _data["StudyAssociations"])
                    this.studyAssociations!.push(ScheduleStudyAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["Breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["Breaks"])
                    this.breaks!.push(StudyUserScheduleBreakModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyUserScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyUserScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["Notes"] = this.notes;
        if (Array.isArray(this.studyAssociations)) {
            data["StudyAssociations"] = [];
            for (let item of this.studyAssociations)
                data["StudyAssociations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.breaks)) {
            data["Breaks"] = [];
            for (let item of this.breaks)
                data["Breaks"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateStudyUserScheduleModel {
    userId: string;
    startOn: Date;
    endOn: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;
}

export class ScheduleStudyAssociationModel implements IScheduleStudyAssociationModel {
    shiftSupervisor!: boolean;
    studyId!: string;

    constructor(data?: IScheduleStudyAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftSupervisor = _data["ShiftSupervisor"];
            this.studyId = _data["StudyId"];
        }
    }

    static fromJS(data: any): ScheduleStudyAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShiftSupervisor"] = this.shiftSupervisor;
        data["StudyId"] = this.studyId;
        return data;
    }
}

export interface IScheduleStudyAssociationModel {
    shiftSupervisor: boolean;
    studyId: string;
}

export class StudyUserScheduleBreakModel implements IStudyUserScheduleBreakModel {
    breakId?: string | undefined;
    startOn!: Date;
    duration!: number;
    deleted!: boolean;

    constructor(data?: IStudyUserScheduleBreakModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakId = _data["BreakId"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.duration = _data["Duration"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): StudyUserScheduleBreakModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserScheduleBreakModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BreakId"] = this.breakId;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["Duration"] = this.duration;
        data["Deleted"] = this.deleted;
        return data;
    }
}

export interface IStudyUserScheduleBreakModel {
    breakId?: string | undefined;
    startOn: Date;
    duration: number;
    deleted: boolean;
}

export class UpdateUserScheduleRequestModel implements IUpdateUserScheduleRequestModel {
    studyUserScheduleId!: string;
    startOn!: Date;
    endOn!: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;

    constructor(data?: IUpdateUserScheduleRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyUserScheduleId = _data["StudyUserScheduleId"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.notes = _data["Notes"];
            if (Array.isArray(_data["StudyAssociations"])) {
                this.studyAssociations = [] as any;
                for (let item of _data["StudyAssociations"])
                    this.studyAssociations!.push(ScheduleStudyAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["Breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["Breaks"])
                    this.breaks!.push(StudyUserScheduleBreakModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUserScheduleRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserScheduleRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyUserScheduleId"] = this.studyUserScheduleId;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["Notes"] = this.notes;
        if (Array.isArray(this.studyAssociations)) {
            data["StudyAssociations"] = [];
            for (let item of this.studyAssociations)
                data["StudyAssociations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.breaks)) {
            data["Breaks"] = [];
            for (let item of this.breaks)
                data["Breaks"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateUserScheduleRequestModel {
    studyUserScheduleId: string;
    startOn: Date;
    endOn: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;
}

export class ScheduleOpeningResult implements IScheduleOpeningResult {
    userId!: string;
    start!: Date;
    end!: Date;

    constructor(data?: IScheduleOpeningResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.start = _data["Start"] ? new Date(_data["Start"].toString()) : <any>undefined;
            this.end = _data["End"] ? new Date(_data["End"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleOpeningResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleOpeningResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["Start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["End"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduleOpeningResult {
    userId: string;
    start: Date;
    end: Date;
}

export class StudyUserHoursResult implements IStudyUserHoursResult {
    userId!: string;
    userName?: string | undefined;
    hours?: number | undefined;
    adjustedHours?: number | undefined;
    studies?: ScheduleStudyReference[] | undefined;

    constructor(data?: IStudyUserHoursResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.hours = _data["Hours"];
            this.adjustedHours = _data["AdjustedHours"];
            if (Array.isArray(_data["Studies"])) {
                this.studies = [] as any;
                for (let item of _data["Studies"])
                    this.studies!.push(ScheduleStudyReference.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyUserHoursResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserHoursResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["Hours"] = this.hours;
        data["AdjustedHours"] = this.adjustedHours;
        if (Array.isArray(this.studies)) {
            data["Studies"] = [];
            for (let item of this.studies)
                data["Studies"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IStudyUserHoursResult {
    userId: string;
    userName?: string | undefined;
    hours?: number | undefined;
    adjustedHours?: number | undefined;
    studies?: ScheduleStudyReference[] | undefined;
}

export class ScheduleStudyReference implements IScheduleStudyReference {
    studyId!: string;
    studyName?: string | undefined;
    role?: string | undefined;

    constructor(data?: IScheduleStudyReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.studyName = _data["StudyName"];
            this.role = _data["Role"];
        }
    }

    static fromJS(data: any): ScheduleStudyReference {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["StudyName"] = this.studyName;
        data["Role"] = this.role;
        return data;
    }
}

export interface IScheduleStudyReference {
    studyId: string;
    studyName?: string | undefined;
    role?: string | undefined;
}

export class DuplicateScheduleViewModel implements IDuplicateScheduleViewModel {
    sourceStart!: Date;
    sourceEnd!: Date;
    target!: Date;

    constructor(data?: IDuplicateScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceStart = _data["SourceStart"] ? new Date(_data["SourceStart"].toString()) : <any>undefined;
            this.sourceEnd = _data["SourceEnd"] ? new Date(_data["SourceEnd"].toString()) : <any>undefined;
            this.target = _data["Target"] ? new Date(_data["Target"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SourceStart"] = this.sourceStart ? this.sourceStart.toISOString() : <any>undefined;
        data["SourceEnd"] = this.sourceEnd ? this.sourceEnd.toISOString() : <any>undefined;
        data["Target"] = this.target ? this.target.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDuplicateScheduleViewModel {
    sourceStart: Date;
    sourceEnd: Date;
    target: Date;
}

export class PostScheduleViewModel implements IPostScheduleViewModel {
    schedulePostedDate!: Date;

    constructor(data?: IPostScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schedulePostedDate = _data["SchedulePostedDate"] ? new Date(_data["SchedulePostedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PostScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SchedulePostedDate"] = this.schedulePostedDate ? this.schedulePostedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPostScheduleViewModel {
    schedulePostedDate: Date;
}

export class GridScheduleViewModel implements IGridScheduleViewModel {
    agentId!: string;
    agentName?: string | undefined;
    languages?: string[] | undefined;
    scheduleDetails?: ScheduleDetail[] | undefined;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;

    constructor(data?: IGridScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["AgentId"];
            this.agentName = _data["AgentName"];
            if (Array.isArray(_data["Languages"])) {
                this.languages = [] as any;
                for (let item of _data["Languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["ScheduleDetails"])) {
                this.scheduleDetails = [] as any;
                for (let item of _data["ScheduleDetails"])
                    this.scheduleDetails!.push(ScheduleDetail.fromJS(item));
            }
            if (Array.isArray(_data["AgentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["AgentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["AgentRole"];
        }
    }

    static fromJS(data: any): GridScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AgentId"] = this.agentId;
        data["AgentName"] = this.agentName;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item);
        }
        if (Array.isArray(this.scheduleDetails)) {
            data["ScheduleDetails"] = [];
            for (let item of this.scheduleDetails)
                data["ScheduleDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.agentProvinces)) {
            data["AgentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["AgentProvinces"].push(item ? item.toJSON() : <any>undefined);
        }
        data["AgentRole"] = this.agentRole;
        return data;
    }
}

export interface IGridScheduleViewModel {
    agentId: string;
    agentName?: string | undefined;
    languages?: string[] | undefined;
    scheduleDetails?: ScheduleDetail[] | undefined;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
}

export class ScheduleDetail implements IScheduleDetail {
    shiftId!: string;
    shiftStudies?: ShiftStudy[] | undefined;
    startOn!: Date;
    endOn!: Date;
    isLocked!: boolean;
    breaks?: BreakResult[] | undefined;
    notes?: string | undefined;

    constructor(data?: IScheduleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["ShiftId"];
            if (Array.isArray(_data["ShiftStudies"])) {
                this.shiftStudies = [] as any;
                for (let item of _data["ShiftStudies"])
                    this.shiftStudies!.push(ShiftStudy.fromJS(item));
            }
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.isLocked = _data["IsLocked"];
            if (Array.isArray(_data["Breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["Breaks"])
                    this.breaks!.push(BreakResult.fromJS(item));
            }
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): ScheduleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShiftId"] = this.shiftId;
        if (Array.isArray(this.shiftStudies)) {
            data["ShiftStudies"] = [];
            for (let item of this.shiftStudies)
                data["ShiftStudies"].push(item ? item.toJSON() : <any>undefined);
        }
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["IsLocked"] = this.isLocked;
        if (Array.isArray(this.breaks)) {
            data["Breaks"] = [];
            for (let item of this.breaks)
                data["Breaks"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IScheduleDetail {
    shiftId: string;
    shiftStudies?: ShiftStudy[] | undefined;
    startOn: Date;
    endOn: Date;
    isLocked: boolean;
    breaks?: BreakResult[] | undefined;
    notes?: string | undefined;
}

export class ShiftStudy implements IShiftStudy {
    studyId!: string;
    shiftSupervisor!: boolean;

    constructor(data?: IShiftStudy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["StudyId"];
            this.shiftSupervisor = _data["ShiftSupervisor"];
        }
    }

    static fromJS(data: any): ShiftStudy {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftStudy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StudyId"] = this.studyId;
        data["ShiftSupervisor"] = this.shiftSupervisor;
        return data;
    }
}

export interface IShiftStudy {
    studyId: string;
    shiftSupervisor: boolean;
}

export class BreakResult implements IBreakResult {
    breakId!: string;
    startOn!: Date;
    duration!: number;

    constructor(data?: IBreakResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakId = _data["BreakId"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.duration = _data["Duration"];
        }
    }

    static fromJS(data: any): BreakResult {
        data = typeof data === 'object' ? data : {};
        let result = new BreakResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BreakId"] = this.breakId;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["Duration"] = this.duration;
        return data;
    }
}

export interface IBreakResult {
    breakId: string;
    startOn: Date;
    duration: number;
}

export class AvailabilityResult implements IAvailabilityResult {
    id!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    start!: Date;
    end!: Date;

    constructor(data?: IAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.start = _data["Start"] ? new Date(_data["Start"].toString()) : <any>undefined;
            this.end = _data["End"] ? new Date(_data["End"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["Start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["End"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityResult {
    id: string;
    userId?: string | undefined;
    userName?: string | undefined;
    start: Date;
    end: Date;
}

export class AvailabilityViewModel implements IAvailabilityViewModel {
    id?: string | undefined;
    userId!: string;
    start!: Date;
    end!: Date;

    constructor(data?: IAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userId = _data["UserId"];
            this.start = _data["Start"] ? new Date(_data["Start"].toString()) : <any>undefined;
            this.end = _data["End"] ? new Date(_data["End"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["Start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["End"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityViewModel {
    id?: string | undefined;
    userId: string;
    start: Date;
    end: Date;
}

export class DuplicateAvailabilityViewModel implements IDuplicateAvailabilityViewModel {
    sourceStart!: Date;
    sourceEnd!: Date;
    target!: Date;

    constructor(data?: IDuplicateAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceStart = _data["SourceStart"] ? new Date(_data["SourceStart"].toString()) : <any>undefined;
            this.sourceEnd = _data["SourceEnd"] ? new Date(_data["SourceEnd"].toString()) : <any>undefined;
            this.target = _data["Target"] ? new Date(_data["Target"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateAvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateAvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SourceStart"] = this.sourceStart ? this.sourceStart.toISOString() : <any>undefined;
        data["SourceEnd"] = this.sourceEnd ? this.sourceEnd.toISOString() : <any>undefined;
        data["Target"] = this.target ? this.target.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDuplicateAvailabilityViewModel {
    sourceStart: Date;
    sourceEnd: Date;
    target: Date;
}

export class CallHistoryResult implements ICallHistoryResult {
    uniqueId?: string | undefined;
    callStartDate!: Date;
    callEndDate?: Date | undefined;
    callDirection!: CallDirection;
    callerId?: string | undefined;
    callType!: CallType;
    userId?: string | undefined;
    studyId!: string;
    cdrs!: CallEntryResult[];

    constructor(data?: ICallHistoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cdrs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["UniqueId"];
            this.callStartDate = _data["CallStartDate"] ? new Date(_data["CallStartDate"].toString()) : <any>undefined;
            this.callEndDate = _data["CallEndDate"] ? new Date(_data["CallEndDate"].toString()) : <any>undefined;
            this.callDirection = _data["CallDirection"];
            this.callerId = _data["CallerId"];
            this.callType = _data["CallType"];
            this.userId = _data["UserId"];
            this.studyId = _data["StudyId"];
            if (Array.isArray(_data["Cdrs"])) {
                this.cdrs = [] as any;
                for (let item of _data["Cdrs"])
                    this.cdrs!.push(CallEntryResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallHistoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UniqueId"] = this.uniqueId;
        data["CallStartDate"] = this.callStartDate ? this.callStartDate.toISOString() : <any>undefined;
        data["CallEndDate"] = this.callEndDate ? this.callEndDate.toISOString() : <any>undefined;
        data["CallDirection"] = this.callDirection;
        data["CallerId"] = this.callerId;
        data["CallType"] = this.callType;
        data["UserId"] = this.userId;
        data["StudyId"] = this.studyId;
        if (Array.isArray(this.cdrs)) {
            data["Cdrs"] = [];
            for (let item of this.cdrs)
                data["Cdrs"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICallHistoryResult {
    uniqueId?: string | undefined;
    callStartDate: Date;
    callEndDate?: Date | undefined;
    callDirection: CallDirection;
    callerId?: string | undefined;
    callType: CallType;
    userId?: string | undefined;
    studyId: string;
    cdrs: CallEntryResult[];
}

export enum CallDirection {
    Inbound = 0,
    Outbound = 1,
}

export class CallEntryResult implements ICallEntryResult {
    callDate?: Date | undefined;
    dContext?: string | undefined;
    src?: string | undefined;
    userId?: string | undefined;
    destinationUserId?: string | undefined;
    duration?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    answeredOn?: Date | undefined;
    linkedId?: string | undefined;
    clid?: string | undefined;
    studyId?: string | undefined;

    constructor(data?: ICallEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callDate = _data["CallDate"] ? new Date(_data["CallDate"].toString()) : <any>undefined;
            this.dContext = _data["DContext"];
            this.src = _data["Src"];
            this.userId = _data["UserId"];
            this.destinationUserId = _data["DestinationUserId"];
            this.duration = _data["Duration"];
            this.start = _data["Start"] ? new Date(_data["Start"].toString()) : <any>undefined;
            this.end = _data["End"] ? new Date(_data["End"].toString()) : <any>undefined;
            this.answeredOn = _data["AnsweredOn"] ? new Date(_data["AnsweredOn"].toString()) : <any>undefined;
            this.linkedId = _data["LinkedId"];
            this.clid = _data["Clid"];
            this.studyId = _data["StudyId"];
        }
    }

    static fromJS(data: any): CallEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallDate"] = this.callDate ? this.callDate.toISOString() : <any>undefined;
        data["DContext"] = this.dContext;
        data["Src"] = this.src;
        data["UserId"] = this.userId;
        data["DestinationUserId"] = this.destinationUserId;
        data["Duration"] = this.duration;
        data["Start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["End"] = this.end ? this.end.toISOString() : <any>undefined;
        data["AnsweredOn"] = this.answeredOn ? this.answeredOn.toISOString() : <any>undefined;
        data["LinkedId"] = this.linkedId;
        data["Clid"] = this.clid;
        data["StudyId"] = this.studyId;
        return data;
    }
}

export interface ICallEntryResult {
    callDate?: Date | undefined;
    dContext?: string | undefined;
    src?: string | undefined;
    userId?: string | undefined;
    destinationUserId?: string | undefined;
    duration?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    answeredOn?: Date | undefined;
    linkedId?: string | undefined;
    clid?: string | undefined;
    studyId?: string | undefined;
}

export class UserQueuesResult implements IUserQueuesResult {
    userId!: string;
    queueIds!: string[];

    constructor(data?: IUserQueuesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.queueIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            if (Array.isArray(_data["QueueIds"])) {
                this.queueIds = [] as any;
                for (let item of _data["QueueIds"])
                    this.queueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserQueuesResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserQueuesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        if (Array.isArray(this.queueIds)) {
            data["QueueIds"] = [];
            for (let item of this.queueIds)
                data["QueueIds"].push(item);
        }
        return data;
    }
}

export interface IUserQueuesResult {
    userId: string;
    queueIds: string[];
}

export class SetUserQueuesModel implements ISetUserQueuesModel {
    asteriskUsername?: string | undefined;
    queueIds?: string[] | undefined;

    constructor(data?: ISetUserQueuesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asteriskUsername = _data["AsteriskUsername"];
            if (Array.isArray(_data["QueueIds"])) {
                this.queueIds = [] as any;
                for (let item of _data["QueueIds"])
                    this.queueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetUserQueuesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserQueuesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AsteriskUsername"] = this.asteriskUsername;
        if (Array.isArray(this.queueIds)) {
            data["QueueIds"] = [];
            for (let item of this.queueIds)
                data["QueueIds"].push(item);
        }
        return data;
    }
}

export interface ISetUserQueuesModel {
    asteriskUsername?: string | undefined;
    queueIds?: string[] | undefined;
}

export class JoinTempQueueModel implements IJoinTempQueueModel {
    queueName?: string | undefined;

    constructor(data?: IJoinTempQueueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["QueueName"];
        }
    }

    static fromJS(data: any): JoinTempQueueModel {
        data = typeof data === 'object' ? data : {};
        let result = new JoinTempQueueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QueueName"] = this.queueName;
        return data;
    }
}

export interface IJoinTempQueueModel {
    queueName?: string | undefined;
}

export class AppointmentResult implements IAppointmentResult {
    id!: string;
    createdOn!: Date;
    studyId?: string | undefined;
    userId!: string;
    createdByUserId?: string | undefined;
    userFullName?: string | undefined;
    appointmentType!: AppointmentType;
    pendingExpiresOn?: Date | undefined;
    startOn!: Date;
    endOn!: Date;
    callbackTaskId?: string | undefined;
    task?: CallbackTaskResult | undefined;
    notes?: string | undefined;
    durationOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: IAppointmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            this.studyId = _data["StudyId"];
            this.userId = _data["UserId"];
            this.createdByUserId = _data["CreatedByUserId"];
            this.userFullName = _data["UserFullName"];
            this.appointmentType = _data["AppointmentType"];
            this.pendingExpiresOn = _data["PendingExpiresOn"] ? new Date(_data["PendingExpiresOn"].toString()) : <any>undefined;
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.callbackTaskId = _data["CallbackTaskId"];
            this.task = _data["Task"] ? CallbackTaskResult.fromJS(_data["Task"]) : <any>undefined;
            this.notes = _data["Notes"];
            this.durationOption = _data["DurationOption"] ? StudyCallDurationOptionResult.fromJS(_data["DurationOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["StudyId"] = this.studyId;
        data["UserId"] = this.userId;
        data["CreatedByUserId"] = this.createdByUserId;
        data["UserFullName"] = this.userFullName;
        data["AppointmentType"] = this.appointmentType;
        data["PendingExpiresOn"] = this.pendingExpiresOn ? this.pendingExpiresOn.toISOString() : <any>undefined;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["CallbackTaskId"] = this.callbackTaskId;
        data["Task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["Notes"] = this.notes;
        data["DurationOption"] = this.durationOption ? this.durationOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppointmentResult {
    id: string;
    createdOn: Date;
    studyId?: string | undefined;
    userId: string;
    createdByUserId?: string | undefined;
    userFullName?: string | undefined;
    appointmentType: AppointmentType;
    pendingExpiresOn?: Date | undefined;
    startOn: Date;
    endOn: Date;
    callbackTaskId?: string | undefined;
    task?: CallbackTaskResult | undefined;
    notes?: string | undefined;
    durationOption?: StudyCallDurationOptionResult | undefined;
}

export enum AppointmentType {
    Other = 0,
    Break = 1,
    ManualBreak = 2,
    Call = 3,
    Pending = 4,
}

export class PendingAppointmentCreatedModel implements IPendingAppointmentCreatedModel {
    appointmentId!: string;

    constructor(data?: IPendingAppointmentCreatedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["AppointmentId"];
        }
    }

    static fromJS(data: any): PendingAppointmentCreatedModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingAppointmentCreatedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AppointmentId"] = this.appointmentId;
        return data;
    }
}

export interface IPendingAppointmentCreatedModel {
    appointmentId: string;
}

export class CreatePendingAppointmentModel implements ICreatePendingAppointmentModel {
    userId!: string;
    startOn!: Date;
    endOn!: Date;

    constructor(data?: ICreatePendingAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePendingAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendingAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreatePendingAppointmentModel {
    userId: string;
    startOn: Date;
    endOn: Date;
}

export class UpdateAppointmentTimeModel implements IUpdateAppointmentTimeModel {
    startOn!: Date;
    endOn!: Date;
    appointmentId!: string;

    constructor(data?: IUpdateAppointmentTimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.appointmentId = _data["AppointmentId"];
        }
    }

    static fromJS(data: any): UpdateAppointmentTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentTimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["AppointmentId"] = this.appointmentId;
        return data;
    }
}

export interface IUpdateAppointmentTimeModel {
    startOn: Date;
    endOn: Date;
    appointmentId: string;
}

export class UpdateAppointmentModel implements IUpdateAppointmentModel {
    startOn!: Date;
    endOn!: Date;
    appointmentId!: string;
    label?: string | undefined;

    constructor(data?: IUpdateAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startOn = _data["StartOn"] ? new Date(_data["StartOn"].toString()) : <any>undefined;
            this.endOn = _data["EndOn"] ? new Date(_data["EndOn"].toString()) : <any>undefined;
            this.appointmentId = _data["AppointmentId"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): UpdateAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartOn"] = this.startOn ? this.startOn.toISOString() : <any>undefined;
        data["EndOn"] = this.endOn ? this.endOn.toISOString() : <any>undefined;
        data["AppointmentId"] = this.appointmentId;
        data["Label"] = this.label;
        return data;
    }
}

export interface IUpdateAppointmentModel {
    startOn: Date;
    endOn: Date;
    appointmentId: string;
    label?: string | undefined;
}

export class FinalizeHcpBreakAppointmentModel implements IFinalizeHcpBreakAppointmentModel {
    appointmentId!: string;
    interactionTypeDurationOptionId!: string;
    studyId!: string;
    notes?: string | undefined;

    constructor(data?: IFinalizeHcpBreakAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["AppointmentId"];
            this.interactionTypeDurationOptionId = _data["InteractionTypeDurationOptionId"];
            this.studyId = _data["StudyId"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): FinalizeHcpBreakAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizeHcpBreakAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AppointmentId"] = this.appointmentId;
        data["InteractionTypeDurationOptionId"] = this.interactionTypeDurationOptionId;
        data["StudyId"] = this.studyId;
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IFinalizeHcpBreakAppointmentModel {
    appointmentId: string;
    interactionTypeDurationOptionId: string;
    studyId: string;
    notes?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}